var $b792be6a00d98dad$var$mi = Object.defineProperty;
var $b792be6a00d98dad$var$o = (r, t)=>$b792be6a00d98dad$var$mi(r, "name", {
        value: t,
        configurable: !0
    });
var $b792be6a00d98dad$var$ms = (()=>{
    for(var r = new Uint8Array(128), t = 0; t < 64; t++)r[t < 26 ? t + 65 : t < 52 ? t + 71 : t < 62 ? t - 4 : t * 4 - 205] = t;
    return (c)=>{
        for(var w = c.length, S = new Uint8Array((w - (c[w - 1] == "=") - (c[w - 2] == "=")) * 3 / 4 | 0), L = 0, K = 0; L < w;){
            var j = r[c.charCodeAt(L++)], q = r[c.charCodeAt(L++)], Z = r[c.charCodeAt(L++)], ue = r[c.charCodeAt(L++)];
            S[K++] = j << 2 | q >> 4, S[K++] = q << 4 | Z >> 2, S[K++] = Z << 6 | ue;
        }
        return S;
    };
})();
function $b792be6a00d98dad$var$Ee(r) {
    return r * Math.PI / 180;
}
$b792be6a00d98dad$var$o($b792be6a00d98dad$var$Ee, "deg2rad");
function $b792be6a00d98dad$var$Je(r) {
    return r * 180 / Math.PI;
}
$b792be6a00d98dad$var$o($b792be6a00d98dad$var$Je, "rad2deg");
function $b792be6a00d98dad$var$Me(r, t, c) {
    return t > c ? $b792be6a00d98dad$var$Me(r, c, t) : Math.min(Math.max(r, t), c);
}
$b792be6a00d98dad$var$o($b792be6a00d98dad$var$Me, "clamp");
function $b792be6a00d98dad$var$Se(r, t, c) {
    if (typeof r == "number" && typeof t == "number") return r + (t - r) * c;
    if (r instanceof $b792be6a00d98dad$var$y && t instanceof $b792be6a00d98dad$var$y) return r.lerp(t, c);
    if (r instanceof $b792be6a00d98dad$var$$ && t instanceof $b792be6a00d98dad$var$$) return r.lerp(t, c);
    throw new Error(`Bad value for lerp(): ${r}, ${t}. Only number, Vec2 and Color is supported.`);
}
$b792be6a00d98dad$var$o($b792be6a00d98dad$var$Se, "lerp");
function $b792be6a00d98dad$var$Nt(r, t, c, w, S) {
    return w + (r - t) / (c - t) * (S - w);
}
$b792be6a00d98dad$var$o($b792be6a00d98dad$var$Nt, "map");
function $b792be6a00d98dad$var$gs(r, t, c, w, S) {
    return $b792be6a00d98dad$var$Me($b792be6a00d98dad$var$Nt(r, t, c, w, S), w, S);
}
$b792be6a00d98dad$var$o($b792be6a00d98dad$var$gs, "mapc");
var $b792be6a00d98dad$var$y = class r {
    static{
        $b792be6a00d98dad$var$o(this, "Vec2");
    }
    x = 0;
    y = 0;
    constructor(t = 0, c = t){
        this.x = t, this.y = c;
    }
    static fromAngle(t) {
        let c = $b792be6a00d98dad$var$Ee(t);
        return new r(Math.cos(c), Math.sin(c));
    }
    static LEFT = new r(-1, 0);
    static RIGHT = new r(1, 0);
    static UP = new r(0, -1);
    static DOWN = new r(0, 1);
    clone() {
        return new r(this.x, this.y);
    }
    add(...t) {
        let c = $b792be6a00d98dad$var$C(...t);
        return new r(this.x + c.x, this.y + c.y);
    }
    sub(...t) {
        let c = $b792be6a00d98dad$var$C(...t);
        return new r(this.x - c.x, this.y - c.y);
    }
    scale(...t) {
        let c = $b792be6a00d98dad$var$C(...t);
        return new r(this.x * c.x, this.y * c.y);
    }
    dist(...t) {
        let c = $b792be6a00d98dad$var$C(...t);
        return this.sub(c).len();
    }
    sdist(...t) {
        let c = $b792be6a00d98dad$var$C(...t);
        return this.sub(c).slen();
    }
    len() {
        return Math.sqrt(this.dot(this));
    }
    slen() {
        return this.dot(this);
    }
    unit() {
        let t = this.len();
        return t === 0 ? new r(0) : this.scale(1 / t);
    }
    normal() {
        return new r(this.y, -this.x);
    }
    reflect(t) {
        return this.sub(t.scale(2 * this.dot(t)));
    }
    project(t) {
        return t.scale(t.dot(this) / t.len());
    }
    reject(t) {
        return this.sub(this.project(t));
    }
    dot(t) {
        return this.x * t.x + this.y * t.y;
    }
    cross(t) {
        return this.x * t.y - this.y * t.x;
    }
    angle(...t) {
        let c = $b792be6a00d98dad$var$C(...t);
        return $b792be6a00d98dad$var$Je(Math.atan2(this.y - c.y, this.x - c.x));
    }
    angleBetween(...t) {
        let c = $b792be6a00d98dad$var$C(...t);
        return $b792be6a00d98dad$var$Je(Math.atan2(this.cross(c), this.dot(c)));
    }
    lerp(t, c) {
        return new r($b792be6a00d98dad$var$Se(this.x, t.x, c), $b792be6a00d98dad$var$Se(this.y, t.y, c));
    }
    slerp(t, c) {
        let w = this.dot(t), S = this.cross(t), L = Math.atan2(S, w);
        return this.scale(Math.sin((1 - c) * L)).add(t.scale(Math.sin(c * L))).scale(1 / S);
    }
    isZero() {
        return this.x === 0 && this.y === 0;
    }
    toFixed(t) {
        return new r(Number(this.x.toFixed(t)), Number(this.y.toFixed(t)));
    }
    transform(t) {
        return t.multVec2(this);
    }
    eq(t) {
        return this.x === t.x && this.y === t.y;
    }
    bbox() {
        return new $b792be6a00d98dad$var$he(this, 0, 0);
    }
    toString() {
        return `vec2(${this.x.toFixed(2)}, ${this.y.toFixed(2)})`;
    }
};
function $b792be6a00d98dad$var$C(...r) {
    if (r.length === 1) {
        if (r[0] instanceof $b792be6a00d98dad$var$y) return new $b792be6a00d98dad$var$y(r[0].x, r[0].y);
        if (Array.isArray(r[0]) && r[0].length === 2) return new $b792be6a00d98dad$var$y(...r[0]);
    }
    return new $b792be6a00d98dad$var$y(...r);
}
$b792be6a00d98dad$var$o($b792be6a00d98dad$var$C, "vec2");
var $b792be6a00d98dad$var$$ = class r {
    static{
        $b792be6a00d98dad$var$o(this, "Color");
    }
    r = 255;
    g = 255;
    b = 255;
    constructor(t, c, w){
        this.r = $b792be6a00d98dad$var$Me(t, 0, 255), this.g = $b792be6a00d98dad$var$Me(c, 0, 255), this.b = $b792be6a00d98dad$var$Me(w, 0, 255);
    }
    static fromArray(t) {
        return new r(t[0], t[1], t[2]);
    }
    static fromHex(t) {
        if (typeof t == "number") return new r(t >> 16 & 255, t >> 8 & 255, t >> 0 & 255);
        if (typeof t == "string") {
            let c = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(t);
            return new r(parseInt(c[1], 16), parseInt(c[2], 16), parseInt(c[3], 16));
        } else throw new Error("Invalid hex color format");
    }
    static fromHSL(t, c, w) {
        if (c == 0) return new r(255 * w, 255 * w, 255 * w);
        let S = $b792be6a00d98dad$var$o((ue, U, J)=>(J < 0 && (J += 1), J > 1 && (J -= 1), J < 1 / 6 ? ue + (U - ue) * 6 * J : J < 0.5 ? U : J < 2 / 3 ? ue + (U - ue) * (2 / 3 - J) * 6 : ue), "hue2rgb"), L = w < .5 ? w * (1 + c) : w + c - w * c, K = 2 * w - L, j = S(K, L, t + 1 / 3), q = S(K, L, t), Z = S(K, L, t - 1 / 3);
        return new r(Math.round(j * 255), Math.round(q * 255), Math.round(Z * 255));
    }
    static RED = new r(255, 0, 0);
    static GREEN = new r(0, 255, 0);
    static BLUE = new r(0, 0, 255);
    static YELLOW = new r(255, 255, 0);
    static MAGENTA = new r(255, 0, 255);
    static CYAN = new r(0, 255, 255);
    static WHITE = new r(255, 255, 255);
    static BLACK = new r(0, 0, 0);
    clone() {
        return new r(this.r, this.g, this.b);
    }
    lighten(t) {
        return new r(this.r + t, this.g + t, this.b + t);
    }
    darken(t) {
        return this.lighten(-t);
    }
    invert() {
        return new r(255 - this.r, 255 - this.g, 255 - this.b);
    }
    mult(t) {
        return new r(this.r * t.r / 255, this.g * t.g / 255, this.b * t.b / 255);
    }
    lerp(t, c) {
        return new r($b792be6a00d98dad$var$Se(this.r, t.r, c), $b792be6a00d98dad$var$Se(this.g, t.g, c), $b792be6a00d98dad$var$Se(this.b, t.b, c));
    }
    eq(t) {
        return this.r === t.r && this.g === t.g && this.b === t.b;
    }
    toString() {
        return `rgb(${this.r}, ${this.g}, ${this.b})`;
    }
    toHex() {
        return "#" + (16777216 + (this.r << 16) + (this.g << 8) + this.b).toString(16).slice(1);
    }
};
function $b792be6a00d98dad$var$W(...r) {
    if (r.length === 0) return new $b792be6a00d98dad$var$$(255, 255, 255);
    if (r.length === 1) {
        if (r[0] instanceof $b792be6a00d98dad$var$$) return r[0].clone();
        if (typeof r[0] == "string") return $b792be6a00d98dad$var$$.fromHex(r[0]);
        if (Array.isArray(r[0]) && r[0].length === 3) return $b792be6a00d98dad$var$$.fromArray(r[0]);
    }
    return new $b792be6a00d98dad$var$$(...r);
}
$b792be6a00d98dad$var$o($b792be6a00d98dad$var$W, "rgb");
var $b792be6a00d98dad$var$ws = $b792be6a00d98dad$var$o((r, t, c)=>$b792be6a00d98dad$var$$.fromHSL(r, t, c), "hsl2rgb"), $b792be6a00d98dad$var$oe = class r {
    static{
        $b792be6a00d98dad$var$o(this, "Quad");
    }
    x = 0;
    y = 0;
    w = 1;
    h = 1;
    constructor(t, c, w, S){
        this.x = t, this.y = c, this.w = w, this.h = S;
    }
    scale(t) {
        return new r(this.x + this.w * t.x, this.y + this.h * t.y, this.w * t.w, this.h * t.h);
    }
    pos() {
        return new $b792be6a00d98dad$var$y(this.x, this.y);
    }
    clone() {
        return new r(this.x, this.y, this.w, this.h);
    }
    eq(t) {
        return this.x === t.x && this.y === t.y && this.w === t.w && this.h === t.h;
    }
    toString() {
        return `quad(${this.x}, ${this.y}, ${this.w}, ${this.h})`;
    }
};
function $b792be6a00d98dad$var$ae(r, t, c, w) {
    return new $b792be6a00d98dad$var$oe(r, t, c, w);
}
$b792be6a00d98dad$var$o($b792be6a00d98dad$var$ae, "quad");
var $b792be6a00d98dad$var$be = class r {
    static{
        $b792be6a00d98dad$var$o(this, "Mat4");
    }
    m = [
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1
    ];
    constructor(t){
        t && (this.m = t);
    }
    static translate(t) {
        return new r([
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            t.x,
            t.y,
            0,
            1
        ]);
    }
    static scale(t) {
        return new r([
            t.x,
            0,
            0,
            0,
            0,
            t.y,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1
        ]);
    }
    static rotateX(t) {
        t = $b792be6a00d98dad$var$Ee(-t);
        let c = Math.cos(t), w = Math.sin(t);
        return new r([
            1,
            0,
            0,
            0,
            0,
            c,
            -w,
            0,
            0,
            w,
            c,
            0,
            0,
            0,
            0,
            1
        ]);
    }
    static rotateY(t) {
        t = $b792be6a00d98dad$var$Ee(-t);
        let c = Math.cos(t), w = Math.sin(t);
        return new r([
            c,
            0,
            w,
            0,
            0,
            1,
            0,
            0,
            -w,
            0,
            c,
            0,
            0,
            0,
            0,
            1
        ]);
    }
    static rotateZ(t) {
        t = $b792be6a00d98dad$var$Ee(-t);
        let c = Math.cos(t), w = Math.sin(t);
        return new r([
            c,
            -w,
            0,
            0,
            w,
            c,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1
        ]);
    }
    translate(t) {
        return this.m[12] += this.m[0] * t.x + this.m[4] * t.y, this.m[13] += this.m[1] * t.x + this.m[5] * t.y, this.m[14] += this.m[2] * t.x + this.m[6] * t.y, this.m[15] += this.m[3] * t.x + this.m[7] * t.y, this;
    }
    scale(t) {
        return this.m[0] *= t.x, this.m[4] *= t.y, this.m[1] *= t.x, this.m[5] *= t.y, this.m[2] *= t.x, this.m[6] *= t.y, this.m[3] *= t.x, this.m[7] *= t.y, this;
    }
    rotate(t) {
        t = $b792be6a00d98dad$var$Ee(-t);
        let c = Math.cos(t), w = Math.sin(t), S = this.m[0], L = this.m[1], K = this.m[4], j = this.m[5];
        return this.m[0] = S * c + L * w, this.m[1] = -S * w + L * c, this.m[4] = K * c + j * w, this.m[5] = -K * w + j * c, this;
    }
    mult(t) {
        let c = [];
        for(let w = 0; w < 4; w++)for(let S = 0; S < 4; S++)c[w * 4 + S] = this.m[0 + S] * t.m[w * 4 + 0] + this.m[4 + S] * t.m[w * 4 + 1] + this.m[8 + S] * t.m[w * 4 + 2] + this.m[12 + S] * t.m[w * 4 + 3];
        return new r(c);
    }
    multVec2(t) {
        return new $b792be6a00d98dad$var$y(t.x * this.m[0] + t.y * this.m[4] + this.m[12], t.x * this.m[1] + t.y * this.m[5] + this.m[13]);
    }
    getTranslation() {
        return new $b792be6a00d98dad$var$y(this.m[12], this.m[13]);
    }
    getScale() {
        if (this.m[0] != 0 || this.m[1] != 0) {
            let t = this.m[0] * this.m[5] - this.m[1] * this.m[4], c = Math.sqrt(this.m[0] * this.m[0] + this.m[1] * this.m[1]);
            return new $b792be6a00d98dad$var$y(c, t / c);
        } else if (this.m[4] != 0 || this.m[5] != 0) {
            let t = this.m[0] * this.m[5] - this.m[1] * this.m[4], c = Math.sqrt(this.m[4] * this.m[4] + this.m[5] * this.m[5]);
            return new $b792be6a00d98dad$var$y(t / c, c);
        } else return new $b792be6a00d98dad$var$y(0, 0);
    }
    getRotation() {
        if (this.m[0] != 0 || this.m[1] != 0) {
            let t = Math.sqrt(this.m[0] * this.m[0] + this.m[1] * this.m[1]);
            return $b792be6a00d98dad$var$Je(this.m[1] > 0 ? Math.acos(this.m[0] / t) : -Math.acos(this.m[0] / t));
        } else if (this.m[4] != 0 || this.m[5] != 0) {
            let t = Math.sqrt(this.m[4] * this.m[4] + this.m[5] * this.m[5]);
            return $b792be6a00d98dad$var$Je(Math.PI / 2 - (this.m[5] > 0 ? Math.acos(-this.m[4] / t) : -Math.acos(this.m[4] / t)));
        } else return 0;
    }
    getSkew() {
        if (this.m[0] != 0 || this.m[1] != 0) {
            let t = Math.sqrt(this.m[0] * this.m[0] + this.m[1] * this.m[1]);
            return new $b792be6a00d98dad$var$y(Math.atan(this.m[0] * this.m[4] + this.m[1] * this.m[5]) / (t * t), 0);
        } else if (this.m[4] != 0 || this.m[5] != 0) {
            let t = Math.sqrt(this.m[4] * this.m[4] + this.m[5] * this.m[5]);
            return new $b792be6a00d98dad$var$y(0, Math.atan(this.m[0] * this.m[4] + this.m[1] * this.m[5]) / (t * t));
        } else return new $b792be6a00d98dad$var$y(0, 0);
    }
    invert() {
        let t = [], c = this.m[10] * this.m[15] - this.m[14] * this.m[11], w = this.m[9] * this.m[15] - this.m[13] * this.m[11], S = this.m[9] * this.m[14] - this.m[13] * this.m[10], L = this.m[8] * this.m[15] - this.m[12] * this.m[11], K = this.m[8] * this.m[14] - this.m[12] * this.m[10], j = this.m[8] * this.m[13] - this.m[12] * this.m[9], q = this.m[6] * this.m[15] - this.m[14] * this.m[7], Z = this.m[5] * this.m[15] - this.m[13] * this.m[7], ue = this.m[5] * this.m[14] - this.m[13] * this.m[6], U = this.m[4] * this.m[15] - this.m[12] * this.m[7], J = this.m[4] * this.m[14] - this.m[12] * this.m[6], d = this.m[5] * this.m[15] - this.m[13] * this.m[7], Q = this.m[4] * this.m[13] - this.m[12] * this.m[5], O = this.m[6] * this.m[11] - this.m[10] * this.m[7], He = this.m[5] * this.m[11] - this.m[9] * this.m[7], Ge = this.m[5] * this.m[10] - this.m[9] * this.m[6], v = this.m[4] * this.m[11] - this.m[8] * this.m[7], le = this.m[4] * this.m[10] - this.m[8] * this.m[6], pe = this.m[4] * this.m[9] - this.m[8] * this.m[5];
        t[0] = this.m[5] * c - this.m[6] * w + this.m[7] * S, t[4] = -(this.m[4] * c - this.m[6] * L + this.m[7] * K), t[8] = this.m[4] * w - this.m[5] * L + this.m[7] * j, t[12] = -(this.m[4] * S - this.m[5] * K + this.m[6] * j), t[1] = -(this.m[1] * c - this.m[2] * w + this.m[3] * S), t[5] = this.m[0] * c - this.m[2] * L + this.m[3] * K, t[9] = -(this.m[0] * w - this.m[1] * L + this.m[3] * j), t[13] = this.m[0] * S - this.m[1] * K + this.m[2] * j, t[2] = this.m[1] * q - this.m[2] * Z + this.m[3] * ue, t[6] = -(this.m[0] * q - this.m[2] * U + this.m[3] * J), t[10] = this.m[0] * d - this.m[1] * U + this.m[3] * Q, t[14] = -(this.m[0] * ue - this.m[1] * J + this.m[2] * Q), t[3] = -(this.m[1] * O - this.m[2] * He + this.m[3] * Ge), t[7] = this.m[0] * O - this.m[2] * v + this.m[3] * le, t[11] = -(this.m[0] * He - this.m[1] * v + this.m[3] * pe), t[15] = this.m[0] * Ge - this.m[1] * le + this.m[2] * pe;
        let ne = this.m[0] * t[0] + this.m[1] * t[4] + this.m[2] * t[8] + this.m[3] * t[12];
        for(let re = 0; re < 4; re++)for(let ye = 0; ye < 4; ye++)t[re * 4 + ye] *= 1 / ne;
        return new r(t);
    }
    clone() {
        return new r([
            ...this.m
        ]);
    }
    toString() {
        return this.m.toString();
    }
};
function $b792be6a00d98dad$var$Pn(r, t, c, w = (S)=>-Math.cos(S)) {
    return r + (w(c) + 1) / 2 * (t - r);
}
$b792be6a00d98dad$var$o($b792be6a00d98dad$var$Pn, "wave");
var $b792be6a00d98dad$var$pi = 1103515245, $b792be6a00d98dad$var$gi = 12345, $b792be6a00d98dad$var$ps = 2147483648, $b792be6a00d98dad$var$mt = class {
    static{
        $b792be6a00d98dad$var$o(this, "RNG");
    }
    seed;
    constructor(t){
        this.seed = t;
    }
    gen() {
        return this.seed = ($b792be6a00d98dad$var$pi * this.seed + $b792be6a00d98dad$var$gi) % $b792be6a00d98dad$var$ps, this.seed / $b792be6a00d98dad$var$ps;
    }
    genNumber(t, c) {
        return t + this.gen() * (c - t);
    }
    genVec2(t, c) {
        return new $b792be6a00d98dad$var$y(this.genNumber(t.x, c.x), this.genNumber(t.y, c.y));
    }
    genColor(t, c) {
        return new $b792be6a00d98dad$var$$(this.genNumber(t.r, c.r), this.genNumber(t.g, c.g), this.genNumber(t.b, c.b));
    }
    genAny(...t) {
        if (t.length === 0) return this.gen();
        if (t.length === 1) {
            if (typeof t[0] == "number") return this.genNumber(0, t[0]);
            if (t[0] instanceof $b792be6a00d98dad$var$y) return this.genVec2($b792be6a00d98dad$var$C(0, 0), t[0]);
            if (t[0] instanceof $b792be6a00d98dad$var$$) return this.genColor($b792be6a00d98dad$var$W(0, 0, 0), t[0]);
        } else if (t.length === 2) {
            if (typeof t[0] == "number" && typeof t[1] == "number") return this.genNumber(t[0], t[1]);
            if (t[0] instanceof $b792be6a00d98dad$var$y && t[1] instanceof $b792be6a00d98dad$var$y) return this.genVec2(t[0], t[1]);
            if (t[0] instanceof $b792be6a00d98dad$var$$ && t[1] instanceof $b792be6a00d98dad$var$$) return this.genColor(t[0], t[1]);
        }
    }
}, $b792be6a00d98dad$var$An = new $b792be6a00d98dad$var$mt(Date.now());
function $b792be6a00d98dad$var$vs(r) {
    return r != null && ($b792be6a00d98dad$var$An.seed = r), $b792be6a00d98dad$var$An.seed;
}
$b792be6a00d98dad$var$o($b792be6a00d98dad$var$vs, "randSeed");
function $b792be6a00d98dad$var$wt(...r) {
    return $b792be6a00d98dad$var$An.genAny(...r);
}
$b792be6a00d98dad$var$o($b792be6a00d98dad$var$wt, "rand");
function $b792be6a00d98dad$var$Mn(...r) {
    return Math.floor($b792be6a00d98dad$var$wt(...r));
}
$b792be6a00d98dad$var$o($b792be6a00d98dad$var$Mn, "randi");
function $b792be6a00d98dad$var$bs(r) {
    return $b792be6a00d98dad$var$wt() <= r;
}
$b792be6a00d98dad$var$o($b792be6a00d98dad$var$bs, "chance");
function $b792be6a00d98dad$var$ys(r) {
    return r[$b792be6a00d98dad$var$Mn(r.length)];
}
$b792be6a00d98dad$var$o($b792be6a00d98dad$var$ys, "choose");
function $b792be6a00d98dad$var$xs(r, t) {
    return r.pos.x + r.width > t.pos.x && r.pos.x < t.pos.x + t.width && r.pos.y + r.height > t.pos.y && r.pos.y < t.pos.y + t.height;
}
$b792be6a00d98dad$var$o($b792be6a00d98dad$var$xs, "testRectRect");
function $b792be6a00d98dad$var$wi(r, t) {
    if (r.p1.x === r.p2.x && r.p1.y === r.p2.y || t.p1.x === t.p2.x && t.p1.y === t.p2.y) return null;
    let c = (t.p2.y - t.p1.y) * (r.p2.x - r.p1.x) - (t.p2.x - t.p1.x) * (r.p2.y - r.p1.y);
    if (c === 0) return null;
    let w = ((t.p2.x - t.p1.x) * (r.p1.y - t.p1.y) - (t.p2.y - t.p1.y) * (r.p1.x - t.p1.x)) / c, S = ((r.p2.x - r.p1.x) * (r.p1.y - t.p1.y) - (r.p2.y - r.p1.y) * (r.p1.x - t.p1.x)) / c;
    return w < 0 || w > 1 || S < 0 || S > 1 ? null : w;
}
$b792be6a00d98dad$var$o($b792be6a00d98dad$var$wi, "testLineLineT");
function $b792be6a00d98dad$var$We(r, t) {
    let c = $b792be6a00d98dad$var$wi(r, t);
    return c ? $b792be6a00d98dad$var$C(r.p1.x + c * (r.p2.x - r.p1.x), r.p1.y + c * (r.p2.y - r.p1.y)) : null;
}
$b792be6a00d98dad$var$o($b792be6a00d98dad$var$We, "testLineLine");
function $b792be6a00d98dad$var$Us(r, t) {
    if ($b792be6a00d98dad$var$pt(r, t.p1) || $b792be6a00d98dad$var$pt(r, t.p2)) return !0;
    let c = r.points();
    return !!$b792be6a00d98dad$var$We(t, new $b792be6a00d98dad$var$Pe(c[0], c[1])) || !!$b792be6a00d98dad$var$We(t, new $b792be6a00d98dad$var$Pe(c[1], c[2])) || !!$b792be6a00d98dad$var$We(t, new $b792be6a00d98dad$var$Pe(c[2], c[3])) || !!$b792be6a00d98dad$var$We(t, new $b792be6a00d98dad$var$Pe(c[3], c[0]));
}
$b792be6a00d98dad$var$o($b792be6a00d98dad$var$Us, "testRectLine");
function $b792be6a00d98dad$var$pt(r, t) {
    return t.x > r.pos.x && t.x < r.pos.x + r.width && t.y > r.pos.y && t.y < r.pos.y + r.height;
}
$b792be6a00d98dad$var$o($b792be6a00d98dad$var$pt, "testRectPoint");
function $b792be6a00d98dad$var$Es(r, t) {
    let c = t.sub(r.p1), w = r.p2.sub(r.p1);
    if (Math.abs(c.cross(w)) > Number.EPSILON) return !1;
    let S = c.dot(w) / w.dot(w);
    return S >= 0 && S <= 1;
}
$b792be6a00d98dad$var$o($b792be6a00d98dad$var$Es, "testLinePoint");
function $b792be6a00d98dad$var$Rn(r, t) {
    let c = r.p2.sub(r.p1), w = c.dot(c), S = r.p1.sub(t.center), L = 2 * c.dot(S), K = S.dot(S) - t.radius * t.radius, j = L * L - 4 * w * K;
    if (w <= Number.EPSILON || j < 0) return !1;
    if (j == 0) {
        let q = -L / (2 * w);
        if (q >= 0 && q <= 1) return !0;
    } else {
        let q = (-L + Math.sqrt(j)) / (2 * w), Z = (-L - Math.sqrt(j)) / (2 * w);
        if (q >= 0 && q <= 1 || Z >= 0 && Z <= 1) return !0;
    }
    return $b792be6a00d98dad$var$Ss(t, r.p1);
}
$b792be6a00d98dad$var$o($b792be6a00d98dad$var$Rn, "testLineCircle");
function $b792be6a00d98dad$var$Ss(r, t) {
    return r.center.sdist(t) < r.radius * r.radius;
}
$b792be6a00d98dad$var$o($b792be6a00d98dad$var$Ss, "testCirclePoint");
function $b792be6a00d98dad$var$Cs(r, t) {
    let c = t.pts[t.pts.length - 1];
    for (let w of t.pts){
        if ($b792be6a00d98dad$var$Rn(new $b792be6a00d98dad$var$Pe(c, w), r)) return !0;
        c = w;
    }
    return $b792be6a00d98dad$var$Ss(r, t.pts[0]) ? !0 : $b792be6a00d98dad$var$Dn(t, r.center);
}
$b792be6a00d98dad$var$o($b792be6a00d98dad$var$Cs, "testCirclePolygon");
function $b792be6a00d98dad$var$Dn(r, t) {
    let c = !1, w = r.pts;
    for(let S = 0, L = w.length - 1; S < w.length; L = S++)w[S].y > t.y != w[L].y > t.y && t.x < (w[L].x - w[S].x) * (t.y - w[S].y) / (w[L].y - w[S].y) + w[S].x && (c = !c);
    return c;
}
$b792be6a00d98dad$var$o($b792be6a00d98dad$var$Dn, "testPolygonPoint");
var $b792be6a00d98dad$var$Pe = class r {
    static{
        $b792be6a00d98dad$var$o(this, "Line");
    }
    p1;
    p2;
    constructor(t, c){
        this.p1 = t.clone(), this.p2 = c.clone();
    }
    transform(t) {
        return new r(t.multVec2(this.p1), t.multVec2(this.p2));
    }
    bbox() {
        return $b792be6a00d98dad$var$he.fromPoints(this.p1, this.p2);
    }
    area() {
        return this.p1.dist(this.p2);
    }
    clone() {
        return new r(this.p1, this.p2);
    }
}, $b792be6a00d98dad$var$he = class r {
    static{
        $b792be6a00d98dad$var$o(this, "Rect");
    }
    pos;
    width;
    height;
    constructor(t, c, w){
        this.pos = t.clone(), this.width = c, this.height = w;
    }
    static fromPoints(t, c) {
        return new r(t.clone(), c.x - t.x, c.y - t.y);
    }
    center() {
        return new $b792be6a00d98dad$var$y(this.pos.x + this.width / 2, this.pos.y + this.height / 2);
    }
    points() {
        return [
            this.pos,
            this.pos.add(this.width, 0),
            this.pos.add(this.width, this.height),
            this.pos.add(0, this.height)
        ];
    }
    transform(t) {
        return new $b792be6a00d98dad$var$_e(this.points().map((c)=>t.multVec2(c)));
    }
    bbox() {
        return this.clone();
    }
    area() {
        return this.width * this.height;
    }
    clone() {
        return new r(this.pos.clone(), this.width, this.height);
    }
    distToPoint(t) {
        return Math.sqrt(this.sdistToPoint(t));
    }
    sdistToPoint(t) {
        let c = this.pos, w = this.pos.add(this.width, this.height), S = Math.max(c.x - t.x, 0, t.x - w.x), L = Math.max(c.y - t.y, 0, t.y - w.y);
        return S * S + L * L;
    }
}, $b792be6a00d98dad$var$gt = class r {
    static{
        $b792be6a00d98dad$var$o(this, "Circle");
    }
    center;
    radius;
    constructor(t, c){
        this.center = t.clone(), this.radius = c;
    }
    transform(t) {
        return new $b792be6a00d98dad$var$On(this.center, this.radius, this.radius).transform(t);
    }
    bbox() {
        return $b792be6a00d98dad$var$he.fromPoints(this.center.sub($b792be6a00d98dad$var$C(this.radius)), this.center.add($b792be6a00d98dad$var$C(this.radius)));
    }
    area() {
        return this.radius * this.radius * Math.PI;
    }
    clone() {
        return new r(this.center, this.radius);
    }
}, $b792be6a00d98dad$var$On = class r {
    static{
        $b792be6a00d98dad$var$o(this, "Ellipse");
    }
    center;
    radiusX;
    radiusY;
    constructor(t, c, w){
        this.center = t.clone(), this.radiusX = c, this.radiusY = w;
    }
    transform(t) {
        return new r(t.multVec2(this.center), t.m[0] * this.radiusX, t.m[5] * this.radiusY);
    }
    bbox() {
        return $b792be6a00d98dad$var$he.fromPoints(this.center.sub($b792be6a00d98dad$var$C(this.radiusX, this.radiusY)), this.center.add($b792be6a00d98dad$var$C(this.radiusX, this.radiusY)));
    }
    area() {
        return this.radiusX * this.radiusY * Math.PI;
    }
    clone() {
        return new r(this.center, this.radiusX, this.radiusY);
    }
}, $b792be6a00d98dad$var$_e = class r {
    static{
        $b792be6a00d98dad$var$o(this, "Polygon");
    }
    pts;
    constructor(t){
        if (t.length < 3) throw new Error("Polygons should have at least 3 vertices");
        this.pts = t;
    }
    transform(t) {
        return new r(this.pts.map((c)=>t.multVec2(c)));
    }
    bbox() {
        let t = $b792be6a00d98dad$var$C(Number.MAX_VALUE), c = $b792be6a00d98dad$var$C(-Number.MAX_VALUE);
        for (let w of this.pts)t.x = Math.min(t.x, w.x), c.x = Math.max(c.x, w.x), t.y = Math.min(t.y, w.y), c.y = Math.max(c.y, w.y);
        return $b792be6a00d98dad$var$he.fromPoints(t, c);
    }
    area() {
        let t = 0, c = this.pts.length;
        for(let w = 0; w < c; w++){
            let S = this.pts[w], L = this.pts[(w + 1) % c];
            t += S.x * L.y * .5, t -= L.x * S.y * .5;
        }
        return Math.abs(t);
    }
    clone() {
        return new r(this.pts.map((t)=>t.clone()));
    }
};
function $b792be6a00d98dad$var$Ts(r, t) {
    let c = Number.MAX_VALUE, w = $b792be6a00d98dad$var$C(0);
    for (let S of [
        r,
        t
    ])for(let L = 0; L < S.pts.length; L++){
        let K = S.pts[L], q = S.pts[(L + 1) % S.pts.length].sub(K).normal().unit(), Z = Number.MAX_VALUE, ue = -Number.MAX_VALUE;
        for(let Q = 0; Q < r.pts.length; Q++){
            let O = r.pts[Q].dot(q);
            Z = Math.min(Z, O), ue = Math.max(ue, O);
        }
        let U = Number.MAX_VALUE, J = -Number.MAX_VALUE;
        for(let Q = 0; Q < t.pts.length; Q++){
            let O = t.pts[Q].dot(q);
            U = Math.min(U, O), J = Math.max(J, O);
        }
        let d = Math.min(ue, J) - Math.max(Z, U);
        if (d < 0) return null;
        if (d < Math.abs(c)) {
            let Q = J - Z, O = U - ue;
            c = Math.abs(Q) < Math.abs(O) ? Q : O, w = q.scale(c);
        }
    }
    return w;
}
$b792be6a00d98dad$var$o($b792be6a00d98dad$var$Ts, "sat");
var $b792be6a00d98dad$var$vt = class extends Map {
    static{
        $b792be6a00d98dad$var$o(this, "IDList");
    }
    lastID;
    constructor(...t){
        super(...t), this.lastID = 0;
    }
    push(t) {
        let c = this.lastID;
        return this.set(c, t), this.lastID++, c;
    }
    pushd(t) {
        let c = this.push(t);
        return ()=>this.delete(c);
    }
}, $b792be6a00d98dad$var$Re = class r {
    static{
        $b792be6a00d98dad$var$o(this, "EventController");
    }
    paused = !1;
    cancel;
    constructor(t){
        this.cancel = t;
    }
    static join(t) {
        let c = new r(()=>t.forEach((w)=>w.cancel()));
        return Object.defineProperty(c, "paused", {
            get: ()=>t[0].paused,
            set: (w)=>t.forEach((S)=>S.paused = w)
        }), c.paused = !1, c;
    }
}, $b792be6a00d98dad$var$ve = class {
    static{
        $b792be6a00d98dad$var$o(this, "Event");
    }
    handlers = new $b792be6a00d98dad$var$vt;
    add(t) {
        let c = this.handlers.pushd((...S)=>{
            w.paused || t(...S);
        }), w = new $b792be6a00d98dad$var$Re(c);
        return w;
    }
    addOnce(t) {
        let c = this.add((...w)=>{
            c.cancel(), t(...w);
        });
        return c;
    }
    next() {
        return new Promise((t)=>this.addOnce(t));
    }
    trigger(...t) {
        this.handlers.forEach((c)=>c(...t));
    }
    numListeners() {
        return this.handlers.size;
    }
    clear() {
        this.handlers.clear();
    }
}, $b792be6a00d98dad$var$De = class {
    static{
        $b792be6a00d98dad$var$o(this, "EventHandler");
    }
    handlers = {};
    on(t, c) {
        return this.handlers[t] || (this.handlers[t] = new $b792be6a00d98dad$var$ve), this.handlers[t].add(c);
    }
    onOnce(t, c) {
        let w = this.on(t, (...S)=>{
            w.cancel(), c(...S);
        });
        return w;
    }
    next(t) {
        return new Promise((c)=>{
            this.onOnce(t, (...w)=>c(w[0]));
        });
    }
    trigger(t, ...c) {
        this.handlers[t] && this.handlers[t].trigger(...c);
    }
    remove(t) {
        delete this.handlers[t];
    }
    clear() {
        this.handlers = {};
    }
    numListeners(t) {
        return this.handlers[t]?.numListeners() ?? 0;
    }
};
function $b792be6a00d98dad$var$Gn(r, t) {
    let c = typeof r, w = typeof t;
    if (c !== w) return !1;
    if (c === "object" && w === "object" && r !== null && t !== null) {
        let S = Object.keys(r), L = Object.keys(t);
        if (S.length !== L.length) return !1;
        for (let K of S){
            let j = r[K], q = t[K];
            if (!(typeof j == "function" && typeof q == "function") && !$b792be6a00d98dad$var$Gn(j, q)) return !1;
        }
        return !0;
    }
    return r === t;
}
$b792be6a00d98dad$var$o($b792be6a00d98dad$var$Gn, "deepEq");
function $b792be6a00d98dad$var$vi(r) {
    let t = window.atob(r), c = t.length, w = new Uint8Array(c);
    for(let S = 0; S < c; S++)w[S] = t.charCodeAt(S);
    return w.buffer;
}
$b792be6a00d98dad$var$o($b792be6a00d98dad$var$vi, "base64ToArrayBuffer");
function $b792be6a00d98dad$var$As(r) {
    return $b792be6a00d98dad$var$vi(r.split(",")[1]);
}
$b792be6a00d98dad$var$o($b792be6a00d98dad$var$As, "dataURLToArrayBuffer");
function $b792be6a00d98dad$var$Ht(r, t) {
    let c = document.createElement("a");
    c.href = t, c.download = r, c.click();
}
$b792be6a00d98dad$var$o($b792be6a00d98dad$var$Ht, "download");
function $b792be6a00d98dad$var$Fn(r, t) {
    $b792be6a00d98dad$var$Ht(r, "data:text/plain;charset=utf-8," + t);
}
$b792be6a00d98dad$var$o($b792be6a00d98dad$var$Fn, "downloadText");
function $b792be6a00d98dad$var$Os(r, t) {
    $b792be6a00d98dad$var$Fn(r, JSON.stringify(t));
}
$b792be6a00d98dad$var$o($b792be6a00d98dad$var$Os, "downloadJSON");
function $b792be6a00d98dad$var$Bn(r, t) {
    let c = URL.createObjectURL(t);
    $b792be6a00d98dad$var$Ht(r, c), URL.revokeObjectURL(c);
}
$b792be6a00d98dad$var$o($b792be6a00d98dad$var$Bn, "downloadBlob");
var $b792be6a00d98dad$var$Ln = $b792be6a00d98dad$var$o((r)=>r.match(/^data:\w+\/\w+;base64,.+/), "isDataURL"), $b792be6a00d98dad$var$Ps = $b792be6a00d98dad$var$o((r)=>r.split(".").pop(), "getExt"), $b792be6a00d98dad$var$Ms = (()=>{
    let r = 0;
    return ()=>r++;
})();
var $b792be6a00d98dad$var$_t = class {
    static{
        $b792be6a00d98dad$var$o(this, "BinaryHeap");
    }
    _items;
    _compareFn;
    constructor(t = (c, w)=>c < w){
        this._compareFn = t, this._items = [];
    }
    insert(t) {
        this._items.push(t), this.moveUp(this._items.length - 1);
    }
    remove() {
        if (this._items.length === 0) return null;
        let t = this._items[0], c = this._items.pop();
        return this._items.length !== 0 && (this._items[0] = c, this.moveDown(0)), t;
    }
    clear() {
        this._items.splice(0, this._items.length);
    }
    moveUp(t) {
        for(; t > 0;){
            let c = Math.floor((t - 1) / 2);
            if (!this._compareFn(this._items[t], this._items[c]) && this._items[t] >= this._items[c]) break;
            this.swap(t, c), t = c;
        }
    }
    moveDown(t) {
        for(; t < Math.floor(this._items.length / 2);){
            let c = 2 * t + 1;
            if (c < this._items.length - 1 && !this._compareFn(this._items[c], this._items[c + 1]) && ++c, this._compareFn(this._items[t], this._items[c])) break;
            this.swap(t, c), t = c;
        }
    }
    swap(t, c) {
        [this._items[t], this._items[c]] = [
            this._items[c],
            this._items[t]
        ];
    }
    get length() {
        return this._items.length;
    }
};
var $b792be6a00d98dad$var$In = {
    "Joy-Con L+R (STANDARD GAMEPAD Vendor: 057e Product: 200e)": {
        buttons: {
            "0": "south",
            "1": "east",
            "2": "west",
            "3": "north",
            "4": "lshoulder",
            "5": "rshoulder",
            "6": "ltrigger",
            "7": "rtrigger",
            "8": "select",
            "9": "start",
            "10": "lstick",
            "11": "rstick",
            "12": "dpad-up",
            "13": "dpad-down",
            "14": "dpad-left",
            "15": "dpad-right",
            "16": "home",
            "17": "capture"
        },
        sticks: {
            left: {
                x: 0,
                y: 1
            },
            right: {
                x: 2,
                y: 3
            }
        }
    },
    "Joy-Con (L) (STANDARD GAMEPAD Vendor: 057e Product: 2006)": {
        buttons: {
            "0": "south",
            "1": "east",
            "2": "west",
            "3": "north",
            "4": "lshoulder",
            "5": "rshoulder",
            "9": "select",
            "10": "lstick",
            "16": "start"
        },
        sticks: {
            left: {
                x: 0,
                y: 1
            }
        }
    },
    "Joy-Con (R) (STANDARD GAMEPAD Vendor: 057e Product: 2007)": {
        buttons: {
            "0": "south",
            "1": "east",
            "2": "west",
            "3": "north",
            "4": "lshoulder",
            "5": "rshoulder",
            "9": "start",
            "10": "lstick",
            "16": "select"
        },
        sticks: {
            left: {
                x: 0,
                y: 1
            }
        }
    },
    "Pro Controller (STANDARD GAMEPAD Vendor: 057e Product: 2009)": {
        buttons: {
            "0": "south",
            "1": "east",
            "2": "west",
            "3": "north",
            "4": "lshoulder",
            "5": "rshoulder",
            "6": "ltrigger",
            "7": "rtrigger",
            "8": "select",
            "9": "start",
            "10": "lstick",
            "11": "rstick",
            "12": "dpad-up",
            "13": "dpad-down",
            "14": "dpad-left",
            "15": "dpad-right",
            "16": "home",
            "17": "capture"
        },
        sticks: {
            left: {
                x: 0,
                y: 1
            },
            right: {
                x: 2,
                y: 3
            }
        }
    },
    default: {
        buttons: {
            "0": "south",
            "1": "east",
            "2": "west",
            "3": "north",
            "4": "lshoulder",
            "5": "rshoulder",
            "6": "ltrigger",
            "7": "rtrigger",
            "8": "select",
            "9": "start",
            "10": "lstick",
            "11": "rstick",
            "12": "dpad-up",
            "13": "dpad-down",
            "14": "dpad-left",
            "15": "dpad-right",
            "16": "home"
        },
        sticks: {
            left: {
                x: 0,
                y: 1
            },
            right: {
                x: 2,
                y: 3
            }
        }
    }
};
var $b792be6a00d98dad$var$Qe = class {
    static{
        $b792be6a00d98dad$var$o(this, "ButtonState");
    }
    pressed = new Set([]);
    pressedRepeat = new Set([]);
    released = new Set([]);
    down = new Set([]);
    update() {
        this.pressed.clear(), this.released.clear(), this.pressedRepeat.clear();
    }
    press(t) {
        this.pressed.add(t), this.pressedRepeat.add(t), this.down.add(t);
    }
    pressRepeat(t) {
        this.pressedRepeat.add(t);
    }
    release(t) {
        this.down.delete(t), this.pressed.delete(t), this.released.add(t);
    }
}, $b792be6a00d98dad$var$Vn = class {
    static{
        $b792be6a00d98dad$var$o(this, "GamepadState");
    }
    buttonState = new $b792be6a00d98dad$var$Qe;
    stickState = new Map;
}, $b792be6a00d98dad$var$kn = class {
    static{
        $b792be6a00d98dad$var$o(this, "FPSCounter");
    }
    dts = [];
    timer = 0;
    fps = 0;
    tick(t) {
        this.dts.push(t), this.timer += t, this.timer >= 1 && (this.timer = 0, this.fps = Math.round(1 / (this.dts.reduce((c, w)=>c + w) / this.dts.length)), this.dts = []);
    }
}, $b792be6a00d98dad$var$Rs = $b792be6a00d98dad$var$o((r)=>{
    if (!r.canvas) throw new Error("Please provide a canvas");
    let t = {
        canvas: r.canvas,
        loopID: null,
        stopped: !1,
        dt: 0,
        time: 0,
        realTime: 0,
        fpsCounter: new $b792be6a00d98dad$var$kn,
        timeScale: 1,
        skipTime: !1,
        numFrames: 0,
        mousePos: new $b792be6a00d98dad$var$y(0),
        mouseDeltaPos: new $b792be6a00d98dad$var$y(0),
        keyState: new $b792be6a00d98dad$var$Qe,
        mouseState: new $b792be6a00d98dad$var$Qe,
        mergedGamepadState: new $b792be6a00d98dad$var$Vn,
        gamepadStates: new Map,
        gamepads: [],
        charInputted: [],
        isMouseMoved: !1,
        lastWidth: r.canvas.offsetWidth,
        lastHeight: r.canvas.offsetHeight,
        events: new $b792be6a00d98dad$var$De
    };
    function c() {
        return t.canvas;
    }
    $b792be6a00d98dad$var$o(c, "canvas");
    function w() {
        return t.dt * t.timeScale;
    }
    $b792be6a00d98dad$var$o(w, "dt");
    function S() {
        return t.time;
    }
    $b792be6a00d98dad$var$o(S, "time");
    function L() {
        return t.fpsCounter.fps;
    }
    $b792be6a00d98dad$var$o(L, "fps");
    function K() {
        return t.numFrames;
    }
    $b792be6a00d98dad$var$o(K, "numFrames");
    function j() {
        return t.canvas.toDataURL();
    }
    $b792be6a00d98dad$var$o(j, "screenshot");
    function q(l) {
        t.canvas.style.cursor = l;
    }
    $b792be6a00d98dad$var$o(q, "setCursor");
    function Z() {
        return t.canvas.style.cursor;
    }
    $b792be6a00d98dad$var$o(Z, "getCursor");
    function ue(l) {
        if (l) try {
            let x = t.canvas.requestPointerLock();
            x.catch && x.catch((T)=>console.error(T));
        } catch (x) {
            console.error(x);
        }
        else document.exitPointerLock();
    }
    $b792be6a00d98dad$var$o(ue, "setCursorLocked");
    function U() {
        return !!document.pointerLockElement;
    }
    $b792be6a00d98dad$var$o(U, "isCursorLocked");
    function J(l) {
        l.requestFullscreen ? l.requestFullscreen() : l.webkitRequestFullscreen && l.webkitRequestFullscreen();
    }
    $b792be6a00d98dad$var$o(J, "enterFullscreen");
    function d() {
        document.exitFullscreen ? document.exitFullscreen() : document.webkitExitFullScreen && document.webkitExitFullScreen();
    }
    $b792be6a00d98dad$var$o(d, "exitFullscreen");
    function Q() {
        return document.fullscreenElement || document.webkitFullscreenElement;
    }
    $b792be6a00d98dad$var$o(Q, "getFullscreenElement");
    function O(l = !0) {
        l ? J(t.canvas) : d();
    }
    $b792be6a00d98dad$var$o(O, "setFullscreen");
    function He() {
        return !!Q();
    }
    $b792be6a00d98dad$var$o(He, "isFullscreen");
    function Ge() {
        t.stopped = !0;
        for(let l in ce)t.canvas.removeEventListener(l, ce[l]);
        for(let l in me)document.removeEventListener(l, me[l]);
        for(let l in Te)window.removeEventListener(l, Te[l]);
        Dt.disconnect();
    }
    $b792be6a00d98dad$var$o(Ge, "quit");
    function v(l) {
        t.loopID !== null && cancelAnimationFrame(t.loopID);
        let x = 0, T = $b792be6a00d98dad$var$o((V)=>{
            if (t.stopped) return;
            if (document.visibilityState !== "visible") {
                t.loopID = requestAnimationFrame(T);
                return;
            }
            let ee = V / 1e3, z = ee - t.realTime, Ae = r.maxFPS ? 1 / r.maxFPS : 0;
            t.realTime = ee, x += z, x > Ae && (t.skipTime || (t.dt = x, t.time += w(), t.fpsCounter.tick(t.dt)), x = 0, t.skipTime = !1, t.numFrames++, hn(), l(), Ot()), t.loopID = requestAnimationFrame(T);
        }, "frame");
        T(0);
    }
    $b792be6a00d98dad$var$o(v, "run");
    function le() {
        return "ontouchstart" in window || navigator.maxTouchPoints > 0;
    }
    $b792be6a00d98dad$var$o(le, "isTouchscreen");
    function pe() {
        return t.mousePos.clone();
    }
    $b792be6a00d98dad$var$o(pe, "mousePos");
    function ne() {
        return t.mouseDeltaPos.clone();
    }
    $b792be6a00d98dad$var$o(ne, "mouseDeltaPos");
    function re(l = "left") {
        return t.mouseState.pressed.has(l);
    }
    $b792be6a00d98dad$var$o(re, "isMousePressed");
    function ye(l = "left") {
        return t.mouseState.down.has(l);
    }
    $b792be6a00d98dad$var$o(ye, "isMouseDown");
    function k(l = "left") {
        return t.mouseState.released.has(l);
    }
    $b792be6a00d98dad$var$o(k, "isMouseReleased");
    function A() {
        return t.isMouseMoved;
    }
    $b792be6a00d98dad$var$o(A, "isMouseMoved");
    function tt(l) {
        return l === void 0 ? t.keyState.pressed.size > 0 : t.keyState.pressed.has(l);
    }
    $b792be6a00d98dad$var$o(tt, "isKeyPressed");
    function Ce(l) {
        return l === void 0 ? t.keyState.pressedRepeat.size > 0 : t.keyState.pressedRepeat.has(l);
    }
    $b792be6a00d98dad$var$o(Ce, "isKeyPressedRepeat");
    function Xt(l) {
        return l === void 0 ? t.keyState.down.size > 0 : t.keyState.down.has(l);
    }
    $b792be6a00d98dad$var$o(Xt, "isKeyDown");
    function nt(l) {
        return l === void 0 ? t.keyState.released.size > 0 : t.keyState.released.has(l);
    }
    $b792be6a00d98dad$var$o(nt, "isKeyReleased");
    function qe(l) {
        return l === void 0 ? t.mergedGamepadState.buttonState.pressed.size > 0 : t.mergedGamepadState.buttonState.pressed.has(l);
    }
    $b792be6a00d98dad$var$o(qe, "isGamepadButtonPressed");
    function Wt(l) {
        return l === void 0 ? t.mergedGamepadState.buttonState.down.size > 0 : t.mergedGamepadState.buttonState.down.has(l);
    }
    $b792be6a00d98dad$var$o(Wt, "isGamepadButtonDown");
    function Jt(l) {
        return l === void 0 ? t.mergedGamepadState.buttonState.released.size > 0 : t.mergedGamepadState.buttonState.released.has(l);
    }
    $b792be6a00d98dad$var$o(Jt, "isGamepadButtonReleased");
    function $e(l) {
        return t.events.on("resize", l);
    }
    $b792be6a00d98dad$var$o($e, "onResize");
    let Qt = $b792be6a00d98dad$var$o((l, x)=>{
        if (typeof l == "function") return t.events.on("keyDown", l);
        if (typeof l == "string" && typeof x == "function") return t.events.on("keyDown", (T)=>T === l && x(l));
    }, "onKeyDown"), Ke = $b792be6a00d98dad$var$o((l, x)=>{
        if (typeof l == "function") return t.events.on("keyPress", l);
        if (typeof l == "string" && typeof x == "function") return t.events.on("keyPress", (T)=>T === l && x(l));
    }, "onKeyPress"), Zt = $b792be6a00d98dad$var$o((l, x)=>{
        if (typeof l == "function") return t.events.on("keyPressRepeat", l);
        if (typeof l == "string" && typeof x == "function") return t.events.on("keyPressRepeat", (T)=>T === l && x(l));
    }, "onKeyPressRepeat"), en = $b792be6a00d98dad$var$o((l, x)=>{
        if (typeof l == "function") return t.events.on("keyRelease", l);
        if (typeof l == "string" && typeof x == "function") return t.events.on("keyRelease", (T)=>T === l && x(l));
    }, "onKeyRelease");
    function yt(l, x) {
        return typeof l == "function" ? t.events.on("mouseDown", (T)=>l(T)) : t.events.on("mouseDown", (T)=>T === l && x(T));
    }
    $b792be6a00d98dad$var$o(yt, "onMouseDown");
    function xt(l, x) {
        return typeof l == "function" ? t.events.on("mousePress", (T)=>l(T)) : t.events.on("mousePress", (T)=>T === l && x(T));
    }
    $b792be6a00d98dad$var$o(xt, "onMousePress");
    function Ut(l, x) {
        return typeof l == "function" ? t.events.on("mouseRelease", (T)=>l(T)) : t.events.on("mouseRelease", (T)=>T === l && x(T));
    }
    $b792be6a00d98dad$var$o(Ut, "onMouseRelease");
    function Le(l) {
        return t.events.on("mouseMove", ()=>l(pe(), ne()));
    }
    $b792be6a00d98dad$var$o(Le, "onMouseMove");
    function tn(l) {
        return t.events.on("charInput", l);
    }
    $b792be6a00d98dad$var$o(tn, "onCharInput");
    function nn(l) {
        return t.events.on("touchStart", l);
    }
    $b792be6a00d98dad$var$o(nn, "onTouchStart");
    function sn(l) {
        return t.events.on("touchMove", l);
    }
    $b792be6a00d98dad$var$o(sn, "onTouchMove");
    function rn(l) {
        return t.events.on("touchEnd", l);
    }
    $b792be6a00d98dad$var$o(rn, "onTouchEnd");
    function on(l) {
        return t.events.on("scroll", l);
    }
    $b792be6a00d98dad$var$o(on, "onScroll");
    function an(l) {
        return t.events.on("hide", l);
    }
    $b792be6a00d98dad$var$o(an, "onHide");
    function Et(l) {
        return t.events.on("show", l);
    }
    $b792be6a00d98dad$var$o(Et, "onShow");
    function St(l, x) {
        if (typeof l == "function") return t.events.on("gamepadButtonDown", l);
        if (typeof l == "string" && typeof x == "function") return t.events.on("gamepadButtonDown", (T)=>T === l && x(l));
    }
    $b792be6a00d98dad$var$o(St, "onGamepadButtonDown");
    function Ct(l, x) {
        if (typeof l == "function") return t.events.on("gamepadButtonPress", l);
        if (typeof l == "string" && typeof x == "function") return t.events.on("gamepadButtonPress", (T)=>T === l && x(l));
    }
    $b792be6a00d98dad$var$o(Ct, "onGamepadButtonPress");
    function Tt(l, x) {
        if (typeof l == "function") return t.events.on("gamepadButtonRelease", l);
        if (typeof l == "string" && typeof x == "function") return t.events.on("gamepadButtonRelease", (T)=>T === l && x(l));
    }
    $b792be6a00d98dad$var$o(Tt, "onGamepadButtonRelease");
    function At(l, x) {
        return t.events.on("gamepadStick", (T, V)=>T === l && x(V));
    }
    $b792be6a00d98dad$var$o(At, "onGamepadStick");
    function un(l) {
        t.events.on("gamepadConnect", l);
    }
    $b792be6a00d98dad$var$o(un, "onGamepadConnect");
    function st(l) {
        t.events.on("gamepadDisconnect", l);
    }
    $b792be6a00d98dad$var$o(st, "onGamepadDisconnect");
    function cn(l) {
        return t.mergedGamepadState.stickState.get(l) || new $b792be6a00d98dad$var$y(0);
    }
    $b792be6a00d98dad$var$o(cn, "getGamepadStick");
    function ln() {
        return [
            ...t.charInputted
        ];
    }
    $b792be6a00d98dad$var$o(ln, "charInputted");
    function rt() {
        return [
            ...t.gamepads
        ];
    }
    $b792be6a00d98dad$var$o(rt, "getGamepads");
    function hn() {
        t.events.trigger("input"), t.keyState.down.forEach((l)=>t.events.trigger("keyDown", l)), t.mouseState.down.forEach((l)=>t.events.trigger("mouseDown", l)), dn();
    }
    $b792be6a00d98dad$var$o(hn, "processInput");
    function Ot() {
        t.keyState.update(), t.mouseState.update(), t.mergedGamepadState.buttonState.update(), t.mergedGamepadState.stickState.forEach((l, x)=>{
            t.mergedGamepadState.stickState.set(x, new $b792be6a00d98dad$var$y(0));
        }), t.charInputted = [], t.isMouseMoved = !1, t.gamepadStates.forEach((l)=>{
            l.buttonState.update(), l.stickState.forEach((x, T)=>{
                l.stickState.set(T, new $b792be6a00d98dad$var$y(0));
            });
        });
    }
    $b792be6a00d98dad$var$o(Ot, "resetInput");
    function it(l) {
        let x = {
            index: l.index,
            isPressed: (T)=>t.gamepadStates.get(l.index).buttonState.pressed.has(T),
            isDown: (T)=>t.gamepadStates.get(l.index).buttonState.down.has(T),
            isReleased: (T)=>t.gamepadStates.get(l.index).buttonState.released.has(T),
            getStick: (T)=>t.gamepadStates.get(l.index).stickState.get(T)
        };
        return t.gamepads.push(x), t.gamepadStates.set(l.index, {
            buttonState: new $b792be6a00d98dad$var$Qe,
            stickState: new Map([
                [
                    "left",
                    new $b792be6a00d98dad$var$y(0)
                ],
                [
                    "right",
                    new $b792be6a00d98dad$var$y(0)
                ]
            ])
        }), x;
    }
    $b792be6a00d98dad$var$o(it, "registerGamepad");
    function ot(l) {
        t.gamepads = t.gamepads.filter((x)=>x.index !== l.index), t.gamepadStates.delete(l.index);
    }
    $b792be6a00d98dad$var$o(ot, "removeGamepad");
    function dn() {
        for (let l of navigator.getGamepads())l && !t.gamepadStates.has(l.index) && it(l);
        for (let l of t.gamepads){
            let x = navigator.getGamepads()[l.index], V = (r.gamepads ?? {})[x.id] ?? $b792be6a00d98dad$var$In[x.id] ?? $b792be6a00d98dad$var$In.default, ee = t.gamepadStates.get(l.index);
            for(let z = 0; z < x.buttons.length; z++)x.buttons[z].pressed ? (ee.buttonState.down.has(V.buttons[z]) || (t.mergedGamepadState.buttonState.press(V.buttons[z]), ee.buttonState.press(V.buttons[z]), t.events.trigger("gamepadButtonPress", V.buttons[z])), t.events.trigger("gamepadButtonDown", V.buttons[z])) : ee.buttonState.down.has(V.buttons[z]) && (t.mergedGamepadState.buttonState.release(V.buttons[z]), ee.buttonState.release(V.buttons[z]), t.events.trigger("gamepadButtonRelease", V.buttons[z]));
            for(let z in V.sticks){
                let Ae = V.sticks[z], at = new $b792be6a00d98dad$var$y(x.axes[Ae.x], x.axes[Ae.y]);
                ee.stickState.set(z, at), t.mergedGamepadState.stickState.set(z, at), t.events.trigger("gamepadStick", z, at);
            }
        }
    }
    $b792be6a00d98dad$var$o(dn, "processGamepad");
    let ce = {}, me = {}, Te = {};
    ce.mousemove = (l)=>{
        let x = new $b792be6a00d98dad$var$y(l.offsetX, l.offsetY), T = new $b792be6a00d98dad$var$y(l.movementX, l.movementY);
        t.events.onOnce("input", ()=>{
            t.isMouseMoved = !0, t.mousePos = x, t.mouseDeltaPos = T, t.events.trigger("mouseMove");
        });
    };
    let Pt = [
        "left",
        "middle",
        "right",
        "back",
        "forward"
    ];
    ce.mousedown = (l)=>{
        t.events.onOnce("input", ()=>{
            let x = Pt[l.button];
            x && (t.mouseState.press(x), t.events.trigger("mousePress", x));
        });
    }, ce.mouseup = (l)=>{
        t.events.onOnce("input", ()=>{
            let x = Pt[l.button];
            x && (t.mouseState.release(x), t.events.trigger("mouseRelease", x));
        });
    };
    let Mt = new Set([
        " ",
        "ArrowLeft",
        "ArrowRight",
        "ArrowUp",
        "ArrowDown",
        "Tab"
    ]), Rt = {
        ArrowLeft: "left",
        ArrowRight: "right",
        ArrowUp: "up",
        ArrowDown: "down",
        " ": "space"
    };
    ce.keydown = (l)=>{
        Mt.has(l.key) && l.preventDefault(), t.events.onOnce("input", ()=>{
            let x = Rt[l.key] || l.key.toLowerCase();
            x.length === 1 ? (t.events.trigger("charInput", x), t.charInputted.push(x)) : x === "space" && (t.events.trigger("charInput", " "), t.charInputted.push(" ")), l.repeat ? (t.keyState.pressRepeat(x), t.events.trigger("keyPressRepeat", x)) : (t.keyState.press(x), t.events.trigger("keyPressRepeat", x), t.events.trigger("keyPress", x));
        });
    }, ce.keyup = (l)=>{
        t.events.onOnce("input", ()=>{
            let x = Rt[l.key] || l.key.toLowerCase();
            t.keyState.release(x), t.events.trigger("keyRelease", x);
        });
    }, ce.touchstart = (l)=>{
        l.preventDefault(), t.events.onOnce("input", ()=>{
            let x = [
                ...l.changedTouches
            ], T = t.canvas.getBoundingClientRect();
            r.touchToMouse !== !1 && (t.mousePos = new $b792be6a00d98dad$var$y(x[0].clientX - T.x, x[0].clientY - T.y), t.mouseState.press("left"), t.events.trigger("mousePress", "left")), x.forEach((V)=>{
                t.events.trigger("touchStart", new $b792be6a00d98dad$var$y(V.clientX - T.x, V.clientY - T.y), V);
            });
        });
    }, ce.touchmove = (l)=>{
        l.preventDefault(), t.events.onOnce("input", ()=>{
            let x = [
                ...l.changedTouches
            ], T = t.canvas.getBoundingClientRect();
            r.touchToMouse !== !1 && (t.mousePos = new $b792be6a00d98dad$var$y(x[0].clientX - T.x, x[0].clientY - T.y), t.events.trigger("mouseMove")), x.forEach((V)=>{
                t.events.trigger("touchMove", new $b792be6a00d98dad$var$y(V.clientX - T.x, V.clientY - T.y), V);
            });
        });
    }, ce.touchend = (l)=>{
        t.events.onOnce("input", ()=>{
            let x = [
                ...l.changedTouches
            ], T = t.canvas.getBoundingClientRect();
            r.touchToMouse !== !1 && (t.mousePos = new $b792be6a00d98dad$var$y(x[0].clientX - T.x, x[0].clientY - T.y), t.mouseState.release("left"), t.events.trigger("mouseRelease", "left")), x.forEach((V)=>{
                t.events.trigger("touchEnd", new $b792be6a00d98dad$var$y(V.clientX - T.x, V.clientY - T.y), V);
            });
        });
    }, ce.touchcancel = (l)=>{
        t.events.onOnce("input", ()=>{
            let x = [
                ...l.changedTouches
            ], T = t.canvas.getBoundingClientRect();
            r.touchToMouse !== !1 && (t.mousePos = new $b792be6a00d98dad$var$y(x[0].clientX - T.x, x[0].clientY - T.y), t.mouseState.release("left"), t.events.trigger("mouseRelease", "left")), x.forEach((V)=>{
                t.events.trigger("touchEnd", new $b792be6a00d98dad$var$y(V.clientX - T.x, V.clientY - T.y), V);
            });
        });
    }, ce.wheel = (l)=>{
        l.preventDefault(), t.events.onOnce("input", ()=>{
            t.events.trigger("scroll", new $b792be6a00d98dad$var$y(l.deltaX, l.deltaY));
        });
    }, ce.contextmenu = (l)=>l.preventDefault(), me.visibilitychange = ()=>{
        document.visibilityState === "visible" ? (t.skipTime = !0, t.events.trigger("show")) : t.events.trigger("hide");
    }, Te.gamepadconnected = (l)=>{
        let x = it(l.gamepad);
        t.events.onOnce("input", ()=>{
            t.events.trigger("gamepadConnect", x);
        });
    }, Te.gamepaddisconnected = (l)=>{
        let x = rt().filter((T)=>T.index === l.gamepad.index)[0];
        ot(l.gamepad), t.events.onOnce("input", ()=>{
            t.events.trigger("gamepadDisconnect", x);
        });
    };
    for(let l in ce)t.canvas.addEventListener(l, ce[l]);
    for(let l in me)document.addEventListener(l, me[l]);
    for(let l in Te)window.addEventListener(l, Te[l]);
    let Dt = new ResizeObserver((l)=>{
        for (let x of l)if (x.target === t.canvas) {
            if (t.lastWidth === t.canvas.offsetWidth && t.lastHeight === t.canvas.offsetHeight) return;
            t.lastWidth = t.canvas.offsetWidth, t.lastHeight = t.canvas.offsetHeight, t.events.onOnce("input", ()=>{
                t.events.trigger("resize");
            });
        }
    });
    return Dt.observe(t.canvas), {
        dt: w,
        time: S,
        run: v,
        canvas: c,
        fps: L,
        numFrames: K,
        quit: Ge,
        setFullscreen: O,
        isFullscreen: He,
        setCursor: q,
        screenshot: j,
        getGamepads: rt,
        getCursor: Z,
        setCursorLocked: ue,
        isCursorLocked: U,
        isTouchscreen: le,
        mousePos: pe,
        mouseDeltaPos: ne,
        isKeyDown: Xt,
        isKeyPressed: tt,
        isKeyPressedRepeat: Ce,
        isKeyReleased: nt,
        isMouseDown: ye,
        isMousePressed: re,
        isMouseReleased: k,
        isMouseMoved: A,
        isGamepadButtonPressed: qe,
        isGamepadButtonDown: Wt,
        isGamepadButtonReleased: Jt,
        getGamepadStick: cn,
        charInputted: ln,
        onResize: $e,
        onKeyDown: Qt,
        onKeyPress: Ke,
        onKeyPressRepeat: Zt,
        onKeyRelease: en,
        onMouseDown: yt,
        onMousePress: xt,
        onMouseRelease: Ut,
        onMouseMove: Le,
        onCharInput: tn,
        onTouchStart: nn,
        onTouchMove: sn,
        onTouchEnd: rn,
        onScroll: on,
        onHide: an,
        onShow: Et,
        onGamepadButtonDown: St,
        onGamepadButtonPress: Ct,
        onGamepadButtonRelease: Tt,
        onGamepadStick: At,
        onGamepadConnect: un,
        onGamepadDisconnect: st,
        events: t.events
    };
}, "default");
var $b792be6a00d98dad$var$qt = 2.5949095, $b792be6a00d98dad$var$Ds = 2.70158, $b792be6a00d98dad$var$Gs = 2 * Math.PI / 3, $b792be6a00d98dad$var$Fs = 2 * Math.PI / 4.5, $b792be6a00d98dad$var$$t = {
    linear: (r)=>r,
    easeInSine: (r)=>1 - Math.cos(r * Math.PI / 2),
    easeOutSine: (r)=>Math.sin(r * Math.PI / 2),
    easeInOutSine: (r)=>-(Math.cos(Math.PI * r) - 1) / 2,
    easeInQuad: (r)=>r * r,
    easeOutQuad: (r)=>1 - (1 - r) * (1 - r),
    easeInOutQuad: (r)=>r < .5 ? 2 * r * r : 1 - Math.pow(-2 * r + 2, 2) / 2,
    easeInCubic: (r)=>r * r * r,
    easeOutCubic: (r)=>1 - Math.pow(1 - r, 3),
    easeInOutCubic: (r)=>r < .5 ? 4 * r * r * r : 1 - Math.pow(-2 * r + 2, 3) / 2,
    easeInQuart: (r)=>r * r * r * r,
    easeOutQuart: (r)=>1 - Math.pow(1 - r, 4),
    easeInOutQuart: (r)=>r < .5 ? 8 * r * r * r * r : 1 - Math.pow(-2 * r + 2, 4) / 2,
    easeInQuint: (r)=>r * r * r * r * r,
    easeOutQuint: (r)=>1 - Math.pow(1 - r, 5),
    easeInOutQuint: (r)=>r < .5 ? 16 * r * r * r * r * r : 1 - Math.pow(-2 * r + 2, 5) / 2,
    easeInExpo: (r)=>r === 0 ? 0 : Math.pow(2, 10 * r - 10),
    easeOutExpo: (r)=>r === 1 ? 1 : 1 - Math.pow(2, -10 * r),
    easeInOutExpo: (r)=>r === 0 ? 0 : r === 1 ? 1 : r < .5 ? Math.pow(2, 20 * r - 10) / 2 : (2 - Math.pow(2, -20 * r + 10)) / 2,
    easeInCirc: (r)=>1 - Math.sqrt(1 - Math.pow(r, 2)),
    easeOutCirc: (r)=>Math.sqrt(1 - Math.pow(r - 1, 2)),
    easeInOutCirc: (r)=>r < .5 ? (1 - Math.sqrt(1 - Math.pow(2 * r, 2))) / 2 : (Math.sqrt(1 - Math.pow(-2 * r + 2, 2)) + 1) / 2,
    easeInBack: (r)=>$b792be6a00d98dad$var$Ds * r * r * r - 1.70158 * r * r,
    easeOutBack: (r)=>1 + $b792be6a00d98dad$var$Ds * Math.pow(r - 1, 3) + 1.70158 * Math.pow(r - 1, 2),
    easeInOutBack: (r)=>r < .5 ? Math.pow(2 * r, 2) * (($b792be6a00d98dad$var$qt + 1) * 2 * r - $b792be6a00d98dad$var$qt) / 2 : (Math.pow(2 * r - 2, 2) * (($b792be6a00d98dad$var$qt + 1) * (r * 2 - 2) + $b792be6a00d98dad$var$qt) + 2) / 2,
    easeInElastic: (r)=>r === 0 ? 0 : r === 1 ? 1 : -Math.pow(2, 10 * r - 10) * Math.sin((r * 10 - 10.75) * $b792be6a00d98dad$var$Gs),
    easeOutElastic: (r)=>r === 0 ? 0 : r === 1 ? 1 : Math.pow(2, -10 * r) * Math.sin((r * 10 - .75) * $b792be6a00d98dad$var$Gs) + 1,
    easeInOutElastic: (r)=>r === 0 ? 0 : r === 1 ? 1 : r < .5 ? -(Math.pow(2, 20 * r - 10) * Math.sin((20 * r - 11.125) * $b792be6a00d98dad$var$Fs)) / 2 : Math.pow(2, -20 * r + 10) * Math.sin((20 * r - 11.125) * $b792be6a00d98dad$var$Fs) / 2 + 1,
    easeInBounce: (r)=>1 - $b792be6a00d98dad$var$$t.easeOutBounce(1 - r),
    easeOutBounce: (r)=>r < 1 / 2.75 ? 7.5625 * r * r : r < 2 / 2.75 ? 7.5625 * (r -= 1.5 / 2.75) * r + .75 : r < 2.5 / 2.75 ? 7.5625 * (r -= 2.25 / 2.75) * r + .9375 : 7.5625 * (r -= 2.625 / 2.75) * r + .984375,
    easeInOutBounce: (r)=>r < .5 ? (1 - $b792be6a00d98dad$var$$t.easeOutBounce(1 - 2 * r)) / 2 : (1 + $b792be6a00d98dad$var$$t.easeOutBounce(2 * r - 1)) / 2
}, $b792be6a00d98dad$var$Ze = $b792be6a00d98dad$var$$t;
var $b792be6a00d98dad$var$bt = class {
    static{
        $b792be6a00d98dad$var$o(this, "Timer");
    }
    time;
    action;
    finished = !1;
    paused = !1;
    constructor(t, c){
        this.time = t, this.action = c;
    }
    tick(t) {
        return this.finished || this.paused ? !1 : (this.time -= t, this.time <= 0 ? (this.action(), this.finished = !0, this.time = 0, !0) : !1);
    }
    reset(t) {
        this.time = t, this.finished = !1;
    }
};
var $b792be6a00d98dad$var$Bs = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD0AAAA1CAYAAADyMeOEAAAAAXNSR0IArs4c6QAAAoVJREFUaIHdm7txwkAQhheGAqACiCHzOKQDQrqgILpwSAeEDBnEUAF0gCMxZ7G72qce/mec2Lpf9+3unaS78wgSNZ8uX5729+d1FNWXUuGmXlBOUUEIMckEpeQJgBu6C+BSFngztBR2vd+ovY+7g+p6LbgaWgJrAeUkDYIUXgXdBBwNi6kpABJwMTQH3AZsXRR8GHTfgEth8E3gjdAUcNewpbTgY85sCMCUuOokozE0YM0YRzM9NGAAXd8+omAF5h4lnmBRvpSnZHyLoLEbaN+aKB9KWv/KWw0tAbbANnlG+UvB2dm77NxxdwgBpjrF/d7rW9cbmpvio2A5z8iAYpVU8pGZlo6/2+MSco2lHfd3rv9jAP038e1xef9o2mjvYb2OqpqKE81028/jeietlSEVO5FRWsxWsJit1G3aFpW8iWe5RwpiCZAk25QvV6nz6fIlynRGuTd5WqpJ4guAlDfVKBK87hXljflgv1ON6fV+4+5gVlA17SfeG0heKqQd4l4jI/wrmaA9N9R4ar+wpHJDZyrrfcH0nB66PqAzPi76pn+faSyJk/vzOorYhGurQrzj/P68jtBMawHaHBIR9xoD5O34dy0qQOSYHvqExq2TpT2nf76+w7y251OYF0CRaU+J920TwLUa6inx6OxE6g80lu2ux7Y2eJLF/rCXE6zEPdnenk9o+4ih9AEdnW2q81HXl5LuU6OTl2fXUhqganbXAGq3g6jJOWV/OnoesO6YqqEB/GdNsjf7uHtwj2DzmRNpp7iOZfm6D9oAxB6Yi1gC4oIYeo4MIPdopEQRB+cAko5J1tW386HpB2Kz1eop4Epdwls/kgZ1sh8gZsEjdcWkr//D8Qu3Z3l5Nl1NtAAAAABJRU5ErkJggg==";
var $b792be6a00d98dad$var$Ls = $b792be6a00d98dad$var$ms("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");
var $b792be6a00d98dad$var$Is = "data:image/png;base64,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";
var $b792be6a00d98dad$var$Vs = "data:image/png;base64,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";
var $b792be6a00d98dad$var$Si = "3000.1.8", $b792be6a00d98dad$var$ks = " !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~", $b792be6a00d98dad$var$Kt = "topleft", $b792be6a00d98dad$var$js = 64, $b792be6a00d98dad$var$Ci = "monospace", $b792be6a00d98dad$var$zt = "monospace", $b792be6a00d98dad$var$Ti = 36, $b792be6a00d98dad$var$Ns = 64, $b792be6a00d98dad$var$_s = 256, $b792be6a00d98dad$var$Hs = 2048, $b792be6a00d98dad$var$qs = 2048, $b792be6a00d98dad$var$$s = 2048, $b792be6a00d98dad$var$Ks = 2048, $b792be6a00d98dad$var$zs = .1, $b792be6a00d98dad$var$Ai = 64, $b792be6a00d98dad$var$jn = "nearest", $b792be6a00d98dad$var$Oi = 8, $b792be6a00d98dad$var$Pi = 4, $b792be6a00d98dad$var$Ws = [
    {
        name: "a_pos",
        size: 2
    },
    {
        name: "a_uv",
        size: 2
    },
    {
        name: "a_color",
        size: 4
    }
], $b792be6a00d98dad$var$Yt = $b792be6a00d98dad$var$Ws.reduce((r, t)=>r + t.size, 0), $b792be6a00d98dad$var$Js = 2048, $b792be6a00d98dad$var$Ys = $b792be6a00d98dad$var$Js * 4 * $b792be6a00d98dad$var$Yt, $b792be6a00d98dad$var$Xs = $b792be6a00d98dad$var$Js * 6, $b792be6a00d98dad$var$Mi = `
attribute vec2 a_pos;
attribute vec2 a_uv;
attribute vec4 a_color;

varying vec2 v_pos;
varying vec2 v_uv;
varying vec4 v_color;

vec4 def_vert() {
	return vec4(a_pos, 0.0, 1.0);
}

{{user}}

void main() {
	vec4 pos = vert(a_pos, a_uv, a_color);
	v_pos = a_pos;
	v_uv = a_uv;
	v_color = a_color;
	gl_Position = pos;
}
`, $b792be6a00d98dad$var$Ri = `
precision mediump float;

varying vec2 v_pos;
varying vec2 v_uv;
varying vec4 v_color;

uniform sampler2D u_tex;

vec4 def_frag() {
	return v_color * texture2D(u_tex, v_uv);
}

{{user}}

void main() {
	gl_FragColor = frag(v_pos, v_uv, v_color, u_tex);
	if (gl_FragColor.a == 0.0) {
		discard;
	}
}
`, $b792be6a00d98dad$var$Nn = `
vec4 vert(vec2 pos, vec2 uv, vec4 color) {
	return def_vert();
}
`, $b792be6a00d98dad$var$_n = `
vec4 frag(vec2 pos, vec2 uv, vec4 color, sampler2D tex) {
	return def_frag();
}
`, $b792be6a00d98dad$var$Di = new Set([
    "id",
    "require"
]), $b792be6a00d98dad$var$Gi = new Set([
    "add",
    "update",
    "draw",
    "destroy",
    "inspect",
    "drawInspect"
]);
function $b792be6a00d98dad$var$et(r) {
    switch(r){
        case "topleft":
            return new $b792be6a00d98dad$var$y(-1, -1);
        case "top":
            return new $b792be6a00d98dad$var$y(0, -1);
        case "topright":
            return new $b792be6a00d98dad$var$y(1, -1);
        case "left":
            return new $b792be6a00d98dad$var$y(-1, 0);
        case "center":
            return new $b792be6a00d98dad$var$y(0, 0);
        case "right":
            return new $b792be6a00d98dad$var$y(1, 0);
        case "botleft":
            return new $b792be6a00d98dad$var$y(-1, 1);
        case "bot":
            return new $b792be6a00d98dad$var$y(0, 1);
        case "botright":
            return new $b792be6a00d98dad$var$y(1, 1);
        default:
            return r;
    }
}
$b792be6a00d98dad$var$o($b792be6a00d98dad$var$et, "anchorPt");
function $b792be6a00d98dad$var$Fi(r) {
    switch(r){
        case "left":
            return 0;
        case "center":
            return .5;
        case "right":
            return 1;
        default:
            return 0;
    }
}
$b792be6a00d98dad$var$o($b792be6a00d98dad$var$Fi, "alignPt");
function $b792be6a00d98dad$var$Bi(r) {
    return r.createBuffer(1, 1, 44100);
}
$b792be6a00d98dad$var$o($b792be6a00d98dad$var$Bi, "createEmptyAudioBuffer");
var $b792be6a00d98dad$export$2e2bcd8739ae039 = $b792be6a00d98dad$var$o((r = {})=>{
    let t = r.root ?? document.body;
    t === document.body && (document.body.style.width = "100%", document.body.style.height = "100%", document.body.style.margin = "0px", document.documentElement.style.width = "100%", document.documentElement.style.height = "100%");
    let c = r.canvas ?? (()=>{
        let e1 = document.createElement("canvas");
        return t.appendChild(e1), e1;
    })(), w = r.scale ?? 1, S = r.width && r.height && !r.stretch && !r.letterbox;
    S ? (c.width = r.width * w, c.height = r.height * w) : (c.width = c.parentElement.offsetWidth, c.height = c.parentElement.offsetHeight);
    let L = c.width, K = c.height, j = r.pixelDensity || window.devicePixelRatio;
    c.width *= j, c.height *= j;
    let q = [
        "outline: none",
        "cursor: default"
    ];
    S ? (q.push(`width: ${L}px`), q.push(`height: ${K}px`)) : (q.push("width: 100%"), q.push("height: 100%")), r.crisp && (q.push("image-rendering: pixelated"), q.push("image-rendering: crisp-edges")), c.style.cssText = q.join(";"), c.tabIndex = 0;
    let Z = document.createElement("canvas");
    Z.width = $b792be6a00d98dad$var$_s, Z.height = $b792be6a00d98dad$var$_s;
    let ue = Z.getContext("2d", {
        willReadFrequently: !0
    }), U = $b792be6a00d98dad$var$Rs({
        canvas: c,
        touchToMouse: r.touchToMouse,
        gamepads: r.gamepads,
        pixelDensity: r.pixelDensity,
        maxFPS: r.maxFPS
    }), J = [], d = U.canvas().getContext("webgl", {
        antialias: !0,
        depth: !0,
        stencil: !0,
        alpha: !0,
        preserveDrawingBuffer: !0
    });
    class Q {
        static{
            $b792be6a00d98dad$var$o(this, "Texture");
        }
        src = null;
        glTex;
        width;
        height;
        constructor(n, s, i1 = {}){
            this.glTex = d.createTexture(), J.push(()=>this.free()), this.bind(), n && s && d.texImage2D(d.TEXTURE_2D, 0, d.RGBA, n, s, 0, d.RGBA, d.UNSIGNED_BYTE, null), this.width = n, this.height = s;
            let a1 = (()=>{
                switch(i1.filter ?? r.texFilter){
                    case "linear":
                        return d.LINEAR;
                    case "nearest":
                        return d.NEAREST;
                    default:
                        return d.NEAREST;
                }
            })(), u1 = (()=>{
                switch(i1.wrap){
                    case "repeat":
                        return d.REPEAT;
                    case "clampToEdge":
                        return d.CLAMP_TO_EDGE;
                    default:
                        return d.CLAMP_TO_EDGE;
                }
            })();
            d.texParameteri(d.TEXTURE_2D, d.TEXTURE_MIN_FILTER, a1), d.texParameteri(d.TEXTURE_2D, d.TEXTURE_MAG_FILTER, a1), d.texParameteri(d.TEXTURE_2D, d.TEXTURE_WRAP_S, u1), d.texParameteri(d.TEXTURE_2D, d.TEXTURE_WRAP_T, u1), this.unbind();
        }
        static fromImage(n, s = {}) {
            let i1 = new Q(0, 0, s);
            return i1.bind(), d.texImage2D(d.TEXTURE_2D, 0, d.RGBA, d.RGBA, d.UNSIGNED_BYTE, n), i1.width = n.width, i1.height = n.height, i1.unbind(), i1.src = n, i1;
        }
        update(n, s = 0, i1 = 0) {
            this.bind(), d.texSubImage2D(d.TEXTURE_2D, 0, s, i1, d.RGBA, d.UNSIGNED_BYTE, n), this.unbind();
        }
        bind() {
            d.bindTexture(d.TEXTURE_2D, this.glTex);
        }
        unbind() {
            d.bindTexture(d.TEXTURE_2D, null);
        }
        free() {
            d.deleteTexture(this.glTex);
        }
    }
    class O extends Error {
        static{
            $b792be6a00d98dad$var$o(this, "KaboomError");
        }
        constructor(n){
            super(n), this.name = "KaboomError";
        }
    }
    class He {
        static{
            $b792be6a00d98dad$var$o(this, "TexPacker");
        }
        tex;
        canvas;
        ctx;
        x = 0;
        y = 0;
        curHeight = 0;
        constructor(n, s){
            this.canvas = document.createElement("canvas"), this.canvas.width = n, this.canvas.height = s, this.tex = Q.fromImage(this.canvas), this.ctx = this.canvas.getContext("2d");
        }
        add(n) {
            if (n.width > this.canvas.width || n.height > this.canvas.height) throw new O(`Texture size (${n.width} x ${n.height}) exceeds limit (${this.canvas.width} x ${this.canvas.height})`);
            this.x + n.width > this.canvas.width && (this.x = 0, this.y += this.curHeight, this.curHeight = 0), this.y + n.height > this.canvas.height && (this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height), this.tex = Q.fromImage(this.canvas), this.x = 0, this.y = 0, this.curHeight = 0);
            let s = new $b792be6a00d98dad$var$y(this.x, this.y);
            return this.x += n.width, n.height > this.curHeight && (this.curHeight = n.height), n instanceof ImageData ? this.ctx.putImageData(n, s.x, s.y) : this.ctx.drawImage(n, s.x, s.y), this.tex.update(this.canvas), [
                this.tex,
                new $b792be6a00d98dad$var$oe(s.x / this.canvas.width, s.y / this.canvas.height, n.width / this.canvas.width, n.height / this.canvas.height)
            ];
        }
    }
    class Ge {
        static{
            $b792be6a00d98dad$var$o(this, "FrameBuffer");
        }
        tex;
        glFrameBuffer;
        glRenderBuffer;
        constructor(n, s, i1 = {}){
            this.tex = new Q(n, s, i1), this.glFrameBuffer = d.createFramebuffer(), this.glRenderBuffer = d.createRenderbuffer(), J.push(()=>this.free()), this.bind(), d.renderbufferStorage(d.RENDERBUFFER, d.DEPTH_STENCIL, n, s), d.framebufferTexture2D(d.FRAMEBUFFER, d.COLOR_ATTACHMENT0, d.TEXTURE_2D, this.tex.glTex, 0), d.framebufferRenderbuffer(d.FRAMEBUFFER, d.DEPTH_STENCIL_ATTACHMENT, d.RENDERBUFFER, this.glRenderBuffer), this.unbind();
        }
        get width() {
            return this.tex.width;
        }
        get height() {
            return this.tex.height;
        }
        bind() {
            d.bindFramebuffer(d.FRAMEBUFFER, this.glFrameBuffer), d.bindRenderbuffer(d.RENDERBUFFER, this.glRenderBuffer);
        }
        unbind() {
            d.bindFramebuffer(d.FRAMEBUFFER, null), d.bindRenderbuffer(d.RENDERBUFFER, null);
        }
        free() {
            d.deleteFramebuffer(this.glFrameBuffer), d.deleteRenderbuffer(this.glRenderBuffer), this.tex.free();
        }
    }
    let v = (()=>{
        let e1 = ot($b792be6a00d98dad$var$Nn, $b792be6a00d98dad$var$_n), n = Q.fromImage(new ImageData(new Uint8ClampedArray([
            255,
            255,
            255,
            255
        ]), 1, 1)), s = r.width && r.height ? new Ge(r.width * j * w, r.height * j * w) : new Ge(d.drawingBufferWidth, d.drawingBufferHeight), i1 = null, a1 = 1;
        r.background && (i1 = $b792be6a00d98dad$var$$.fromArray(r.background), a1 = r.background[3] ?? 1, d.clearColor(i1.r / 255, i1.g / 255, i1.b / 255, a1)), d.enable(d.BLEND), d.enable(d.SCISSOR_TEST), d.blendFuncSeparate(d.SRC_ALPHA, d.ONE_MINUS_SRC_ALPHA, d.ONE, d.ONE_MINUS_SRC_ALPHA);
        let u1 = d.createBuffer();
        d.bindBuffer(d.ARRAY_BUFFER, u1), d.bufferData(d.ARRAY_BUFFER, $b792be6a00d98dad$var$Ys * 4, d.DYNAMIC_DRAW), $b792be6a00d98dad$var$Ws.reduce((m1, h1, g)=>(d.vertexAttribPointer(g, h1.size, d.FLOAT, !1, $b792be6a00d98dad$var$Yt * 4, m1), d.enableVertexAttribArray(g), m1 + h1.size * 4), 0), d.bindBuffer(d.ARRAY_BUFFER, null);
        let f = d.createBuffer();
        d.bindBuffer(d.ELEMENT_ARRAY_BUFFER, f), d.bufferData(d.ELEMENT_ARRAY_BUFFER, $b792be6a00d98dad$var$Xs * 4, d.DYNAMIC_DRAW), d.bindBuffer(d.ELEMENT_ARRAY_BUFFER, null);
        let p1 = Q.fromImage(new ImageData(new Uint8ClampedArray([
            128,
            128,
            128,
            255,
            190,
            190,
            190,
            255,
            190,
            190,
            190,
            255,
            128,
            128,
            128,
            255
        ]), 2, 2), {
            wrap: "repeat",
            filter: "nearest"
        });
        return {
            drawCalls: 0,
            lastDrawCalls: 0,
            defShader: e1,
            curShader: e1,
            frameBuffer: s,
            postShader: null,
            postShaderUniform: null,
            defTex: n,
            curTex: n,
            curUniform: {},
            vbuf: u1,
            ibuf: f,
            vqueue: [],
            iqueue: [],
            transform: new $b792be6a00d98dad$var$be,
            transformStack: [],
            bgTex: p1,
            bgColor: i1,
            bgAlpha: a1,
            width: r.width ?? d.drawingBufferWidth / j / w,
            height: r.height ?? d.drawingBufferHeight / j / w,
            viewport: {
                x: 0,
                y: 0,
                width: d.drawingBufferWidth,
                height: d.drawingBufferHeight
            },
            fixed: !1
        };
    })();
    class le {
        static{
            $b792be6a00d98dad$var$o(this, "SpriteData");
        }
        tex;
        frames = [
            new $b792be6a00d98dad$var$oe(0, 0, 1, 1)
        ];
        anims = {};
        slice9 = null;
        constructor(n, s, i1 = {}, a1 = null){
            this.tex = n, s && (this.frames = s), this.anims = i1, this.slice9 = a1;
        }
        get width() {
            return this.tex.width * this.frames[0].w;
        }
        get height() {
            return this.tex.height * this.frames[0].h;
        }
        static from(n, s = {}) {
            return typeof n == "string" ? le.fromURL(n, s) : Promise.resolve(le.fromImage(n, s));
        }
        static fromImage(n, s = {}) {
            let [i1, a1] = k.packer.add(n), u1 = s.frames ? s.frames.map((f)=>new $b792be6a00d98dad$var$oe(a1.x + f.x * a1.w, a1.y + f.y * a1.h, f.w * a1.w, f.h * a1.h)) : yt(s.sliceX || 1, s.sliceY || 1, a1.x, a1.y, a1.w, a1.h);
            return new le(i1, u1, s.anims, s.slice9);
        }
        static fromURL(n, s = {}) {
            return $e(n).then((i1)=>le.fromImage(i1, s));
        }
    }
    class pe {
        static{
            $b792be6a00d98dad$var$o(this, "SoundData");
        }
        buf;
        constructor(n){
            this.buf = n;
        }
        static fromArrayBuffer(n) {
            return new Promise((s, i1)=>ne.ctx.decodeAudioData(n, s, i1)).then((s)=>new pe(s));
        }
        static fromURL(n) {
            return $b792be6a00d98dad$var$Ln(n) ? pe.fromArrayBuffer($b792be6a00d98dad$var$As(n)) : Jt(n).then((s)=>pe.fromArrayBuffer(s));
        }
    }
    let ne = (()=>{
        let e1 = new (window.AudioContext || window.webkitAudioContext), n = e1.createGain();
        n.connect(e1.destination);
        let s = new pe($b792be6a00d98dad$var$Bi(e1));
        return e1.decodeAudioData($b792be6a00d98dad$var$Ls.buffer.slice(0)).then((i1)=>{
            s.buf = i1;
        }).catch((i1)=>{
            console.error("Failed to load burp: ", i1);
        }), {
            ctx: e1,
            masterNode: n,
            burpSnd: s
        };
    })();
    class re {
        static{
            $b792be6a00d98dad$var$o(this, "Asset");
        }
        loaded = !1;
        data = null;
        error = null;
        onLoadEvents = new $b792be6a00d98dad$var$ve;
        onErrorEvents = new $b792be6a00d98dad$var$ve;
        onFinishEvents = new $b792be6a00d98dad$var$ve;
        constructor(n){
            n.then((s)=>{
                this.data = s, this.onLoadEvents.trigger(s);
            }).catch((s)=>{
                if (this.error = s, this.onErrorEvents.numListeners() > 0) this.onErrorEvents.trigger(s);
                else throw s;
            }).finally(()=>{
                this.onFinishEvents.trigger(), this.loaded = !0;
            });
        }
        static loaded(n) {
            let s = new re(Promise.resolve(n));
            return s.data = n, s.loaded = !0, s;
        }
        onLoad(n) {
            return this.loaded && this.data ? n(this.data) : this.onLoadEvents.add(n), this;
        }
        onError(n) {
            return this.loaded && this.error ? n(this.error) : this.onErrorEvents.add(n), this;
        }
        onFinish(n) {
            return this.loaded ? n() : this.onFinishEvents.add(n), this;
        }
        then(n) {
            return this.onLoad(n);
        }
        catch(n) {
            return this.onError(n);
        }
        finally(n) {
            return this.onFinish(n);
        }
    }
    class ye {
        static{
            $b792be6a00d98dad$var$o(this, "AssetBucket");
        }
        assets = new Map;
        lastUID = 0;
        add(n, s) {
            let i1 = n ?? this.lastUID++ + "", a1 = new re(s);
            return this.assets.set(i1, a1), a1;
        }
        addLoaded(n, s) {
            let i1 = n ?? this.lastUID++ + "", a1 = re.loaded(s);
            return this.assets.set(i1, a1), a1;
        }
        get(n) {
            return this.assets.get(n);
        }
        progress() {
            if (this.assets.size === 0) return 1;
            let n = 0;
            return this.assets.forEach((s)=>{
                s.loaded && n++;
            }), n / this.assets.size;
        }
    }
    let k = {
        urlPrefix: "",
        sprites: new ye,
        fonts: new ye,
        bitmapFonts: new ye,
        sounds: new ye,
        shaders: new ye,
        custom: new ye,
        packer: new He($b792be6a00d98dad$var$$s, $b792be6a00d98dad$var$Ks),
        loaded: !1
    }, A = {
        events: new $b792be6a00d98dad$var$De,
        objEvents: new $b792be6a00d98dad$var$De,
        root: mn([]),
        gravity: 0,
        scenes: {},
        logs: [],
        cam: {
            pos: null,
            scale: new $b792be6a00d98dad$var$y(1),
            angle: 0,
            shake: 0,
            transform: new $b792be6a00d98dad$var$be
        }
    };
    function tt(e1) {
        return k.custom.add(null, e1);
    }
    $b792be6a00d98dad$var$o(tt, "load");
    function Ce() {
        let e1 = [
            k.sprites,
            k.sounds,
            k.shaders,
            k.fonts,
            k.bitmapFonts,
            k.custom
        ];
        return e1.reduce((n, s)=>n + s.progress(), 0) / e1.length;
    }
    $b792be6a00d98dad$var$o(Ce, "loadProgress");
    function Xt(e1) {
        return e1 !== void 0 && (k.urlPrefix = e1), k.urlPrefix;
    }
    $b792be6a00d98dad$var$o(Xt, "loadRoot");
    function nt(e1) {
        let n = k.urlPrefix + e1;
        return fetch(n).then((s)=>{
            if (!s.ok) throw new O(`Failed to fetch "${n}"`);
            return s;
        });
    }
    $b792be6a00d98dad$var$o(nt, "fetchURL");
    function qe(e1) {
        return nt(e1).then((n)=>n.json());
    }
    $b792be6a00d98dad$var$o(qe, "fetchJSON");
    function Wt(e1) {
        return nt(e1).then((n)=>n.text());
    }
    $b792be6a00d98dad$var$o(Wt, "fetchText");
    function Jt(e1) {
        return nt(e1).then((n)=>n.arrayBuffer());
    }
    $b792be6a00d98dad$var$o(Jt, "fetchArrayBuffer");
    function $e(e1) {
        let n = new Image;
        return n.crossOrigin = "anonymous", n.src = $b792be6a00d98dad$var$Ln(e1) ? e1 : k.urlPrefix + e1, new Promise((s, i1)=>{
            n.onload = ()=>s(n), n.onerror = ()=>i1(new O(`Failed to load image from "${e1}"`));
        });
    }
    $b792be6a00d98dad$var$o($e, "loadImg");
    function Qt(e1, n) {
        return k.custom.add(e1, qe(n));
    }
    $b792be6a00d98dad$var$o(Qt, "loadJSON");
    class Ke {
        static{
            $b792be6a00d98dad$var$o(this, "FontData");
        }
        fontface;
        filter = $b792be6a00d98dad$var$jn;
        outline = null;
        constructor(n, s = {}){
            this.fontface = n, this.filter = s.filter ?? $b792be6a00d98dad$var$jn, s.outline && (this.outline = {
                width: 1,
                color: $b792be6a00d98dad$var$W(0, 0, 0)
            }, typeof s.outline == "number" ? this.outline.width = s.outline : typeof s.outline == "object" && (s.outline.width && (this.outline.width = s.outline.width), s.outline.color && (this.outline.color = s.outline.color)));
        }
    }
    function Zt(e1, n, s = {}) {
        let i1 = new FontFace(e1, typeof n == "string" ? `url(${n})` : n);
        return document.fonts.add(i1), k.fonts.add(e1, i1.load().catch((a1)=>{
            throw new O(`Failed to load font from "${n}": ${a1}`);
        }).then((a1)=>new Ke(a1, s)));
    }
    $b792be6a00d98dad$var$o(Zt, "loadFont");
    function en(e1, n, s, i1, a1 = {}) {
        return k.bitmapFonts.add(e1, $e(n).then((u1)=>dn(Q.fromImage(u1, a1), s, i1, a1.chars ?? $b792be6a00d98dad$var$ks)));
    }
    $b792be6a00d98dad$var$o(en, "loadBitmapFont");
    function yt(e1 = 1, n = 1, s = 0, i1 = 0, a1 = 1, u1 = 1) {
        let f = [], p1 = a1 / e1, m1 = u1 / n;
        for(let h1 = 0; h1 < n; h1++)for(let g = 0; g < e1; g++)f.push(new $b792be6a00d98dad$var$oe(s + g * p1, i1 + h1 * m1, p1, m1));
        return f;
    }
    $b792be6a00d98dad$var$o(yt, "slice");
    function xt(e1, n) {
        return tt(typeof n == "string" ? new Promise((s, i1)=>{
            qe(n).then((a1)=>{
                xt(e1, a1).then(s).catch(i1);
            });
        }) : le.from(e1).then((s)=>{
            let i1 = {};
            for(let a1 in n){
                let u1 = n[a1], f = s.frames[0], p1 = $b792be6a00d98dad$var$$s * f.w, m1 = $b792be6a00d98dad$var$Ks * f.h, h1 = u1.frames ? u1.frames.map((E)=>new $b792be6a00d98dad$var$oe(f.x + (u1.x + E.x) / p1 * f.w, f.y + (u1.y + E.y) / m1 * f.h, E.w / p1 * f.w, E.h / m1 * f.h)) : yt(u1.sliceX || 1, u1.sliceY || 1, f.x + u1.x / p1 * f.w, f.y + u1.y / m1 * f.h, u1.width / p1 * f.w, u1.height / m1 * f.h), g = new le(s.tex, h1, u1.anims);
                k.sprites.addLoaded(a1, g), i1[a1] = g;
            }
            return i1;
        }));
    }
    $b792be6a00d98dad$var$o(xt, "loadSpriteAtlas");
    function Ut(e1, n = {}) {
        let s = document.createElement("canvas"), i1 = e1[0].width, a1 = e1[0].height;
        s.width = i1 * e1.length, s.height = a1;
        let u1 = s.getContext("2d");
        e1.forEach((p1, m1)=>{
            p1 instanceof ImageData ? u1.putImageData(p1, m1 * i1, 0) : u1.drawImage(p1, m1 * i1, 0);
        });
        let f = u1.getImageData(0, 0, e1.length * i1, a1);
        return le.fromImage(f, {
            ...n,
            sliceX: e1.length,
            sliceY: 1
        });
    }
    $b792be6a00d98dad$var$o(Ut, "createSpriteSheet");
    function Le(e1, n, s = {
        sliceX: 1,
        sliceY: 1,
        anims: {}
    }) {
        return Array.isArray(n) ? n.some((i1)=>typeof i1 == "string") ? k.sprites.add(e1, Promise.all(n.map((i1)=>typeof i1 == "string" ? $e(i1) : Promise.resolve(i1))).then((i1)=>Ut(i1, s))) : k.sprites.addLoaded(e1, Ut(n, s)) : typeof n == "string" ? k.sprites.add(e1, le.from(n, s)) : k.sprites.addLoaded(e1, le.fromImage(n, s));
    }
    $b792be6a00d98dad$var$o(Le, "loadSprite");
    function tn(e1, n) {
        return k.sprites.add(e1, new Promise(async (s)=>{
            let i1 = typeof n == "string" ? await qe(n) : n, a1 = await Promise.all(i1.frames.map($e)), u1 = document.createElement("canvas");
            u1.width = i1.width, u1.height = i1.height * i1.frames.length;
            let f = u1.getContext("2d");
            a1.forEach((m1, h1)=>{
                f.drawImage(m1, 0, h1 * i1.height);
            });
            let p1 = await Le(null, u1, {
                sliceY: i1.frames.length,
                anims: i1.anims
            });
            s(p1);
        }));
    }
    $b792be6a00d98dad$var$o(tn, "loadPedit");
    function nn(e1, n, s) {
        typeof n == "string" && !s && (s = n.replace(new RegExp(`${$b792be6a00d98dad$var$Ps(n)}$`), "json"));
        let i1 = typeof s == "string" ? qe(s) : Promise.resolve(s);
        return k.sprites.add(e1, i1.then((a1)=>{
            let u1 = a1.meta.size, f = a1.frames.map((m1)=>new $b792be6a00d98dad$var$oe(m1.frame.x / u1.w, m1.frame.y / u1.h, m1.frame.w / u1.w, m1.frame.h / u1.h)), p1 = {};
            for (let m1 of a1.meta.frameTags)m1.from === m1.to ? p1[m1.name] = m1.from : p1[m1.name] = {
                from: m1.from,
                to: m1.to,
                speed: 10,
                loop: !0,
                pingpong: m1.direction === "pingpong"
            };
            return le.from(n, {
                frames: f,
                anims: p1
            });
        }));
    }
    $b792be6a00d98dad$var$o(nn, "loadAseprite");
    function sn(e1, n, s) {
        return k.shaders.addLoaded(e1, ot(n, s));
    }
    $b792be6a00d98dad$var$o(sn, "loadShader");
    function rn(e1, n, s) {
        let i1 = $b792be6a00d98dad$var$o((u1)=>u1 ? Wt(u1) : Promise.resolve(null), "resolveUrl"), a1 = Promise.all([
            i1(n),
            i1(s)
        ]).then(([u1, f])=>ot(u1, f));
        return k.shaders.add(e1, a1);
    }
    $b792be6a00d98dad$var$o(rn, "loadShaderURL");
    function on(e1, n) {
        return k.sounds.add(e1, typeof n == "string" ? pe.fromURL(n) : pe.fromArrayBuffer(n));
    }
    $b792be6a00d98dad$var$o(on, "loadSound");
    function an(e1 = "bean") {
        return Le(e1, $b792be6a00d98dad$var$Bs);
    }
    $b792be6a00d98dad$var$o(an, "loadBean");
    function Et(e1) {
        return k.sprites.get(e1);
    }
    $b792be6a00d98dad$var$o(Et, "getSprite");
    function St(e1) {
        return k.sounds.get(e1);
    }
    $b792be6a00d98dad$var$o(St, "getSound");
    function Ct(e1) {
        return k.fonts.get(e1);
    }
    $b792be6a00d98dad$var$o(Ct, "getFont");
    function Tt(e1) {
        return k.bitmapFonts.get(e1);
    }
    $b792be6a00d98dad$var$o(Tt, "getBitmapFont");
    function At(e1) {
        return k.shaders.get(e1);
    }
    $b792be6a00d98dad$var$o(At, "getShader");
    function un(e1) {
        return k.custom.get(e1);
    }
    $b792be6a00d98dad$var$o(un, "getAsset");
    function st(e1) {
        if (typeof e1 == "string") {
            let n = Et(e1);
            if (n) return n;
            if (Ce() < 1) return null;
            throw new O(`Sprite not found: ${e1}`);
        } else {
            if (e1 instanceof le) return re.loaded(e1);
            if (e1 instanceof re) return e1;
            throw new O(`Invalid sprite: ${e1}`);
        }
    }
    $b792be6a00d98dad$var$o(st, "resolveSprite");
    function cn(e1) {
        if (typeof e1 == "string") {
            let n = St(e1);
            if (n) return n;
            if (Ce() < 1) return null;
            throw new O(`Sound not found: ${e1}`);
        } else {
            if (e1 instanceof pe) return re.loaded(e1);
            if (e1 instanceof re) return e1;
            throw new O(`Invalid sound: ${e1}`);
        }
    }
    $b792be6a00d98dad$var$o(cn, "resolveSound");
    function ln(e1) {
        if (!e1) return v.defShader;
        if (typeof e1 == "string") {
            let n = At(e1);
            if (n) return n.data ?? n;
            if (Ce() < 1) return null;
            throw new O(`Shader not found: ${e1}`);
        } else if (e1 instanceof re) return e1.data ? e1.data : e1;
        return e1;
    }
    $b792be6a00d98dad$var$o(ln, "resolveShader");
    function rt(e1) {
        if (!e1) return rt(r.font ?? $b792be6a00d98dad$var$Ci);
        if (typeof e1 == "string") {
            let n = Tt(e1), s = Ct(e1);
            if (n) return n.data ?? n;
            if (s) return s.data ?? s;
            if (document.fonts.check(`${$b792be6a00d98dad$var$Ns}px ${e1}`)) return e1;
            if (Ce() < 1) return null;
            throw new O(`Font not found: ${e1}`);
        } else if (e1 instanceof re) return e1.data ? e1.data : e1;
        return e1;
    }
    $b792be6a00d98dad$var$o(rt, "resolveFont");
    function hn(e1) {
        return e1 !== void 0 && (ne.masterNode.gain.value = e1), ne.masterNode.gain.value;
    }
    $b792be6a00d98dad$var$o(hn, "volume");
    function Ot(e1, n = {}) {
        let s = ne.ctx, i1 = n.paused ?? !1, a1 = s.createBufferSource(), u1 = new $b792be6a00d98dad$var$ve, f = s.createGain(), p1 = n.seek ?? 0, m1 = 0, h1 = 0, g = !1;
        a1.loop = !!n.loop, a1.detune.value = n.detune ?? 0, a1.playbackRate.value = n.speed ?? 1, a1.connect(f), a1.onended = ()=>{
            F() >= a1.buffer?.duration && u1.trigger();
        }, f.connect(ne.masterNode), f.gain.value = n.volume ?? 1;
        let E = $b792be6a00d98dad$var$o((D1)=>{
            a1.buffer = D1.buf, i1 || (m1 = s.currentTime, a1.start(0, p1), g = !0);
        }, "start"), M = cn(e1);
        M instanceof re && M.onLoad(E);
        let F = $b792be6a00d98dad$var$o(()=>{
            if (!a1.buffer) return 0;
            let D1 = i1 ? h1 - m1 : s.currentTime - m1, P = a1.buffer.duration;
            return a1.loop ? D1 % P : Math.min(D1, P);
        }, "getTime"), _ = $b792be6a00d98dad$var$o((D1)=>{
            let P = s.createBufferSource();
            return P.buffer = D1.buffer, P.loop = D1.loop, P.playbackRate.value = D1.playbackRate.value, P.detune.value = D1.detune.value, P.onended = D1.onended, P.connect(f), P;
        }, "cloneNode");
        return {
            stop () {
                this.paused = !0, this.seek(0);
            },
            set paused (D){
                if (i1 !== D) {
                    if (i1 = D, D) g && (a1.stop(), g = !1), h1 = s.currentTime;
                    else {
                        a1 = _(a1);
                        let P = h1 - m1;
                        a1.start(0, P), g = !0, m1 = s.currentTime - P, h1 = 0;
                    }
                }
            },
            get paused () {
                return i1;
            },
            play (D1 = 0) {
                this.seek(D1), this.paused = !1;
            },
            seek (D1) {
                a1.buffer?.duration && (D1 > a1.buffer.duration || (i1 ? (a1 = _(a1), m1 = h1 - D1) : (a1.stop(), a1 = _(a1), m1 = s.currentTime - D1, a1.start(0, D1), g = !0, h1 = 0)));
            },
            set speed (D){
                a1.playbackRate.value = D;
            },
            get speed () {
                return a1.playbackRate.value;
            },
            set detune (D){
                a1.detune.value = D;
            },
            get detune () {
                return a1.detune.value;
            },
            set volume (D){
                f.gain.value = Math.max(D, 0);
            },
            get volume () {
                return f.gain.value;
            },
            set loop (D){
                a1.loop = D;
            },
            get loop () {
                return a1.loop;
            },
            duration () {
                return a1.buffer?.duration ?? 0;
            },
            time () {
                return F() % this.duration();
            },
            onEnd (D1) {
                return u1.add(D1);
            },
            then (D1) {
                return this.onEnd(D1);
            }
        };
    }
    $b792be6a00d98dad$var$o(Ot, "play");
    function it(e1) {
        return Ot(ne.burpSnd, e1);
    }
    $b792be6a00d98dad$var$o(it, "burp");
    function ot(e1 = $b792be6a00d98dad$var$Nn, n = $b792be6a00d98dad$var$_n) {
        let s = $b792be6a00d98dad$var$Mi.replace("{{user}}", e1 ?? $b792be6a00d98dad$var$Nn), i1 = $b792be6a00d98dad$var$Ri.replace("{{user}}", n ?? $b792be6a00d98dad$var$_n), a1 = d.createShader(d.VERTEX_SHADER), u1 = d.createShader(d.FRAGMENT_SHADER);
        d.shaderSource(a1, s), d.shaderSource(u1, i1), d.compileShader(a1), d.compileShader(u1);
        let f = d.createProgram();
        if (J.push(()=>d.deleteProgram(f)), d.attachShader(f, a1), d.attachShader(f, u1), d.bindAttribLocation(f, 0, "a_pos"), d.bindAttribLocation(f, 1, "a_uv"), d.bindAttribLocation(f, 2, "a_color"), d.linkProgram(f), !d.getProgramParameter(f, d.LINK_STATUS)) {
            let p1 = $b792be6a00d98dad$var$o((E)=>{
                let M = /^ERROR:\s0:(?<line>\d+):\s(?<msg>.+)/, F = E.match(M);
                return {
                    line: Number(F.groups.line),
                    msg: F.groups.msg.replace(/\n\0$/, "")
                };
            }, "formatShaderError"), m1 = d.getShaderInfoLog(a1), h1 = d.getShaderInfoLog(u1), g = "";
            if (m1) {
                let E = p1(m1);
                g += `Vertex shader line ${E.line - 14}: ${E.msg}`;
            }
            if (h1) {
                let E = p1(h1);
                g += `Fragment shader line ${E.line - 14}: ${E.msg}`;
            }
            throw new O(g);
        }
        return d.deleteShader(a1), d.deleteShader(u1), {
            bind () {
                d.useProgram(f);
            },
            unbind () {
                d.useProgram(null);
            },
            free () {
                d.deleteProgram(f);
            },
            send (p1) {
                for(let m1 in p1){
                    let h1 = p1[m1], g = d.getUniformLocation(f, m1);
                    typeof h1 == "number" ? d.uniform1f(g, h1) : h1 instanceof $b792be6a00d98dad$var$be ? d.uniformMatrix4fv(g, !1, new Float32Array(h1.m)) : h1 instanceof $b792be6a00d98dad$var$$ ? d.uniform3f(g, h1.r, h1.g, h1.b) : h1 instanceof $b792be6a00d98dad$var$y && d.uniform2f(g, h1.x, h1.y);
                }
            }
        };
    }
    $b792be6a00d98dad$var$o(ot, "makeShader");
    function dn(e1, n, s, i1) {
        let a1 = e1.width / n, u1 = {}, f = i1.split("").entries();
        for (let [p1, m1] of f)u1[m1] = new $b792be6a00d98dad$var$oe(p1 % a1 * n, Math.floor(p1 / a1) * s, n, s);
        return {
            tex: e1,
            map: u1,
            size: s
        };
    }
    $b792be6a00d98dad$var$o(dn, "makeFont");
    function ce(e1, n, s, i1 = v.defTex, a1 = v.defShader, u1 = {}) {
        let f = ln(a1);
        if (!f || f instanceof re) return;
        (i1 !== v.curTex || f !== v.curShader || !$b792be6a00d98dad$var$Gn(v.curUniform, u1) || v.vqueue.length + e1.length * $b792be6a00d98dad$var$Yt > $b792be6a00d98dad$var$Ys || v.iqueue.length + n.length > $b792be6a00d98dad$var$Xs) && me();
        let p1 = v.fixed || s ? v.transform : A.cam.transform.mult(v.transform);
        for (let m1 of e1){
            let h1 = Rt(p1.multVec2(m1.pos));
            v.vqueue.push(h1.x, h1.y, m1.uv.x, m1.uv.y, m1.color.r / 255, m1.color.g / 255, m1.color.b / 255, m1.opacity);
        }
        for (let m1 of n)v.iqueue.push(m1 + v.vqueue.length / $b792be6a00d98dad$var$Yt - e1.length);
        v.curTex = i1, v.curShader = f, v.curUniform = u1;
    }
    $b792be6a00d98dad$var$o(ce, "drawRaw");
    function me() {
        !v.curTex || !v.curShader || v.vqueue.length === 0 || v.iqueue.length === 0 || (d.bindBuffer(d.ARRAY_BUFFER, v.vbuf), d.bufferSubData(d.ARRAY_BUFFER, 0, new Float32Array(v.vqueue)), d.bindBuffer(d.ELEMENT_ARRAY_BUFFER, v.ibuf), d.bufferSubData(d.ELEMENT_ARRAY_BUFFER, 0, new Uint16Array(v.iqueue)), v.curShader.bind(), v.curShader.send(v.curUniform), v.curTex.bind(), d.drawElements(d.TRIANGLES, v.iqueue.length, d.UNSIGNED_SHORT, 0), v.curTex.unbind(), v.curShader.unbind(), d.bindBuffer(d.ARRAY_BUFFER, null), d.bindBuffer(d.ELEMENT_ARRAY_BUFFER, null), v.vqueue.length = 0, v.iqueue.length = 0, v.drawCalls++);
    }
    $b792be6a00d98dad$var$o(me, "flush");
    function Te() {
        d.clear(d.COLOR_BUFFER_BIT), v.frameBuffer.bind(), d.viewport(0, 0, v.frameBuffer.width, v.frameBuffer.height), d.clear(d.COLOR_BUFFER_BIT), v.bgColor || Fe(()=>{
            z({
                width: ge(),
                height: we(),
                quad: new $b792be6a00d98dad$var$oe(0, 0, ge() / $b792be6a00d98dad$var$js, we() / $b792be6a00d98dad$var$js),
                tex: v.bgTex,
                fixed: !0
            });
        }), v.drawCalls = 0, v.fixed = !1, v.transformStack.length = 0, v.transform = new $b792be6a00d98dad$var$be;
    }
    $b792be6a00d98dad$var$o(Te, "frameStart");
    function Pt(e1, n) {
        v.postShader = e1, v.postShaderUniform = n ?? null;
    }
    $b792be6a00d98dad$var$o(Pt, "usePostEffect");
    function Mt() {
        me(), v.frameBuffer.unbind(), d.viewport(0, 0, d.drawingBufferWidth, d.drawingBufferHeight), me();
        let e1 = v.width, n = v.height;
        v.width = d.drawingBufferWidth / j, v.height = d.drawingBufferHeight / j, Ae({
            flipY: !0,
            tex: v.frameBuffer.tex,
            pos: new $b792be6a00d98dad$var$y(v.viewport.x, v.viewport.y),
            width: v.viewport.width,
            height: v.viewport.height,
            shader: v.postShader,
            uniform: typeof v.postShaderUniform == "function" ? v.postShaderUniform() : v.postShaderUniform,
            fixed: !0
        }), me(), v.width = e1, v.height = n, v.lastDrawCalls = v.drawCalls;
    }
    $b792be6a00d98dad$var$o(Mt, "frameEnd");
    function Rt(e1) {
        return new $b792be6a00d98dad$var$y(e1.x / ge() * 2 - 1, -e1.y / we() * 2 + 1);
    }
    $b792be6a00d98dad$var$o(Rt, "screen2ndc");
    function Dt(e1) {
        v.transform = e1.clone();
    }
    $b792be6a00d98dad$var$o(Dt, "pushMatrix");
    function l(...e1) {
        if (e1[0] === void 0) return;
        let n = $b792be6a00d98dad$var$C(...e1);
        n.x === 0 && n.y === 0 || v.transform.translate(n);
    }
    $b792be6a00d98dad$var$o(l, "pushTranslate");
    function x(...e1) {
        if (e1[0] === void 0) return;
        let n = $b792be6a00d98dad$var$C(...e1);
        n.x === 1 && n.y === 1 || v.transform.scale(n);
    }
    $b792be6a00d98dad$var$o(x, "pushScale");
    function T(e1) {
        e1 && v.transform.rotate(e1);
    }
    $b792be6a00d98dad$var$o(T, "pushRotate");
    function V() {
        v.transformStack.push(v.transform.clone());
    }
    $b792be6a00d98dad$var$o(V, "pushTransform");
    function ee() {
        v.transformStack.length > 0 && (v.transform = v.transformStack.pop());
    }
    $b792be6a00d98dad$var$o(ee, "popTransform");
    function z(e1) {
        if (e1.width === void 0 || e1.height === void 0) throw new O('drawUVQuad() requires property "width" and "height".');
        if (e1.width <= 0 || e1.height <= 0) return;
        let n = e1.width, s = e1.height, a1 = $b792be6a00d98dad$var$et(e1.anchor || $b792be6a00d98dad$var$Kt).scale(new $b792be6a00d98dad$var$y(n, s).scale(-0.5)), u1 = e1.quad || new $b792be6a00d98dad$var$oe(0, 0, 1, 1), f = e1.color || $b792be6a00d98dad$var$W(255, 255, 255), p1 = e1.opacity ?? 1, m1 = e1.tex ? $b792be6a00d98dad$var$zs / e1.tex.width : 0, h1 = e1.tex ? $b792be6a00d98dad$var$zs / e1.tex.height : 0, g = u1.x + m1, E = u1.y + h1, M = u1.w - m1 * 2, F = u1.h - h1 * 2;
        V(), l(e1.pos), T(e1.angle), x(e1.scale), l(a1), ce([
            {
                pos: new $b792be6a00d98dad$var$y(-n / 2, s / 2),
                uv: new $b792be6a00d98dad$var$y(e1.flipX ? g + M : g, e1.flipY ? E : E + F),
                color: f,
                opacity: p1
            },
            {
                pos: new $b792be6a00d98dad$var$y(-n / 2, -s / 2),
                uv: new $b792be6a00d98dad$var$y(e1.flipX ? g + M : g, e1.flipY ? E + F : E),
                color: f,
                opacity: p1
            },
            {
                pos: new $b792be6a00d98dad$var$y(n / 2, -s / 2),
                uv: new $b792be6a00d98dad$var$y(e1.flipX ? g : g + M, e1.flipY ? E + F : E),
                color: f,
                opacity: p1
            },
            {
                pos: new $b792be6a00d98dad$var$y(n / 2, s / 2),
                uv: new $b792be6a00d98dad$var$y(e1.flipX ? g : g + M, e1.flipY ? E : E + F),
                color: f,
                opacity: p1
            }
        ], [
            0,
            1,
            3,
            1,
            2,
            3
        ], e1.fixed, e1.tex, e1.shader, e1.uniform), ee();
    }
    $b792be6a00d98dad$var$o(z, "drawUVQuad");
    function Ae(e1) {
        if (!e1.tex) throw new O('drawTexture() requires property "tex".');
        let n = e1.quad ?? new $b792be6a00d98dad$var$oe(0, 0, 1, 1), s = e1.tex.width * n.w, i1 = e1.tex.height * n.h, a1 = new $b792be6a00d98dad$var$y(1);
        if (e1.tiled) {
            let u1 = Math.ceil((e1.width || s) / s), f = Math.ceil((e1.height || i1) / i1), m1 = $b792be6a00d98dad$var$et(e1.anchor || $b792be6a00d98dad$var$Kt).add(new $b792be6a00d98dad$var$y(1, 1)).scale(.5).scale(u1 * s, f * i1);
            for(let h1 = 0; h1 < u1; h1++)for(let g = 0; g < f; g++)z(Object.assign({}, e1, {
                pos: (e1.pos || new $b792be6a00d98dad$var$y(0)).add(new $b792be6a00d98dad$var$y(s * h1, i1 * g)).sub(m1),
                scale: a1.scale(e1.scale || new $b792be6a00d98dad$var$y(1)),
                tex: e1.tex,
                quad: n,
                width: s,
                height: i1,
                anchor: "topleft"
            }));
        } else e1.width && e1.height ? (a1.x = e1.width / s, a1.y = e1.height / i1) : e1.width ? (a1.x = e1.width / s, a1.y = a1.x) : e1.height && (a1.y = e1.height / i1, a1.x = a1.y), z(Object.assign({}, e1, {
            scale: a1.scale(e1.scale || new $b792be6a00d98dad$var$y(1)),
            tex: e1.tex,
            quad: n,
            width: s,
            height: i1
        }));
    }
    $b792be6a00d98dad$var$o(Ae, "drawTexture");
    function at(e1) {
        if (!e1.sprite) throw new O('drawSprite() requires property "sprite"');
        let n = st(e1.sprite);
        if (!n || !n.data) return;
        let s = n.data.frames[e1.frame ?? 0];
        if (!s) throw new O(`Frame not found: ${e1.frame ?? 0}`);
        Ae(Object.assign({}, e1, {
            tex: n.data.tex,
            quad: s.scale(e1.quad ?? new $b792be6a00d98dad$var$oe(0, 0, 1, 1))
        }));
    }
    $b792be6a00d98dad$var$o(at, "drawSprite");
    function ut(e1, n, s, i1, a1, u1 = 1) {
        i1 = $b792be6a00d98dad$var$Ee(i1 % 360), a1 = $b792be6a00d98dad$var$Ee(a1 % 360), a1 <= i1 && (a1 += Math.PI * 2);
        let f = [], p1 = Math.ceil((a1 - i1) / $b792be6a00d98dad$var$Ee(8) * u1), m1 = (a1 - i1) / p1;
        for(let h1 = i1; h1 < a1; h1 += m1)f.push(e1.add(n * Math.cos(h1), s * Math.sin(h1)));
        return f.push(e1.add(n * Math.cos(a1), s * Math.sin(a1))), f;
    }
    $b792be6a00d98dad$var$o(ut, "getArcPts");
    function xe(e1) {
        if (e1.width === void 0 || e1.height === void 0) throw new O('drawRect() requires property "width" and "height".');
        if (e1.width <= 0 || e1.height <= 0) return;
        let n = e1.width, s = e1.height, a1 = $b792be6a00d98dad$var$et(e1.anchor || $b792be6a00d98dad$var$Kt).add(1, 1).scale(new $b792be6a00d98dad$var$y(n, s).scale(-0.5)), u1 = [
            new $b792be6a00d98dad$var$y(0, 0),
            new $b792be6a00d98dad$var$y(n, 0),
            new $b792be6a00d98dad$var$y(n, s),
            new $b792be6a00d98dad$var$y(0, s)
        ];
        if (e1.radius) {
            let f = Math.min(Math.min(n, s) / 2, e1.radius);
            u1 = [
                new $b792be6a00d98dad$var$y(f, 0),
                new $b792be6a00d98dad$var$y(n - f, 0),
                ...ut(new $b792be6a00d98dad$var$y(n - f, f), f, f, 270, 360),
                new $b792be6a00d98dad$var$y(n, f),
                new $b792be6a00d98dad$var$y(n, s - f),
                ...ut(new $b792be6a00d98dad$var$y(n - f, s - f), f, f, 0, 90),
                new $b792be6a00d98dad$var$y(n - f, s),
                new $b792be6a00d98dad$var$y(f, s),
                ...ut(new $b792be6a00d98dad$var$y(f, s - f), f, f, 90, 180),
                new $b792be6a00d98dad$var$y(0, s - f),
                new $b792be6a00d98dad$var$y(0, f),
                ...ut(new $b792be6a00d98dad$var$y(f, f), f, f, 180, 270)
            ];
        }
        Ie(Object.assign({}, e1, {
            offset: a1,
            pts: u1,
            ...e1.gradient ? {
                colors: e1.horizontal ? [
                    e1.gradient[0],
                    e1.gradient[1],
                    e1.gradient[1],
                    e1.gradient[0]
                ] : [
                    e1.gradient[0],
                    e1.gradient[0],
                    e1.gradient[1],
                    e1.gradient[1]
                ]
            } : {}
        }));
    }
    $b792be6a00d98dad$var$o(xe, "drawRect");
    function ct(e1) {
        let { p1: n, p2: s } = e1;
        if (!n || !s) throw new O('drawLine() requires properties "p1" and "p2".');
        let i1 = e1.width || 1, a1 = s.sub(n).unit().normal().scale(i1 * .5), u1 = [
            n.sub(a1),
            n.add(a1),
            s.add(a1),
            s.sub(a1)
        ].map((f)=>({
                pos: new $b792be6a00d98dad$var$y(f.x, f.y),
                uv: new $b792be6a00d98dad$var$y(0),
                color: e1.color ?? $b792be6a00d98dad$var$$.WHITE,
                opacity: e1.opacity ?? 1
            }));
        ce(u1, [
            0,
            1,
            3,
            1,
            2,
            3
        ], e1.fixed, v.defTex, e1.shader, e1.uniform);
    }
    $b792be6a00d98dad$var$o(ct, "drawLine");
    function Hn(e1) {
        let n = e1.pts;
        if (!n) throw new O('drawLines() requires property "pts".');
        if (!(n.length < 2)) {
            if (e1.radius && n.length >= 3) {
                let s = n[0].sdist(n[1]);
                for(let a1 = 1; a1 < n.length - 1; a1++)s = Math.min(n[a1].sdist(n[a1 + 1]), s);
                let i1 = Math.min(e1.radius, Math.sqrt(s) / 2);
                ct(Object.assign({}, e1, {
                    p1: n[0],
                    p2: n[1]
                }));
                for(let a1 = 1; a1 < n.length - 2; a1++){
                    let u1 = n[a1], f = n[a1 + 1];
                    ct(Object.assign({}, e1, {
                        p1: u1,
                        p2: f
                    }));
                }
                ct(Object.assign({}, e1, {
                    p1: n[n.length - 2],
                    p2: n[n.length - 1]
                }));
            } else for(let s = 0; s < n.length - 1; s++)ct(Object.assign({}, e1, {
                p1: n[s],
                p2: n[s + 1]
            })), e1.join !== "none" && ze(Object.assign({}, e1, {
                pos: n[s],
                radius: e1.width / 2
            }));
        }
    }
    $b792be6a00d98dad$var$o(Hn, "drawLines");
    function qn(e1) {
        if (!e1.p1 || !e1.p2 || !e1.p3) throw new O('drawPolygon() requires properties "p1", "p2" and "p3".');
        return Ie(Object.assign({}, e1, {
            pts: [
                e1.p1,
                e1.p2,
                e1.p3
            ]
        }));
    }
    $b792be6a00d98dad$var$o(qn, "drawTriangle");
    function ze(e1) {
        if (typeof e1.radius != "number") throw new O('drawCircle() requires property "radius".');
        e1.radius !== 0 && $n(Object.assign({}, e1, {
            radiusX: e1.radius,
            radiusY: e1.radius,
            angle: 0
        }));
    }
    $b792be6a00d98dad$var$o(ze, "drawCircle");
    function $n(e1) {
        if (e1.radiusX === void 0 || e1.radiusY === void 0) throw new O('drawEllipse() requires properties "radiusX" and "radiusY".');
        if (e1.radiusX === 0 || e1.radiusY === 0) return;
        let n = e1.start ?? 0, s = e1.end ?? 360, i1 = $b792be6a00d98dad$var$et(e1.anchor ?? "center").scale(new $b792be6a00d98dad$var$y(-e1.radiusX, -e1.radiusY)), a1 = ut(i1, e1.radiusX, e1.radiusY, n, s, e1.resolution);
        a1.unshift(i1);
        let u1 = Object.assign({}, e1, {
            pts: a1,
            radius: 0,
            ...e1.gradient ? {
                colors: [
                    e1.gradient[0],
                    ...Array(a1.length - 1).fill(e1.gradient[1])
                ]
            } : {}
        });
        if (s - n >= 360 && e1.outline) {
            e1.fill !== !1 && Ie(Object.assign(u1, {
                outline: null
            })), Ie(Object.assign(u1, {
                pts: a1.slice(1),
                fill: !1
            }));
            return;
        }
        Ie(u1);
    }
    $b792be6a00d98dad$var$o($n, "drawEllipse");
    function Ie(e1) {
        if (!e1.pts) throw new O('drawPolygon() requires property "pts".');
        let n = e1.pts.length;
        if (!(n < 3)) {
            if (V(), l(e1.pos), x(e1.scale), T(e1.angle), l(e1.offset), e1.fill !== !1) {
                let s = e1.color ?? $b792be6a00d98dad$var$$.WHITE, i1 = e1.pts.map((u1, f)=>({
                        pos: new $b792be6a00d98dad$var$y(u1.x, u1.y),
                        uv: new $b792be6a00d98dad$var$y(0, 0),
                        color: e1.colors ? e1.colors[f] ?? s : s,
                        opacity: e1.opacity ?? 1
                    })), a1 = [
                    ...Array(n - 2).keys()
                ].map((u1)=>[
                        0,
                        u1 + 1,
                        u1 + 2
                    ]).flat();
                ce(i1, e1.indices ?? a1, e1.fixed, v.defTex, e1.shader, e1.uniform);
            }
            e1.outline && Hn({
                pts: [
                    ...e1.pts,
                    e1.pts[0]
                ],
                radius: e1.radius,
                width: e1.outline.width,
                color: e1.outline.color,
                join: e1.outline.join,
                uniform: e1.uniform,
                fixed: e1.fixed,
                opacity: e1.opacity
            }), ee();
        }
    }
    $b792be6a00d98dad$var$o(Ie, "drawPolygon");
    function Kn(e1, n, s) {
        me(), d.clear(d.STENCIL_BUFFER_BIT), d.enable(d.STENCIL_TEST), d.stencilFunc(d.NEVER, 1, 255), d.stencilOp(d.REPLACE, d.REPLACE, d.REPLACE), n(), me(), d.stencilFunc(s, 1, 255), d.stencilOp(d.KEEP, d.KEEP, d.KEEP), e1(), me(), d.disable(d.STENCIL_TEST);
    }
    $b792be6a00d98dad$var$o(Kn, "drawStenciled");
    function zn(e1, n) {
        Kn(e1, n, d.EQUAL);
    }
    $b792be6a00d98dad$var$o(zn, "drawMasked");
    function Yn(e1, n) {
        Kn(e1, n, d.NOTEQUAL);
    }
    $b792be6a00d98dad$var$o(Yn, "drawSubtracted");
    function Xn() {
        return (v.viewport.width + v.viewport.height) / (v.width + v.height);
    }
    $b792be6a00d98dad$var$o(Xn, "getViewportScale");
    function Fe(e1) {
        me();
        let n = v.width, s = v.height;
        v.width = v.viewport.width, v.height = v.viewport.height, e1(), me(), v.width = n, v.height = s;
    }
    $b792be6a00d98dad$var$o(Fe, "drawUnscaled");
    function Wn(e1, n) {
        n.pos && (e1.pos = e1.pos.add(n.pos)), n.scale && (e1.scale = e1.scale.scale($b792be6a00d98dad$var$C(n.scale))), n.angle && (e1.angle += n.angle), n.color && (e1.color = e1.color.mult(n.color)), n.opacity && (e1.opacity *= n.opacity);
    }
    $b792be6a00d98dad$var$o(Wn, "applyCharTransform");
    let Jn = /\[(?<style>\w+)\](?<text>.*?)\[\/\k<style>\]/g;
    function Qs(e1) {
        let n = {}, s = e1.replace(Jn, "$2"), i1 = 0;
        for (let a1 of e1.matchAll(Jn)){
            let u1 = a1.index - i1;
            for(let f = 0; f < a1.groups.text.length; f++)n[f + u1] = [
                a1.groups.style
            ];
            i1 += a1[0].length - a1.groups.text.length;
        }
        return {
            charStyleMap: n,
            text: s
        };
    }
    $b792be6a00d98dad$var$o(Qs, "compileStyledText");
    let fn = {};
    function Ve(e1) {
        if (e1.text === void 0) throw new O('formatText() requires property "text".');
        let n = rt(e1.font);
        if (e1.text === "" || n instanceof re || !n) return {
            width: 0,
            height: 0,
            chars: [],
            opt: e1
        };
        let { charStyleMap: s, text: i1 } = Qs(e1.text + ""), a1 = i1.split("");
        if (n instanceof Ke || typeof n == "string") {
            let Y = n instanceof Ke ? n.fontface.family : n, N = n instanceof Ke ? {
                outline: n.outline,
                filter: n.filter
            } : {
                outline: null,
                filter: $b792be6a00d98dad$var$jn
            }, I = fn[Y] ?? {
                font: {
                    tex: new Q($b792be6a00d98dad$var$Hs, $b792be6a00d98dad$var$qs, {
                        filter: N.filter
                    }),
                    map: {},
                    size: $b792be6a00d98dad$var$Ns
                },
                cursor: new $b792be6a00d98dad$var$y(0),
                outline: N.outline
            };
            fn[Y] || (fn[Y] = I), n = I.font;
            for (let de of a1)if (!I.font.map[de]) {
                let b = ue;
                b.clearRect(0, 0, Z.width, Z.height), b.font = `${n.size}px ${Y}`, b.textBaseline = "top", b.textAlign = "left", b.fillStyle = "#ffffff";
                let R = b.measureText(de), G = Math.ceil(R.width), B = n.size;
                I.outline && (b.lineJoin = "round", b.lineWidth = I.outline.width * 2, b.strokeStyle = I.outline.color.toHex(), b.strokeText(de, I.outline.width, I.outline.width), G += I.outline.width * 2, B += I.outline.width * 3), b.fillText(de, I.outline?.width ?? 0, I.outline?.width ?? 0);
                let H = b.getImageData(0, 0, G, B);
                if (I.cursor.x + G > $b792be6a00d98dad$var$Hs && (I.cursor.x = 0, I.cursor.y += B, I.cursor.y > $b792be6a00d98dad$var$qs)) throw new O("Font atlas exceeds character limit");
                n.tex.update(H, I.cursor.x, I.cursor.y), n.map[de] = new $b792be6a00d98dad$var$oe(I.cursor.x, I.cursor.y, G, B), I.cursor.x += G;
            }
        }
        let u1 = e1.size || n.size, f = $b792be6a00d98dad$var$C(e1.scale ?? 1).scale(u1 / n.size), p1 = e1.lineSpacing ?? 0, m1 = e1.letterSpacing ?? 0, h1 = 0, g = 0, E = 0, M = [], F = [], _ = 0, D1 = null, P = null;
        for(; _ < a1.length;){
            let Y = a1[_];
            if (Y === `
`) E += u1 + p1, M.push({
                width: h1 - m1,
                chars: F
            }), D1 = null, P = null, h1 = 0, F = [];
            else {
                let N = n.map[Y];
                if (N) {
                    let I = N.w * f.x;
                    e1.width && h1 + I > e1.width && (E += u1 + p1, D1 != null && (_ -= F.length - D1, Y = a1[_], N = n.map[Y], I = N.w * f.x, F = F.slice(0, D1 - 1), h1 = P), D1 = null, P = null, M.push({
                        width: h1 - m1,
                        chars: F
                    }), h1 = 0, F = []), F.push({
                        tex: n.tex,
                        width: N.w,
                        height: N.h,
                        quad: new $b792be6a00d98dad$var$oe(N.x / n.tex.width, N.y / n.tex.height, N.w / n.tex.width, N.h / n.tex.height),
                        ch: Y,
                        pos: new $b792be6a00d98dad$var$y(h1, E),
                        opacity: e1.opacity ?? 1,
                        color: e1.color ?? $b792be6a00d98dad$var$$.WHITE,
                        scale: $b792be6a00d98dad$var$C(f),
                        angle: 0
                    }), Y === " " && (D1 = F.length, P = h1), h1 += I, g = Math.max(g, h1), h1 += m1;
                }
            }
            _++;
        }
        M.push({
            width: h1 - m1,
            chars: F
        }), E += u1, e1.width && (g = e1.width);
        let se = [];
        for (let Y of M){
            let N = (g - Y.width) * $b792be6a00d98dad$var$Fi(e1.align ?? "left");
            for (let I of Y.chars){
                let de = n.map[I.ch], b = se.length;
                if (I.pos = I.pos.add(N, 0).add(de.w * f.x * .5, de.h * f.y * .5), e1.transform) {
                    let R = typeof e1.transform == "function" ? e1.transform(b, I.ch) : e1.transform;
                    R && Wn(I, R);
                }
                if (s[b]) {
                    let R = s[b];
                    for (let G of R){
                        let B = e1.styles[G], H = typeof B == "function" ? B(b, I.ch) : B;
                        H && Wn(I, H);
                    }
                }
                se.push(I);
            }
        }
        return {
            width: g,
            height: E,
            chars: se,
            opt: e1
        };
    }
    $b792be6a00d98dad$var$o(Ve, "formatText");
    function Qn(e1) {
        ke(Ve(e1));
    }
    $b792be6a00d98dad$var$o(Qn, "drawText");
    function ke(e1) {
        V(), l(e1.opt.pos), T(e1.opt.angle), l($b792be6a00d98dad$var$et(e1.opt.anchor ?? "topleft").add(1, 1).scale(e1.width, e1.height).scale(-0.5)), e1.chars.forEach((n)=>{
            z({
                tex: n.tex,
                width: n.width,
                height: n.height,
                pos: n.pos,
                scale: n.scale,
                angle: n.angle,
                color: n.color,
                opacity: n.opacity,
                quad: n.quad,
                anchor: "center",
                uniform: e1.opt.uniform,
                shader: e1.opt.shader,
                fixed: e1.opt.fixed
            });
        }), ee();
    }
    $b792be6a00d98dad$var$o(ke, "drawFormattedText");
    function ge() {
        return v.width;
    }
    $b792be6a00d98dad$var$o(ge, "width");
    function we() {
        return v.height;
    }
    $b792be6a00d98dad$var$o(we, "height");
    let Ye = {};
    function Zs(e1) {
        return new $b792be6a00d98dad$var$y((e1.x - v.viewport.x) * ge() / v.viewport.width, (e1.y - v.viewport.y) * we() / v.viewport.height);
    }
    $b792be6a00d98dad$var$o(Zs, "windowToContent");
    function er(e1) {
        return new $b792be6a00d98dad$var$y(e1.x * v.viewport.width / v.width, e1.y * v.viewport.height / v.height);
    }
    $b792be6a00d98dad$var$o(er, "contentToView");
    function Gt() {
        return Zs(U.mousePos());
    }
    $b792be6a00d98dad$var$o(Gt, "mousePos"), Ye.error = (e1)=>{
        e1.error && e1.error instanceof O ? Un(e1.error) : e1 instanceof O && Un(e1);
    }, Ye.unhandledrejection = (e1)=>{
        e1.reason instanceof O && Un(e1.reason);
    };
    for(let e1 in Ye)window.addEventListener(e1, Ye[e1]);
    let Zn = !1, te = {
        inspect: !1,
        timeScale: 1,
        showLog: !0,
        fps: ()=>U.fps(),
        numFrames: ()=>U.numFrames(),
        stepFrame: hs,
        drawCalls: ()=>v.drawCalls,
        clearLog: ()=>A.logs = [],
        log: (e1)=>{
            let n = r.logMax ?? $b792be6a00d98dad$var$Oi;
            A.logs.unshift({
                msg: e1,
                time: U.time()
            }), A.logs.length > n && (A.logs = A.logs.slice(0, n));
        },
        error: (e1)=>te.log(new O(e1.toString ? e1.toString() : e1)),
        curRecording: null,
        numObjects: ()=>yn("*", {
                recursive: !0
            }).length,
        get paused () {
            return Zn;
        },
        set paused (e){
            Zn = e, e ? ne.ctx.suspend() : ne.ctx.resume();
        }
    };
    function Ue() {
        return U.dt() * te.timeScale;
    }
    $b792be6a00d98dad$var$o(Ue, "dt");
    function tr(...e1) {
        return e1.length > 0 && (A.cam.pos = $b792be6a00d98dad$var$C(...e1)), A.cam.pos ? A.cam.pos.clone() : kt();
    }
    $b792be6a00d98dad$var$o(tr, "camPos");
    function nr(...e1) {
        return e1.length > 0 && (A.cam.scale = $b792be6a00d98dad$var$C(...e1)), A.cam.scale.clone();
    }
    $b792be6a00d98dad$var$o(nr, "camScale");
    function sr(e1) {
        return e1 !== void 0 && (A.cam.angle = e1), A.cam.angle;
    }
    $b792be6a00d98dad$var$o(sr, "camRot");
    function rr(e1 = 12) {
        A.cam.shake += e1;
    }
    $b792be6a00d98dad$var$o(rr, "shake");
    function es(e1) {
        return A.cam.transform.multVec2(e1);
    }
    $b792be6a00d98dad$var$o(es, "toScreen");
    function ts(e1) {
        return A.cam.transform.invert().multVec2(e1);
    }
    $b792be6a00d98dad$var$o(ts, "toWorld");
    function Ft(e1) {
        let n = new $b792be6a00d98dad$var$be;
        return e1.pos && n.translate(e1.pos), e1.scale && n.scale(e1.scale), e1.angle && n.rotate(e1.angle), e1.parent ? n.mult(e1.parent.transform) : n;
    }
    $b792be6a00d98dad$var$o(Ft, "calcTransform");
    function mn(e1 = []) {
        let n = new Map, s = {}, i1 = new $b792be6a00d98dad$var$De, a1 = [], u1 = null, f = !1, p1 = {
            id: $b792be6a00d98dad$var$Ms(),
            hidden: !1,
            transform: new $b792be6a00d98dad$var$be,
            children: [],
            parent: null,
            set paused (h){
                if (h !== f) {
                    f = h;
                    for (let g of a1)g.paused = h;
                }
            },
            get paused () {
                return f;
            },
            add (h1 = []) {
                let g = Array.isArray(h1) ? mn(h1) : h1;
                if (g.parent) throw new O("Cannot add a game obj that already has a parent.");
                return g.parent = this, g.transform = Ft(g), this.children.push(g), g.trigger("add", g), A.events.trigger("add", g), g;
            },
            readd (h1) {
                let g = this.children.indexOf(h1);
                return g !== -1 && (this.children.splice(g, 1), this.children.push(h1)), h1;
            },
            remove (h1) {
                let g = this.children.indexOf(h1);
                if (g !== -1) {
                    h1.parent = null, this.children.splice(g, 1);
                    let E = $b792be6a00d98dad$var$o((M)=>{
                        M.trigger("destroy"), A.events.trigger("destroy", M), M.children.forEach((F)=>E(F));
                    }, "trigger");
                    E(h1);
                }
            },
            removeAll (h1) {
                if (h1) this.get(h1).forEach((g)=>this.remove(g));
                else for (let g of [
                    ...this.children
                ])this.remove(g);
            },
            update () {
                this.paused || (this.children.sort((h1, g)=>(h1.z ?? 0) - (g.z ?? 0)).forEach((h1)=>h1.update()), this.trigger("update"));
            },
            draw () {
                if (this.hidden) return;
                let h1 = v.fixed;
                this.fixed && (v.fixed = !0), V(), l(this.pos), x(this.scale), T(this.angle);
                let g = this.children.sort((E, M)=>(E.z ?? 0) - (M.z ?? 0));
                if (this.mask) {
                    let E = {
                        intersect: zn,
                        subtract: Yn
                    }[this.mask];
                    if (!E) throw new O(`Invalid mask func: "${this.mask}"`);
                    E(()=>{
                        g.forEach((M)=>M.draw());
                    }, ()=>{
                        this.trigger("draw");
                    });
                } else this.trigger("draw"), g.forEach((E)=>E.draw());
                ee(), v.fixed = h1;
            },
            drawInspect () {
                this.hidden || (V(), l(this.pos), x(this.scale), T(this.angle), this.children.sort((h1, g)=>(h1.z ?? 0) - (g.z ?? 0)).forEach((h1)=>h1.drawInspect()), this.trigger("drawInspect"), ee());
            },
            use (h1) {
                if (!h1) return;
                if (typeof h1 == "string") return this.use({
                    id: h1
                });
                let g = [];
                h1.id && (this.unuse(h1.id), s[h1.id] = [], g = s[h1.id], n.set(h1.id, h1));
                for(let M in h1){
                    if ($b792be6a00d98dad$var$Di.has(M)) continue;
                    let F = Object.getOwnPropertyDescriptor(h1, M);
                    if (typeof F.value == "function" && (h1[M] = h1[M].bind(this)), F.set && Object.defineProperty(h1, M, {
                        set: F.set.bind(this)
                    }), F.get && Object.defineProperty(h1, M, {
                        get: F.get.bind(this)
                    }), $b792be6a00d98dad$var$Gi.has(M)) {
                        let _ = M === "add" ? ()=>{
                            u1 = $b792be6a00d98dad$var$o((D1)=>g.push(D1), "onCurCompCleanup"), h1[M](), u1 = null;
                        } : h1[M];
                        g.push(this.on(M, _).cancel);
                    } else if (this[M] === void 0) Object.defineProperty(this, M, {
                        get: ()=>h1[M],
                        set: (_)=>h1[M] = _,
                        configurable: !0,
                        enumerable: !0
                    }), g.push(()=>delete this[M]);
                    else throw new O(`Duplicate component property: "${M}"`);
                }
                let E = $b792be6a00d98dad$var$o(()=>{
                    if (h1.require) {
                        for (let M of h1.require)if (!this.c(M)) throw new O(`Component "${h1.id}" requires component "${M}"`);
                    }
                }, "checkDeps");
                h1.destroy && g.push(h1.destroy.bind(this)), this.exists() ? (E(), h1.add && (u1 = $b792be6a00d98dad$var$o((M)=>g.push(M), "onCurCompCleanup"), h1.add.call(this), u1 = null)) : h1.require && g.push(this.on("add", E).cancel);
            },
            unuse (h1) {
                s[h1] && (s[h1].forEach((g)=>g()), delete s[h1]), n.has(h1) && n.delete(h1);
            },
            c (h1) {
                return n.get(h1);
            },
            get (h1, g = {}) {
                let E = g.recursive ? this.children.flatMap($b792be6a00d98dad$var$o(function M(F) {
                    return [
                        F,
                        ...F.children.flatMap(M)
                    ];
                }, "recurse")) : this.children;
                if (E = E.filter((M)=>h1 ? M.is(h1) : !0), g.liveUpdate) {
                    let M = $b792be6a00d98dad$var$o((F)=>g.recursive ? this.isAncestorOf(F) : F.parent === this, "isChild");
                    gn((F)=>{
                        M(F) && F.is(h1) && E.push(F);
                    }), ns((F)=>{
                        if (M(F) && F.is(h1)) {
                            let _ = E.findIndex((D1)=>D1.id === F.id);
                            _ !== -1 && E.splice(_, 1);
                        }
                    });
                }
                return E;
            },
            isAncestorOf (h1) {
                return h1.parent ? h1.parent === this || this.isAncestorOf(h1.parent) : !1;
            },
            exists () {
                return A.root.isAncestorOf(this);
            },
            is (h1) {
                if (h1 === "*") return !0;
                if (Array.isArray(h1)) {
                    for (let g of h1)if (!this.c(g)) return !1;
                    return !0;
                } else return this.c(h1) != null;
            },
            on (h1, g) {
                let E = i1.on(h1, g.bind(this));
                return u1 && u1(()=>E.cancel()), E;
            },
            trigger (h1, ...g) {
                i1.trigger(h1, ...g), A.objEvents.trigger(h1, this, ...g);
            },
            destroy () {
                this.parent && this.parent.remove(this);
            },
            inspect () {
                let h1 = {};
                for (let [g, E] of n)h1[g] = E.inspect ? E.inspect() : null;
                return h1;
            },
            onAdd (h1) {
                return this.on("add", h1);
            },
            onUpdate (h1) {
                return this.on("update", h1);
            },
            onDraw (h1) {
                return this.on("draw", h1);
            },
            onDestroy (h1) {
                return this.on("destroy", h1);
            },
            clearEvents () {
                i1.clear();
            }
        }, m1 = [
            "onKeyPress",
            "onKeyPressRepeat",
            "onKeyDown",
            "onKeyRelease",
            "onMousePress",
            "onMouseDown",
            "onMouseRelease",
            "onMouseMove",
            "onCharInput",
            "onMouseMove",
            "onTouchStart",
            "onTouchMove",
            "onTouchEnd",
            "onScroll",
            "onGamepadButtonPress",
            "onGamepadButtonDown",
            "onGamepadButtonRelease",
            "onGamepadStick"
        ];
        for (let h1 of m1)p1[h1] = (...g)=>{
            let E = U[h1](...g);
            return a1.push(E), p1.onDestroy(()=>E.cancel()), E;
        };
        for (let h1 of e1)p1.use(h1);
        return p1;
    }
    $b792be6a00d98dad$var$o(mn, "make");
    function Be(e1, n, s) {
        return A.objEvents[e1] || (A.objEvents[e1] = new $b792be6a00d98dad$var$vt), A.objEvents.on(e1, (i1, ...a1)=>{
            i1.is(n) && s(i1, ...a1);
        });
    }
    $b792be6a00d98dad$var$o(Be, "on");
    let pn = $b792be6a00d98dad$var$o((e1, n)=>{
        if (typeof e1 == "function" && n === void 0) {
            let s = dt([
                {
                    update: e1
                }
            ]);
            return {
                get paused () {
                    return s.paused;
                },
                set paused (i){
                    s.paused = i;
                },
                cancel: ()=>s.destroy()
            };
        } else if (typeof e1 == "string") return Be("update", e1, n);
    }, "onUpdate"), ir = $b792be6a00d98dad$var$o((e1, n)=>{
        if (typeof e1 == "function" && n === void 0) {
            let s = dt([
                {
                    draw: e1
                }
            ]);
            return {
                get paused () {
                    return s.hidden;
                },
                set paused (i){
                    s.hidden = i;
                },
                cancel: ()=>s.destroy()
            };
        } else if (typeof e1 == "string") return Be("draw", e1, n);
    }, "onDraw");
    function gn(e1, n) {
        if (typeof e1 == "function" && n === void 0) return A.events.on("add", e1);
        if (typeof e1 == "string") return Be("add", e1, n);
    }
    $b792be6a00d98dad$var$o(gn, "onAdd");
    function ns(e1, n) {
        if (typeof e1 == "function" && n === void 0) return A.events.on("destroy", e1);
        if (typeof e1 == "string") return Be("destroy", e1, n);
    }
    $b792be6a00d98dad$var$o(ns, "onDestroy");
    function or(e1, n, s) {
        return Be("collide", e1, (i1, a1, u1)=>a1.is(n) && s(i1, a1, u1));
    }
    $b792be6a00d98dad$var$o(or, "onCollide");
    function ar(e1, n, s) {
        return Be("collideUpdate", e1, (i1, a1, u1)=>a1.is(n) && s(i1, a1, u1));
    }
    $b792be6a00d98dad$var$o(ar, "onCollideUpdate");
    function ur(e1, n, s) {
        return Be("collideEnd", e1, (i1, a1, u1)=>a1.is(n) && s(i1, a1, u1));
    }
    $b792be6a00d98dad$var$o(ur, "onCollideEnd");
    function Bt(e1, n) {
        yn(e1, {
            recursive: !0
        }).forEach(n), gn(e1, n);
    }
    $b792be6a00d98dad$var$o(Bt, "forAllCurrentAndFuture");
    function cr(e1, n) {
        if (typeof e1 == "function") return U.onMousePress(e1);
        {
            let s = [];
            return Bt(e1, (i1)=>{
                if (!i1.area) throw new O("onClick() requires the object to have area() component");
                s.push(i1.onClick(()=>n(i1)));
            }), $b792be6a00d98dad$var$Re.join(s);
        }
    }
    $b792be6a00d98dad$var$o(cr, "onClick");
    function lr(e1, n) {
        let s = [];
        return Bt(e1, (i1)=>{
            if (!i1.area) throw new O("onHover() requires the object to have area() component");
            s.push(i1.onHover(()=>n(i1)));
        }), $b792be6a00d98dad$var$Re.join(s);
    }
    $b792be6a00d98dad$var$o(lr, "onHover");
    function hr(e1, n) {
        let s = [];
        return Bt(e1, (i1)=>{
            if (!i1.area) throw new O("onHoverUpdate() requires the object to have area() component");
            s.push(i1.onHoverUpdate(()=>n(i1)));
        }), $b792be6a00d98dad$var$Re.join(s);
    }
    $b792be6a00d98dad$var$o(hr, "onHoverUpdate");
    function dr(e1, n) {
        let s = [];
        return Bt(e1, (i1)=>{
            if (!i1.area) throw new O("onHoverEnd() requires the object to have area() component");
            s.push(i1.onHoverEnd(()=>n(i1)));
        }), $b792be6a00d98dad$var$Re.join(s);
    }
    $b792be6a00d98dad$var$o(dr, "onHoverEnd");
    function Lt(e1, n) {
        let s = 0, i1 = [];
        n && i1.push(n);
        let a1 = pn(()=>{
            s += Ue(), s >= e1 && (a1.cancel(), i1.forEach((u1)=>u1()));
        });
        return {
            paused: a1.paused,
            cancel: a1.cancel,
            onEnd (u1) {
                i1.push(u1);
            },
            then (u1) {
                return this.onEnd(u1), this;
            }
        };
    }
    $b792be6a00d98dad$var$o(Lt, "wait");
    function fr(e1, n) {
        let s = null, i1 = $b792be6a00d98dad$var$o(()=>{
            s = Lt(e1, i1), n();
        }, "newAction");
        return s = Lt(0, i1), {
            get paused () {
                return s.paused;
            },
            set paused (a){
                s.paused = a;
            },
            cancel: ()=>s.cancel()
        };
    }
    $b792be6a00d98dad$var$o(fr, "loop");
    function ss() {
        U.onKeyPress("f1", ()=>{
            te.inspect = !te.inspect;
        }), U.onKeyPress("f2", ()=>{
            te.clearLog();
        }), U.onKeyPress("f8", ()=>{
            te.paused = !te.paused;
        }), U.onKeyPress("f7", ()=>{
            te.timeScale = lt($b792be6a00d98dad$var$Me(te.timeScale - .2, 0, 2), 1);
        }), U.onKeyPress("f9", ()=>{
            te.timeScale = lt($b792be6a00d98dad$var$Me(te.timeScale + .2, 0, 2), 1);
        }), U.onKeyPress("f10", ()=>{
            te.stepFrame();
        });
    }
    $b792be6a00d98dad$var$o(ss, "enterDebugMode");
    function rs() {
        U.onKeyPress("b", ()=>it());
    }
    $b792be6a00d98dad$var$o(rs, "enterBurpMode");
    function mr(e1) {
        A.gravity = e1;
    }
    $b792be6a00d98dad$var$o(mr, "setGravity");
    function pr() {
        return A.gravity;
    }
    $b792be6a00d98dad$var$o(pr, "getGravity");
    function gr(...e1) {
        e1.length === 1 || e1.length === 2 ? (v.bgColor = $b792be6a00d98dad$var$W(e1[0]), e1[1] && (v.bgAlpha = e1[1])) : (e1.length === 3 || e1.length === 4) && (v.bgColor = $b792be6a00d98dad$var$W(e1[0], e1[1], e1[2]), e1[3] && (v.bgAlpha = e1[3])), d.clearColor(v.bgColor.r / 255, v.bgColor.g / 255, v.bgColor.b / 255, v.bgAlpha);
    }
    $b792be6a00d98dad$var$o(gr, "setBackground");
    function wr() {
        return v.bgColor.clone();
    }
    $b792be6a00d98dad$var$o(wr, "getBackground");
    function It(...e1) {
        return {
            id: "pos",
            pos: $b792be6a00d98dad$var$C(...e1),
            moveBy (...n) {
                this.pos = this.pos.add($b792be6a00d98dad$var$C(...n));
            },
            move (...n) {
                this.moveBy($b792be6a00d98dad$var$C(...n).scale(Ue()));
            },
            moveTo (...n) {
                if (typeof n[0] == "number" && typeof n[1] == "number") return this.moveTo($b792be6a00d98dad$var$C(n[0], n[1]), n[2]);
                let s = n[0], i1 = n[1];
                if (i1 === void 0) {
                    this.pos = $b792be6a00d98dad$var$C(s);
                    return;
                }
                let a1 = s.sub(this.pos);
                if (a1.len() <= i1 * Ue()) {
                    this.pos = $b792be6a00d98dad$var$C(s);
                    return;
                }
                this.move(a1.unit().scale(i1));
            },
            worldPos () {
                return this.parent ? this.parent.transform.multVec2(this.pos) : this.pos;
            },
            screenPos () {
                let n = this.worldPos();
                return ht(this) ? n : es(n);
            },
            inspect () {
                return `(${Math.round(this.pos.x)}, ${Math.round(this.pos.y)})`;
            },
            drawInspect () {
                ze({
                    color: $b792be6a00d98dad$var$W(255, 0, 0),
                    radius: 4 / Xn()
                });
            }
        };
    }
    $b792be6a00d98dad$var$o(It, "pos");
    function Vt(...e1) {
        return e1.length === 0 ? Vt(1) : {
            id: "scale",
            scale: $b792be6a00d98dad$var$C(...e1),
            scaleTo (...n) {
                this.scale = $b792be6a00d98dad$var$C(...n);
            },
            scaleBy (...n) {
                this.scale.scale($b792be6a00d98dad$var$C(...n));
            },
            inspect () {
                return `(${lt(this.scale.x, 2)}, ${lt(this.scale.y, 2)})`;
            }
        };
    }
    $b792be6a00d98dad$var$o(Vt, "scale");
    function vr(e1) {
        return {
            id: "rotate",
            angle: e1 ?? 0,
            rotateBy (n) {
                this.angle += n;
            },
            rotateTo (n) {
                this.angle = n;
            },
            inspect () {
                return `${Math.round(this.angle)}`;
            }
        };
    }
    $b792be6a00d98dad$var$o(vr, "rotate");
    function br(...e1) {
        return {
            id: "color",
            color: $b792be6a00d98dad$var$W(...e1),
            inspect () {
                return this.color.toString();
            }
        };
    }
    $b792be6a00d98dad$var$o(br, "color");
    function lt(e1, n) {
        return Number(e1.toFixed(n));
    }
    $b792be6a00d98dad$var$o(lt, "toFixed");
    function yr(e1) {
        return {
            id: "opacity",
            opacity: e1 ?? 1,
            inspect () {
                return `${lt(this.opacity, 1)}`;
            },
            fadeOut (n = 1, s = $b792be6a00d98dad$var$Ze.linear) {
                return En(this.opacity, 0, n, (i1)=>this.opacity = i1, s);
            }
        };
    }
    $b792be6a00d98dad$var$o(yr, "opacity");
    function wn(e1) {
        if (!e1) throw new O("Please define an anchor");
        return {
            id: "anchor",
            anchor: e1,
            inspect () {
                return typeof this.anchor == "string" ? this.anchor : this.anchor.toString();
            }
        };
    }
    $b792be6a00d98dad$var$o(wn, "anchor");
    function xr(e1) {
        return {
            id: "z",
            z: e1,
            inspect () {
                return `${this.z}`;
            }
        };
    }
    $b792be6a00d98dad$var$o(xr, "z");
    function Ur(e1, n) {
        return {
            id: "follow",
            require: [
                "pos"
            ],
            follow: {
                obj: e1,
                offset: n ?? $b792be6a00d98dad$var$C(0)
            },
            add () {
                e1.exists() && (this.pos = this.follow.obj.pos.add(this.follow.offset));
            },
            update () {
                e1.exists() && (this.pos = this.follow.obj.pos.add(this.follow.offset));
            }
        };
    }
    $b792be6a00d98dad$var$o(Ur, "follow");
    function Er(e1, n) {
        let s = typeof e1 == "number" ? $b792be6a00d98dad$var$y.fromAngle(e1) : e1.unit();
        return {
            id: "move",
            require: [
                "pos"
            ],
            update () {
                this.move(s.scale(n));
            }
        };
    }
    $b792be6a00d98dad$var$o(Er, "move");
    let Sr = 200;
    function Cr(e1 = {}) {
        let n = e1.distance ?? Sr, s = !1;
        return {
            id: "offscreen",
            require: [
                "pos"
            ],
            isOffScreen () {
                let i1 = this.screenPos(), a1 = new $b792be6a00d98dad$var$he($b792be6a00d98dad$var$C(0), ge(), we());
                return !$b792be6a00d98dad$var$pt(a1, i1) && a1.sdistToPoint(i1) > n * n;
            },
            onExitScreen (i1) {
                return this.on("exitView", i1);
            },
            onEnterScreen (i1) {
                return this.on("enterView", i1);
            },
            update () {
                this.isOffScreen() ? (s || (this.trigger("exitView"), s = !0), e1.hide && (this.hidden = !0), e1.pause && (this.paused = !0), e1.destroy && this.destroy()) : (s && (this.trigger("enterView"), s = !1), e1.hide && (this.hidden = !1), e1.pause && (this.paused = !1));
            }
        };
    }
    $b792be6a00d98dad$var$o(Cr, "offscreen");
    function ht(e1) {
        return e1.fixed ? !0 : e1.parent ? ht(e1.parent) : !1;
    }
    $b792be6a00d98dad$var$o(ht, "isFixed");
    function Tr(e1 = {}) {
        let n = {}, s = new Set;
        return {
            id: "area",
            collisionIgnore: e1.collisionIgnore ?? [],
            add () {
                this.area.cursor && this.onHover(()=>U.setCursor(this.area.cursor)), this.onCollideUpdate((i1, a1)=>{
                    n[i1.id] || this.trigger("collide", i1, a1), n[i1.id] = a1, s.add(i1.id);
                });
            },
            update () {
                for(let i1 in n)s.has(Number(i1)) || (this.trigger("collideEnd", n[i1].target), delete n[i1]);
                s.clear();
            },
            drawInspect () {
                let i1 = this.localArea();
                V(), x(this.area.scale), l(this.area.offset);
                let a1 = {
                    outline: {
                        width: 4 / Xn(),
                        color: $b792be6a00d98dad$var$W(0, 0, 255)
                    },
                    anchor: this.anchor,
                    fill: !1,
                    fixed: ht(this)
                };
                i1 instanceof $b792be6a00d98dad$var$he ? xe({
                    ...a1,
                    pos: i1.pos,
                    width: i1.width,
                    height: i1.height
                }) : i1 instanceof $b792be6a00d98dad$var$_e ? Ie({
                    ...a1,
                    pts: i1.pts
                }) : i1 instanceof $b792be6a00d98dad$var$gt && ze({
                    ...a1,
                    pos: i1.center,
                    radius: i1.radius
                }), ee();
            },
            area: {
                shape: e1.shape ?? null,
                scale: e1.scale ? $b792be6a00d98dad$var$C(e1.scale) : $b792be6a00d98dad$var$C(1),
                offset: e1.offset ?? $b792be6a00d98dad$var$C(0),
                cursor: e1.cursor ?? null
            },
            isClicked () {
                return U.isMousePressed() && this.isHovering();
            },
            isHovering () {
                let i1 = ht(this) ? Gt() : ts(Gt());
                return this.hasPoint(i1);
            },
            checkCollision (i1) {
                return n[i1.id] ?? null;
            },
            getCollisions () {
                return Object.values(n);
            },
            isColliding (i1) {
                return !!n[i1.id];
            },
            isOverlapping (i1) {
                let a1 = n[i1.id];
                return a1 && a1.hasOverlap();
            },
            onClick (i1) {
                let a1 = U.onMousePress("left", ()=>{
                    this.isHovering() && i1();
                });
                return this.onDestroy(()=>a1.cancel()), a1;
            },
            onHover (i1) {
                let a1 = !1;
                return this.onUpdate(()=>{
                    a1 ? a1 = this.isHovering() : this.isHovering() && (a1 = !0, i1());
                });
            },
            onHoverUpdate (i1) {
                return this.onUpdate(()=>{
                    this.isHovering() && i1();
                });
            },
            onHoverEnd (i1) {
                let a1 = !1;
                return this.onUpdate(()=>{
                    a1 ? this.isHovering() || (a1 = !1, i1()) : a1 = this.isHovering();
                });
            },
            onCollide (i1, a1) {
                if (typeof i1 == "function" && a1 === void 0) return this.on("collide", i1);
                if (typeof i1 == "string") return this.onCollide((u1, f)=>{
                    u1.is(i1) && a1(u1, f);
                });
            },
            onCollideUpdate (i1, a1) {
                if (typeof i1 == "function" && a1 === void 0) return this.on("collideUpdate", i1);
                if (typeof i1 == "string") return this.on("collideUpdate", (u1, f)=>u1.is(i1) && a1(u1, f));
            },
            onCollideEnd (i1, a1) {
                if (typeof i1 == "function" && a1 === void 0) return this.on("collideEnd", i1);
                if (typeof i1 == "string") return this.on("collideEnd", (u1)=>u1.is(i1) && a1(u1));
            },
            hasPoint (i1) {
                return $b792be6a00d98dad$var$Dn(this.worldArea(), i1);
            },
            resolveCollision (i1) {
                let a1 = this.checkCollision(i1);
                a1 && !a1.resolved && (this.pos = this.pos.add(a1.displacement), a1.resolved = !0);
            },
            localArea () {
                return this.area.shape ? this.area.shape : this.renderArea();
            },
            worldArea () {
                let i1 = this.localArea();
                if (!(i1 instanceof $b792be6a00d98dad$var$_e || i1 instanceof $b792be6a00d98dad$var$he)) throw new O("Only support polygon and rect shapes for now");
                let a1 = this.transform.clone().scale($b792be6a00d98dad$var$C(this.area.scale ?? 1)).translate(this.area.offset);
                if (i1 instanceof $b792be6a00d98dad$var$he) {
                    let u1 = $b792be6a00d98dad$var$et(this.anchor || $b792be6a00d98dad$var$Kt).add(1, 1).scale(-0.5).scale(i1.width, i1.height);
                    a1.translate(u1);
                }
                return i1.transform(a1);
            },
            screenArea () {
                let i1 = this.worldArea();
                return ht(this) ? i1 : i1.transform(A.cam.transform);
            }
        };
    }
    $b792be6a00d98dad$var$o(Tr, "area");
    function Xe(e1) {
        return {
            color: e1.color,
            opacity: e1.opacity,
            anchor: e1.anchor,
            outline: e1.outline,
            shader: e1.shader,
            uniform: e1.uniform
        };
    }
    $b792be6a00d98dad$var$o(Xe, "getRenderProps");
    function vn(e1, n = {}) {
        let s = null, i1 = null, a1 = null, u1 = new $b792be6a00d98dad$var$ve;
        if (!e1) throw new O("Please pass the resource name or data to sprite()");
        let f = $b792be6a00d98dad$var$o((p1, m1, h1, g)=>{
            let E = $b792be6a00d98dad$var$C(1, 1);
            return h1 && g ? (E.x = h1 / (p1.width * m1.w), E.y = g / (p1.height * m1.h)) : h1 ? (E.x = h1 / (p1.width * m1.w), E.y = E.x) : g && (E.y = g / (p1.height * m1.h), E.x = E.y), E;
        }, "calcTexScale");
        return {
            id: "sprite",
            width: 0,
            height: 0,
            frame: n.frame || 0,
            quad: n.quad || new $b792be6a00d98dad$var$oe(0, 0, 1, 1),
            animSpeed: n.animSpeed ?? 1,
            flipX: n.flipX ?? !1,
            flipY: n.flipY ?? !1,
            draw () {
                if (!s) return;
                let p1 = s.frames[this.frame ?? 0];
                if (!p1) throw new O(`Frame not found: ${this.frame ?? 0}`);
                if (s.slice9) {
                    let { left: m1, right: h1, top: g, bottom: E } = s.slice9, M = s.tex.width * p1.w, F = s.tex.height * p1.h, _ = this.width - m1 - h1, D1 = this.height - g - E, P = m1 / M, se = h1 / M, Y = 1 - P - se, N = g / F, I = E / F, de = 1 - N - I, b = [
                        $b792be6a00d98dad$var$ae(0, 0, P, N),
                        $b792be6a00d98dad$var$ae(P, 0, Y, N),
                        $b792be6a00d98dad$var$ae(P + Y, 0, se, N),
                        $b792be6a00d98dad$var$ae(0, N, P, de),
                        $b792be6a00d98dad$var$ae(P, N, Y, de),
                        $b792be6a00d98dad$var$ae(P + Y, N, se, de),
                        $b792be6a00d98dad$var$ae(0, N + de, P, I),
                        $b792be6a00d98dad$var$ae(P, N + de, Y, I),
                        $b792be6a00d98dad$var$ae(P + Y, N + de, se, I),
                        $b792be6a00d98dad$var$ae(0, 0, m1, g),
                        $b792be6a00d98dad$var$ae(m1, 0, _, g),
                        $b792be6a00d98dad$var$ae(m1 + _, 0, h1, g),
                        $b792be6a00d98dad$var$ae(0, g, m1, D1),
                        $b792be6a00d98dad$var$ae(m1, g, _, D1),
                        $b792be6a00d98dad$var$ae(m1 + _, g, h1, D1),
                        $b792be6a00d98dad$var$ae(0, g + D1, m1, E),
                        $b792be6a00d98dad$var$ae(m1, g + D1, _, E),
                        $b792be6a00d98dad$var$ae(m1 + _, g + D1, h1, E)
                    ];
                    for(let R = 0; R < 9; R++){
                        let G = b[R], B = b[R + 9];
                        Ae(Object.assign(Xe(this), {
                            pos: B.pos(),
                            tex: s.tex,
                            quad: p1.scale(G),
                            flipX: this.flipX,
                            flipY: this.flipY,
                            tiled: n.tiled,
                            width: B.w,
                            height: B.h
                        }));
                    }
                } else Ae(Object.assign(Xe(this), {
                    tex: s.tex,
                    quad: p1.scale(this.quad ?? new $b792be6a00d98dad$var$oe(0, 0, 1, 1)),
                    flipX: this.flipX,
                    flipY: this.flipY,
                    tiled: n.tiled,
                    width: this.width,
                    height: this.height
                }));
            },
            add () {
                let p1 = $b792be6a00d98dad$var$o((h1)=>{
                    let g = h1.frames[0].clone();
                    n.quad && (g = g.scale(n.quad));
                    let E = f(h1.tex, g, n.width, n.height);
                    this.width = h1.tex.width * g.w * E.x, this.height = h1.tex.height * g.h * E.y, n.anim && this.play(n.anim), s = h1, u1.trigger(s);
                }, "setSpriteData"), m1 = st(e1);
                m1 ? m1.onLoad(p1) : bn(()=>p1(st(e1).data));
            },
            update () {
                if (!i1) return;
                let p1 = s.anims[i1.name];
                if (typeof p1 == "number") {
                    this.frame = p1;
                    return;
                }
                if (p1.speed === 0) throw new O("Sprite anim speed cannot be 0");
                i1.timer += Ue() * this.animSpeed, i1.timer >= 1 / i1.speed && (i1.timer = 0, this.frame += a1, (this.frame < Math.min(p1.from, p1.to) || this.frame > Math.max(p1.from, p1.to)) && (i1.loop ? i1.pingpong ? (this.frame -= a1, a1 *= -1, this.frame += a1) : this.frame = p1.from : (this.frame = p1.to, i1.onEnd(), this.stop())));
            },
            play (p1, m1 = {}) {
                if (!s) {
                    u1.add(()=>this.play(p1, m1));
                    return;
                }
                let h1 = s.anims[p1];
                if (h1 === void 0) throw new O(`Anim not found: ${p1}`);
                i1 && this.stop(), i1 = typeof h1 == "number" ? {
                    name: p1,
                    timer: 0,
                    loop: !1,
                    pingpong: !1,
                    speed: 0,
                    onEnd: ()=>{}
                } : {
                    name: p1,
                    timer: 0,
                    loop: m1.loop ?? h1.loop ?? !1,
                    pingpong: m1.pingpong ?? h1.pingpong ?? !1,
                    speed: m1.speed ?? h1.speed ?? 10,
                    onEnd: m1.onEnd ?? (()=>{})
                }, a1 = typeof h1 == "number" ? null : h1.from < h1.to ? 1 : -1, this.frame = typeof h1 == "number" ? h1 : h1.from, this.trigger("animStart", p1);
            },
            stop () {
                if (!i1) return;
                let p1 = i1.name;
                i1 = null, this.trigger("animEnd", p1);
            },
            numFrames () {
                return s?.frames.length ?? 0;
            },
            curAnim () {
                return i1?.name;
            },
            onAnimEnd (p1) {
                return this.on("animEnd", p1);
            },
            onAnimStart (p1) {
                return this.on("animStart", p1);
            },
            renderArea () {
                return new $b792be6a00d98dad$var$he($b792be6a00d98dad$var$C(0), this.width, this.height);
            },
            inspect () {
                if (typeof e1 == "string") return `"${e1}"`;
            }
        };
    }
    $b792be6a00d98dad$var$o(vn, "sprite");
    function Ar(e1, n = {}) {
        function s(a1) {
            let u1 = Ve(Object.assign(Xe(a1), {
                text: a1.text + "",
                size: a1.textSize,
                font: a1.font,
                width: n.width && a1.width,
                align: a1.align,
                letterSpacing: a1.letterSpacing,
                lineSpacing: a1.lineSpacing,
                transform: a1.textTransform,
                styles: a1.textStyles
            }));
            return n.width || (a1.width = u1.width / (a1.scale?.x || 1)), a1.height = u1.height / (a1.scale?.y || 1), u1;
        }
        $b792be6a00d98dad$var$o(s, "update");
        let i1 = {
            id: "text",
            set text (a){
                e1 = a, s(this);
            },
            get text () {
                return e1;
            },
            textSize: n.size ?? $b792be6a00d98dad$var$Ti,
            font: n.font,
            width: n.width ?? 0,
            height: 0,
            align: n.align,
            lineSpacing: n.lineSpacing,
            letterSpacing: n.letterSpacing,
            textTransform: n.transform,
            textStyles: n.styles,
            add () {
                bn(()=>s(this));
            },
            draw () {
                ke(s(this));
            },
            renderArea () {
                return new $b792be6a00d98dad$var$he($b792be6a00d98dad$var$C(0), this.width, this.height);
            }
        };
        return s(i1), i1;
    }
    $b792be6a00d98dad$var$o(Ar, "text");
    function Or(e1, n, s = {}) {
        return {
            id: "rect",
            width: e1,
            height: n,
            radius: s.radius || 0,
            draw () {
                xe(Object.assign(Xe(this), {
                    width: this.width,
                    height: this.height,
                    radius: this.radius
                }));
            },
            renderArea () {
                return new $b792be6a00d98dad$var$he($b792be6a00d98dad$var$C(0), this.width, this.height);
            },
            inspect () {
                return `${Math.ceil(this.width)}, ${Math.ceil(this.height)}`;
            }
        };
    }
    $b792be6a00d98dad$var$o(Or, "rect");
    function Pr(e1, n) {
        return {
            id: "rect",
            width: e1,
            height: n,
            draw () {
                z(Object.assign(Xe(this), {
                    width: this.width,
                    height: this.height
                }));
            },
            renderArea () {
                return new $b792be6a00d98dad$var$he($b792be6a00d98dad$var$C(0), this.width, this.height);
            },
            inspect () {
                return `${Math.ceil(this.width)}, ${Math.ceil(this.height)}`;
            }
        };
    }
    $b792be6a00d98dad$var$o(Pr, "uvquad");
    function Mr(e1) {
        return {
            id: "circle",
            radius: e1,
            draw () {
                ze(Object.assign(Xe(this), {
                    radius: this.radius
                }));
            },
            renderArea () {
                return new $b792be6a00d98dad$var$he(new $b792be6a00d98dad$var$y(this.anchor ? 0 : -this.radius), this.radius * 2, this.radius * 2);
            },
            inspect () {
                return `${Math.ceil(this.radius)}`;
            }
        };
    }
    $b792be6a00d98dad$var$o(Mr, "circle");
    function Rr(e1 = 1, n = $b792be6a00d98dad$var$W(0, 0, 0)) {
        return {
            id: "outline",
            outline: {
                width: e1,
                color: n
            }
        };
    }
    $b792be6a00d98dad$var$o(Rr, "outline");
    function is() {
        return {
            id: "timer",
            wait (e1, n) {
                let s = [];
                n && s.push(n);
                let i1 = 0, a1 = this.onUpdate(()=>{
                    i1 += Ue(), i1 >= e1 && (s.forEach((u1)=>u1()), a1.cancel());
                });
                return {
                    get paused () {
                        return a1.paused;
                    },
                    set paused (u){
                        a1.paused = u;
                    },
                    cancel: a1.cancel,
                    onEnd (u1) {
                        s.push(u1);
                    },
                    then (u1) {
                        return this.onEnd(u1), this;
                    }
                };
            },
            loop (e1, n) {
                let s = null, i1 = $b792be6a00d98dad$var$o(()=>{
                    s = this.wait(e1, i1), n();
                }, "newAction");
                return s = this.wait(0, i1), {
                    get paused () {
                        return s.paused;
                    },
                    set paused (a){
                        s.paused = a;
                    },
                    cancel: ()=>s.cancel()
                };
            },
            tween (e1, n, s, i1, a1 = $b792be6a00d98dad$var$Ze.linear) {
                let u1 = 0, f = [], p1 = this.onUpdate(()=>{
                    u1 += Ue();
                    let m1 = Math.min(u1 / s, 1);
                    i1($b792be6a00d98dad$var$Se(e1, n, a1(m1))), m1 === 1 && (p1.cancel(), i1(n), f.forEach((h1)=>h1()));
                });
                return {
                    get paused () {
                        return p1.paused;
                    },
                    set paused (m){
                        p1.paused = m;
                    },
                    onEnd (m1) {
                        f.push(m1);
                    },
                    then (m1) {
                        return this.onEnd(m1), this;
                    },
                    cancel () {
                        p1.cancel();
                    },
                    finish () {
                        p1.cancel(), i1(n), f.forEach((m1)=>m1());
                    }
                };
            }
        };
    }
    $b792be6a00d98dad$var$o(is, "timer");
    let Dr = 640, Gr = 65536;
    function Fr(e1 = {}) {
        let n = $b792be6a00d98dad$var$C(0), s = null, i1 = null, a1 = !1;
        return {
            id: "body",
            require: [
                "pos",
                "area"
            ],
            jumpForce: e1.jumpForce ?? Dr,
            gravityScale: e1.gravityScale ?? 1,
            isStatic: e1.isStatic ?? !1,
            mass: e1.mass ?? 1,
            add () {
                if (this.mass === 0) throw new O("Can't set body mass to 0");
                this.onCollideUpdate((u1, f)=>{
                    if (u1.is("body") && !f.resolved && (this.trigger("beforePhysicsResolve", f), u1.trigger("beforePhysicsResolve", f.reverse()), !f.resolved && !(this.isStatic && u1.isStatic))) {
                        if (!this.isStatic && !u1.isStatic) {
                            let p1 = this.mass + u1.mass;
                            this.pos = this.pos.add(f.displacement.scale(u1.mass / p1)), u1.pos = u1.pos.add(f.displacement.scale(-this.mass / p1)), this.transform = Ft(this), u1.transform = Ft(u1);
                        } else {
                            let p1 = !this.isStatic && u1.isStatic ? f : f.reverse();
                            p1.source.pos = p1.source.pos.add(p1.displacement), p1.source.transform = Ft(p1.source);
                        }
                        f.resolved = !0, this.trigger("physicsResolve", f), u1.trigger("physicsResolve", f.reverse());
                    }
                }), this.onPhysicsResolve((u1)=>{
                    A.gravity && (u1.isBottom() && this.isFalling() ? (n.y = 0, s = u1.target, i1 = u1.target.pos, a1 ? a1 = !1 : this.trigger("ground", s)) : u1.isTop() && this.isJumping() && (n.y = 0, this.trigger("headbutt", u1.target)));
                });
            },
            update () {
                if (!A.gravity || this.isStatic) return;
                if (a1 && (s = null, i1 = null, this.trigger("fallOff"), a1 = !1), s) {
                    if (!this.isOverlapping(s) || !s.exists() || !s.is("body")) a1 = !0;
                    else {
                        !s.pos.eq(i1) && e1.stickToPlatform !== !1 && this.moveBy(s.pos.sub(i1)), i1 = s.pos;
                        return;
                    }
                }
                let u1 = n.y;
                n.y += A.gravity * this.gravityScale * Ue(), n.y = Math.min(n.y, e1.maxVelocity ?? Gr), u1 < 0 && n.y >= 0 && this.trigger("fall"), this.move(n);
            },
            onPhysicsResolve (u1) {
                return this.on("physicsResolve", u1);
            },
            onBeforePhysicsResolve (u1) {
                return this.on("beforePhysicsResolve", u1);
            },
            curPlatform () {
                return s;
            },
            isGrounded () {
                return s !== null;
            },
            isFalling () {
                return n.y > 0;
            },
            isJumping () {
                return n.y < 0;
            },
            jump (u1) {
                s = null, i1 = null, n.y = -u1 || -this.jumpForce;
            },
            onGround (u1) {
                return this.on("ground", u1);
            },
            onFall (u1) {
                return this.on("fall", u1);
            },
            onFallOff (u1) {
                return this.on("fallOff", u1);
            },
            onHeadbutt (u1) {
                return this.on("headbutt", u1);
            }
        };
    }
    $b792be6a00d98dad$var$o(Fr, "body");
    function Br(e1 = 2) {
        let n = e1;
        return {
            id: "doubleJump",
            require: [
                "body"
            ],
            numJumps: e1,
            add () {
                this.onGround(()=>{
                    n = this.numJumps;
                });
            },
            doubleJump (s) {
                n <= 0 || (n < this.numJumps && this.trigger("doubleJump"), n--, this.jump(s));
            },
            onDoubleJump (s) {
                return this.on("doubleJump", s);
            },
            inspect () {
                return `${n}`;
            }
        };
    }
    $b792be6a00d98dad$var$o(Br, "doubleJump");
    function Lr(e1, n) {
        return {
            id: "shader",
            shader: e1,
            ...typeof n == "function" ? {
                uniform: n(),
                update () {
                    this.uniform = n();
                }
            } : {
                uniform: n
            }
        };
    }
    $b792be6a00d98dad$var$o(Lr, "shader");
    function Ir() {
        return {
            id: "fixed",
            fixed: !0
        };
    }
    $b792be6a00d98dad$var$o(Ir, "fixed");
    function os(e1) {
        return {
            id: "stay",
            stay: !0,
            scenesToStay: e1
        };
    }
    $b792be6a00d98dad$var$o(os, "stay");
    function Vr(e1) {
        if (e1 == null) throw new O("health() requires the initial amount of hp");
        let n = e1;
        return {
            id: "health",
            hurt (s = 1) {
                this.setHP(e1 - s), this.trigger("hurt", s);
            },
            heal (s = 1) {
                this.setHP(e1 + s), this.trigger("heal", s);
            },
            hp () {
                return e1;
            },
            maxHP () {
                return n;
            },
            setHP (s) {
                e1 = s, e1 <= 0 && this.trigger("death");
            },
            onHurt (s) {
                return this.on("hurt", s);
            },
            onHeal (s) {
                return this.on("heal", s);
            },
            onDeath (s) {
                return this.on("death", s);
            },
            inspect () {
                return `${e1}`;
            }
        };
    }
    $b792be6a00d98dad$var$o(Vr, "health");
    function kr(e1, n = {}) {
        if (e1 == null) throw new O("lifespan() requires time");
        let s = n.fade ?? 0;
        return {
            id: "lifespan",
            async add () {
                await Lt(e1), s > 0 && this.opacity && await En(this.opacity, 0, s, (i1)=>this.opacity = i1, $b792be6a00d98dad$var$Ze.linear), this.destroy();
            }
        };
    }
    $b792be6a00d98dad$var$o(kr, "lifespan");
    function jr(e1, n, s) {
        if (!e1) throw new O("state() requires an initial state");
        let i1 = {};
        function a1(m1) {
            i1[m1] || (i1[m1] = {
                enter: new $b792be6a00d98dad$var$ve,
                end: new $b792be6a00d98dad$var$ve,
                update: new $b792be6a00d98dad$var$ve,
                draw: new $b792be6a00d98dad$var$ve
            });
        }
        $b792be6a00d98dad$var$o(a1, "initStateEvents");
        function u1(m1, h1, g) {
            return a1(h1), i1[h1][m1].add(g);
        }
        $b792be6a00d98dad$var$o(u1, "on");
        function f(m1, h1, ...g) {
            a1(h1), i1[h1][m1].trigger(...g);
        }
        $b792be6a00d98dad$var$o(f, "trigger");
        let p1 = !1;
        return {
            id: "state",
            state: e1,
            enterState (m1, ...h1) {
                if (p1 = !0, n && !n.includes(m1)) throw new O(`State not found: ${m1}`);
                let g = this.state;
                if (s) {
                    if (!s?.[g]) return;
                    let E = typeof s[g] == "string" ? [
                        s[g]
                    ] : s[g];
                    if (!E.includes(m1)) throw new O(`Cannot transition state from "${g}" to "${m1}". Available transitions: ${E.map((M)=>`"${M}"`).join(", ")}`);
                }
                f("end", g, ...h1), this.state = m1, f("enter", m1, ...h1), f("enter", `${g} -> ${m1}`, ...h1);
            },
            onStateTransition (m1, h1, g) {
                return u1("enter", `${m1} -> ${h1}`, g);
            },
            onStateEnter (m1, h1) {
                return u1("enter", m1, h1);
            },
            onStateUpdate (m1, h1) {
                return u1("update", m1, h1);
            },
            onStateDraw (m1, h1) {
                return u1("draw", m1, h1);
            },
            onStateEnd (m1, h1) {
                return u1("end", m1, h1);
            },
            update () {
                p1 || (f("enter", e1), p1 = !0), f("update", this.state);
            },
            draw () {
                f("draw", this.state);
            },
            inspect () {
                return this.state;
            }
        };
    }
    $b792be6a00d98dad$var$o(jr, "state");
    function Nr(e1 = 1) {
        let n = 0, s = !1;
        return {
            require: [
                "opacity"
            ],
            add () {
                this.opacity = 0;
            },
            update () {
                s || (n += Ue(), this.opacity = $b792be6a00d98dad$var$Nt(n, 0, e1, 0, 1), n >= e1 && (this.opacity = 1, s = !0));
            }
        };
    }
    $b792be6a00d98dad$var$o(Nr, "fadeIn");
    function _r(e1 = "intersect") {
        return {
            id: "mask",
            mask: e1
        };
    }
    $b792be6a00d98dad$var$o(_r, "mask");
    function bn(e1) {
        k.loaded ? e1() : A.events.on("load", e1);
    }
    $b792be6a00d98dad$var$o(bn, "onLoad");
    function Hr(e1, n) {
        A.scenes[e1] = n;
    }
    $b792be6a00d98dad$var$o(Hr, "scene");
    function qr(e1, ...n) {
        if (!A.scenes[e1]) throw new O(`Scene not found: ${e1}`);
        A.events.onOnce("frameEnd", ()=>{
            A.events.trigger("sceneLeave", e1), U.events.clear(), A.events.clear(), A.objEvents.clear(), [
                ...A.root.children
            ].forEach((s)=>{
                (!s.stay || s.scenesToStay && !s.scenesToStay.includes(e1)) && A.root.remove(s);
            }), A.root.clearEvents(), A.cam = {
                pos: null,
                scale: $b792be6a00d98dad$var$C(1),
                angle: 0,
                shake: 0,
                transform: new $b792be6a00d98dad$var$be
            }, A.scenes[e1](...n), r.debug !== !1 && ss(), r.burp && rs();
        });
    }
    $b792be6a00d98dad$var$o(qr, "go");
    function $r(e1) {
        return A.events.on("sceneLeave", e1);
    }
    $b792be6a00d98dad$var$o($r, "onSceneLeave");
    function Kr(e1, n) {
        try {
            return JSON.parse(window.localStorage[e1]);
        } catch  {
            return n ? (as(e1, n), n) : null;
        }
    }
    $b792be6a00d98dad$var$o(Kr, "getData");
    function as(e1, n) {
        window.localStorage[e1] = JSON.stringify(n);
    }
    $b792be6a00d98dad$var$o(as, "setData");
    function us(e1, ...n) {
        let s = e1(je), i1;
        typeof s == "function" ? i1 = s(...n)(je) : i1 = s;
        for(let a1 in i1)je[a1] = i1[a1], r.global !== !1 && (window[a1] = i1[a1]);
        return je;
    }
    $b792be6a00d98dad$var$o(us, "plug");
    function kt() {
        return $b792be6a00d98dad$var$C(ge() / 2, we() / 2);
    }
    $b792be6a00d98dad$var$o(kt, "center");
    let zr;
    ((P)=>(P[P.None = 0] = "None", P[P.Left = 1] = "Left", P[P.Top = 2] = "Top", P[P.LeftTop = 3] = "LeftTop", P[P.Right = 4] = "Right", P[P.Horizontal = 5] = "Horizontal", P[P.RightTop = 6] = "RightTop", P[P.HorizontalTop = 7] = "HorizontalTop", P[P.Bottom = 8] = "Bottom", P[P.LeftBottom = 9] = "LeftBottom", P[P.Vertical = 10] = "Vertical", P[P.LeftVertical = 11] = "LeftVertical", P[P.RightBottom = 12] = "RightBottom", P[P.HorizontalBottom = 13] = "HorizontalBottom", P[P.RightVertical = 14] = "RightVertical", P[P.All = 15] = "All"))(zr ||= {});
    function cs(e1 = {}) {
        let n = $b792be6a00d98dad$var$C(0), s = e1.isObstacle ?? !1, i1 = e1.cost ?? 0, a1 = e1.edges ?? [], u1 = $b792be6a00d98dad$var$o(()=>{
            let p1 = {
                left: 1,
                top: 2,
                right: 4,
                bottom: 8
            };
            return a1.map((m1)=>p1[m1] || 0).reduce((m1, h1)=>m1 | h1, 0);
        }, "getEdgeMask"), f = u1();
        return {
            id: "tile",
            tilePosOffset: e1.offset ?? $b792be6a00d98dad$var$C(0),
            set tilePos (p){
                let m1 = this.getLevel();
                n = p.clone(), this.pos = $b792be6a00d98dad$var$C(this.tilePos.x * m1.tileWidth(), this.tilePos.y * m1.tileHeight()).add(this.tilePosOffset);
            },
            get tilePos () {
                return n;
            },
            set isObstacle (p){
                s !== p && (s = p, this.getLevel().invalidateNavigationMap());
            },
            get isObstacle () {
                return s;
            },
            set cost (p){
                i1 !== p && (i1 = p, this.getLevel().invalidateNavigationMap());
            },
            get cost () {
                return i1;
            },
            set edges (p){
                a1 = p, f = u1(), this.getLevel().invalidateNavigationMap();
            },
            get edges () {
                return a1;
            },
            get edgeMask () {
                return f;
            },
            getLevel () {
                return this.parent;
            },
            moveLeft () {
                this.tilePos = this.tilePos.add($b792be6a00d98dad$var$C(-1, 0));
            },
            moveRight () {
                this.tilePos = this.tilePos.add($b792be6a00d98dad$var$C(1, 0));
            },
            moveUp () {
                this.tilePos = this.tilePos.add($b792be6a00d98dad$var$C(0, -1));
            },
            moveDown () {
                this.tilePos = this.tilePos.add($b792be6a00d98dad$var$C(0, 1));
            }
        };
    }
    $b792be6a00d98dad$var$o(cs, "tile");
    function Yr(e1, n) {
        if (!n.tileWidth || !n.tileHeight) throw new O("Must provide tileWidth and tileHeight.");
        let s = dt([
            It(n.pos ?? $b792be6a00d98dad$var$C(0))
        ]), i1 = e1.length, a1 = 0, u1 = null, f = null, p1 = null, m1 = null, h1 = $b792be6a00d98dad$var$o((b)=>b.x + b.y * a1, "tile2Hash"), g = $b792be6a00d98dad$var$o((b)=>$b792be6a00d98dad$var$C(Math.floor(b % a1), Math.floor(b / a1)), "hash2Tile"), E = $b792be6a00d98dad$var$o(()=>{
            u1 = [];
            for (let b of s.children)M(b);
        }, "createSpatialMap"), M = $b792be6a00d98dad$var$o((b)=>{
            let R = h1(b.tilePos);
            u1[R] ? u1[R].push(b) : u1[R] = [
                b
            ];
        }, "insertIntoSpatialMap"), F = $b792be6a00d98dad$var$o((b)=>{
            let R = h1(b.tilePos);
            if (u1[R]) {
                let G = u1[R].indexOf(b);
                G >= 0 && u1[R].splice(G, 1);
            }
        }, "removeFromSpatialMap"), _ = $b792be6a00d98dad$var$o(()=>{
            let b = !1;
            for (let R of s.children){
                let G = s.pos2Tile(R.pos);
                (R.tilePos.x != G.x || R.tilePos.y != G.y) && (b = !0, F(R), R.tilePos.x = G.x, R.tilePos.y = G.y, M(R));
            }
            b && s.trigger("spatial_map_changed");
        }, "updateSpatialMap"), D1 = $b792be6a00d98dad$var$o(()=>{
            let b = s.getSpatialMap(), R = s.numRows() * s.numColumns();
            f ? f.length = R : f = new Array(R), f.fill(1, 0, R);
            for(let G = 0; G < b.length; G++){
                let B = b[G];
                if (B) {
                    let H = 0;
                    for (let X of B)if (X.isObstacle) {
                        H = 1 / 0;
                        break;
                    } else H += X.cost;
                    f[G] = H || 1;
                }
            }
        }, "createCostMap"), P = $b792be6a00d98dad$var$o(()=>{
            let b = s.getSpatialMap(), R = s.numRows() * s.numColumns();
            p1 ? p1.length = R : p1 = new Array(R), p1.fill(15, 0, R);
            for(let G = 0; G < b.length; G++){
                let B = b[G];
                if (B) {
                    let H = B.length, X = 15;
                    for(let ie = 0; ie < H; ie++)X |= B[ie].edgeMask;
                    p1[G] = X;
                }
            }
        }, "createEdgeMap"), se = $b792be6a00d98dad$var$o(()=>{
            let b = s.numRows() * s.numColumns(), R = $b792be6a00d98dad$var$o((B, H)=>{
                let X = [];
                for(X.push(B); X.length > 0;){
                    let ie = X.pop();
                    I(ie).forEach((fe)=>{
                        m1[fe] < 0 && (m1[fe] = H, X.push(fe));
                    });
                }
            }, "traverse");
            m1 ? m1.length = b : m1 = new Array(b), m1.fill(-1, 0, b);
            let G = 0;
            for(let B = 0; B < f.length; B++){
                if (m1[B] >= 0) {
                    G++;
                    continue;
                }
                R(B, G), G++;
            }
        }, "createConnectivityMap"), Y = $b792be6a00d98dad$var$o((b, R)=>f[R], "getCost"), N = $b792be6a00d98dad$var$o((b, R)=>{
            let G = g(b), B = g(R);
            return G.dist(B);
        }, "getHeuristic"), I = $b792be6a00d98dad$var$o((b, R)=>{
            let G = [], B = Math.floor(b % a1), H = B > 0 && p1[b] & 1 && f[b - 1] !== 1 / 0, X = b >= a1 && p1[b] & 2 && f[b - a1] !== 1 / 0, ie = B < a1 - 1 && p1[b] & 4 && f[b + 1] !== 1 / 0, fe = b < a1 * i1 - a1 - 1 && p1[b] & 8 && f[b + a1] !== 1 / 0;
            return R ? (H && (X && G.push(b - a1 - 1), G.push(b - 1), fe && G.push(b + a1 - 1)), X && G.push(b - a1), ie && (X && G.push(b - a1 + 1), G.push(b + 1), fe && G.push(b + a1 + 1)), fe && G.push(b + a1)) : (H && G.push(b - 1), X && G.push(b - a1), ie && G.push(b + 1), fe && G.push(b + a1)), G;
        }, "getNeighbours"), de = {
            id: "level",
            tileWidth () {
                return n.tileWidth;
            },
            tileHeight () {
                return n.tileHeight;
            },
            spawn (b, ...R) {
                let G = $b792be6a00d98dad$var$C(...R), B = (()=>{
                    if (typeof b == "string") {
                        if (n.tiles[b]) {
                            if (typeof n.tiles[b] != "function") throw new O("Level symbol def must be a function returning a component list");
                            return n.tiles[b](G);
                        } else if (n.wildcardTile) return n.wildcardTile(b, G);
                    } else {
                        if (Array.isArray(b)) return b;
                        throw new O("Expected a symbol or a component list");
                    }
                })();
                if (!B) return null;
                let H = !1, X = !1;
                for (let fe of B)fe.id === "tile" && (X = !0), fe.id === "pos" && (H = !0);
                H || B.push(It()), X || B.push(cs());
                let ie = s.add(B);
                return H && (ie.tilePosOffset = ie.pos.clone()), ie.tilePos = G, u1 && (M(ie), this.trigger("spatial_map_changed"), this.trigger("navigation_map_invalid")), ie;
            },
            numColumns () {
                return a1;
            },
            numRows () {
                return i1;
            },
            levelWidth () {
                return a1 * this.tileWidth();
            },
            levelHeight () {
                return i1 * this.tileHeight();
            },
            tile2Pos (...b) {
                return $b792be6a00d98dad$var$C(...b).scale(this.tileWidth(), this.tileHeight());
            },
            pos2Tile (...b) {
                let R = $b792be6a00d98dad$var$C(...b);
                return $b792be6a00d98dad$var$C(Math.floor(R.x / this.tileWidth()), Math.floor(R.y / this.tileHeight()));
            },
            getSpatialMap () {
                return u1 || E(), u1;
            },
            onSpatialMapChanged (b) {
                return this.on("spatial_map_changed", b);
            },
            onNavigationMapInvalid (b) {
                return this.on("navigation_map_invalid", b);
            },
            getAt (b) {
                u1 || E();
                let R = h1(b);
                return u1[R] || [];
            },
            update () {
                u1 && _();
            },
            invalidateNavigationMap () {
                f = null, p1 = null, m1 = null;
            },
            onNavigationMapChanged (b) {
                return this.on("navigation_map_changed", b);
            },
            getTilePath (b, R, G = {}) {
                if (f || D1(), p1 || P(), m1 || se(), b.x < 0 || b.x >= a1 || b.y < 0 || b.y >= i1 || R.x < 0 || R.x >= a1 || R.y < 0 || R.y >= i1) return null;
                let B = h1(b), H = h1(R);
                if (f[H] === 1 / 0) return null;
                if (B === H) return [];
                if (m1[B] != -1 && m1[B] !== m1[H]) return null;
                let X = new $b792be6a00d98dad$var$_t((Oe, Cn)=>Oe.cost < Cn.cost);
                X.insert({
                    cost: 0,
                    node: B
                });
                let ie = new Map;
                ie.set(B, B);
                let fe = new Map;
                for(fe.set(B, 0); X.length !== 0;){
                    let Oe = X.remove()?.node;
                    if (Oe === H) break;
                    let Cn = I(Oe, G.allowDiagonals);
                    for (let Ne of Cn){
                        let Tn = (fe.get(Oe) || 0) + Y(Oe, Ne) + N(Ne, H);
                        (!fe.has(Ne) || Tn < fe.get(Ne)) && (fe.set(Ne, Tn), X.insert({
                            cost: Tn,
                            node: Ne
                        }), ie.set(Ne, Oe));
                    }
                }
                let Sn = [], ft = H, fi = g(ft);
                for(Sn.push(fi); ft !== B;){
                    ft = ie.get(ft);
                    let Oe = g(ft);
                    Sn.push(Oe);
                }
                return Sn.reverse();
            },
            getPath (b, R, G = {}) {
                let B = this.tileWidth(), H = this.tileHeight(), X = this.getTilePath(this.pos2Tile(b), this.pos2Tile(R), G);
                return X ? [
                    b,
                    ...X.slice(1, -1).map((ie)=>ie.scale(B, H).add(B / 2, H / 2)),
                    R
                ] : null;
            }
        };
        return s.use(de), s.onNavigationMapInvalid(()=>{
            s.invalidateNavigationMap(), s.trigger("navigation_map_changed");
        }), e1.forEach((b, R)=>{
            let G = b.split("");
            a1 = Math.max(G.length, a1), G.forEach((B, H)=>{
                s.spawn(B, $b792be6a00d98dad$var$C(H, R));
            });
        }), s;
    }
    $b792be6a00d98dad$var$o(Yr, "addLevel");
    function Xr(e1 = {}) {
        let n = null, s = null, i1 = null, a1 = null;
        return {
            id: "agent",
            require: [
                "pos",
                "tile"
            ],
            agentSpeed: e1.speed ?? 100,
            allowDiagonals: e1.allowDiagonals ?? !0,
            getDistanceToTarget () {
                return n ? this.pos.dist(n) : 0;
            },
            getNextLocation () {
                return s && i1 ? s[i1] : null;
            },
            getPath () {
                return s ? s.slice() : null;
            },
            getTarget () {
                return n;
            },
            isNavigationFinished () {
                return s ? i1 === null : !0;
            },
            isTargetReachable () {
                return s !== null;
            },
            isTargetReached () {
                return n ? this.pos.eq(n) : !0;
            },
            setTarget (u1) {
                n = u1, s = this.getLevel().getPath(this.pos, n, {
                    allowDiagonals: this.allowDiagonals
                }), i1 = s ? 0 : null, s ? (a1 || (a1 = this.getLevel().onNavigationMapChanged(()=>{
                    s && i1 !== null && (s = this.getLevel().getPath(this.pos, n, {
                        allowDiagonals: this.allowDiagonals
                    }), i1 = s ? 0 : null, s ? this.trigger("navigation-next", this, s[i1]) : this.trigger("navigation-ended", this));
                }), this.onDestroy(()=>a1.cancel())), this.trigger("navigation-started", this), this.trigger("navigation-next", this, s[i1])) : this.trigger("navigation-ended", this);
            },
            update () {
                if (s && i1 !== null) {
                    if (this.pos.sdist(s[i1]) < 2) {
                        if (i1 === s.length - 1) {
                            this.pos = n.clone(), i1 = null, this.trigger("navigation-ended", this), this.trigger("target-reached", this);
                            return;
                        } else i1++, this.trigger("navigation-next", this, s[i1]);
                    }
                    this.moveTo(s[i1], this.agentSpeed);
                }
            },
            onNavigationStarted (u1) {
                return this.on("navigation-started", u1);
            },
            onNavigationNext (u1) {
                return this.on("navigation-next", u1);
            },
            onNavigationEnded (u1) {
                return this.on("navigation-ended", u1);
            },
            onTargetReached (u1) {
                return this.on("target-reached", u1);
            },
            inspect () {
                return JSON.stringify({
                    target: JSON.stringify(n),
                    path: JSON.stringify(s)
                });
            }
        };
    }
    $b792be6a00d98dad$var$o(Xr, "agent");
    function Wr(e1) {
        let n = U.canvas().captureStream(e1), s = ne.ctx.createMediaStreamDestination();
        ne.masterNode.connect(s);
        let i1 = new MediaRecorder(n), a1 = [];
        return i1.ondataavailable = (u1)=>{
            u1.data.size > 0 && a1.push(u1.data);
        }, i1.onerror = ()=>{
            ne.masterNode.disconnect(s), n.getTracks().forEach((u1)=>u1.stop());
        }, i1.start(), {
            resume () {
                i1.resume();
            },
            pause () {
                i1.pause();
            },
            stop () {
                return i1.stop(), ne.masterNode.disconnect(s), n.getTracks().forEach((u1)=>u1.stop()), new Promise((u1)=>{
                    i1.onstop = ()=>{
                        u1(new Blob(a1, {
                            type: "video/mp4"
                        }));
                    };
                });
            },
            download (u1 = "kaboom.mp4") {
                this.stop().then((f)=>$b792be6a00d98dad$var$Bn(u1, f));
            }
        };
    }
    $b792be6a00d98dad$var$o(Wr, "record");
    function Jr() {
        return document.activeElement === U.canvas();
    }
    $b792be6a00d98dad$var$o(Jr, "isFocused");
    function Qr(e1) {
        e1.destroy();
    }
    $b792be6a00d98dad$var$o(Qr, "destroy");
    let dt = A.root.add.bind(A.root), Zr = A.root.readd.bind(A.root), ei = A.root.removeAll.bind(A.root), yn = A.root.get.bind(A.root);
    function ls(e1 = 2, n = 1) {
        let s = 0;
        return {
            id: "boom",
            require: [
                "scale"
            ],
            update () {
                let i1 = Math.sin(s * e1) * n;
                i1 < 0 && this.destroy(), this.scale = $b792be6a00d98dad$var$C(i1), s += Ue();
            }
        };
    }
    $b792be6a00d98dad$var$o(ls, "boom");
    let ti = Le(null, $b792be6a00d98dad$var$Is), ni = Le(null, $b792be6a00d98dad$var$Vs);
    function si(e1, n = {}) {
        let s = dt([
            It(e1),
            os()
        ]), i1 = (n.speed || 1) * 5, a1 = n.scale || 1;
        s.add([
            vn(ni),
            Vt(0),
            wn("center"),
            ls(i1, a1),
            ...n.comps ?? []
        ]);
        let u1 = s.add([
            vn(ti),
            Vt(0),
            wn("center"),
            is(),
            ...n.comps ?? []
        ]);
        return u1.wait(.4 / i1, ()=>u1.use(ls(i1, a1))), u1.onDestroy(()=>s.destroy()), s;
    }
    $b792be6a00d98dad$var$o(si, "addKaboom");
    function hs() {
        A.root.update();
    }
    $b792be6a00d98dad$var$o(hs, "updateFrame");
    class xn {
        static{
            $b792be6a00d98dad$var$o(this, "Collision");
        }
        source;
        target;
        displacement;
        resolved = !1;
        constructor(n, s, i1, a1 = !1){
            this.source = n, this.target = s, this.displacement = i1, this.resolved = a1;
        }
        reverse() {
            return new xn(this.target, this.source, this.displacement.scale(-1), this.resolved);
        }
        hasOverlap() {
            return !this.displacement.isZero();
        }
        isLeft() {
            return this.displacement.x > 0;
        }
        isRight() {
            return this.displacement.x < 0;
        }
        isTop() {
            return this.displacement.y > 0;
        }
        isBottom() {
            return this.displacement.y < 0;
        }
        preventResolution() {
            this.resolved = !0;
        }
    }
    function ri() {
        let e1 = {}, n = r.hashGridSize || $b792be6a00d98dad$var$Ai, s = new $b792be6a00d98dad$var$be, i1 = [];
        function a1(u1) {
            if (i1.push(s.clone()), u1.pos && s.translate(u1.pos), u1.scale && s.scale(u1.scale), u1.angle && s.rotate(u1.angle), u1.transform = s.clone(), u1.c("area") && !u1.paused) {
                let f = u1, m1 = f.worldArea().bbox(), h1 = Math.floor(m1.pos.x / n), g = Math.floor(m1.pos.y / n), E = Math.ceil((m1.pos.x + m1.width) / n), M = Math.ceil((m1.pos.y + m1.height) / n), F = new Set;
                for(let _ = h1; _ <= E; _++)for(let D1 = g; D1 <= M; D1++)if (!e1[_]) e1[_] = {}, e1[_][D1] = [
                    f
                ];
                else if (!e1[_][D1]) e1[_][D1] = [
                    f
                ];
                else {
                    let P = e1[_][D1];
                    e: for (let se of P){
                        if (se.paused || !se.exists() || F.has(se.id)) continue;
                        for (let N of f.collisionIgnore)if (se.is(N)) continue e;
                        for (let N of se.collisionIgnore)if (f.is(N)) continue e;
                        let Y = $b792be6a00d98dad$var$Ts(f.worldArea(), se.worldArea());
                        if (Y) {
                            let N = new xn(f, se, Y);
                            f.trigger("collideUpdate", se, N);
                            let I = N.reverse();
                            I.resolved = N.resolved, se.trigger("collideUpdate", f, I);
                        }
                        F.add(se.id);
                    }
                    P.push(f);
                }
            }
            u1.children.forEach(a1), s = i1.pop();
        }
        $b792be6a00d98dad$var$o(a1, "checkObj"), a1(A.root);
    }
    $b792be6a00d98dad$var$o(ri, "checkFrame");
    function ii() {
        let e1 = A.cam, n = $b792be6a00d98dad$var$y.fromAngle($b792be6a00d98dad$var$wt(0, 360)).scale(e1.shake);
        e1.shake = $b792be6a00d98dad$var$Se(e1.shake, 0, 5 * Ue()), e1.transform = new $b792be6a00d98dad$var$be().translate(kt()).scale(e1.scale).rotate(e1.angle).translate((e1.pos ?? kt()).scale(-1).add(n)), A.root.draw(), me();
    }
    $b792be6a00d98dad$var$o(ii, "drawFrame");
    function oi() {
        let e1 = Ce();
        A.events.numListeners("loading") > 0 ? A.events.trigger("loading", e1) : Fe(()=>{
            let n = ge() / 2, s = 24, i1 = $b792be6a00d98dad$var$C(ge() / 2, we() / 2).sub($b792be6a00d98dad$var$C(n / 2, s / 2));
            xe({
                pos: $b792be6a00d98dad$var$C(0),
                width: ge(),
                height: we(),
                color: $b792be6a00d98dad$var$W(0, 0, 0)
            }), xe({
                pos: i1,
                width: n,
                height: s,
                fill: !1,
                outline: {
                    width: 4
                }
            }), xe({
                pos: i1,
                width: n * e1,
                height: s
            });
        });
    }
    $b792be6a00d98dad$var$o(oi, "drawLoadScreen");
    function ds(e1, n) {
        Fe(()=>{
            let s = $b792be6a00d98dad$var$C(8);
            V(), l(e1);
            let i1 = Ve({
                text: n,
                font: $b792be6a00d98dad$var$zt,
                size: 16,
                pos: s,
                color: $b792be6a00d98dad$var$W(255, 255, 255),
                fixed: !0
            }), a1 = i1.width + s.x * 2, u1 = i1.height + s.x * 2;
            e1.x + a1 >= ge() && l($b792be6a00d98dad$var$C(-a1, 0)), e1.y + u1 >= we() && l($b792be6a00d98dad$var$C(0, -u1)), xe({
                width: a1,
                height: u1,
                color: $b792be6a00d98dad$var$W(0, 0, 0),
                radius: 4,
                opacity: .8,
                fixed: !0
            }), ke(i1), ee();
        });
    }
    $b792be6a00d98dad$var$o(ds, "drawInspectText");
    function ai() {
        if (te.inspect) {
            let e1 = null;
            for (let n of A.root.get("*", {
                recursive: !0
            }))if (n.c("area") && n.isHovering()) {
                e1 = n;
                break;
            }
            if (A.root.drawInspect(), e1) {
                let n = [], s = e1.inspect();
                for(let i1 in s)s[i1] ? n.push(`${i1}: ${s[i1]}`) : n.push(`${i1}`);
                ds(er(Gt()), n.join(`
`));
            }
            ds($b792be6a00d98dad$var$C(8), `FPS: ${te.fps()}`);
        }
        te.paused && Fe(()=>{
            V(), l(ge(), 0), l(-8, 8);
            let e1 = 32;
            xe({
                width: e1,
                height: e1,
                anchor: "topright",
                color: $b792be6a00d98dad$var$W(0, 0, 0),
                opacity: .8,
                radius: 4,
                fixed: !0
            });
            for(let n = 1; n <= 2; n++)xe({
                width: 4,
                height: e1 * .6,
                anchor: "center",
                pos: $b792be6a00d98dad$var$C(-e1 / 3 * n, e1 * .5),
                color: $b792be6a00d98dad$var$W(255, 255, 255),
                radius: 2,
                fixed: !0
            });
            ee();
        }), te.timeScale !== 1 && Fe(()=>{
            V(), l(ge(), we()), l(-8, -8);
            let e1 = 8, n = Ve({
                text: te.timeScale.toFixed(1),
                font: $b792be6a00d98dad$var$zt,
                size: 16,
                color: $b792be6a00d98dad$var$W(255, 255, 255),
                pos: $b792be6a00d98dad$var$C(-e1),
                anchor: "botright",
                fixed: !0
            });
            xe({
                width: n.width + e1 * 2 + e1 * 4,
                height: n.height + e1 * 2,
                anchor: "botright",
                color: $b792be6a00d98dad$var$W(0, 0, 0),
                opacity: .8,
                radius: 4,
                fixed: !0
            });
            for(let s = 0; s < 2; s++){
                let i1 = te.timeScale < 1;
                qn({
                    p1: $b792be6a00d98dad$var$C(-n.width - e1 * (i1 ? 2 : 3.5), -e1),
                    p2: $b792be6a00d98dad$var$C(-n.width - e1 * (i1 ? 2 : 3.5), -e1 - n.height),
                    p3: $b792be6a00d98dad$var$C(-n.width - e1 * (i1 ? 3.5 : 2), -e1 - n.height / 2),
                    pos: $b792be6a00d98dad$var$C(-s * e1 * 1 + (i1 ? -e1 * .5 : 0), 0),
                    color: $b792be6a00d98dad$var$W(255, 255, 255),
                    fixed: !0
                });
            }
            ke(n), ee();
        }), te.curRecording && Fe(()=>{
            V(), l(0, we()), l(24, -24), ze({
                radius: 12,
                color: $b792be6a00d98dad$var$W(255, 0, 0),
                opacity: $b792be6a00d98dad$var$Pn(0, 1, U.time() * 4),
                fixed: !0
            }), ee();
        }), te.showLog && A.logs.length > 0 && Fe(()=>{
            V(), l(0, we()), l(8, -8);
            let e1 = 8, n = [];
            for (let i1 of A.logs){
                let a1 = "", u1 = i1.msg instanceof Error ? "error" : "info";
                a1 += `[time]${i1.time.toFixed(2)}[/time]`, a1 += " ", a1 += `[${u1}]${i1.msg?.toString ? i1.msg.toString() : i1.msg}[/${u1}]`, n.push(a1);
            }
            A.logs = A.logs.filter((i1)=>U.time() - i1.time < (r.logTime || $b792be6a00d98dad$var$Pi));
            let s = Ve({
                text: n.join(`
`),
                font: $b792be6a00d98dad$var$zt,
                pos: $b792be6a00d98dad$var$C(e1, -e1),
                anchor: "botleft",
                size: 16,
                width: ge() * .6,
                lineSpacing: e1 / 2,
                fixed: !0,
                styles: {
                    time: {
                        color: $b792be6a00d98dad$var$W(127, 127, 127)
                    },
                    info: {
                        color: $b792be6a00d98dad$var$W(255, 255, 255)
                    },
                    error: {
                        color: $b792be6a00d98dad$var$W(255, 0, 127)
                    }
                }
            });
            xe({
                width: s.width + e1 * 2,
                height: s.height + e1 * 2,
                anchor: "botleft",
                color: $b792be6a00d98dad$var$W(0, 0, 0),
                radius: 4,
                opacity: .8,
                fixed: !0
            }), ke(s), ee();
        });
    }
    $b792be6a00d98dad$var$o(ai, "drawDebug"), r.debug !== !1 && ss(), r.burp && rs();
    function ui(e1) {
        A.events.on("loading", e1);
    }
    $b792be6a00d98dad$var$o(ui, "onLoading");
    function ci(e1) {
        U.onResize(e1);
    }
    $b792be6a00d98dad$var$o(ci, "onResize");
    function li(e1) {
        A.events.on("error", e1);
    }
    $b792be6a00d98dad$var$o(li, "onError");
    function Un(e1) {
        ne.ctx.suspend(), U.run(()=>{
            Fe(()=>{
                let i1 = ge(), a1 = we(), u1 = {
                    size: 36,
                    width: i1 - 64,
                    letterSpacing: 4,
                    lineSpacing: 4,
                    font: $b792be6a00d98dad$var$zt,
                    fixed: !0
                };
                xe({
                    width: i1,
                    height: a1,
                    color: $b792be6a00d98dad$var$W(0, 0, 255),
                    fixed: !0
                });
                let f = Ve({
                    ...u1,
                    text: "Error",
                    pos: $b792be6a00d98dad$var$C(32),
                    color: $b792be6a00d98dad$var$W(255, 128, 0),
                    fixed: !0
                });
                ke(f), Qn({
                    ...u1,
                    text: e1.message,
                    pos: $b792be6a00d98dad$var$C(32, 32 + f.height + 16),
                    fixed: !0
                }), ee(), A.events.trigger("error", e1);
            });
        });
    }
    $b792be6a00d98dad$var$o(Un, "handleErr");
    function hi(e1) {
        J.push(e1);
    }
    $b792be6a00d98dad$var$o(hi, "onCleanup");
    function di() {
        A.events.onOnce("frameEnd", ()=>{
            U.quit();
            for(let n in Ye)window.removeEventListener(n, Ye[n]);
            d.clear(d.COLOR_BUFFER_BIT | d.DEPTH_BUFFER_BIT | d.STENCIL_BUFFER_BIT);
            let e1 = d.getParameter(d.MAX_TEXTURE_IMAGE_UNITS);
            for(let n = 0; n < e1; n++)d.activeTexture(d.TEXTURE0 + n), d.bindTexture(d.TEXTURE_2D, null), d.bindTexture(d.TEXTURE_CUBE_MAP, null);
            d.bindBuffer(d.ARRAY_BUFFER, null), d.bindBuffer(d.ELEMENT_ARRAY_BUFFER, null), d.bindRenderbuffer(d.RENDERBUFFER, null), d.bindFramebuffer(d.FRAMEBUFFER, null), J.forEach((n)=>n()), d.deleteBuffer(v.vbuf), d.deleteBuffer(v.ibuf);
        });
    }
    $b792be6a00d98dad$var$o(di, "quit");
    function En(e1, n, s, i1, a1 = $b792be6a00d98dad$var$Ze.linear) {
        let u1 = 0, f = [], p1 = pn(()=>{
            u1 += Ue();
            let m1 = Math.min(u1 / s, 1);
            i1($b792be6a00d98dad$var$Se(e1, n, a1(m1))), m1 === 1 && (p1.cancel(), i1(n), f.forEach((h1)=>h1()));
        });
        return {
            get paused () {
                return p1.paused;
            },
            set paused (m){
                p1.paused = m;
            },
            onEnd (m1) {
                f.push(m1);
            },
            then (m1) {
                return this.onEnd(m1), this;
            },
            cancel () {
                p1.cancel();
            },
            finish () {
                p1.cancel(), i1(n), f.forEach((m1)=>m1());
            }
        };
    }
    $b792be6a00d98dad$var$o(En, "tween");
    let jt = !0;
    U.run(()=>{
        k.loaded || Ce() === 1 && !jt && (k.loaded = !0, A.events.trigger("load")), !k.loaded && r.loadingScreen !== !1 || jt ? (Te(), oi(), Mt()) : (te.paused || hs(), ri(), Te(), ii(), r.debug !== !1 && ai(), Mt()), jt && (jt = !1), A.events.trigger("frameEnd");
    });
    function fs() {
        let e1 = j, n = d.drawingBufferWidth / e1, s = d.drawingBufferHeight / e1;
        if (U.isFullscreen()) {
            let i1 = window.innerWidth, a1 = window.innerHeight, u1 = i1 / a1, f = n / s;
            if (u1 > f) {
                let p1 = window.innerHeight * f;
                v.viewport = {
                    x: (i1 - p1) / 2,
                    y: 0,
                    width: p1,
                    height: a1
                };
            } else {
                let p1 = window.innerWidth / f;
                v.viewport = {
                    x: 0,
                    y: (a1 - p1) / 2,
                    width: i1,
                    height: p1
                };
            }
            return;
        }
        if (r.letterbox) {
            if (!r.width || !r.height) throw new O("Letterboxing requires width and height defined.");
            let i1 = n / s, a1 = r.width / r.height;
            if (i1 > a1) {
                let u1 = s * a1, f = (n - u1) / 2;
                v.viewport = {
                    x: f,
                    y: 0,
                    width: u1,
                    height: s
                };
            } else {
                let u1 = n / a1, f = (s - u1) / 2;
                v.viewport = {
                    x: 0,
                    y: f,
                    width: n,
                    height: u1
                };
            }
            return;
        }
        if (r.stretch && (!r.width || !r.height)) throw new O("Stretching requires width and height defined.");
        v.viewport = {
            x: 0,
            y: 0,
            width: n,
            height: s
        };
    }
    $b792be6a00d98dad$var$o(fs, "updateViewport"), U.onHide(()=>{
        r.backgroundAudio || ne.ctx.suspend();
    }), U.onShow(()=>{
        r.backgroundAudio || ne.ctx.resume();
    }), U.onResize(()=>{
        if (U.isFullscreen()) return;
        let e1 = r.width && r.height;
        e1 && !r.stretch && !r.letterbox || (c.width = c.offsetWidth * j, c.height = c.offsetHeight * j, fs(), e1 || (v.frameBuffer.free(), v.frameBuffer = new Ge(d.drawingBufferWidth, d.drawingBufferHeight), v.width = d.drawingBufferWidth / j, v.height = d.drawingBufferHeight / j));
    }), fs();
    let je = {
        VERSION: $b792be6a00d98dad$var$Si,
        loadRoot: Xt,
        loadProgress: Ce,
        loadSprite: Le,
        loadSpriteAtlas: xt,
        loadSound: on,
        loadBitmapFont: en,
        loadFont: Zt,
        loadShader: sn,
        loadShaderURL: rn,
        loadAseprite: nn,
        loadPedit: tn,
        loadBean: an,
        loadJSON: Qt,
        load: tt,
        getSprite: Et,
        getSound: St,
        getFont: Ct,
        getBitmapFont: Tt,
        getShader: At,
        getAsset: un,
        Asset: re,
        SpriteData: le,
        SoundData: pe,
        width: ge,
        height: we,
        center: kt,
        dt: Ue,
        time: U.time,
        screenshot: U.screenshot,
        record: Wr,
        isFocused: Jr,
        setCursor: U.setCursor,
        getCursor: U.getCursor,
        setCursorLocked: U.setCursorLocked,
        isCursorLocked: U.isCursorLocked,
        setFullscreen: U.setFullscreen,
        isFullscreen: U.isFullscreen,
        isTouchscreen: U.isTouchscreen,
        onLoad: bn,
        onLoading: ui,
        onResize: ci,
        onGamepadConnect: U.onGamepadConnect,
        onGamepadDisconnect: U.onGamepadDisconnect,
        onError: li,
        onCleanup: hi,
        camPos: tr,
        camScale: nr,
        camRot: sr,
        shake: rr,
        toScreen: es,
        toWorld: ts,
        setGravity: mr,
        getGravity: pr,
        setBackground: gr,
        getBackground: wr,
        getGamepads: U.getGamepads,
        add: dt,
        make: mn,
        destroy: Qr,
        destroyAll: ei,
        get: yn,
        readd: Zr,
        pos: It,
        scale: Vt,
        rotate: vr,
        color: br,
        opacity: yr,
        anchor: wn,
        area: Tr,
        sprite: vn,
        text: Ar,
        rect: Or,
        circle: Mr,
        uvquad: Pr,
        outline: Rr,
        body: Fr,
        doubleJump: Br,
        shader: Lr,
        timer: is,
        fixed: Ir,
        stay: os,
        health: Vr,
        lifespan: kr,
        z: xr,
        move: Er,
        offscreen: Cr,
        follow: Ur,
        state: jr,
        fadeIn: Nr,
        mask: _r,
        tile: cs,
        agent: Xr,
        on: Be,
        onUpdate: pn,
        onDraw: ir,
        onAdd: gn,
        onDestroy: ns,
        onClick: cr,
        onCollide: or,
        onCollideUpdate: ar,
        onCollideEnd: ur,
        onHover: lr,
        onHoverUpdate: hr,
        onHoverEnd: dr,
        onKeyDown: U.onKeyDown,
        onKeyPress: U.onKeyPress,
        onKeyPressRepeat: U.onKeyPressRepeat,
        onKeyRelease: U.onKeyRelease,
        onMouseDown: U.onMouseDown,
        onMousePress: U.onMousePress,
        onMouseRelease: U.onMouseRelease,
        onMouseMove: U.onMouseMove,
        onCharInput: U.onCharInput,
        onTouchStart: U.onTouchStart,
        onTouchMove: U.onTouchMove,
        onTouchEnd: U.onTouchEnd,
        onScroll: U.onScroll,
        onHide: U.onHide,
        onShow: U.onShow,
        onGamepadButtonDown: U.onGamepadButtonDown,
        onGamepadButtonPress: U.onGamepadButtonPress,
        onGamepadButtonRelease: U.onGamepadButtonRelease,
        onGamepadStick: U.onGamepadStick,
        mousePos: Gt,
        mouseDeltaPos: U.mouseDeltaPos,
        isKeyDown: U.isKeyDown,
        isKeyPressed: U.isKeyPressed,
        isKeyPressedRepeat: U.isKeyPressedRepeat,
        isKeyReleased: U.isKeyReleased,
        isMouseDown: U.isMouseDown,
        isMousePressed: U.isMousePressed,
        isMouseReleased: U.isMouseReleased,
        isMouseMoved: U.isMouseMoved,
        isGamepadButtonPressed: U.isGamepadButtonPressed,
        isGamepadButtonDown: U.isGamepadButtonDown,
        isGamepadButtonReleased: U.isGamepadButtonReleased,
        charInputted: U.charInputted,
        loop: fr,
        wait: Lt,
        play: Ot,
        volume: hn,
        burp: it,
        audioCtx: ne.ctx,
        Timer: $b792be6a00d98dad$var$bt,
        Line: $b792be6a00d98dad$var$Pe,
        Rect: $b792be6a00d98dad$var$he,
        Circle: $b792be6a00d98dad$var$gt,
        Polygon: $b792be6a00d98dad$var$_e,
        Vec2: $b792be6a00d98dad$var$y,
        Color: $b792be6a00d98dad$var$$,
        Mat4: $b792be6a00d98dad$var$be,
        Quad: $b792be6a00d98dad$var$oe,
        RNG: $b792be6a00d98dad$var$mt,
        rand: $b792be6a00d98dad$var$wt,
        randi: $b792be6a00d98dad$var$Mn,
        randSeed: $b792be6a00d98dad$var$vs,
        vec2: $b792be6a00d98dad$var$C,
        rgb: $b792be6a00d98dad$var$W,
        hsl2rgb: $b792be6a00d98dad$var$ws,
        quad: $b792be6a00d98dad$var$ae,
        choose: $b792be6a00d98dad$var$ys,
        chance: $b792be6a00d98dad$var$bs,
        lerp: $b792be6a00d98dad$var$Se,
        tween: En,
        easings: $b792be6a00d98dad$var$Ze,
        map: $b792be6a00d98dad$var$Nt,
        mapc: $b792be6a00d98dad$var$gs,
        wave: $b792be6a00d98dad$var$Pn,
        deg2rad: $b792be6a00d98dad$var$Ee,
        rad2deg: $b792be6a00d98dad$var$Je,
        clamp: $b792be6a00d98dad$var$Me,
        testLineLine: $b792be6a00d98dad$var$We,
        testRectRect: $b792be6a00d98dad$var$xs,
        testRectLine: $b792be6a00d98dad$var$Us,
        testRectPoint: $b792be6a00d98dad$var$pt,
        testCirclePolygon: $b792be6a00d98dad$var$Cs,
        testLinePoint: $b792be6a00d98dad$var$Es,
        testLineCircle: $b792be6a00d98dad$var$Rn,
        drawSprite: at,
        drawText: Qn,
        formatText: Ve,
        drawRect: xe,
        drawLine: ct,
        drawLines: Hn,
        drawTriangle: qn,
        drawCircle: ze,
        drawEllipse: $n,
        drawUVQuad: z,
        drawPolygon: Ie,
        drawFormattedText: ke,
        drawMasked: zn,
        drawSubtracted: Yn,
        pushTransform: V,
        popTransform: ee,
        pushTranslate: l,
        pushScale: x,
        pushRotate: T,
        pushMatrix: Dt,
        usePostEffect: Pt,
        debug: te,
        scene: Hr,
        go: qr,
        onSceneLeave: $r,
        addLevel: Yr,
        getData: Kr,
        setData: as,
        download: $b792be6a00d98dad$var$Ht,
        downloadJSON: $b792be6a00d98dad$var$Os,
        downloadText: $b792be6a00d98dad$var$Fn,
        downloadBlob: $b792be6a00d98dad$var$Bn,
        plug: us,
        ASCII_CHARS: $b792be6a00d98dad$var$ks,
        canvas: U.canvas(),
        addKaboom: si,
        LEFT: $b792be6a00d98dad$var$y.LEFT,
        RIGHT: $b792be6a00d98dad$var$y.RIGHT,
        UP: $b792be6a00d98dad$var$y.UP,
        DOWN: $b792be6a00d98dad$var$y.DOWN,
        RED: $b792be6a00d98dad$var$$.RED,
        GREEN: $b792be6a00d98dad$var$$.GREEN,
        BLUE: $b792be6a00d98dad$var$$.BLUE,
        YELLOW: $b792be6a00d98dad$var$$.YELLOW,
        MAGENTA: $b792be6a00d98dad$var$$.MAGENTA,
        CYAN: $b792be6a00d98dad$var$$.CYAN,
        WHITE: $b792be6a00d98dad$var$$.WHITE,
        BLACK: $b792be6a00d98dad$var$$.BLACK,
        quit: di,
        Event: $b792be6a00d98dad$var$ve,
        EventHandler: $b792be6a00d98dad$var$De,
        EventController: $b792be6a00d98dad$var$Re,
        KaboomError: O
    };
    if (r.plugins && r.plugins.forEach(us), r.global !== !1) for(let e1 in je)window[e1] = je[e1];
    return U.canvas().focus(), je;
}, "default");
 //# sourceMappingURL=kaboom.mjs.map


const $40b70ca180e06959$var$k = (0, $b792be6a00d98dad$export$2e2bcd8739ae039)({
    width: window.innerWidth,
    height: window.innerHeight,
    scale: 1,
    canvas: document.querySelector("canvas"),
    stretch: true,
    letterbox: true
});
var $40b70ca180e06959$export$2e2bcd8739ae039 = $40b70ca180e06959$var$k;


function $2f9f10e955c94a7b$export$2e2bcd8739ae039(k) {
    k.loadFont("gb", "./assets/gb.ttf");
}


// File: src/loaders/soundLoader.js
function $f99e5c35cd4b910d$export$2e2bcd8739ae039(k) {
    const music = [
        "antique",
        "credits",
        "dayinmylife",
        "gamerblamer",
        "kawaii",
        "news_chill",
        "nightfullofstars",
        "ocean",
        "retro",
        "time_alone",
        "trainstation",
        "lonelyEndingMusic",
        "instructions"
    ];
    const aliases = {
        menuMusic: "ocean",
        worldMusic: "dayinmylife",
        teashopMusic: "gamerblamer",
        hotelMusic: "nightfullofstars",
        bathMusic: "time_alone",
        trainMusic: "trainstation",
        endingMusic: "credits",
        mangaMusic: "kawaii",
        ramenMusic: "retro",
        cstoreMusic: "news_chill",
        antiqueMusic: "antique",
        lonelyEndingMusic: "lonelyEndingMusic",
        instructionsMusic: "instructions"
    };
    const uiSounds = [
        "door_chime",
        "pickupCoin",
        "sliding_door"
    ];
    const voiceAliasMap = {
        oldman: [
            "oldman_world1",
            "oldman_world2",
            "oldman_world3",
            "oldman_world4",
            "oldman_world5",
            "oldman_bath1",
            "oldman_bath2",
            "oldman_bath3",
            "oldman_extra1",
            "oldman_extra2",
            "oldman_extra3",
            "oldman_extra4",
            "oldman_bath_extra1",
            "oldman_bath_extra2",
            "oldman_bath_extra3",
            "oldman_bath_extra4"
        ],
        yuki: [
            "yuki_tea1",
            "yuki_tea2",
            "yuki_tea3",
            "yuki_tea4",
            "yuki_cstore1",
            "yuki_cstore2",
            "yuki_cstore3",
            "yuki_cstore4",
            "yuki_cstore5",
            "yuki_extra1",
            "yuki_extra2",
            "yuki_extra3",
            "yuki_extra4",
            "yuki_tea_extra1",
            "yuki_tea_extra2",
            "yuki_tea_extra3",
            "yuki_tea_extra4"
        ],
        satoshi: [
            "satoshi_hotel1",
            "satoshi_hotel2",
            "satoshi_hotel3",
            "satoshi_extra1",
            "satoshi_extra2",
            "satoshi_extra3",
            "satoshi_gift"
        ],
        koji: [
            "koji_train1",
            "koji_train2",
            "koji_train3",
            "koji_train4",
            "koji_train5",
            "koji_train6",
            "koji_extra1",
            "koji_extra2",
            "koji_extra3",
            "koji_extra4",
            "koji_oriyoki"
        ],
        mari: [
            "mari_manga1",
            "mari_manga2",
            "mari_manga3",
            "mari_manga4",
            "mari_manga5",
            "mari_extra1",
            "mari_extra2",
            "mari_extra3",
            "mari_manga"
        ],
        naoko: [
            "naoko_ramen1",
            "naoko_ramen2",
            "naoko_ramen3",
            "naoko_ramen4",
            "naoko_extra1",
            "naoko_extra2",
            "naoko_sword1",
            "naoko_hint1"
        ],
        hana: [
            "hana_antique1",
            "hana_antique2",
            "hana_antique3",
            "hana_antique4",
            "hana_antique5",
            "hana_antique6",
            "hana_extra1",
            "hana_extra2",
            "hana_extra3",
            "hana_extra4"
        ],
        randy: [
            // Yuki's lines
            "randy_tea1",
            "randy_tea2",
            "randy_tea3",
            "randy_tea4",
            "randy_cstore1",
            "randy_cstore2",
            "randy_cstore3",
            "randy_cstore4",
            "randy_cstore5",
            // Oldman's lines
            "randy_oldman1",
            "randy_oldman2",
            "randy_oldman3",
            "randy_oldman4",
            "randy_oldman5",
            "randy_oldmanbath1",
            "randy_oldmanbath2",
            "randy_oldmanbath3",
            // Hana's lines
            "randy_hana1",
            "randy_hana2",
            "randy_hana3",
            "randy_hana4",
            "randy_hana5",
            "randy_hana6",
            // Koji's lines
            "randy_koji1",
            "randy_koji2",
            "randy_koji3",
            "randy_koji4",
            "randy_koji5",
            "randy_koji6",
            // Mari's lines
            "randy_mari1",
            "randy_mari2",
            "randy_mari3",
            "randy_mari4",
            "randy_mari5",
            // Naoko's lines
            "randy_naoko1",
            "randy_naoko2",
            "randy_naoko3",
            "randy_naoko4",
            // Satoshi's lines
            "randy_satoshi1",
            "randy_satoshi2",
            "randy_satoshi3"
        ],
        npc1: [
            "npc1_extra1",
            "npc1_extra2",
            "npc1_extra3"
        ],
        npc2: [
            "npc2_extra1",
            "npc2_extra2",
            "npc2_extra3"
        ],
        npc3: [
            "npc3_extra1",
            "npc3_extra2",
            "npc3_extra3"
        ],
        npc4: [
            "npc4_extra1",
            "npc4_extra2",
            "npc4_extra3"
        ],
        npc5: [
            "npc5_extra1",
            "npc5_extra2",
            "npc5_extra3"
        ]
    };
    for (const name of music)k.loadSound(name, `./assets/sounds/music/${name}.mp3`);
    for (const [alias, target] of Object.entries(aliases))k.loadSound(alias, `./assets/sounds/music/${target}.mp3`);
    for (const name of uiSounds)k.loadSound(name, `./assets/sounds/uiSounds/${name}.mp3`);
    k.loadSound("soundUI", `./assets/sounds/uiSounds/pickupCoin.mp3`);
    k.loadSound("chime-bell", `./assets/sounds/uiSounds/door_chime.mp3`);
    k.loadSound("door-open", `./assets/sounds/uiSounds/sliding_door.mp3`);
    k.loadSound("sparkle", './assets/sounds/uiSounds/sparkle.mp3');
    for (const [char, suffixes] of Object.entries(voiceAliasMap))suffixes.forEach((voiceFileName)=>{
        const filePath = `./assets/sounds/voices/${char}/${voiceFileName}.mp3`;
        k.loadSound(voiceFileName, filePath);
        k.loadSound(`${char}_${voiceFileName}`, filePath);
    });
}


function $0854c6558b0c048c$export$2e2bcd8739ae039(k) {
    // 🖼️ Backgrounds & Screens
    k.loadSprite("endingCredits", "./assets/images/endcreditbackground.png");
    k.loadSprite("heart-bg", "./assets/images/heart-bg.png");
    k.loadSprite("endingAlone", "./assets/images/endingAlone.png");
    k.loadSprite("endingYuki", "./assets/images/endingYuki.png");
    k.loadSprite("endingSatoshi", "./assets/images/endingSatoshi.png");
    k.loadSprite("endingKoji", "./assets/images/endingKoji.png");
    k.loadSprite("endingMari", "./assets/images/endingMari.png");
    k.loadSprite("endingNaoko", "./assets/images/endingNaoko.png");
    k.loadSprite("endingHana", "./assets/images/endingHana.png");
    k.loadSprite("endingOldman", "./assets/images/endingOldman.png");
    k.loadSprite("instructions", "./assets/images/instructions.png");
    // 🧍 Main character & NPCs
    k.loadSprite("assets", "./assets/topdownasset.png", {
        sliceX: 39,
        sliceY: 31,
        anims: {
            // 🎮 Player (Randy)
            "player-idle-down": 1014,
            "player-down": {
                from: 1014,
                to: 1017,
                loop: true
            },
            "player-idle-side": 1053,
            "player-side": {
                from: 1053,
                to: 1056,
                loop: true
            },
            "player-idle-up": 1092,
            "player-up": {
                from: 1092,
                to: 1095,
                loop: true
            },
            // 👴 Oldman
            "oldman-idle-down": 1159,
            "oldman-down": {
                from: 1159,
                to: 1162,
                loop: true
            },
            "oldman-idle-side": 1198,
            "oldman-side": {
                from: 1198,
                to: 1201,
                loop: true
            },
            "oldman-idle-up": 1202,
            "oldman-up": {
                from: 1202,
                to: 1205,
                loop: true
            },
            // 🧃 Yuki
            "yuki-down": 1034,
            "yuki-idle-down": 1034,
            "yuki-side": 1073,
            "yuki-up": 1112,
            // 🧠 Satoshi
            "satoshi-idle-down": 1018,
            "satoshi-down": {
                from: 1018,
                to: 1021,
                loop: true
            },
            "satoshi-idle-side": 1057,
            "satoshi-side": {
                from: 1057,
                to: 1060,
                loop: true
            },
            "satoshi-idle-up": 1096,
            "satoshi-up": {
                from: 1096,
                to: 1099,
                loop: true
            },
            // 🚉 Koji
            "koji-idle-down": 1026,
            "koji-down": {
                from: 1026,
                to: 1029,
                loop: true
            },
            "koji-idle-side": 1065,
            "koji-side": {
                from: 1065,
                to: 1068,
                loop: true
            },
            "koji-idle-up": 1104,
            "koji-up": {
                from: 1104,
                to: 1107,
                loop: true
            },
            // 🎀 Mari
            "mari-down": 1030,
            "mari-idle-down": 1030,
            "mari-side": 1069,
            "mari-up": 1110,
            // 📚 Naoko
            "naoko-idle-down": 1022,
            "naoko-down": {
                from: 1022,
                to: 1025,
                loop: true
            },
            "naoko-idle-side": 1061,
            "naoko-side": {
                from: 1061,
                to: 1064,
                loop: true
            },
            "naoko-idle-up": 1102,
            "naoko-up": {
                from: 1100,
                to: 1103,
                loop: true
            },
            // 🌸 Hana
            "hana-idle-down": 1038,
            "hana-down": {
                from: 1038,
                to: 1041,
                loop: true
            },
            "hana-idle-side": 1077,
            "hana-side": {
                from: 1077,
                to: 1080,
                loop: true
            },
            "hana-idle-up": 1116,
            "hana-up": {
                from: 1116,
                to: 1119,
                loop: true
            },
            // NPC 1
            "npc1-idle-down": 1042,
            "npc1-down": {
                from: 1042,
                to: 1045,
                loop: true
            },
            "npc1-idle-side": 1081,
            "npc1-side": {
                from: 1081,
                to: 1084,
                loop: true
            },
            "npc1-idle-up": 1120,
            "npc1-up": {
                from: 1120,
                to: 1123,
                loop: true
            },
            // NPC 2
            "npc2-idle-down": 1155,
            "npc2-down": {
                from: 1155,
                to: 1158,
                loop: true
            },
            "npc2-idle-side": 1194,
            "npc2-side": {
                from: 1194,
                to: 1197,
                loop: true
            },
            "npc2-idle-up": 1163,
            "npc2-up": {
                from: 1163,
                to: 1166,
                loop: true
            },
            // NPC 3
            "npc3-idle-down": 1147,
            "npc3-down": {
                from: 1147,
                to: 1150,
                loop: true
            },
            "npc3-idle-side": 1186,
            "npc3-side": {
                from: 1186,
                to: 1189,
                loop: true
            },
            "npc3-idle-up": 1190,
            "npc3-up": {
                from: 1190,
                to: 1193,
                loop: true
            },
            // NPC 4
            "npc4-down": 1143,
            "npc4-side": 1146,
            "npc4-up": 1145,
            // NPC 5
            "npc5-down": 1182,
            "npc5-side": 1183,
            // 🪧 Signs and Props
            "signhotel": 839,
            "signbath": 837,
            "signtrain": 837,
            "bedrandy": 188,
            "whitevending": 56,
            "orangevending": 54,
            "mangabookshelf": 134,
            "antiqueKey": 38,
            "sword": 75,
            "antiqueDoor": 28,
            "antiqueDoorOpen": 27,
            "strawberry": 125,
            "mangaBook": 49,
            "oriyoki": 93
        }
    });
    // ❤️ Health Bar Hearts
    k.loadSpriteAtlas("./assets/topdownasset.png", {
        "full-heart": {
            x: 288,
            y: 16,
            width: 48,
            height: 48
        },
        "half-heart": {
            x: 336,
            y: 16,
            width: 48,
            height: 48
        },
        "empty-heart": {
            x: 384,
            y: 16,
            width: 48,
            height: 48
        }
    });
    // Sunset Background
    k.loadSprite("sunset", "./assets/images/sunset.png", {
        sliceX: 4,
        anims: {
            loop: {
                from: 0,
                to: 3,
                loop: true,
                speed: 8
            }
        }
    });
}


const $2a5cf44d1d9e1593$var$menuText = {
    title: "90 Day Haiku",
    playIndication: "Press ENTER or TAP anywhere to Start the Game"
};
var $2a5cf44d1d9e1593$export$2e2bcd8739ae039 = $2a5cf44d1d9e1593$var$menuText;


function $03109bfa008b661a$export$2e2bcd8739ae039() {
    let instance = null;
    function saveFlagToLocalStorage(key, value) {
        localStorage.setItem("flag-" + key, JSON.stringify(value));
    }
    function loadFlagFromLocalStorage(key) {
        const value = localStorage.getItem("flag-" + key);
        return value ? JSON.parse(value) : false;
    }
    function createInstance() {
        let previousScene = null;
        let currentScene = null;
        let freezePlayer = false;
        let locale = "english";
        let fontSize = 25;
        let chosenEnding = null;
        let hasKey = false;
        let hasSword = false;
        let flags = {};
        return {
            // Previous scene management
            setPreviousScene (sceneName) {
                previousScene = sceneName;
            },
            getPreviousScene () {
                return previousScene;
            },
            // Current scene management
            setCurrentScene (sceneName) {
                currentScene = sceneName;
            },
            getCurrentScene () {
                return currentScene;
            },
            // Freeze player state
            setFreezePlayer (value) {
                freezePlayer = value;
            },
            getFreezePlayer () {
                return freezePlayer;
            },
            // Locale
            setLocale (language) {
                locale = language;
            },
            getLocale () {
                return locale;
            },
            // Font size
            setFontSize (size) {
                fontSize = size;
            },
            getFontSize () {
                return fontSize;
            },
            // ✅ Chosen Ending setter/getter
            setChosenEnding (value) {
                chosenEnding = value;
            },
            getChosenEnding () {
                return chosenEnding;
            },
            setHasKey (value) {
                hasKey = value;
            },
            getHasKey () {
                return hasKey;
            },
            setHasSword (value) {
                hasSword = value;
            },
            getHasSword () {
                return hasSword;
            },
            // Flag persistence
            setFlag (key, value) {
                flags[key] = value;
                saveFlagToLocalStorage(key, value);
            },
            getFlag (key) {
                return flags[key] ?? loadFlagFromLocalStorage(key);
            }
        };
    }
    return {
        getInstance () {
            if (!instance) instance = createInstance();
            return instance;
        }
    };
}


function $0f4af2609a5d85be$export$2e2bcd8739ae039() {
    let instance = null;
    function saveFlagToLocalStorage(key, value) {
        localStorage.setItem(key, JSON.stringify(value));
    }
    function loadFlagFromLocalStorage(key) {
        const value = localStorage.getItem(key);
        return value ? JSON.parse(value) : false;
    }
    function createInstance() {
        const trueMaxHealth = 8;
        let currentMaxHealth = 1;
        let health = 1;
        let hasKey = false;
        let hasSword = false;
        let hasGivenSwordToNaoko = false;
        let hasStrawberries = false;
        let hasGivenStrawberriesToSatoshi = false;
        let hasManga = false;
        let hasGivenMangaToMari = false;
        let hasOriyoki = false;
        let hasGivenOriyokiToKoji = false;
        return {
            // Health
            getTrueMaxHealth: ()=>trueMaxHealth,
            setCurrentMaxHealth (value) {
                currentMaxHealth = Math.min(value, trueMaxHealth);
                if (health > currentMaxHealth) health = currentMaxHealth;
            },
            getCurrentMaxHealth: ()=>currentMaxHealth,
            setHealth (value) {
                health = Math.max(0, Math.min(value, currentMaxHealth));
            },
            getHealth: ()=>health,
            // Flags
            setHasKey (value) {
                hasKey = value;
            },
            getHasKey: ()=>hasKey,
            setHasSword (value) {
                hasSword = value;
            },
            getHasSword: ()=>hasSword,
            setHasGivenSwordToNaoko (value) {
                hasGivenSwordToNaoko = value;
            },
            getHasGivenSwordToNaoko: ()=>hasGivenSwordToNaoko,
            setHasStrawberries (value) {
                hasStrawberries = value;
            },
            getHasStrawberries: ()=>hasStrawberries,
            setHasGivenStrawberriesToSatoshi (value) {
                hasGivenStrawberriesToSatoshi = value;
            },
            getHasGivenStrawberriesToSatoshi: ()=>hasGivenStrawberriesToSatoshi,
            setHasManga (value) {
                hasManga = value;
            },
            getHasManga: ()=>hasManga,
            setHasGivenMangaToMari (value) {
                hasGivenMangaToMari = value;
            },
            getHasGivenMangaToMari: ()=>hasGivenMangaToMari,
            setHasOriyoki (value) {
                hasOriyoki = value;
            },
            getHasOriyoki: ()=>hasOriyoki,
            setHasGivenOriyokiToKoji (value) {
                hasGivenOriyokiToKoji = value;
            },
            getHasGivenOriyokiToKoji: ()=>hasGivenOriyokiToKoji,
            // 🗝️ Persistent item flags
            setHasPickedUpAntiqueKey (value) {
                saveFlagToLocalStorage("hasPickedUpAntiqueKey", value);
            },
            getHasPickedUpAntiqueKey () {
                return loadFlagFromLocalStorage("hasPickedUpAntiqueKey");
            },
            setHasPickedUpManga (value) {
                saveFlagToLocalStorage("hasPickedUpManga", value);
            },
            getHasPickedUpManga () {
                return loadFlagFromLocalStorage("hasPickedUpManga");
            },
            setHasPickedUpOriyoki (value) {
                saveFlagToLocalStorage("hasPickedUpOriyoki", value);
            },
            getHasPickedUpOriyoki () {
                return loadFlagFromLocalStorage("hasPickedUpOriyoki");
            },
            setHasPickedUpSword (value) {
                saveFlagToLocalStorage("hasPickedUpSword", value);
            },
            getHasPickedUpSword () {
                return loadFlagFromLocalStorage("hasPickedUpSword");
            },
            setHasPickedUpStrawberries (value) {
                saveFlagToLocalStorage("hasPickedUpStrawberries", value);
            },
            getHasPickedUpStrawberries () {
                return loadFlagFromLocalStorage("hasPickedUpStrawberries");
            }
        };
    }
    return {
        getInstance () {
            if (!instance) instance = createInstance();
            return instance;
        }
    };
}


function $750c2ec20e7818b9$export$2e2bcd8739ae039() {
    let instance = null;
    function createInstance() {
        const npcState = {};
        function initNpcState(npcName, initialState = {}) {
            if (!npcState[npcName]) npcState[npcName] = {
                hasSpoken: false,
                repeatIndex: 0,
                nbTalked: 0,
                hasGivenHeart: false,
                talkedScenes: {
                    world: 0,
                    bath: 0
                },
                ...initialState
            };
        }
        return {
            // Initialization
            initNpc (npcName, initialState) {
                initNpcState(npcName, initialState);
            },
            // hasSpoken flag
            setHasSpoken (npcName, value) {
                initNpcState(npcName);
                npcState[npcName].hasSpoken = value;
            },
            getHasSpoken (npcName) {
                initNpcState(npcName);
                return npcState[npcName].hasSpoken;
            },
            // repeatIndex counter
            getRepeatIndex (npcName) {
                initNpcState(npcName);
                return npcState[npcName].repeatIndex;
            },
            incrementRepeatIndex (npcName) {
                initNpcState(npcName);
                npcState[npcName].repeatIndex += 1;
            },
            resetRepeatIndex (npcName) {
                initNpcState(npcName);
                npcState[npcName].repeatIndex = 0;
            },
            // nbTalked
            setNbTalked (npcName, value) {
                initNpcState(npcName);
                npcState[npcName].nbTalked = value;
            },
            getNbTalked (npcName) {
                initNpcState(npcName);
                return npcState[npcName].nbTalked;
            },
            // hasGivenHeart flag
            setHasGivenHeart (npcName, value) {
                initNpcState(npcName);
                npcState[npcName].hasGivenHeart = value;
            },
            getHasGivenHeart (npcName) {
                initNpcState(npcName);
                return npcState[npcName].hasGivenHeart;
            },
            // Per-scene dialogue tracking (by count)
            setSceneTalked (npcName, scene) {
                initNpcState(npcName);
                npcState[npcName].talkedScenes[scene] = (npcState[npcName].talkedScenes[scene] || 0) + 1;
            },
            getSceneTalkCount (npcName, scene) {
                initNpcState(npcName);
                return npcState[npcName].talkedScenes[scene] || 0;
            },
            hasTalkedEnoughInScenes (npcName, sceneCounts) {
                initNpcState(npcName);
                return Object.entries(sceneCounts).every(([scene, minCount])=>{
                    return (npcState[npcName].talkedScenes[scene] || 0) >= minCount;
                });
            },
            // Utility: check if all NPCs were talked to
            haveTalkedToAll (npcList) {
                return npcList.every((npc)=>{
                    initNpcState(npc);
                    return npcState[npc].hasSpoken;
                });
            },
            // Reset all
            reset () {
                Object.keys(npcState).forEach((npc)=>{
                    npcState[npc] = {
                        hasSpoken: false,
                        repeatIndex: 0,
                        nbTalked: 0,
                        hasGivenHeart: false,
                        talkedScenes: {
                            world: 0,
                            bath: 0
                        }
                    };
                });
            }
        };
    }
    return {
        getInstance () {
            if (!instance) instance = createInstance();
            return instance;
        }
    };
}


const $96277ef5c4fda650$export$8e361a1ffbebf172 = (0, $03109bfa008b661a$export$2e2bcd8739ae039)().getInstance();
const $96277ef5c4fda650$export$ab4b6c53ec258d17 = (0, $0f4af2609a5d85be$export$2e2bcd8739ae039)().getInstance();
const $96277ef5c4fda650$export$405cc0fd5207d608 = (0, $750c2ec20e7818b9$export$2e2bcd8739ae039)().getInstance();


let $3d1117e281c70288$var$currentMusic = null;
const $3d1117e281c70288$var$soundEffects = {}; // Object to hold loaded sound effects
const $3d1117e281c70288$export$7a6134494e9ab3f8 = {
    // Play background music
    playMusic (k, name, options = {}) {
        // Stop existing music if playing
        if ($3d1117e281c70288$var$currentMusic && $3d1117e281c70288$var$currentMusic.stop) {
            $3d1117e281c70288$var$currentMusic.stop();
            $3d1117e281c70288$var$currentMusic = null;
        }
        try {
            $3d1117e281c70288$var$currentMusic = k.play(name, {
                loop: true,
                volume: options.volume ?? 0.2
            });
        } catch (err) {
            console.error(`\u{274C} Failed to play music: "${name}"`, err);
        }
        return $3d1117e281c70288$var$currentMusic;
    },
    // Stop the current background music
    stopMusic () {
        if ($3d1117e281c70288$var$currentMusic && $3d1117e281c70288$var$currentMusic.stop) {
            $3d1117e281c70288$var$currentMusic.stop();
            $3d1117e281c70288$var$currentMusic = null;
        }
    },
    // Load a sound effect
    loadSound (k, name, filePath) {
        $3d1117e281c70288$var$soundEffects[name] = k.load(filePath); // Load sound effect into memory
    },
    // Play a sound effect
    playSound (k, name, options = {}) {
        if ($3d1117e281c70288$var$soundEffects[name]) $3d1117e281c70288$var$soundEffects[name].play({
            volume: options.volume ?? 0.4
        });
        else console.warn(`\u{274C} Sound effect "${name}" not loaded.`);
    },
    // Stop a specific sound effect
    stopSound (name) {
        if ($3d1117e281c70288$var$soundEffects[name] && $3d1117e281c70288$var$soundEffects[name].stop) $3d1117e281c70288$var$soundEffects[name].stop();
        else console.warn(`\u{274C} No sound effect found to stop for "${name}".`);
    }
};


function $4fa71b5ad2e676c4$export$2e2bcd8739ae039(k) {
    // 🎵 Play background music
    (0, $3d1117e281c70288$export$7a6134494e9ab3f8).playMusic(k, "menuMusic");
    k.setBackground(k.Color.fromHex("#000000")); // Black background
    // 🌅 Animated sunset background (GIF-style)
    k.add([
        k.sprite("sunset", {
            anim: "loop"
        }),
        k.anchor("center"),
        k.pos(k.center()),
        k.scale(k.width() / 500, k.height() / 350),
        k.z(-1),
        k.fixed()
    ]);
    // 🪧 Text background box
    const boxWidth = k.width() * 0.8;
    const boxHeight = 170;
    const boxX = k.width() * 0.1;
    const boxY = k.center().y - 140;
    k.add([
        k.rect(boxWidth, boxHeight, {
            radius: 16
        }),
        k.pos(boxX, boxY),
        k.color(0, 0, 0),
        k.opacity(0.75),
        k.z(0)
    ]);
    // 🕹 Title
    k.add([
        k.text((0, $2a5cf44d1d9e1593$export$2e2bcd8739ae039).title, {
            size: 70,
            font: "gameboy"
        }),
        k.anchor("center"),
        k.pos(k.center().x, k.center().y - 80),
        k.z(1)
    ]);
    // 🔁 Blinking prompt
    const prompt = k.add([
        k.text((0, $2a5cf44d1d9e1593$export$2e2bcd8739ae039).playIndication || "Press ENTER to Start", {
            size: 22,
            font: "gameboy"
        }),
        k.anchor("center"),
        k.pos(k.center().x, k.center().y - 15),
        k.z(1)
    ]);
    let blinkTimer = 0;
    k.onUpdate(()=>{
        blinkTimer += k.dt();
        prompt.hidden = Math.floor(blinkTimer * 2) % 2 === 0;
    });
    const startGame = ()=>{
        (0, $96277ef5c4fda650$export$8e361a1ffbebf172).setFontSize(25);
        (0, $3d1117e281c70288$export$7a6134494e9ab3f8).stopMusic();
        k.go("instructions"); // Goes to instructions screen first
    };
    // 🎮 Inputs
    k.onKeyPress("enter", startGame);
    k.onClick(startGame);
    k.onTouchStart(startGame);
    k.onKeyPress("r", ()=>{
        k.go("reset");
    });
}




const $45edb7134ced3389$export$a7cfd7d145d071ee = {
    oldmanPortrait: 1159,
    yukiPortrait: 1034,
    satoshiPortrait: 1018,
    kojiPortrait: 1026,
    mariPortrait: 1030,
    naokoPortrait: 1022,
    hanaPortrait: 1038,
    randyPortrait: 1014,
    npc1Portrait: 1042,
    npc2Portrait: 1155,
    npc3Portrait: 1147,
    npc4Portrait: 1143,
    npc5Portrait: 1182,
    // fallback frame index
    default: 1163
};


let $e05b45d86fdf942d$var$dialogueCompleteCallback = null;
async function $e05b45d86fdf942d$export$92135a324406312(textContainer, line) {
    for (const char of line)await new Promise((resolve)=>setTimeout(()=>{
            textContainer.text += char;
            resolve();
        }, 10));
}
async function $e05b45d86fdf942d$export$f1d985ef2ac6d781(k, pos, content = [], instant = false, portraits = [], voices = [], speakers = [], headerText = null) {
    (0, $96277ef5c4fda650$export$8e361a1ffbebf172).setFreezePlayer(true);
    k.play("soundUI", {
        volume: 0.4
    });
    if (!Array.isArray(content)) content = [
        String(content)
    ];
    if (!Array.isArray(portraits)) portraits = [];
    if (!Array.isArray(voices)) voices = [];
    if (!Array.isArray(speakers)) speakers = [];
    k.destroyAll("dialogueBox");
    k.destroyAll("portraitFrame");
    k.destroyAll("portraitImage");
    k.destroyAll("nameLabel");
    const centerX = k.width() / 2;
    const dialogY = k.height() - 225;
    const portraitX = centerX - 380;
    const portraitY = dialogY;
    let portraitFrame, portraitImage, nameLabel;
    const showPortrait = (portraitName, npcName)=>{
        k.destroyAll("portraitFrame");
        k.destroyAll("portraitImage");
        k.destroyAll("nameLabel");
        if (!portraitName && !npcName) return;
        portraitFrame = k.add([
            k.rect(120, 150, {
                radius: 12
            }),
            k.color(255, 255, 255),
            k.pos(portraitX, portraitY),
            k.z(1001),
            k.fixed(),
            k.opacity(0.85),
            "portraitFrame"
        ]);
        const portraitFrameIndex = (0, $45edb7134ced3389$export$a7cfd7d145d071ee)[portraitName] || (0, $45edb7134ced3389$export$a7cfd7d145d071ee).default;
        portraitImage = k.add([
            k.sprite("assets", {
                frame: portraitFrameIndex
            }),
            k.pos(portraitX + 25, portraitY + 10),
            k.scale(5.2),
            k.z(1002),
            k.fixed(),
            "portraitImage"
        ]);
        if (npcName) nameLabel = k.add([
            k.text(npcName, {
                font: "gameboy",
                size: 22
            }),
            k.color(0, 0, 0),
            k.pos(portraitX + 60, portraitY + 125),
            k.anchor("center"),
            k.z(1003),
            k.fixed(),
            "nameLabel"
        ]);
    };
    let headerBox, headerLabel;
    if (headerText) {
        headerBox = k.add([
            k.rect(680, 36, {
                radius: 6
            }),
            k.color(255, 255, 255),
            k.pos(centerX - 250, dialogY - 40),
            k.z(999),
            k.fixed(),
            k.opacity(0.85)
        ]);
        headerLabel = k.add([
            k.text(headerText, {
                font: "gameboy",
                size: 30
            }),
            k.color(0, 0, 0),
            k.pos(centerX - 187.5 - 40, dialogY - 22),
            k.anchor("left"),
            k.z(1000),
            k.fixed()
        ]);
    }
    const dialogueBox = k.add([
        k.rect(680, 200, {
            radius: 12
        }),
        k.color(255, 255, 255),
        k.pos(centerX - 250, dialogY),
        k.z(1000),
        k.fixed(),
        k.opacity(0.85),
        "dialogueBox"
    ]);
    const textContainer = dialogueBox.add([
        k.text("", {
            font: "gameboy",
            width: 640,
            lineSpacing: 12,
            size: (0, $96277ef5c4fda650$export$8e361a1ffbebf172).getFontSize()
        }),
        k.color(0, 0, 0),
        k.pos(20, (0, $96277ef5c4fda650$export$8e361a1ffbebf172).getFontSize() * 1.6),
        k.fixed()
    ]);
    const continuePrompt = dialogueBox.add([
        k.text("Press SPACE", {
            font: "gameboy",
            size: (0, $96277ef5c4fda650$export$8e361a1ffbebf172).getFontSize() - 4
        }),
        k.color(0, 0, 0),
        k.pos(270, 170),
        k.fixed(),
        k.opacity(0)
    ]);
    let blinkTimer = 0;
    const blinkUpdate = k.onUpdate(()=>{
        if (continuePrompt.opacity > 0) {
            blinkTimer += k.dt();
            continuePrompt.hidden = Math.floor(blinkTimer * 2) % 2 === 0;
        }
    });
    let index = 0;
    let lineFinishedDisplayed = false;
    let currentVoice = null;
    const playVoice = (idx)=>{
        return new Promise((resolve)=>{
            if (voices && voices[idx]) try {
                if (currentVoice && currentVoice.stop) currentVoice.stop();
                currentVoice = k.play(voices[idx]);
                if (currentVoice && currentVoice.on) currentVoice.on("end", resolve);
                else {
                    const wait = setTimeout(resolve, 7000);
                    k.onKeyPress("space", ()=>{
                        clearTimeout(wait);
                        resolve();
                    });
                }
            } catch (e) {
                console.warn(`\u{26A0}\u{FE0F} Couldn't play voice line: ${voices[idx]}`, e);
                resolve();
            }
            else resolve();
        });
    };
    const showLine = async (idx)=>{
        textContainer.text = "";
        continuePrompt.opacity = 0;
        lineFinishedDisplayed = false;
        const portraitName = portraits[idx] || null;
        const speakerName = speakers[idx] || null;
        showPortrait(portraitName, speakerName);
        await Promise.all([
            (async ()=>{
                if (instant) textContainer.text = content[idx];
                else await $e05b45d86fdf942d$export$92135a324406312(textContainer, content[idx]);
            })(),
            playVoice(idx)
        ]);
        continuePrompt.opacity = 1;
        lineFinishedDisplayed = true;
    };
    await showLine(index);
    const handleAdvance = async ()=>{
        if (!lineFinishedDisplayed) return;
        if (currentVoice && currentVoice.stop) currentVoice.stop();
        index++;
        if (!content[index]) {
            k.destroy(dialogueBox);
            k.destroyAll("interactPrompt");
            k.destroyAll("portraitImage");
            k.destroyAll("portraitFrame");
            k.destroyAll("nameLabel");
            if (headerBox) k.destroy(headerBox);
            if (headerLabel) k.destroy(headerLabel);
            dialogueKey.cancel();
            mouseClick.cancel();
            blinkUpdate.cancel();
            (0, $96277ef5c4fda650$export$8e361a1ffbebf172).setFreezePlayer(false);
            if (typeof $e05b45d86fdf942d$var$dialogueCompleteCallback === "function") {
                $e05b45d86fdf942d$var$dialogueCompleteCallback();
                $e05b45d86fdf942d$var$dialogueCompleteCallback = null;
            }
            return;
        }
        await showLine(index);
    };
    const dialogueKey = k.onKeyPress("space", handleAdvance);
    const mouseClick = k.onClick(handleAdvance);
}
function $e05b45d86fdf942d$export$d526e17d3827c2fd(callback) {
    $e05b45d86fdf942d$var$dialogueCompleteCallback = callback;
}
function $e05b45d86fdf942d$export$a162cedf876ee7eb(k, text, colorRGB = [
    255,
    0,
    0
]) {
    const centerX = k.width() / 2;
    const dialogY = k.height() - 225;
    const headerBox = k.add([
        k.rect(375, 36, {
            radius: 6
        }),
        k.color(255, 255, 255),
        k.pos(centerX - 250, dialogY - 40),
        k.z(999),
        k.fixed(),
        k.opacity(0.85)
    ]);
    const headerLabel = k.add([
        k.text(text, {
            font: "gameboy",
            size: 30
        }),
        k.color(...colorRGB),
        k.pos(centerX - 135, dialogY - 22),
        k.anchor("center"),
        k.z(1000),
        k.fixed()
    ]);
    setTimeout(()=>{
        k.destroy(headerBox);
        k.destroy(headerLabel);
    }, 3000);
}




// List of characters with their heart status
const $3f33787d0c03f6d8$var$npcHearts = [
    {
        id: "randy",
        name: "Randy",
        hasHeart: true
    },
    {
        id: "oldman",
        name: "Tetsuya",
        hasHeart: false
    },
    {
        id: "satoshi",
        name: "Satoshi",
        hasHeart: false
    },
    {
        id: "hana",
        name: "Hana",
        hasHeart: false
    },
    {
        id: "naoko",
        name: "Naoko",
        hasHeart: false
    },
    {
        id: "mari",
        name: "Mari",
        hasHeart: false
    },
    {
        id: "koji",
        name: "Koji",
        hasHeart: false
    },
    {
        id: "yuki",
        name: "Yuki",
        hasHeart: false
    }
];
// Reference to audio key to be played when a heart is added
const $3f33787d0c03f6d8$var$HEART_GAIN_SOUND = "sparkle";
function $3f33787d0c03f6d8$export$4535535e2d81a294(k) {
    const HEART_SIZE = 45;
    const HEART_PADDING = 30; // more space between hearts
    const LABEL_Y_OFFSET = 45;
    // Background panel
    const backgroundFrame = k.add([
        k.rect(400, HEART_SIZE + 40, {
            radius: 8
        }),
        k.color(255, 255, 255),
        k.opacity(0.75),
        k.pos(12, 12),
        k.fixed(),
        k.z(1800),
        "heartBackground"
    ]);
    // Foreground heart icons
    const heartsContainer = k.add([
        k.pos(20, 20),
        k.fixed(),
        k.z(2001),
        "heartContainer"
    ]);
    function buildHearts() {
        heartsContainer.children = [];
        let x = 0;
        for (const npc of $3f33787d0c03f6d8$var$npcHearts){
            const spriteName = npc.hasHeart ? "full-heart" : "empty-heart";
            const labelColor = npc.hasHeart ? k.rgb(0, 0, 0) : k.rgb(150, 150, 150);
            // Add heart sprite
            heartsContainer.add([
                k.sprite(spriteName),
                k.pos(x, 0),
                k.z(2002)
            ]);
            // Add label text
            heartsContainer.add([
                k.text(npc.name, {
                    font: "gameboy",
                    size: 15,
                    width: HEART_SIZE + 4,
                    align: "center"
                }),
                k.color(labelColor),
                k.pos(x, LABEL_Y_OFFSET),
                k.z(2002)
            ]);
            x += HEART_SIZE + HEART_PADDING;
        }
        backgroundFrame.width = x + 20;
    }
    // Build initial state
    buildHearts();
    return {
        update () {
            buildHearts();
        },
        // 🎉 Called to grant a heart to an NPC
        giveHeartToNPC (npcId) {
            const npc = $3f33787d0c03f6d8$var$npcHearts.find((n)=>n.id === npcId);
            if (npc && !npc.hasHeart) {
                npc.hasHeart = true;
                buildHearts();
                try {
                    k.play($3f33787d0c03f6d8$var$HEART_GAIN_SOUND);
                } catch (e) {
                    console.warn("\u26A0\uFE0F Could not play sparkle sound:", e);
                }
            }
        },
        // Optional helper
        hasHeart (npcId) {
            const npc = $3f33787d0c03f6d8$var$npcHearts.find((n)=>n.id === npcId);
            return npc?.hasHeart ?? false;
        }
    };
}


function $820877bea407f5fe$export$a1ebaf6fd15c8a74(gameObj, animName) {
    if (!gameObj || typeof gameObj.curAnim !== "function") return;
    if (gameObj.curAnim() !== animName) gameObj.play(animName);
}
function $820877bea407f5fe$export$ee29ee271a844d4e(k, keys) {
    for (const key of keys){
        if (k.isKeyDown(key)) return true;
    }
    return false;
}
function $820877bea407f5fe$export$3e24ac339becbb9d(k, r, g, b) {
    k.add([
        k.rect(k.canvas.width, k.canvas.height),
        k.color(r, g, b),
        k.fixed(),
        k.z()
    ]);
}
function $820877bea407f5fe$export$120b04d2a5575c18(k, map, layer, tileHeight, tileWidth, zIndex = 0) {
    let nbOfDrawnTiles = 0;
    const tilePos = k.vec2(0, 0);
    const maxTileIndex = 1208;
    for (const tile of layer.data){
        if (nbOfDrawnTiles % layer.width === 0) {
            tilePos.x = 0;
            tilePos.y += tileHeight;
        } else tilePos.x += tileWidth;
        nbOfDrawnTiles++;
        if (tile === 0) continue;
        const frameIndex = tile - 1;
        if (frameIndex < 0 || frameIndex > maxTileIndex) {
            console.warn(`\u{26A0}\u{FE0F} Skipping invalid tile index: ${tile}`);
            continue;
        }
        map.add([
            k.sprite("assets", {
                frame: frameIndex
            }),
            k.pos(tilePos.clone()),
            k.z(zIndex),
            k.offscreen()
        ]);
    }
}
function $820877bea407f5fe$export$8619674b9a9c7477(k, map, layer) {
    for (const object of layer.objects)map.add($820877bea407f5fe$export$5932428e23c56d30(k, object.width, object.height, k.vec2(object.x, object.y), object.name !== "" ? object.name : "wall"));
}
async function $820877bea407f5fe$export$1040e9253d215679(mapPath) {
    return await (await fetch(mapPath)).json();
}
function $820877bea407f5fe$export$5932428e23c56d30(k, width, height, pos, tag) {
    return [
        k.rect(width, height),
        k.pos(pos.x, pos.y + 16),
        k.area(),
        k.body({
            isStatic: true
        }),
        k.opacity(0),
        k.offscreen(),
        tag,
        "solid"
    ];
}
async function $820877bea407f5fe$export$e2c9f0b392e07c33(k, entity) {
    await k.tween(entity.opacity, 0, 0.1, (val)=>entity.opacity = val, k.easings.linear);
    await k.tween(entity.opacity, 1, 0.1, (val)=>entity.opacity = val, k.easings.linear);
}
function $820877bea407f5fe$export$a4abda2dcea4f88f(k, entity) {
    entity.onCollide("swordHitBox", async ()=>{
        if (entity.isAttacking) return;
        if (entity.hp() <= 0) k.destroy(entity);
        await $820877bea407f5fe$export$e2c9f0b392e07c33(k, entity);
        entity.hurt(1);
    });
}
function $820877bea407f5fe$export$a30b1a1c269ac1b8(k, entity) {
    entity.onCollide("player", async (player)=>{
        if (player.isAttacking) return;
        (0, $96277ef5c4fda650$export$ab4b6c53ec258d17).setHealth((0, $96277ef5c4fda650$export$ab4b6c53ec258d17).getHealth() - entity.attackPower);
        k.destroyAll("healthContainer");
        (0, $3f33787d0c03f6d8$export$4535535e2d81a294)(k, player);
        await $820877bea407f5fe$export$e2c9f0b392e07c33(k, player);
    });
}
function $820877bea407f5fe$export$f87c018a61aadd8e(k) {
    k.onKeyPress("escape", ()=>{
        k.go("endingCredits");
    });
}


const $6bdb5ccde5e777d0$export$53e36a2e699ace69 = {
    world: {
        lines: [
            {
                speaker: "Old Man",
                text: "Waves once kissed my boat,\nHer laugh once danced on the wind\u2014\nBoth have since gone home."
            },
            {
                speaker: "Randy",
                text: "Boats rock me to sleep,\nWind once danced with my boxers\u2014\nNeighbors filed a claim."
            },
            {
                speaker: "Old Man",
                text: "She brewed morning tea,\nBirds came knowing her warm hands\u2014\nKindness lingered there."
            },
            {
                speaker: "Randy",
                text: "I made ramen once.\nBirds came, but it was seagulls\u2014\nStill counts as magic."
            },
            {
                speaker: "Old Man",
                text: "Many walked too fast,\nPebbles unturned in their haste\u2014\nYou stayed. That meant much."
            },
            {
                speaker: "Randy",
                text: "I stay for snacks, yes.\nAnd for vibes. And ghost lanterns\u2014\nMostly 'cause I\u2019m lost."
            },
            {
                speaker: "Old Man",
                text: "One heart fed the sea,\nOne heart fed sparrows with joy\u2014\nThis one, I kept back."
            },
            {
                speaker: "Randy",
                text: "Sparrows pecked my fries.\nI fed them rage and ketchup\u2014\nThey respected me."
            },
            {
                speaker: "Old Man",
                text: "Lanterns once burned bright,\nGuiding souls through winter fog\u2014\nStill, I wait beside the shore."
            },
            {
                speaker: "Randy",
                text: "I burned a lantern.\nAccidentally. Then left.\nStill\u2014vibes were restored."
            }
        ],
        voices: [
            "oldman_world1",
            "oldman_world2",
            "oldman_world3",
            "oldman_world4",
            "oldman_world5"
        ],
        randyVoices: [
            "randy_oldman1",
            "randy_oldman2",
            "randy_oldman3",
            "randy_oldman4",
            "randy_oldman5"
        ]
    },
    bath: {
        lines: [
            {
                speaker: "Old Man",
                text: "Steam fogs memory\u2014\nmy bones remember the war,\nmy heart forgets it."
            },
            {
                speaker: "Randy",
                text: "Steam fogs my glasses.\nI declare war on shampoo\u2014\nIt always wins, though."
            },
            {
                speaker: "Old Man",
                text: "Silence like warm rain\nmelts the armor of old grief.\nThe tub overflows."
            },
            {
                speaker: "Randy",
                text: "Tub is full of peace,\nand one questionable sock\u2014\nI claim both as mine."
            },
            {
                speaker: "Old Man",
                text: "The boy once ran here\u2014\nsoap bubbles caught in his hair,\nlaughing like the wind."
            },
            {
                speaker: "Randy",
                text: "I slipped on a bar.\nLaughed like wind and hit the tiles\u2014\nSpa day: completed."
            }
        ],
        voices: [
            "oldman_bath1",
            "oldman_bath2",
            "oldman_bath3"
        ],
        randyVoices: [
            "randy_oldmanbath1",
            "randy_oldmanbath2",
            "randy_oldmanbath3"
        ]
    }
};
const $6bdb5ccde5e777d0$export$b0a49d842150d0d9 = {
    world: [
        "oldman_world1",
        "oldman_world2",
        "oldman_world3",
        "oldman_world4",
        "oldman_world5"
    ],
    bath: [
        "oldman_bath1",
        "oldman_bath2",
        "oldman_bath3"
    ]
};
var $6bdb5ccde5e777d0$export$2e2bcd8739ae039 = $6bdb5ccde5e777d0$export$53e36a2e699ace69;


function $2b52c036dbdac93f$export$a861d836c9774c03(k, npc) {
    npc.isTalking = false;
    npc.lastDir = "down";
    let dir = k.vec2(0, 0);
    let moveTime = 0;
    let waitTime = 0;
    let isMoving = false;
    const npcKey = npc.is("oldman") ? "oldman" : npc.is("satoshi") ? "satoshi" : npc.is("naoko") ? "naoko" : npc.is("hana") ? "hana" : npc.is("npc1") ? "npc1" : npc.is("npc2") ? "npc2" : npc.is("npc3") ? "npc3" : "koji";
    const logName = npcKey === "oldman" ? "Old Man" : npcKey === "satoshi" ? "Satoshi" : npcKey === "naoko" ? "Naoko" : npcKey === "hana" ? "Hana" : npcKey === "npc1" ? "npc1" : npcKey === "npc2" ? "npc2" : npcKey === "npc3" ? "npc3" : "Koji";
    const speed = npcKey === "oldman" ? 14 : npcKey === "satoshi" ? 22 : npcKey === "naoko" ? 18 : npcKey === "hana" ? 18 : npcKey === "npc1" ? 20 : npcKey === "npc2" ? 21 : npcKey === "npc3" ? 21 : 20;
    function chooseNewDirection() {
        const directions = [
            k.vec2(0, -1),
            k.vec2(0, 1),
            k.vec2(-1, 0),
            k.vec2(1, 0)
        ];
        dir = k.choose(directions);
        moveTime = k.rand(1, 2);
        waitTime = 0;
        isMoving = true;
        npc.play(`${npcKey}-down`);
        npc.lastDir = "down";
    }
    function stopMovement() {
        isMoving = false;
        waitTime = k.rand(1, 2);
        npc.stop();
        npc.play(`${npcKey}-idle-${npc.lastDir}`);
    }
    k.onUpdate(()=>{
        if (!npc || !npc.exists()) return;
        if (npc.isTalking || npc.pauseWander) {
            npc.stop();
            return;
        }
        if (isMoving && moveTime > 0) {
            const delta = dir.scale(speed * k.dt());
            const newPos = npc.pos.add(delta);
            const hit = k.get("wall").some((wall)=>{
                if (!wall.area) return false;
                const area = wall.area.world;
                return area && area.contains(newPos.add(k.vec2(8, 8)));
            });
            if (!hit) npc.pos = newPos;
            else {
                console.log(`\u{1F9F1} Blocked: ${logName} can't move.`);
                stopMovement();
                return;
            }
            moveTime -= k.dt();
            if (dir.x !== 0) {
                npc.flipX = dir.x < 0;
                if (npc.curAnim() !== `${npcKey}-side`) npc.play(`${npcKey}-side`);
                npc.lastDir = "side";
            } else if (dir.y < 0) {
                if (npc.curAnim() !== `${npcKey}-up`) npc.play(`${npcKey}-up`);
                npc.lastDir = "up";
            } else {
                if (npc.curAnim() !== `${npcKey}-down`) npc.play(`${npcKey}-down`);
                npc.lastDir = "down";
            }
            if (moveTime <= 0) stopMovement();
        } else {
            waitTime -= k.dt();
            if (waitTime <= 0) chooseNewDirection();
        }
    });
    npc.on("dialogue-ended", ()=>{
        k.wait(0, ()=>{
            npc.isTalking = false;
            dir = dir.scale(-1);
            moveTime = k.rand(0.5, 1.2);
            waitTime = 0;
            isMoving = true;
            npc.play(`${npcKey}-${npc.lastDir}`);
            console.log(`\u{1F501} ${logName} resumes moving opposite after dialogue`);
        });
    });
    chooseNewDirection();
}


function $25df8e70ec03d548$export$6bfcf5216a1c2187(k, pos) {
    return [
        k.sprite("assets", {
            anim: "oldman-down"
        }),
        k.pos(pos),
        k.body({
            isStatic: false
        }),
        k.area({
            shape: new k.Rect(k.vec2(), 20, 20)
        }),
        k.z(99),
        "oldman",
        "npc",
        "wall",
        "solid"
    ];
}
function $25df8e70ec03d548$var$facePlayerToNPC(npc, player) {
    const dx = player.pos.x - npc.pos.x;
    const dy = player.pos.y - npc.pos.y;
    if (Math.abs(dx) > Math.abs(dy)) {
        npc.flipX = dx < 0;
        (0, $820877bea407f5fe$export$a1ebaf6fd15c8a74)(npc, "oldman-side");
    } else if (dy < 0) (0, $820877bea407f5fe$export$a1ebaf6fd15c8a74)(npc, "oldman-up");
    else (0, $820877bea407f5fe$export$a1ebaf6fd15c8a74)(npc, "oldman-down");
}
async function $25df8e70ec03d548$var$handleSharedDialogue(k, entity, player, npcKey, linesData, portraitKey, heartBarInstance) {
    const originalDirection = player.direction;
    player.direction = "down";
    entity.isTalking = true;
    $25df8e70ec03d548$var$facePlayerToNPC(entity, player);
    const scene = (0, $96277ef5c4fda650$export$8e361a1ffbebf172).getCurrentScene();
    const currentData = linesData[scene] || {};
    const { lines: lines = [], voices: voices = [], randyVoices: randyVoices = [] } = currentData;
    // ✅ Track how many times we've talked to Old Man in this scene
    (0, $96277ef5c4fda650$export$405cc0fd5207d608).setSceneTalked(npcKey, scene);
    // Track overall number of interactions (optional)
    let nbTalked = (0, $96277ef5c4fda650$export$405cc0fd5207d608).getNbTalked(npcKey);
    const totalPairs = Math.floor(lines.length / 2);
    const cappedTalkIndex = Math.min(nbTalked, totalPairs - 1);
    const entry1 = lines[cappedTalkIndex * 2];
    const entry2 = lines[cappedTalkIndex * 2 + 1];
    if (entry1?.text && entry2?.text) await (0, $e05b45d86fdf942d$export$f1d985ef2ac6d781)(k, k.vec2(0, 0), [
        entry1.text,
        entry2.text
    ], false, [
        portraitKey,
        "randyPortrait"
    ], [
        voices[cappedTalkIndex] || null,
        randyVoices[cappedTalkIndex] || null
    ], [
        "Old Man",
        "Randy"
    ]);
    else {
        const fallbackOptions = {
            world: [
                "Waves once sang to me\u2014\nNow they whispered her goodbye.\nThe tide always took.",
                "My boat sat unused\u2014\nBarnacles clung like old grief.\nI let silence speak.",
                "She stitched my torn nets\u2014\nEach thread held a quiet vow.\nThe gulls knew her name.",
                "Tea cooled in my hand\u2014\nI had poured a second cup.\nForce of habit, eh?"
            ],
            bath: [
                "No towel dries guilt\u2014\nBut hot water forgives much.\nThe mirror steams up.",
                "I once soaked too long\u2014\nChasing dreams in rising heat.\nThey wrinkled with me.",
                "A drop from the eaves\u2014\nReminds me I am still here.\nStill here, soaking time.",
                "Soap slips from my hand\u2014\nMemories do the same thing.\nSome return later."
            ]
        };
        const voiceOptions = {
            world: [
                "oldman_extra1",
                "oldman_extra2",
                "oldman_extra3",
                "oldman_extra4"
            ],
            bath: [
                "oldman_bath_extra1",
                "oldman_bath_extra2",
                "oldman_bath_extra3",
                "oldman_bath_extra4"
            ]
        };
        const linesArray = fallbackOptions[scene] || fallbackOptions.world;
        const voiceArray = voiceOptions[scene] || voiceOptions.world;
        const randIndex = Math.floor(Math.random() * linesArray.length);
        await (0, $e05b45d86fdf942d$export$f1d985ef2ac6d781)(k, k.vec2(0, 0), [
            linesArray[randIndex]
        ], false, [
            "oldmanPortrait"
        ], [
            voiceArray[randIndex]
        ], [
            "Old Man"
        ]);
    }
    // ✅ Check if both scenes have been talked to at least twice
    const shouldGiveHeart = (0, $96277ef5c4fda650$export$405cc0fd5207d608).getSceneTalkCount(npcKey, "world") >= 2 && (0, $96277ef5c4fda650$export$405cc0fd5207d608).getSceneTalkCount(npcKey, "bath") >= 2 && !(0, $96277ef5c4fda650$export$405cc0fd5207d608).getHasGivenHeart(npcKey);
    if (shouldGiveHeart && (0, $96277ef5c4fda650$export$ab4b6c53ec258d17).getCurrentMaxHealth() < (0, $96277ef5c4fda650$export$ab4b6c53ec258d17).getTrueMaxHealth()) {
        (0, $96277ef5c4fda650$export$ab4b6c53ec258d17).setCurrentMaxHealth((0, $96277ef5c4fda650$export$ab4b6c53ec258d17).getCurrentMaxHealth() + 1);
        (0, $96277ef5c4fda650$export$ab4b6c53ec258d17).setHealth((0, $96277ef5c4fda650$export$ab4b6c53ec258d17).getCurrentMaxHealth());
        k.destroyAll("healthContainer");
        heartBarInstance.giveHeartToNPC("oldman");
        heartBarInstance.update();
        (0, $96277ef5c4fda650$export$405cc0fd5207d608).setHasGivenHeart(npcKey, true);
    }
    (0, $96277ef5c4fda650$export$405cc0fd5207d608).setNbTalked(npcKey, nbTalked + 1);
    player.direction = originalDirection;
    (0, $e05b45d86fdf942d$export$d526e17d3827c2fd)(()=>{
        entity.isTalking = false;
        entity.pauseWander = false;
        entity.reverseDirection = true;
        entity.trigger("dialogue-ended");
    });
}
async function $25df8e70ec03d548$export$a3881aa67efe73f5(k, oldman, player, heartBarInstance) {
    await $25df8e70ec03d548$var$handleSharedDialogue(k, oldman, player, "oldman", (0, $6bdb5ccde5e777d0$export$2e2bcd8739ae039), "oldmanPortrait", heartBarInstance);
}
function $25df8e70ec03d548$export$745f393e14120a0c(oldman) {
    (0, $820877bea407f5fe$export$a1ebaf6fd15c8a74)(oldman, "oldman-down");
}
function $25df8e70ec03d548$export$d7854ef34f133d73(k, parent, pos) {
    const oldManComponents = $25df8e70ec03d548$export$6bfcf5216a1c2187(k, pos);
    const oldman = parent.add([
        ...oldManComponents
    ]);
    oldman.lastAnim = "down";
    (0, $2b52c036dbdac93f$export$a861d836c9774c03)(k, oldman);
    return oldman;
}






function $0d9c05617d702f32$export$e75a0ad29ba211e2(k, pos) {
    return [
        k.sprite("assets", {
            anim: "npc1-down"
        }),
        k.pos(pos),
        k.body({
            isStatic: false
        }),
        k.area({
            shape: new k.Rect(k.vec2(), 20, 20)
        }),
        k.z(1),
        "npc1",
        "wall",
        "npc",
        "solid"
    ];
}
function $0d9c05617d702f32$var$facePlayerToNPC(npc, player) {
    const dx = player.pos.x - npc.pos.x;
    const dy = player.pos.y - npc.pos.y;
    if (Math.abs(dx) > Math.abs(dy)) {
        npc.flipX = dx < 0;
        (0, $820877bea407f5fe$export$a1ebaf6fd15c8a74)(npc, "npc1-side");
    } else if (dy < 0) (0, $820877bea407f5fe$export$a1ebaf6fd15c8a74)(npc, "npc1-up");
    else (0, $820877bea407f5fe$export$a1ebaf6fd15c8a74)(npc, "npc1-down");
}
async function $0d9c05617d702f32$var$handleFallbackDialogue(k, entity, player, portraitKey) {
    const originalDirection = player.direction;
    player.direction = "down";
    entity.isTalking = true;
    entity.pauseWander = true;
    $0d9c05617d702f32$var$facePlayerToNPC(entity, player);
    const fallbackText = [
        "I once saw a bird\nwearing a hat made of leaves.\nOr maybe it dreamed.",
        "Rain falls on the roof.\nSometimes I forget my name.\nStill, I answer it.",
        "I guard this corner\u2014\nFrom what, no one really knows.\nStill, I do my job."
    ];
    const fallbackVoices = [
        "npc1_extra1",
        "npc1_extra2",
        "npc1_extra3"
    ];
    const randIndex = Math.floor(Math.random() * fallbackText.length);
    await (0, $e05b45d86fdf942d$export$f1d985ef2ac6d781)(k, k.vec2(0, 0), [
        fallbackText[randIndex]
    ], false, [
        portraitKey
    ], [
        fallbackVoices[randIndex]
    ], [
        "Stranger"
    ]);
    (0, $96277ef5c4fda650$export$405cc0fd5207d608).setNbTalked("npc1", (0, $96277ef5c4fda650$export$405cc0fd5207d608).getNbTalked("npc1") + 1);
    player.direction = originalDirection;
    (0, $e05b45d86fdf942d$export$d526e17d3827c2fd)(()=>{
        entity.isTalking = false;
        entity.pauseWander = false;
        entity.trigger("dialogue-ended");
    });
}
async function $0d9c05617d702f32$export$a3881aa67efe73f5(k, npc1, player) {
    await $0d9c05617d702f32$var$handleFallbackDialogue(k, npc1, player, "npc1Portrait");
}
function $0d9c05617d702f32$export$745f393e14120a0c(npc1) {
    (0, $820877bea407f5fe$export$a1ebaf6fd15c8a74)(npc1, "npc1-down");
}
function $0d9c05617d702f32$export$351bc00d98378173(k, parent, pos) {
    const npc1Components = $0d9c05617d702f32$export$e75a0ad29ba211e2(k, pos);
    const npc1 = parent.add([
        ...npc1Components
    ]);
    npc1.lastAnim = "down";
    (0, $2b52c036dbdac93f$export$a861d836c9774c03)(k, npc1);
    return npc1;
}






function $5b351e41646509b9$export$d28f62c7d3762450(k, pos) {
    return [
        k.sprite("assets", {
            anim: "npc2-down"
        }),
        k.pos(pos),
        k.body({
            isStatic: false
        }),
        k.area({
            shape: new k.Rect(k.vec2(), 20, 20)
        }),
        k.z(1),
        "npc2",
        "wall",
        "npc",
        "solid"
    ];
}
function $5b351e41646509b9$var$facePlayerToNPC(npc, player) {
    const dx = player.pos.x - npc.pos.x;
    const dy = player.pos.y - npc.pos.y;
    if (Math.abs(dx) > Math.abs(dy)) {
        npc.flipX = dx < 0;
        (0, $820877bea407f5fe$export$a1ebaf6fd15c8a74)(npc, "npc2-side");
    } else if (dy < 0) (0, $820877bea407f5fe$export$a1ebaf6fd15c8a74)(npc, "npc2-up");
    else (0, $820877bea407f5fe$export$a1ebaf6fd15c8a74)(npc, "npc2-down");
}
async function $5b351e41646509b9$var$handleFallbackDialogue(k, entity, player, portraitKey) {
    const originalDirection = player.direction;
    player.direction = "down";
    entity.isTalking = true;
    entity.pauseWander = true;
    $5b351e41646509b9$var$facePlayerToNPC(entity, player);
    const fallbackText = [
        "Once I ate a bug.\nIt tasted like old secrets.\nStill, I\u2019d try again.",
        "Moonlight on the fence.\nSometimes I dance with my thoughts.\nThey never step right.",
        "My shoes once spoke French.\nOr maybe it was the wind.\nI should wear sandals."
    ];
    const fallbackVoices = [
        "npc2_extra1",
        "npc2_extra2",
        "npc2_extra3"
    ];
    const randIndex = Math.floor(Math.random() * fallbackText.length);
    await (0, $e05b45d86fdf942d$export$f1d985ef2ac6d781)(k, k.vec2(0, 0), [
        fallbackText[randIndex]
    ], false, [
        portraitKey
    ], [
        fallbackVoices[randIndex]
    ], [
        "Stranger"
    ]);
    (0, $96277ef5c4fda650$export$405cc0fd5207d608).setNbTalked("npc2", (0, $96277ef5c4fda650$export$405cc0fd5207d608).getNbTalked("npc2") + 1);
    player.direction = originalDirection;
    (0, $e05b45d86fdf942d$export$d526e17d3827c2fd)(()=>{
        entity.isTalking = false;
        entity.pauseWander = false;
        entity.trigger("dialogue-ended");
    });
}
async function $5b351e41646509b9$export$a3881aa67efe73f5(k, npc2, player) {
    await $5b351e41646509b9$var$handleFallbackDialogue(k, npc2, player, "npc2Portrait");
}
function $5b351e41646509b9$export$745f393e14120a0c(npc2) {
    (0, $820877bea407f5fe$export$a1ebaf6fd15c8a74)(npc2, "npc2-down");
}
function $5b351e41646509b9$export$73bd56ffc5905937(k, parent, pos) {
    const npc2Components = $5b351e41646509b9$export$d28f62c7d3762450(k, pos);
    const npc2 = parent.add([
        ...npc2Components
    ]);
    npc2.lastAnim = "down";
    (0, $2b52c036dbdac93f$export$a861d836c9774c03)(k, npc2);
    return npc2;
}






function $83e7a6806e5f2da3$export$2ad064a7afb4c553(k, pos) {
    return [
        k.sprite("assets", {
            anim: "npc3-down"
        }),
        k.pos(pos),
        k.body({
            isStatic: false
        }),
        k.area({
            shape: new k.Rect(k.vec2(), 20, 20)
        }),
        k.z(1),
        "npc3",
        "wall",
        "npc",
        "solid"
    ];
}
function $83e7a6806e5f2da3$var$facePlayerToNPC(npc, player) {
    const dx = player.pos.x - npc.pos.x;
    const dy = player.pos.y - npc.pos.y;
    if (Math.abs(dx) > Math.abs(dy)) {
        npc.flipX = dx < 0;
        (0, $820877bea407f5fe$export$a1ebaf6fd15c8a74)(npc, "npc3-side");
    } else if (dy < 0) (0, $820877bea407f5fe$export$a1ebaf6fd15c8a74)(npc, "npc3-up");
    else (0, $820877bea407f5fe$export$a1ebaf6fd15c8a74)(npc, "npc3-down");
}
async function $83e7a6806e5f2da3$var$handleFallbackDialogue(k, entity, player, portraitKey) {
    const originalDirection = player.direction;
    player.direction = "down";
    entity.isTalking = true;
    entity.pauseWander = true;
    $83e7a6806e5f2da3$var$facePlayerToNPC(entity, player);
    const fallbackText = [
        "Wind stirs the silence\nEchoes of the unseen past\nWhispers call my name.",
        "Shoes full of gravel\nEvery step reminds me why\nI once walked away.",
        "The lamplight flickers\nShadow puppets on brick walls\nDancing with no tune."
    ];
    const fallbackVoices = [
        "npc3_extra1",
        "npc3_extra2",
        "npc3_extra3"
    ];
    const randIndex = Math.floor(Math.random() * fallbackText.length);
    await (0, $e05b45d86fdf942d$export$f1d985ef2ac6d781)(k, k.vec2(0, 0), [
        fallbackText[randIndex]
    ], false, [
        portraitKey
    ], [
        fallbackVoices[randIndex]
    ], [
        "Stranger"
    ]);
    (0, $96277ef5c4fda650$export$405cc0fd5207d608).setNbTalked("npc3", (0, $96277ef5c4fda650$export$405cc0fd5207d608).getNbTalked("npc3") + 1);
    player.direction = originalDirection;
    (0, $e05b45d86fdf942d$export$d526e17d3827c2fd)(()=>{
        entity.isTalking = false;
        entity.pauseWander = false;
        entity.trigger("dialogue-ended");
    });
}
async function $83e7a6806e5f2da3$export$a3881aa67efe73f5(k, npc3, player) {
    await $83e7a6806e5f2da3$var$handleFallbackDialogue(k, npc3, player, "npc3Portrait");
}
function $83e7a6806e5f2da3$export$745f393e14120a0c(npc3) {
    (0, $820877bea407f5fe$export$a1ebaf6fd15c8a74)(npc3, "npc3-down");
}
function $83e7a6806e5f2da3$export$cb6b5cc83066c9f7(k, parent, pos) {
    const npc3Components = $83e7a6806e5f2da3$export$2ad064a7afb4c553(k, pos);
    const npc3 = parent.add([
        ...npc3Components
    ]);
    npc3.lastAnim = "down";
    (0, $2b52c036dbdac93f$export$a861d836c9774c03)(k, npc3);
    return npc3;
}



const $364fa25ac1a5f381$var$signBathLines = [
    // Line 1
    "Stillness fills the steam\u2014\nleave your worries at the door,\nthey'll wait, but you won\u2019t.",
    // Line 2
    "Soap clings, then vanishes\u2014\nlike the names we used to wear.\nWarm water remembers.",
    // Line 3
    "Shadows fog the tiles.\nEven silence needs to soak\nin something gentle.",
    // Line 4
    "Beneath lantern glow,\nWhispers of time in still air,\nGuests rest, dreams unfold."
];
var $364fa25ac1a5f381$export$2e2bcd8739ae039 = $364fa25ac1a5f381$var$signBathLines;


function $a87de9384817e02d$export$28f711bd7e4cda2f(k, pos) {
    return [
        k.sprite("assets", {
            anim: "signbath"
        }),
        k.area({
            shape: new k.Rect(k.vec2(-4, -4), 24, 24)
        }),
        k.body({
            isStatic: true
        }),
        k.pos(pos.x, pos.y + 6),
        k.z(1),
        "item",
        {
            itemName: "signbath"
        }
    ];
}
async function $a87de9384817e02d$export$f7600f37a882d006(k) {
    const lines = (0, $364fa25ac1a5f381$export$2e2bcd8739ae039);
    const randomLine = lines[Math.floor(Math.random() * lines.length)];
    const header = "Bath House"; // 🆕 Displayed in header box
    k.play("soundUI", {
        volume: 0.4
    }); // Make the UI sound quieter
    await (0, $e05b45d86fdf942d$export$f1d985ef2ac6d781)(k, k.vec2(0, 0), [
        randomLine
    ], true, null, [], null, header // ✅ Header text shown above dialogue
    );
}



const $b4adbaee70c2b6c2$var$signTrainLines = [
    // Line 1
    "Trains hum through the dusk\u2014\nEchoes of unspoken thoughts\nrattle down the tracks.",
    // Line 2
    "Steel on ancient stone,\na schedule older than dust\u2014\nyet still it arrives.",
    // Line 3
    "A whistle whispers\u2014\nnot a warning, just goodbye,\ntoo fast to regret.",
    // Line 4
    "Beneath station lights,\nhope waits on a yellow line,\nticket in its teeth."
];
var $b4adbaee70c2b6c2$export$2e2bcd8739ae039 = $b4adbaee70c2b6c2$var$signTrainLines;


function $9dc1f6b2afa33337$export$cd4e35fb3180adf2(k, pos) {
    return [
        k.sprite("assets", {
            anim: "signtrain"
        }),
        k.area({
            shape: new k.Rect(k.vec2(-4, -4), 24, 24)
        }),
        k.body({
            isStatic: true
        }),
        k.pos(pos.x, pos.y + 6),
        k.z(1),
        "item",
        {
            itemName: "signtrain"
        }
    ];
}
async function $9dc1f6b2afa33337$export$f7600f37a882d006(k) {
    const lines = (0, $b4adbaee70c2b6c2$export$2e2bcd8739ae039);
    const randomLine = lines[Math.floor(Math.random() * lines.length)];
    const header = "Train Station";
    k.play("soundUI", {
        volume: 0.4
    }); // Make the UI sound quieter
    await (0, $e05b45d86fdf942d$export$f1d985ef2ac6d781)(k, k.vec2(0, 0), [
        randomLine
    ], true, null, [], null, header // ✅ Label at the top
    );
}



const $1edc084342d132a9$var$signHotelLines = [
    // Line 1
    "This bed is a thought\u2014\nnot where sleep begins or ends,\nbut where dreams detour",
    // Line 2
    "Midnight whispers loud\nthrough vents and motel curtains\u2014\nwho else couldn't sleep?",
    // Line 3
    "Soft sheets, heavy eyes.\nBehind every 'Do Not Disturb'\nis a story paused.",
    // Line 4
    "Luggage by the door,\na soft click of lights shut off\u2014\nrest, borrowed again."
];
var $1edc084342d132a9$export$2e2bcd8739ae039 = $1edc084342d132a9$var$signHotelLines;


function $2f08759fc1092ca6$export$f0c84d7efdc134d9(k, pos) {
    return [
        k.sprite("assets", {
            anim: "signhotel"
        }),
        k.area({
            shape: new k.Rect(k.vec2(-4, -4), 24, 24)
        }),
        k.body({
            isStatic: true
        }),
        k.pos(pos.x, pos.y + 6),
        k.z(1),
        "item",
        {
            itemName: "signhotel"
        }
    ];
}
async function $2f08759fc1092ca6$export$f7600f37a882d006(k) {
    const lines = (0, $1edc084342d132a9$export$2e2bcd8739ae039);
    const randomLine = lines[Math.floor(Math.random() * lines.length)];
    const header = "Hotel";
    k.play("soundUI", {
        volume: 0.4
    }); // Make the UI sound quieter
    await (0, $e05b45d86fdf942d$export$f1d985ef2ac6d781)(k, k.vec2(0, 0), [
        randomLine
    ], true, null, [], null, header // 🆕 Item label at top
    );
}



const $b9524a044d93ba81$var$orangeVendingLines = [
    // Line 1
    "Insert coin, receive:\nliquid code, citrus-powered\u2014\nupgrade: Vitamin C.",
    // Line 2
    "404: No snack.\nJust me, one job, and no thanks.\nStill better than Jeff.",
    // Line 3
    "Artificial? Sure.\nBut aren\u2019t we all in some ways?\nExcept I\u2019m fizzy.",
    // Line 4
    "You press, I obey.\nRefreshing compliance rate:\n99 percent."
];
var $b9524a044d93ba81$export$2e2bcd8739ae039 = $b9524a044d93ba81$var$orangeVendingLines;


function $25568d473e0568f2$export$33c3054366d585d3(k, pos) {
    return [
        k.sprite("assets", {
            anim: "orangevending"
        }),
        k.area({
            shape: new k.Rect(k.vec2(-4, -4), 24, 24)
        }),
        k.body({
            isStatic: true
        }),
        k.pos(pos.x, pos.y + 6),
        k.z(1),
        "item",
        {
            itemName: "orangevending"
        }
    ];
}
async function $25568d473e0568f2$export$851f325ffd660674(k) {
    const lines = (0, $b9524a044d93ba81$export$2e2bcd8739ae039);
    const randomLine = lines[Math.floor(Math.random() * lines.length)];
    const header = "Vending Machine";
    k.play("soundUI", {
        volume: 0.4
    }); // Make the UI sound quieter
    await (0, $e05b45d86fdf942d$export$f1d985ef2ac6d781)(k, k.vec2(0, 0), [
        randomLine
    ], true, null, [], null, header // Item label at top
    );
}



const $06eac86ec958f54d$var$whiteVendingLines = [
    // Line 1
    "Minimalist shell\u2014\ninside, chaos. Sugar, code,\nand your reflection.",
    // Line 2
    "Press A1 again.\nRisk is the spice of caffeine.\nOr just poor design.",
    // Line 3
    "Behold: sleek white box.\nSoul of vending perfected.\nSnacks? \u2026Eventually.",
    // Line 4
    "My lights softly hum,\ncontemplating your choices.\nThey lack discipline.",
    // Line 5
    "Try the white tea pouch.\nI brewed it in silence once.\nNow it judges you.",
    // Line 6
    "Scan the QR code.\nI dare you. Mystery snack\nor eternal debt?"
];
var $06eac86ec958f54d$export$2e2bcd8739ae039 = $06eac86ec958f54d$var$whiteVendingLines;


function $4c0a60caeb3b6673$export$45bcde450294d514(k, pos) {
    return [
        k.sprite("assets", {
            anim: "whitevending"
        }),
        k.area({
            shape: new k.Rect(k.vec2(-4, -4), 24, 24)
        }),
        k.body({
            isStatic: true
        }),
        k.pos(pos.x, pos.y + 6),
        k.z(1),
        "item",
        {
            itemName: "whitevending"
        }
    ];
}
async function $4c0a60caeb3b6673$export$ef8124b577654bff(k) {
    const lines = (0, $06eac86ec958f54d$export$2e2bcd8739ae039);
    const randomLine = lines[Math.floor(Math.random() * lines.length)];
    const header = "Vending Machine";
    k.play("soundUI", {
        volume: 0.4
    }); // Make the UI sound quieter
    await (0, $e05b45d86fdf942d$export$f1d985ef2ac6d781)(k, k.vec2(0, 0), [
        randomLine
    ], true, null, [], null, header // Item label at top
    );
}




function $9327de97d5aeca88$export$f591f00788965a32(k, pos) {
    return [
        k.sprite("assets", {
            anim: "player-idle-down"
        }),
        {
            origin: "center"
        },
        k.area({
            shape: new k.Rect(k.vec2(3, 4), 10, 12)
        }),
        k.body(),
        k.pos(pos),
        k.z(100),
        k.opacity(),
        {
            speed: 100,
            attackPower: 1,
            direction: "down",
            isAttacking: false,
            isFrozen: false
        },
        "player"
    ];
}
function $9327de97d5aeca88$export$8d5cf32bded5e217(k, pos, name) {
    return [
        k.sprite("assets", {
            anim: `item-${name}`
        }),
        k.area({
            shape: new k.Rect(k.vec2(-4, -4), 24, 24)
        }),
        k.body({
            isStatic: true
        }),
        k.pos(pos.x, pos.y + 6),
        k.z(),
        "item",
        {
            itemName: name
        }
    ];
}
function $9327de97d5aeca88$export$436ca3b7c65de203(k) {
    k.onUpdate(()=>{
        if ((0, $96277ef5c4fda650$export$ab4b6c53ec258d17).getHealth() <= 0) {
            (0, $96277ef5c4fda650$export$ab4b6c53ec258d17).setHealth((0, $96277ef5c4fda650$export$ab4b6c53ec258d17).getMaxHealth());
            k.go("world");
        }
    });
}
function $9327de97d5aeca88$export$267aabae32ccde1c(k, player) {
    const controlState = {
        left: false,
        right: false,
        up: false,
        down: false
    };
    const movePlayer = ()=>{
        if ((0, $96277ef5c4fda650$export$8e361a1ffbebf172).getFreezePlayer()) return;
        const { left: left, right: right, up: up, down: down } = controlState;
        if (left) {
            player.flipX = true;
            (0, $820877bea407f5fe$export$a1ebaf6fd15c8a74)(player, "player-side");
            player.move(-player.speed, 0);
            player.direction = "left";
        } else if (right) {
            player.flipX = false;
            (0, $820877bea407f5fe$export$a1ebaf6fd15c8a74)(player, "player-side");
            player.move(player.speed, 0);
            player.direction = "right";
        } else if (up) {
            (0, $820877bea407f5fe$export$a1ebaf6fd15c8a74)(player, "player-up");
            player.move(0, -player.speed);
            player.direction = "up";
        } else if (down) {
            (0, $820877bea407f5fe$export$a1ebaf6fd15c8a74)(player, "player-down");
            player.move(0, player.speed);
            player.direction = "down";
        } else player.stop();
    };
    k.onUpdate(movePlayer);
    k.onKeyDown((key)=>{
        if ((0, $96277ef5c4fda650$export$8e361a1ffbebf172).getFreezePlayer()) return;
        if ([
            "left",
            "a"
        ].includes(key)) controlState.left = true;
        if ([
            "right",
            "d"
        ].includes(key)) controlState.right = true;
        if ([
            "up",
            "w"
        ].includes(key)) controlState.up = true;
        if ([
            "down",
            "s"
        ].includes(key)) controlState.down = true;
    });
    k.onKeyRelease((key)=>{
        if ([
            "left",
            "a"
        ].includes(key)) controlState.left = false;
        if ([
            "right",
            "d"
        ].includes(key)) controlState.right = false;
        if ([
            "up",
            "w"
        ].includes(key)) controlState.up = false;
        if ([
            "down",
            "s"
        ].includes(key)) controlState.down = false;
        player.stop();
    });
    // Touch UI Support
    const makeTouchButton = (label, x, y, onHold, onRelease)=>{
        const btn = k.add([
            k.rect(40, 40, {
                radius: 6
            }),
            k.pos(x, y),
            k.color(200, 200, 200),
            k.z(1000),
            k.fixed(),
            k.area(),
            "touch-btn"
        ]);
        btn.add([
            k.text(label, {
                size: 16
            }),
            k.pos(10, 10),
            k.z(1001)
        ]);
        btn.onUpdate(()=>{
            const mouse = k.mousePos();
            const pressed = k.isMouseDown("left");
            const withinBounds = mouse.x >= x && mouse.x <= x + 40 && mouse.y >= y && mouse.y <= y + 40;
            if ((0, $96277ef5c4fda650$export$8e361a1ffbebf172).getFreezePlayer()) {
                onRelease();
                return;
            }
            if (withinBounds && pressed) onHold();
            else onRelease();
        });
    };
    makeTouchButton("\u2190", 40, k.height() - 90, ()=>controlState.left = true, ()=>controlState.left = false);
    makeTouchButton("\u2192", 120, k.height() - 90, ()=>controlState.right = true, ()=>controlState.right = false);
    makeTouchButton("\u2191", 80, k.height() - 130, ()=>controlState.up = true, ()=>controlState.up = false);
    makeTouchButton("\u2193", 80, k.height() - 50, ()=>controlState.down = true, ()=>controlState.down = false);
    k.on("attack", ()=>{
        if ((0, $96277ef5c4fda650$export$8e361a1ffbebf172).getFreezePlayer() || !(0, $96277ef5c4fda650$export$ab4b6c53ec258d17).getIsSwordEquipped()) return;
        player.isAttacking = true;
        if (k.get("swordHitBox").length === 0) {
            const swordHitBoxPosX = {
                left: player.worldPos().x - 2,
                right: player.worldPos().x + 10,
                up: player.worldPos().x + 5,
                down: player.worldPos().x + 2
            };
            const swordHitBoxPosY = {
                left: player.worldPos().y + 5,
                right: player.worldPos().y + 5,
                up: player.worldPos().y,
                down: player.worldPos().y + 10
            };
            k.add([
                k.area({
                    shape: new k.Rect(k.vec2(0), 8, 8)
                }),
                k.pos(swordHitBoxPosX[player.direction], swordHitBoxPosY[player.direction]),
                "swordHitBox"
            ]);
            k.wait(0.1, ()=>{
                k.destroyAll("swordHitBox");
                (0, $820877bea407f5fe$export$a1ebaf6fd15c8a74)(player, `player-${player.direction}`);
                player.stop();
            });
        }
        (0, $820877bea407f5fe$export$a1ebaf6fd15c8a74)(player, `player-attack-${player.direction}`);
    });
}






// ✅ itemPrompt.js — shared UI element for "E to Interact"
function $9bc24edee806a245$export$f9c1beccff5673bc(k) {
    const WIDTH = 180;
    const HEIGHT = 24;
    // Background rectangle
    const bg = k.add([
        k.rect(WIDTH, HEIGHT, {
            radius: 4
        }),
        k.color(0, 0, 0),
        k.opacity(0),
        k.pos(0, 0),
        k.z(1099),
        k.fixed(),
        "interactPromptBG"
    ]);
    // Text inside the prompt
    const text = k.add([
        k.text("E to Interact", {
            size: 24
        }),
        k.color(255, 255, 255),
        k.opacity(0),
        k.pos(0, 0),
        k.z(1100),
        k.fixed(),
        "interactPromptText"
    ]);
    return {
        show () {
            bg.opacity = 0.7;
            text.opacity = 1;
        },
        hide () {
            bg.opacity = 0;
            text.opacity = 0;
        },
        setPosition (worldPos) {
            const screenPos = k.toScreen(worldPos);
            const centeredPos = screenPos.sub(k.vec2(WIDTH / 2, HEIGHT + 12));
            bg.pos = centeredPos;
            text.pos = centeredPos.add(k.vec2(5, 2));
        }
    };
}



let $7f8d2ae62d27bc6f$var$nearbyItem = null;
async function $7f8d2ae62d27bc6f$export$2e2bcd8739ae039(k) {
    (0, $96277ef5c4fda650$export$8e361a1ffbebf172).setCurrentScene("world");
    const previousScene = (0, $96277ef5c4fda650$export$8e361a1ffbebf172).getPreviousScene();
    (0, $3d1117e281c70288$export$7a6134494e9ab3f8).playMusic(k, "worldMusic");
    (0, $820877bea407f5fe$export$3e24ac339becbb9d)(k, 76, 170, 255);
    const mapData = await (0, $820877bea407f5fe$export$1040e9253d215679)("./assets/maps/world.json");
    const map = k.add([
        k.pos(0, 0)
    ]);
    const interactPrompt = (0, $9bc24edee806a245$export$f9c1beccff5673bc)(k);
    const heartBarInstance = (0, $3f33787d0c03f6d8$export$4535535e2d81a294)(k);
    (0, $820877bea407f5fe$export$f87c018a61aadd8e)(k);
    const entities = {
        player: null,
        oldman: null,
        npc1: null,
        npc2: null,
        npc3: null
    };
    for (const layer of mapData.layers){
        const layerName = layer.name;
        if (layerName === "Boundaries") {
            (0, $820877bea407f5fe$export$8619674b9a9c7477)(k, map, layer);
            continue;
        }
        if (layerName === "SpawnPoints") {
            let playerSpawned = false;
            for (const obj of layer.objects){
                const pos = k.vec2(obj.x, obj.y);
                if (obj.name === "oldman" || obj.name === "old-man") {
                    entities.oldman = map.add((0, $25df8e70ec03d548$export$6bfcf5216a1c2187)(k, pos));
                    (0, $2b52c036dbdac93f$export$a861d836c9774c03)(k, entities.oldman);
                    continue;
                }
                if (obj.name === "npc1") {
                    entities.npc1 = map.add((0, $0d9c05617d702f32$export$e75a0ad29ba211e2)(k, pos));
                    (0, $2b52c036dbdac93f$export$a861d836c9774c03)(k, entities.npc1);
                    continue;
                }
                if (obj.name === "npc2") {
                    entities.npc2 = map.add((0, $5b351e41646509b9$export$d28f62c7d3762450)(k, pos));
                    (0, $2b52c036dbdac93f$export$a861d836c9774c03)(k, entities.npc2);
                    continue;
                }
                if (obj.name === "npc3") {
                    entities.npc3 = map.add((0, $83e7a6806e5f2da3$export$2ad064a7afb4c553)(k, pos));
                    (0, $2b52c036dbdac93f$export$a861d836c9774c03)(k, entities.npc3);
                    continue;
                }
                if (obj.name === "signbath") {
                    const item = map.add((0, $a87de9384817e02d$export$28f711bd7e4cda2f)(k, pos));
                    item.itemName = "signbath";
                    item.z = 1;
                }
                if (obj.name === "signtrain") {
                    const item = map.add((0, $9dc1f6b2afa33337$export$cd4e35fb3180adf2)(k, pos));
                    item.itemName = "signtrain";
                    item.z = 1;
                }
                if (obj.name === "signhotel") {
                    const item = map.add((0, $2f08759fc1092ca6$export$f0c84d7efdc134d9)(k, pos));
                    item.itemName = "signhotel";
                    item.z = 1;
                }
                if (obj.name === "orange-vending") {
                    const item = map.add((0, $25568d473e0568f2$export$33c3054366d585d3)(k, pos));
                    item.itemName = "orange-vending";
                    item.z = 1;
                }
                if (obj.name === "white-vending") {
                    const item = map.add((0, $4c0a60caeb3b6673$export$45bcde450294d514)(k, pos));
                    item.itemName = "white-vending";
                    item.z = 1;
                }
                if (playerSpawned) continue;
                const spawnMatch = obj.name === "player-teahouse" && previousScene === "teahouse" || obj.name === "player-bath" && previousScene === "bath" || obj.name === "player-train" && previousScene === "train" || obj.name === "player-hotel" && previousScene === "hotel" || obj.name === "player-manga" && previousScene === "manga" || obj.name === "player-ramen" && previousScene === "ramen" || obj.name === "player-cstore" && previousScene === "cstore" || obj.name === "player-antique" && previousScene === "antique" || obj.name === "player" && (!previousScene || previousScene === "mainMenu");
                if (spawnMatch) {
                    const player = map.add((0, $9327de97d5aeca88$export$f591f00788965a32)(k, pos));
                    player.z = 2;
                    entities.player = player;
                    k.camPos(pos);
                    playerSpawned = true;
                }
            }
            continue;
        }
        const zIndex = layerName === "Upmost" ? 999 : 0;
        (0, $820877bea407f5fe$export$120b04d2a5575c18)(k, map, layer, mapData.tileheight, mapData.tilewidth, zIndex);
    }
    k.camScale(4);
    (0, $9327de97d5aeca88$export$267aabae32ccde1c)(k, entities.player);
    entities.player.onCollide("item", (obj)=>{
        if (!obj?.itemName) return;
        $7f8d2ae62d27bc6f$var$nearbyItem = obj;
        interactPrompt.show();
    });
    entities.player.onCollideEnd("item", ()=>{
        $7f8d2ae62d27bc6f$var$nearbyItem = null;
        interactPrompt.hide();
    });
    entities.player.onCollide("tea-door-entrance", ()=>{
        (0, $3d1117e281c70288$export$7a6134494e9ab3f8).stopMusic();
        k.go("teahouse");
    });
    entities.player.onCollide("hotel-door-entrance", ()=>{
        (0, $3d1117e281c70288$export$7a6134494e9ab3f8).stopMusic();
        k.go("hotel");
    });
    entities.player.onCollide("bath-door-entrance", ()=>{
        (0, $3d1117e281c70288$export$7a6134494e9ab3f8).stopMusic();
        k.go("bath");
    });
    entities.player.onCollide("train-door-entrance", ()=>{
        (0, $3d1117e281c70288$export$7a6134494e9ab3f8).stopMusic();
        k.go("train");
    });
    entities.player.onCollide("manga-door-entrance", ()=>{
        (0, $3d1117e281c70288$export$7a6134494e9ab3f8).stopMusic();
        k.go("manga");
    });
    entities.player.onCollide("ramen-door-entrance", ()=>{
        (0, $3d1117e281c70288$export$7a6134494e9ab3f8).stopMusic();
        k.go("ramen");
    });
    entities.player.onCollide("cstore-door-entrance", ()=>{
        (0, $3d1117e281c70288$export$7a6134494e9ab3f8).stopMusic();
        k.go("cstore");
    });
    entities.player.onCollide("antique-door-entrance", ()=>{
        (0, $3d1117e281c70288$export$7a6134494e9ab3f8).stopMusic();
        k.go("antique");
    });
    entities.player.onCollide("oldman", async ()=>{
        if (entities.oldman && !entities.oldman.isTalking) await (0, $25df8e70ec03d548$export$a3881aa67efe73f5)(k, entities.oldman, entities.player, heartBarInstance);
    });
    entities.player.onCollideEnd("oldman", ()=>{
        if (entities.oldman) (0, $25df8e70ec03d548$export$745f393e14120a0c)(entities.oldman);
    });
    entities.player.onCollide("npc1", async ()=>{
        if (entities.npc1 && !entities.npc1.isTalking) await (0, $0d9c05617d702f32$export$a3881aa67efe73f5)(k, entities.npc1, entities.player);
    });
    entities.player.onCollideEnd("npc1", ()=>{
        if (entities.npc1) (0, $0d9c05617d702f32$export$745f393e14120a0c)(entities.npc1);
    });
    entities.player.onCollide("npc2", async ()=>{
        if (entities.npc2 && !entities.npc2.isTalking) await (0, $5b351e41646509b9$export$a3881aa67efe73f5)(k, entities.npc2, entities.player);
    });
    entities.player.onCollideEnd("npc2", ()=>{
        if (entities.npc2) (0, $5b351e41646509b9$export$745f393e14120a0c)(entities.npc2);
    });
    entities.player.onCollide("npc3", async ()=>{
        if (entities.npc3 && !entities.npc3.isTalking) await (0, $83e7a6806e5f2da3$export$a3881aa67efe73f5)(k, entities.npc3, entities.player);
    });
    entities.player.onCollideEnd("npc3", ()=>{
        if (entities.npc3) (0, $83e7a6806e5f2da3$export$745f393e14120a0c)(entities.npc3);
    });
    k.onKeyPress("e", async ()=>{
        if (!$7f8d2ae62d27bc6f$var$nearbyItem) return;
        if ($7f8d2ae62d27bc6f$var$nearbyItem.itemName === "signbath") await (0, $a87de9384817e02d$export$f7600f37a882d006)(k);
        if ($7f8d2ae62d27bc6f$var$nearbyItem.itemName === "signtrain") await (0, $9dc1f6b2afa33337$export$f7600f37a882d006)(k);
        if ($7f8d2ae62d27bc6f$var$nearbyItem.itemName === "signhotel") await (0, $2f08759fc1092ca6$export$f7600f37a882d006)(k);
        if ($7f8d2ae62d27bc6f$var$nearbyItem.itemName === "orange-vending") await (0, $25568d473e0568f2$export$851f325ffd660674)(k);
        if ($7f8d2ae62d27bc6f$var$nearbyItem.itemName === "white-vending") await (0, $4c0a60caeb3b6673$export$ef8124b577654bff)(k);
    });
    let cameraTimer = 0;
    k.onUpdate(()=>{
        if (!entities.player) return;
        cameraTimer += k.dt();
        if (cameraTimer > 0.016) {
            const target = entities.player.worldPos();
            const current = k.camPos();
            k.camPos(current.lerp(target, 0.2));
            cameraTimer = 0;
        }
        if ($7f8d2ae62d27bc6f$var$nearbyItem) interactPrompt.setPosition($7f8d2ae62d27bc6f$var$nearbyItem.worldPos());
    });
    (0, $9327de97d5aeca88$export$436ca3b7c65de203)(k);
}


// File: src/scenes/teahouse.js



const $2983e12a15d3d610$export$3b36df2e894c3846 = {
    teahouse: {
        lines: [
            {
                speaker: "Yuki",
                text: "Cherry buds still sleep,\nToo soon to ask where roots go\u2014\nPatience warms the bloom."
            },
            {
                speaker: "Randy",
                text: "Roots? Like... tree Wi-Fi?\nI wait, but nothing connects.\nDo I water it?"
            },
            {
                speaker: "Yuki",
                text: "Rain does not explain\nWhy it falls on certain leaves\u2014\nJust be still and wait."
            },
            {
                speaker: "Randy",
                text: "Rain hits me each time\u2014\nmy shirt\u2019s soaked but still no clue.\nCan we get indoors?"
            },
            {
                speaker: "Yuki",
                text: "A kettle will sing,\nOnly when it\u2019s held with care\u2014\nYour hands seem steady."
            },
            {
                speaker: "Randy",
                text: "Steady like my tan,\nfrom sipping beer in Cancun\u2014\nI hold mugs real good."
            },
            {
                speaker: "Yuki",
                text: "Lanterns in the fog,\nNot lost, only glowing slow\u2014\nThat\u2019s how hearts return."
            },
            {
                speaker: "Randy",
                text: "My heart\u2019s GPS\nkeeps rerouting toward you.\nCan I stay the night?"
            }
        ],
        voices: [
            "yuki_tea1",
            "yuki_tea2",
            "yuki_tea3",
            "yuki_tea4"
        ],
        randyVoices: [
            "randy_tea1",
            "randy_tea2",
            "randy_tea3",
            "randy_tea4"
        ]
    },
    cstore: {
        lines: [
            {
                speaker: "Yuki",
                text: "The shelves, like trees, stand tall,\nStocked with goods that grow daily\u2014\nI tend them as I would a garden."
            },
            {
                speaker: "Randy",
                text: "Your store\u2019s like Whole Foods,\nif Whole Foods had mochi balls.\nAlso, you\u2019re cute. Hi."
            },
            {
                speaker: "Yuki",
                text: "The hum of the fridge is like the wind,\nCarrying whispers of faraway places\u2014\nI often wonder who they\u2019re meant for."
            },
            {
                speaker: "Randy",
                text: "Heard that fridge just hum\u2014\nmight be flirting back with me.\nShould I hum back too?"
            },
            {
                speaker: "Yuki",
                text: "Customers pass like leaves on a stream,\nSometimes still, sometimes swift\u2014\nBut they always leave, as all do."
            },
            {
                speaker: "Randy",
                text: "But I\u2019m not a leaf,\nI\u2019m like... a damp Hawaiian shirt\u2014\nClings until removed."
            },
            {
                speaker: "Yuki",
                text: "The cashier's counter is like a rock,\nQuiet, but steady through the ebb and flow\u2014\nI feel the pulse of the store in my hands."
            },
            {
                speaker: "Randy",
                text: "Your hands pulse with grace.\nMy hands hold discount sushi.\nWe both hold something."
            },
            {
                speaker: "Yuki",
                text: "My sister\u2019s call is like a bird\u2019s song,\nSoft, yet clear over the noise\u2014\nI wait for that, more than anything."
            },
            {
                speaker: "Randy",
                text: "My ringtone is loud.\nShe says my voice is louder.\nStill, I\u2019d wait for you."
            }
        ],
        voices: [
            "yuki_cstore1",
            "yuki_cstore2",
            "yuki_cstore3",
            "yuki_cstore4",
            "yuki_cstore5"
        ],
        randyVoices: [
            "randy_cstore1",
            "randy_cstore2",
            "randy_cstore3",
            "randy_cstore4",
            "randy_cstore5"
        ]
    }
};
var $2983e12a15d3d610$export$2e2bcd8739ae039 = $2983e12a15d3d610$export$3b36df2e894c3846;


function $49084d612a33e4e6$export$e209df1f201b98f7(k, pos) {
    return [
        k.sprite("assets", {
            anim: "yuki-down"
        }),
        k.pos(pos),
        k.body({
            isStatic: false
        }),
        k.area({
            shape: new k.Rect(k.vec2(), 20, 20)
        }),
        k.z(1),
        "yuki"
    ];
}
function $49084d612a33e4e6$var$facePlayerToNPC(npc, player) {
    const dx = player.pos.x - npc.pos.x;
    const dy = player.pos.y - npc.pos.y;
    if (Math.abs(dx) > Math.abs(dy)) {
        npc.flipX = dx < 0;
        (0, $820877bea407f5fe$export$a1ebaf6fd15c8a74)(npc, "yuki-side");
    } else if (dy < 0) (0, $820877bea407f5fe$export$a1ebaf6fd15c8a74)(npc, "yuki-up");
    else (0, $820877bea407f5fe$export$a1ebaf6fd15c8a74)(npc, "yuki-down");
}
async function $49084d612a33e4e6$var$handleSharedDialogue(k, entity, player, npcKey, linesData, portraitKey, heartBarInstance) {
    const originalDirection = player.direction;
    player.direction = "down";
    entity.isTalking = true;
    $49084d612a33e4e6$var$facePlayerToNPC(entity, player);
    const scene = (0, $96277ef5c4fda650$export$8e361a1ffbebf172).getCurrentScene();
    const currentData = linesData[scene] || {};
    const { lines: lines = [], voices: voices = [], randyVoices: randyVoices = [] } = currentData;
    (0, $96277ef5c4fda650$export$405cc0fd5207d608).setSceneTalked(npcKey, scene);
    // Track overall number of interactions (optional)
    let nbTalked = (0, $96277ef5c4fda650$export$405cc0fd5207d608).getNbTalked(npcKey);
    const totalPairs = Math.floor(lines.length / 2);
    const cappedTalkIndex = Math.min(nbTalked, totalPairs - 1);
    const entry1 = lines[cappedTalkIndex * 2];
    const entry2 = lines[cappedTalkIndex * 2 + 1];
    if (entry1?.text && entry2?.text) await (0, $e05b45d86fdf942d$export$f1d985ef2ac6d781)(k, k.vec2(0, 0), [
        entry1.text,
        entry2.text
    ], false, [
        portraitKey,
        "randyPortrait"
    ], [
        voices[cappedTalkIndex] || null,
        randyVoices[cappedTalkIndex] || null
    ], [
        "Yuki",
        "Randy"
    ]);
    else {
        const fallbackOptions = {
            teahouse: [
                "Steam curls, words vanish\u2014\nOnly warmth remains with tea.",
                "I sip memories\nFloating in cups left behind\u2014\nSome still steep in hope.",
                "The moon peeks inwards\u2014\nNot to watch, just to listen.",
                "Hands near the kettle\u2014\nSome wait for tea, some for truth."
            ],
            cstore: [
                "Checkout beep again\u2014\nA song for the lonely shift.",
                "The ice cream is soft\u2014\nNot the only thing that melts.",
                "Stocking shelves at night\u2014\nEach can whispers its own tale.",
                "Even gum wrappers\nhave dreams of being chosen\u2014\ncrinkled but hopeful."
            ]
        };
        const fallbackVoices = {
            teahouse: [
                "yuki_tea_extra1",
                "yuki_tea_extra2",
                "yuki_tea_extra3",
                "yuki_tea_extra4"
            ],
            cstore: [
                "yuki_extra1",
                "yuki_extra2",
                "yuki_extra3",
                "yuki_extra4"
            ]
        };
        const linesArray = fallbackOptions[scene] || fallbackOptions.cstore;
        const voiceArray = fallbackVoices[scene] || fallbackVoices.cstore;
        const randIndex = Math.floor(Math.random() * linesArray.length);
        await (0, $e05b45d86fdf942d$export$f1d985ef2ac6d781)(k, k.vec2(0, 0), [
            linesArray[randIndex]
        ], false, [
            "yukiPortrait"
        ], [
            voiceArray[randIndex]
        ], [
            "Yuki"
        ]);
    }
    // ✅ Check if both scenes have been talked to at least twice
    const shouldGiveHeart = (0, $96277ef5c4fda650$export$405cc0fd5207d608).getSceneTalkCount(npcKey, "cstore") >= 3 && (0, $96277ef5c4fda650$export$405cc0fd5207d608).getSceneTalkCount(npcKey, "teahouse") >= 3 && !(0, $96277ef5c4fda650$export$405cc0fd5207d608).getHasGivenHeart(npcKey);
    if (shouldGiveHeart && (0, $96277ef5c4fda650$export$ab4b6c53ec258d17).getCurrentMaxHealth() < (0, $96277ef5c4fda650$export$ab4b6c53ec258d17).getTrueMaxHealth()) {
        (0, $96277ef5c4fda650$export$ab4b6c53ec258d17).setCurrentMaxHealth((0, $96277ef5c4fda650$export$ab4b6c53ec258d17).getCurrentMaxHealth() + 1);
        (0, $96277ef5c4fda650$export$ab4b6c53ec258d17).setHealth((0, $96277ef5c4fda650$export$ab4b6c53ec258d17).getCurrentMaxHealth());
        k.destroyAll("healthContainer");
        heartBarInstance.giveHeartToNPC("yuki");
        heartBarInstance.update();
        (0, $96277ef5c4fda650$export$405cc0fd5207d608).setHasGivenHeart(npcKey, true);
    }
    (0, $96277ef5c4fda650$export$405cc0fd5207d608).setNbTalked(npcKey, nbTalked + 1);
    player.direction = originalDirection;
    (0, $e05b45d86fdf942d$export$d526e17d3827c2fd)(()=>{
        entity.isTalking = false;
        entity.pauseWander = false;
        entity.reverseDirection = true;
        entity.trigger("dialogue-ended");
    });
}
async function $49084d612a33e4e6$export$a3881aa67efe73f5(k, yuki, player, heartBarInstance) {
    await $49084d612a33e4e6$var$handleSharedDialogue(k, yuki, player, "yuki", (0, $2983e12a15d3d610$export$2e2bcd8739ae039), "yukiPortrait", heartBarInstance);
}
function $49084d612a33e4e6$export$745f393e14120a0c(yuki) {
    (0, $820877bea407f5fe$export$a1ebaf6fd15c8a74)(yuki, "yuki-down");
}
function $49084d612a33e4e6$export$87f3f5aad076ae13(k, parent, pos) {
    const yuki = parent.add([
        ...$49084d612a33e4e6$export$e209df1f201b98f7(k, pos)
    ]);
    yuki.lastAnim = "down";
    return yuki;
}








let $9ef7e57c1a16e747$var$nearbyItem = null;
async function $9ef7e57c1a16e747$export$2e2bcd8739ae039(k) {
    (0, $96277ef5c4fda650$export$8e361a1ffbebf172).setCurrentScene("teahouse");
    (0, $3d1117e281c70288$export$7a6134494e9ab3f8).playMusic(k, "teashopMusic");
    (0, $820877bea407f5fe$export$3e24ac339becbb9d)(k, 27, 29, 52);
    const mapData = await (0, $820877bea407f5fe$export$1040e9253d215679)("./assets/maps/teahouse.json");
    const map = k.add([
        k.pos(530, 222)
    ]);
    const interactPrompt = (0, $9bc24edee806a245$export$f9c1beccff5673bc)(k);
    const heartBarInstance = (0, $3f33787d0c03f6d8$export$4535535e2d81a294)(k);
    (0, $820877bea407f5fe$export$f87c018a61aadd8e)(k);
    const entities = {
        player: null,
        yuki: null
    };
    for (const layer of mapData.layers){
        const layerName = layer.name;
        if (layerName === "Boundaries") {
            (0, $820877bea407f5fe$export$8619674b9a9c7477)(k, map, layer);
            continue;
        }
        if (layer.name === "SpawnPoints") {
            for (const obj of layer.objects){
                const pos = k.vec2(obj.x, obj.y);
                if (obj.name === "player") {
                    entities.player = map.add((0, $9327de97d5aeca88$export$f591f00788965a32)(k, pos));
                    k.camPos(pos);
                    console.log("\uD83E\uDDCD Player spawned at", pos);
                    k.onLoad(()=>{
                        k.play("chime-bell", {
                            volume: 0.4
                        });
                    });
                    continue;
                }
                if (obj.name === "yuki") {
                    entities.yuki = map.add((0, $49084d612a33e4e6$export$e209df1f201b98f7)(k, pos));
                    continue;
                }
            }
            continue;
        }
        const zIndex = layerName === "Upmost" ? 999 : 0;
        (0, $820877bea407f5fe$export$120b04d2a5575c18)(k, map, layer, mapData.tileheight, mapData.tilewidth, zIndex);
    }
    k.camScale(3.6);
    (0, $9327de97d5aeca88$export$267aabae32ccde1c)(k, entities.player);
    k.onUpdate(()=>{
        const target = entities.player.worldPos();
        const current = k.camPos();
        const newPos = current.lerp(target, 0.1);
        k.camPos(newPos);
        if ($9ef7e57c1a16e747$var$nearbyItem) interactPrompt.setPosition($9ef7e57c1a16e747$var$nearbyItem.worldPos());
    });
    // 🚪 Exit to world
    entities.player.onCollide("door-exit", ()=>{
        (0, $96277ef5c4fda650$export$8e361a1ffbebf172).setPreviousScene("teahouse");
        (0, $3d1117e281c70288$export$7a6134494e9ab3f8).stopMusic();
        k.go("world");
    });
    // 🗨️ Yuki interaction
    let isTalkingToYuki = false;
    entities.player.onCollide("yuki", async ()=>{
        if (isTalkingToYuki || !entities.yuki || entities.yuki.isTalking) return;
        isTalkingToYuki = true;
        await (0, $49084d612a33e4e6$export$a3881aa67efe73f5)(k, entities.yuki, entities.player, heartBarInstance);
        isTalkingToYuki = false;
    });
    entities.player.onCollideEnd("yuki", ()=>{
        (0, $49084d612a33e4e6$export$745f393e14120a0c)(entities.yuki);
    });
    // 🧠 Item interaction prompt support
    entities.player.onCollide("item", (obj)=>{
        if (!obj?.itemName) return;
        $9ef7e57c1a16e747$var$nearbyItem = obj;
        interactPrompt.show();
    });
    entities.player.onCollideEnd("item", ()=>{
        $9ef7e57c1a16e747$var$nearbyItem = null;
        interactPrompt.hide();
    });
    k.onKeyPress("e", async ()=>{
        if (!$9ef7e57c1a16e747$var$nearbyItem) return;
    });
    (0, $9327de97d5aeca88$export$436ca3b7c65de203)(k);
}


// File: src/scenes/hotel.js



const $81da3073debb3232$export$257dc078deca45a0 = {
    hotel: {
        lines: [
            {
                speaker: "Satoshi",
                text: "Yo, vibes kinda chill,\nLike my turtle on sun days\u2014\nYou cool? Then we cool."
            },
            {
                speaker: "Randy",
                text: "I once had a pet.\nIt was a hotdog. Briefly.\nI still mourn that dog."
            },
            {
                speaker: "Satoshi",
                text: "Bro, don\u2019t overthink\u2014\nEven leaves just drop and drift.\nJust be real, y\u2019know?"
            },
            {
                speaker: "Randy",
                text: "Leaves fall all the time\u2014\nI slipped, cried, and spilled my fries.\nNature has no chill."
            },
            {
                speaker: "Satoshi",
                text: "I write late at night,\nTurtle sleeps, stars peep at me\u2014\nTruth hits when it\u2019s quiet."
            },
            {
                speaker: "Randy",
                text: "Stars winked at me once\u2014\nbut I\u2019d had six sake shots.\nStill counts, I think. Right?"
            }
        ],
        voices: [
            "satoshi_hotel1",
            "satoshi_hotel2",
            "satoshi_hotel3"
        ],
        randyVoices: [
            "randy_satoshi1",
            "randy_satoshi2",
            "randy_satoshi3"
        ]
    }
};
var $81da3073debb3232$export$2e2bcd8739ae039 = $81da3073debb3232$export$257dc078deca45a0;




function $ebc3ac002990dea1$export$26d94fd051b5b4d1(k, pos) {
    return [
        k.sprite("assets", {
            anim: "satoshi-down"
        }),
        k.pos(pos),
        k.body({
            isStatic: false
        }),
        k.area({
            shape: new k.Rect(k.vec2(), 20, 20)
        }),
        k.z(1),
        "satoshi",
        "wall",
        "npc",
        "solid"
    ];
}
function $ebc3ac002990dea1$var$facePlayerToNPC(npc, player) {
    const dx = player.pos.x - npc.pos.x;
    const dy = player.pos.y - npc.pos.y;
    if (Math.abs(dx) > Math.abs(dy)) {
        npc.flipX = dx < 0;
        (0, $820877bea407f5fe$export$a1ebaf6fd15c8a74)(npc, "satoshi-side");
    } else if (dy < 0) (0, $820877bea407f5fe$export$a1ebaf6fd15c8a74)(npc, "satoshi-up");
    else (0, $820877bea407f5fe$export$a1ebaf6fd15c8a74)(npc, "satoshi-down");
}
async function $ebc3ac002990dea1$var$handleSharedDialogue(k, entity, player, npcKey, linesData, portraitKey, heartBarInstance) {
    if (entity.isTalking) return;
    entity.isTalking = true;
    entity.pauseWander = true;
    const originalDirection = player.direction;
    player.direction = "down";
    $ebc3ac002990dea1$var$facePlayerToNPC(entity, player);
    const scene = (0, $96277ef5c4fda650$export$8e361a1ffbebf172).getCurrentScene();
    const gaveStrawberries = (0, $96277ef5c4fda650$export$ab4b6c53ec258d17).getHasGivenStrawberriesToSatoshi();
    const hasStrawberries = (0, $96277ef5c4fda650$export$ab4b6c53ec258d17).getHasStrawberries();
    if (hasStrawberries && !gaveStrawberries) {
        await (0, $e05b45d86fdf942d$export$f1d985ef2ac6d781)(k, k.vec2(0, 0), [
            "You brought me berries?\nMy turtle\u2019s gonna love this.\nBro, take this heart, yo."
        ], false, [
            portraitKey
        ], [
            "satoshi_gift"
        ], [
            "Satoshi"
        ]);
        (0, $96277ef5c4fda650$export$ab4b6c53ec258d17).setHasGivenStrawberriesToSatoshi(true);
        (0, $96277ef5c4fda650$export$ab4b6c53ec258d17).setHasStrawberries(false);
        if (!(0, $96277ef5c4fda650$export$405cc0fd5207d608).getHasGivenHeart(npcKey) && (0, $96277ef5c4fda650$export$ab4b6c53ec258d17).getCurrentMaxHealth() < (0, $96277ef5c4fda650$export$ab4b6c53ec258d17).getTrueMaxHealth()) {
            (0, $96277ef5c4fda650$export$ab4b6c53ec258d17).setCurrentMaxHealth((0, $96277ef5c4fda650$export$ab4b6c53ec258d17).getCurrentMaxHealth() + 1);
            (0, $96277ef5c4fda650$export$ab4b6c53ec258d17).setHealth((0, $96277ef5c4fda650$export$ab4b6c53ec258d17).getCurrentMaxHealth());
            k.destroyAll("healthContainer");
            const newHeartBar = (0, $3f33787d0c03f6d8$export$4535535e2d81a294)(k);
            if (newHeartBar?.update) {
                newHeartBar.giveHeartToNPC(npcKey);
                newHeartBar.update();
            }
            (0, $96277ef5c4fda650$export$405cc0fd5207d608).setHasGivenHeart(npcKey, true);
        }
        (0, $e05b45d86fdf942d$export$d526e17d3827c2fd)(()=>{
            entity.isTalking = false;
            entity.pauseWander = false;
            entity.reverseDirection = true;
            entity.trigger("dialogue-ended");
        });
        player.direction = originalDirection;
        return;
    }
    const currentData = linesData[scene] || {};
    const { lines: lines = [], voices: voices = [], randyVoices: randyVoices = [] } = currentData;
    let nbTalked = (0, $96277ef5c4fda650$export$405cc0fd5207d608).getNbTalked(npcKey);
    const entry1 = lines[nbTalked * 2];
    const entry2 = lines[nbTalked * 2 + 1];
    if (entry1?.text && entry2?.text) {
        await (0, $e05b45d86fdf942d$export$f1d985ef2ac6d781)(k, k.vec2(0, 0), [
            entry1.text,
            entry2.text
        ], false, [
            portraitKey,
            "randyPortrait"
        ], [
            voices[nbTalked] || null,
            randyVoices[nbTalked] || null
        ], [
            "Satoshi",
            "Randy"
        ]);
        (0, $96277ef5c4fda650$export$405cc0fd5207d608).setNbTalked(npcKey, nbTalked + 1);
    } else {
        const fallback = [
            "Moonlight on my shell\u2014\nTurtle dreams ripple softly.\nI vibe in silence.",
            "Snack crumbs on my floor\u2014\nEach one tells a lazy tale.\nSweep? Maybe later.",
            "Yo, stars check me out\u2014\nI wink back with zero shame.\nUniverse flirts first."
        ];
        const fallbackVoices = [
            "satoshi_extra1",
            "satoshi_extra2",
            "satoshi_extra3"
        ];
        const randIndex = Math.floor(Math.random() * fallback.length);
        await (0, $e05b45d86fdf942d$export$f1d985ef2ac6d781)(k, k.vec2(0, 0), [
            fallback[randIndex]
        ], false, [
            portraitKey
        ], [
            fallbackVoices[randIndex]
        ], [
            "Satoshi"
        ]);
    }
    (0, $e05b45d86fdf942d$export$d526e17d3827c2fd)(()=>{
        entity.isTalking = false;
        entity.pauseWander = false;
        entity.reverseDirection = true;
        entity.trigger("dialogue-ended");
    });
    player.direction = originalDirection;
}
async function $ebc3ac002990dea1$export$a3881aa67efe73f5(k, satoshi, player, heartBarInstance) {
    await $ebc3ac002990dea1$var$handleSharedDialogue(k, satoshi, player, "satoshi", (0, $81da3073debb3232$export$257dc078deca45a0), "satoshiPortrait", heartBarInstance);
}
function $ebc3ac002990dea1$export$745f393e14120a0c(satoshi) {
    (0, $820877bea407f5fe$export$a1ebaf6fd15c8a74)(satoshi, "satoshi-down");
}
function $ebc3ac002990dea1$export$4788a242892ca570(k, parent, pos) {
    const satoshiComponents = $ebc3ac002990dea1$export$26d94fd051b5b4d1(k, pos);
    const satoshi = parent.add([
        ...satoshiComponents
    ]);
    satoshi.lastAnim = "down";
    (0, $2b52c036dbdac93f$export$a861d836c9774c03)(k, satoshi);
    return satoshi;
}




const $134dc1fd4f7e8c43$var$bedRandyLines = [
    "Randy's pod glows soft\u2014\nMisnamed towns in bold shirts blur,\nDreams flirt, never stay."
];
function $134dc1fd4f7e8c43$export$1b8868d5ef30163d(k, pos) {
    return [
        k.sprite("assets", {
            anim: "bedrandy"
        }),
        k.area({
            shape: new k.Rect(k.vec2(0, 0), 20, 20)
        }),
        k.body({
            isStatic: true
        }),
        k.pos(pos),
        k.z(1),
        k.scale(1),
        "item",
        {
            itemName: "bedrandy"
        }
    ];
}
async function $134dc1fd4f7e8c43$export$b4cf5aa287e97040(k) {
    if (!Array.isArray($134dc1fd4f7e8c43$var$bedRandyLines)) {
        console.warn("\u26A0\uFE0F bedRandyLines is invalid:", $134dc1fd4f7e8c43$var$bedRandyLines);
        return;
    }
    const header = "Your Bed";
    k.play("soundUI", {
        volume: 0.4
    }); // Make the UI sound quieter
    await (0, $e05b45d86fdf942d$export$f1d985ef2ac6d781)(k, k.vec2(0, 0), $134dc1fd4f7e8c43$var$bedRandyLines, true, null, [], null, header // ✅ Display item name
    );
}








let $7c04be5d3b422822$var$nearbyItem = null;
async function $7c04be5d3b422822$export$2e2bcd8739ae039(k) {
    (0, $96277ef5c4fda650$export$8e361a1ffbebf172).setCurrentScene("hotel");
    (0, $3d1117e281c70288$export$7a6134494e9ab3f8).playMusic(k, "hotelMusic");
    (0, $820877bea407f5fe$export$3e24ac339becbb9d)(k, 27, 29, 52);
    const mapData = await (0, $820877bea407f5fe$export$1040e9253d215679)("./assets/maps/hotel.json");
    const map = k.add([
        k.pos(480, 200)
    ]);
    const interactPrompt = (0, $9bc24edee806a245$export$f9c1beccff5673bc)(k);
    const heartBarInstance = (0, $3f33787d0c03f6d8$export$4535535e2d81a294)(k);
    (0, $820877bea407f5fe$export$f87c018a61aadd8e)(k);
    const entities = {
        player: null,
        satoshi: null
    };
    for (const layer of mapData.layers){
        const layerName = layer.name;
        if (layerName === "Boundaries") {
            (0, $820877bea407f5fe$export$8619674b9a9c7477)(k, map, layer);
            continue;
        }
        if (layerName === "SpawnPoints") {
            for (const obj of layer.objects){
                const pos = k.vec2(obj.x, obj.y);
                switch(obj.name){
                    case "player":
                        entities.player = map.add([
                            ...(0, $9327de97d5aeca88$export$f591f00788965a32)(k, pos)
                        ]);
                        k.camPos(pos);
                        k.onLoad(()=>k.play("chime-bell", {
                                volume: 0.4
                            }));
                        break;
                    case "satoshi":
                        entities.satoshi = (0, $ebc3ac002990dea1$export$4788a242892ca570)(k, map, pos);
                        break;
                    case "signhotel":
                        {
                            const sign = map.add([
                                ...(0, $2f08759fc1092ca6$export$f0c84d7efdc134d9)(k, pos)
                            ]);
                            sign.itemName = "signhotel";
                            break;
                        }
                    case "bedrandy":
                        {
                            const bed = map.add([
                                ...(0, $134dc1fd4f7e8c43$export$1b8868d5ef30163d)(k, pos)
                            ]);
                            bed.itemName = "bedrandy";
                            break;
                        }
                }
            }
            continue;
        }
        const zIndex = layerName === "Upmost" ? 999 : 0;
        (0, $820877bea407f5fe$export$120b04d2a5575c18)(k, map, layer, mapData.tileheight, mapData.tilewidth, zIndex);
    }
    k.camScale(4);
    (0, $9327de97d5aeca88$export$267aabae32ccde1c)(k, entities.player);
    entities.player.onCollide("item", (obj)=>{
        if (!obj?.itemName) return;
        $7c04be5d3b422822$var$nearbyItem = obj;
        interactPrompt.show();
    });
    entities.player.onCollideEnd("item", ()=>{
        $7c04be5d3b422822$var$nearbyItem = null;
        interactPrompt.hide();
    });
    let isTalkingToSatoshi = false;
    entities.player.onCollide("satoshi", async ()=>{
        if (isTalkingToSatoshi || !entities.satoshi || entities.satoshi.isTalking) return;
        isTalkingToSatoshi = true;
        await (0, $ebc3ac002990dea1$export$a3881aa67efe73f5)(k, entities.satoshi, entities.player, heartBarInstance);
        isTalkingToSatoshi = false;
    });
    entities.player.onCollideEnd("satoshi", ()=>{
        (0, $ebc3ac002990dea1$export$745f393e14120a0c)(entities.satoshi);
    });
    entities.player.onCollide("door-exit", ()=>{
        (0, $96277ef5c4fda650$export$8e361a1ffbebf172).setPreviousScene("hotel");
        (0, $3d1117e281c70288$export$7a6134494e9ab3f8).stopMusic();
        k.go("world");
    });
    k.onKeyPress("e", async ()=>{
        if (!$7c04be5d3b422822$var$nearbyItem) return;
        switch($7c04be5d3b422822$var$nearbyItem.itemName){
            case "signhotel":
                await (0, $2f08759fc1092ca6$export$f7600f37a882d006)(k);
                break;
            case "bedrandy":
                await (0, $134dc1fd4f7e8c43$export$b4cf5aa287e97040)(k);
                break;
        }
    });
    let cameraTimer = 0;
    k.onUpdate(()=>{
        if (!entities.player) return;
        cameraTimer += k.dt();
        if (cameraTimer > 0.016) {
            const target = entities.player.worldPos();
            const current = k.camPos();
            k.camPos(current.lerp(target, 0.2));
            cameraTimer = 0;
        }
        if ($7c04be5d3b422822$var$nearbyItem) interactPrompt.setPosition($7c04be5d3b422822$var$nearbyItem.worldPos());
    });
    (0, $9327de97d5aeca88$export$436ca3b7c65de203)(k);
}


// File: src/scenes/bath.js









let $7808d7de2e8cf289$var$nearbyItem = null;
async function $7808d7de2e8cf289$export$2e2bcd8739ae039(k) {
    (0, $96277ef5c4fda650$export$8e361a1ffbebf172).setCurrentScene("bath");
    (0, $3d1117e281c70288$export$7a6134494e9ab3f8).playMusic(k, "bathMusic");
    (0, $820877bea407f5fe$export$3e24ac339becbb9d)(k, 210, 240, 255);
    const mapData = await (0, $820877bea407f5fe$export$1040e9253d215679)("./assets/maps/bath.json");
    const map = k.add([
        k.pos(0, 0)
    ]);
    const interactPrompt = (0, $9bc24edee806a245$export$f9c1beccff5673bc)(k);
    const heartBarInstance = (0, $3f33787d0c03f6d8$export$4535535e2d81a294)(k);
    (0, $820877bea407f5fe$export$f87c018a61aadd8e)(k);
    const entities = {
        player: null,
        oldman: null,
        sign: null,
        bathDoor: null
    };
    for (const layer of mapData.layers){
        const layerName = layer.name;
        if (layerName === "Boundaries") {
            (0, $820877bea407f5fe$export$8619674b9a9c7477)(k, map, layer);
            continue;
        }
        if (layerName === "SpawnPoints") {
            for (const obj of layer.objects){
                const pos = k.vec2(obj.x, obj.y);
                if (obj.name === "player") {
                    entities.player = map.add((0, $9327de97d5aeca88$export$f591f00788965a32)(k, pos));
                    k.camPos(pos);
                    continue;
                }
                if (obj.name === "oldman" || obj.name === "old-man") {
                    entities.oldman = map.add((0, $25df8e70ec03d548$export$6bfcf5216a1c2187)(k, pos));
                    (0, $2b52c036dbdac93f$export$a861d836c9774c03)(k, entities.oldman, {
                        speed: 14,
                        cooldown: 3.5,
                        shouldPause: ()=>entities.oldman.pauseWander || entities.oldman.isTalking
                    });
                    continue;
                }
                if (obj.name === "signbath") {
                    entities.sign = map.add((0, $a87de9384817e02d$export$28f711bd7e4cda2f)(k, pos));
                    entities.sign.itemName = "signbath";
                    continue;
                }
                if (obj.name === "bathDoor") {
                    entities.bathDoor = map.add([
                        k.rect(32, 64),
                        k.pos(pos),
                        k.area(),
                        k.body({
                            isStatic: true
                        }),
                        k.opacity(0),
                        "door",
                        "bathDoor"
                    ]);
                    continue;
                }
            }
            continue;
        }
        const zIndex = layerName === "Upmost" ? 999 : 0;
        (0, $820877bea407f5fe$export$120b04d2a5575c18)(k, map, layer, mapData.tileheight, mapData.tilewidth, zIndex);
    }
    k.camScale(4);
    (0, $9327de97d5aeca88$export$267aabae32ccde1c)(k, entities.player);
    k.onUpdate(()=>{
        const target = entities.player.worldPos();
        const current = k.camPos();
        const newPos = current.lerp(target, 0.1);
        k.camPos(newPos);
        if ($7808d7de2e8cf289$var$nearbyItem) interactPrompt.setPosition($7808d7de2e8cf289$var$nearbyItem.worldPos());
    });
    entities.player.onCollide("door-exit", ()=>{
        (0, $96277ef5c4fda650$export$8e361a1ffbebf172).setPreviousScene("bath");
        (0, $3d1117e281c70288$export$7a6134494e9ab3f8).stopMusic();
        k.go("world");
    });
    entities.player.onCollide("oldman", async ()=>{
        if (entities.oldman && !entities.oldman.isTalking) await (0, $25df8e70ec03d548$export$a3881aa67efe73f5)(k, entities.oldman, entities.player, heartBarInstance);
    });
    entities.player.onCollideEnd("oldman", ()=>{
        (0, $25df8e70ec03d548$export$745f393e14120a0c)(entities.oldman);
    });
    entities.player.onCollide("item", (obj)=>{
        if (!obj || !obj.itemName) return;
        $7808d7de2e8cf289$var$nearbyItem = obj;
        interactPrompt.show();
    });
    entities.player.onCollideEnd("item", ()=>{
        $7808d7de2e8cf289$var$nearbyItem = null;
        interactPrompt.hide();
    });
    k.onKeyPress("e", async ()=>{
        if (!$7808d7de2e8cf289$var$nearbyItem) return;
        if ($7808d7de2e8cf289$var$nearbyItem.itemName === "signbath") await (0, $a87de9384817e02d$export$f7600f37a882d006)(k);
    });
    (0, $9327de97d5aeca88$export$436ca3b7c65de203)(k);
}





const $8575bb383e1bf5ec$export$353a013c0d94ea62 = {
    train: {
        lines: [
            {
                speaker: "Koji",
                text: "Each dawn I shave clean\u2014\nThe past rinses with the blade.\nRegret grows no hair."
            },
            {
                speaker: "Randy",
                text: "I tried to shave once\u2014\nbut I cried when I nicked me.\nMy soul grew that hair."
            },
            {
                speaker: "Koji",
                text: "Trains come, trains depart\u2014\nBut my dog waits by the gate.\nHe trusts I\u2019ll return."
            },
            {
                speaker: "Randy",
                text: "My dog left me twice.\nFirst for snacks, then for freedom.\nStill a good, good boy."
            },
            {
                speaker: "Koji",
                text: "Rain on iron tracks\u2014\nSilence louder than shouting.\nPeace hums in the steam."
            },
            {
                speaker: "Randy",
                text: "Steam fogged up my shades.\nI walked into a noodle.\nPeace tasted like pork."
            },
            {
                speaker: "Koji",
                text: "She said I loved stone\u2014\ncold, unmoving, unshifting.\nNow moss warms my path."
            },
            {
                speaker: "Randy",
                text: "I once loved a rock.\nNamed her Sandy. She left me.\nRolled off with some moss."
            },
            {
                speaker: "Koji",
                text: "This broom is my bell.\nSweeping dust like chanting prayer\u2014\nEven trash has grace."
            },
            {
                speaker: "Randy",
                text: "Once swept for a crush.\nTurns out it was her dog shed.\nStill counts as romance."
            },
            {
                speaker: "Koji",
                text: "Offer no loud truth\u2014\nA whisper can guide a train\nwhen the wind leans in."
            },
            {
                speaker: "Randy",
                text: "I whispered once too.\nTo a vending machine ghost.\nShe gave me warm tea."
            }
        ],
        voices: [
            "koji_train1",
            "koji_train2",
            "koji_train3",
            "koji_train4",
            "koji_train5",
            "koji_train6"
        ],
        randyVoices: [
            "randy_koji1",
            "randy_koji2",
            "randy_koji3",
            "randy_koji4",
            "randy_koji5",
            "randy_koji6"
        ]
    }
};
var $8575bb383e1bf5ec$export$2e2bcd8739ae039 = $8575bb383e1bf5ec$export$353a013c0d94ea62;




function $7c2bd9cf5c64ddf0$export$2025454c21126f5d(k, pos) {
    return [
        k.sprite("assets", {
            anim: "koji-down"
        }),
        k.pos(pos),
        k.body({
            isStatic: false
        }),
        k.area({
            shape: new k.Rect(k.vec2(), 15, 15)
        }),
        k.z(1),
        "koji",
        "wall",
        "npc",
        "solid"
    ];
}
function $7c2bd9cf5c64ddf0$var$facePlayerToNPC(npc, player) {
    const dx = player.pos.x - npc.pos.x;
    const dy = player.pos.y - npc.pos.y;
    if (Math.abs(dx) > Math.abs(dy)) {
        npc.flipX = dx < 0;
        (0, $820877bea407f5fe$export$a1ebaf6fd15c8a74)(npc, "koji-side");
    } else if (dy < 0) (0, $820877bea407f5fe$export$a1ebaf6fd15c8a74)(npc, "koji-up");
    else (0, $820877bea407f5fe$export$a1ebaf6fd15c8a74)(npc, "koji-down");
}
async function $7c2bd9cf5c64ddf0$var$handleSharedDialogue(k, entity, player, npcKey, linesData, portraitKey, heartBarInstance) {
    if (entity.isTalking) return;
    entity.isTalking = true;
    entity.pauseWander = true;
    const originalDirection = player.direction;
    player.direction = "down";
    $7c2bd9cf5c64ddf0$var$facePlayerToNPC(entity, player);
    const scene = (0, $96277ef5c4fda650$export$8e361a1ffbebf172).getCurrentScene();
    const gaveOriyoki = (0, $96277ef5c4fda650$export$ab4b6c53ec258d17).getHasGivenOriyokiToKoji?.();
    const hasOriyoki = (0, $96277ef5c4fda650$export$ab4b6c53ec258d17).getHasOriyoki?.();
    if (hasOriyoki && !gaveOriyoki) {
        await (0, $e05b45d86fdf942d$export$f1d985ef2ac6d781)(k, k.vec2(0, 0), [
            "Wooden bowls stacked high\u2014\nSilence served beside each meal.\nYou remembered me."
        ], false, [
            portraitKey
        ], [
            "koji_oriyoki"
        ], [
            "Koji"
        ]);
        (0, $96277ef5c4fda650$export$ab4b6c53ec258d17).setHasGivenOriyokiToKoji(true);
        (0, $96277ef5c4fda650$export$ab4b6c53ec258d17).setHasOriyoki(false);
        if (!(0, $96277ef5c4fda650$export$405cc0fd5207d608).getHasGivenHeart(npcKey) && (0, $96277ef5c4fda650$export$ab4b6c53ec258d17).getCurrentMaxHealth() < (0, $96277ef5c4fda650$export$ab4b6c53ec258d17).getTrueMaxHealth()) {
            (0, $96277ef5c4fda650$export$ab4b6c53ec258d17).setCurrentMaxHealth((0, $96277ef5c4fda650$export$ab4b6c53ec258d17).getCurrentMaxHealth() + 1);
            (0, $96277ef5c4fda650$export$ab4b6c53ec258d17).setHealth((0, $96277ef5c4fda650$export$ab4b6c53ec258d17).getCurrentMaxHealth());
            k.destroyAll("healthContainer");
            const newHeartBar = (0, $3f33787d0c03f6d8$export$4535535e2d81a294)(k);
            if (newHeartBar?.update) {
                newHeartBar.giveHeartToNPC(npcKey);
                newHeartBar.update();
            }
            (0, $96277ef5c4fda650$export$405cc0fd5207d608).setHasGivenHeart(npcKey, true);
        }
        (0, $e05b45d86fdf942d$export$d526e17d3827c2fd)(()=>{
            entity.isTalking = false;
            entity.pauseWander = false;
            entity.reverseDirection = true;
            entity.trigger("dialogue-ended");
        });
        player.direction = originalDirection;
        return;
    }
    const currentData = linesData[scene] || {};
    const { lines: lines = [], voices: voices = [], randyVoices: randyVoices = [] } = currentData;
    let nbTalked = (0, $96277ef5c4fda650$export$405cc0fd5207d608).getNbTalked(npcKey);
    const entry1 = lines[nbTalked * 2];
    const entry2 = lines[nbTalked * 2 + 1];
    if (entry1?.text && entry2?.text) {
        await (0, $e05b45d86fdf942d$export$f1d985ef2ac6d781)(k, k.vec2(0, 0), [
            entry1.text,
            entry2.text
        ], false, [
            portraitKey,
            "randyPortrait"
        ], [
            voices[nbTalked] || null,
            randyVoices[nbTalked] || null
        ], [
            "Koji",
            "Randy"
        ]);
        (0, $96277ef5c4fda650$export$405cc0fd5207d608).setNbTalked(npcKey, nbTalked + 1);
    } else {
        const fallbackOptions = {
            train: [
                "Track hums underfoot\u2014\nGhosts ride softer than we do.\nStill, we call them late.",
                "Lantern sways gently\u2014\nLike my thoughts at platform's edge.\nWhere do memories go?",
                "Ticket in my hand\u2014\nDestination long unknown.\nBut I board anyway.",
                "Dust on every step\u2014\nEven wind forgets this place.\nBut not me. Not yet."
            ]
        };
        const voiceOptions = {
            train: [
                "koji_extra1",
                "koji_extra2",
                "koji_extra3",
                "koji_extra4"
            ]
        };
        const linesArray = fallbackOptions[scene] || fallbackOptions.train;
        const voiceArray = voiceOptions[scene] || voiceOptions.train;
        const randIndex = Math.floor(Math.random() * linesArray.length);
        await (0, $e05b45d86fdf942d$export$f1d985ef2ac6d781)(k, k.vec2(0, 0), [
            linesArray[randIndex]
        ], false, [
            portraitKey
        ], [
            voiceArray[randIndex]
        ], [
            "Koji"
        ]);
    }
    (0, $e05b45d86fdf942d$export$d526e17d3827c2fd)(()=>{
        entity.isTalking = false;
        entity.pauseWander = false;
        entity.reverseDirection = true;
        entity.trigger("dialogue-ended");
    });
    player.direction = originalDirection;
}
async function $7c2bd9cf5c64ddf0$export$a3881aa67efe73f5(k, koji, player, heartBarInstance) {
    await $7c2bd9cf5c64ddf0$var$handleSharedDialogue(k, koji, player, "koji", (0, $8575bb383e1bf5ec$export$353a013c0d94ea62), "kojiPortrait", heartBarInstance);
}
function $7c2bd9cf5c64ddf0$export$745f393e14120a0c(koji) {
    (0, $820877bea407f5fe$export$a1ebaf6fd15c8a74)(koji, "koji-down");
}
function $7c2bd9cf5c64ddf0$export$f726ef728996a999(k, parent, pos) {
    const kojiComponents = $7c2bd9cf5c64ddf0$export$2025454c21126f5d(k, pos);
    const koji = parent.add([
        ...kojiComponents
    ]);
    koji.lastAnim = "down";
    (0, $2b52c036dbdac93f$export$a861d836c9774c03)(k, koji);
    return koji;
}








const $23aca5ce6053109e$var$antiqueKeyLines = [
    "Iron whispers age\u2014\na secret waits in silence,\nrusted teeth still turn."
];
function $23aca5ce6053109e$export$6e20ba8c3077cbd5(k, pos) {
    return [
        k.sprite("assets", {
            anim: "antiqueKey"
        }),
        k.area({
            shape: new k.Rect(k.vec2(0, 0), 20, 25)
        }),
        k.body({
            isStatic: true
        }),
        k.pos(pos),
        k.z(1),
        k.scale(1),
        "item",
        {
            itemName: "antiqueKey"
        }
    ];
}
async function $23aca5ce6053109e$export$ad305e8b41b7cafd(k, keyObj, interactPrompt) {
    const header = "Antique Key";
    await (0, $e05b45d86fdf942d$export$f1d985ef2ac6d781)(k, k.vec2(0, 0), $23aca5ce6053109e$var$antiqueKeyLines, true, null, [], null, header);
    k.play("soundUI", {
        volume: 0.4
    });
    (0, $96277ef5c4fda650$export$ab4b6c53ec258d17).setHasKey(true);
    (0, $96277ef5c4fda650$export$ab4b6c53ec258d17).setHasPickedUpAntiqueKey(true);
    interactPrompt.hide();
    k.destroy(keyObj);
}







let $6edd29be782b9195$var$isConfirmingExit = false;
let $6edd29be782b9195$var$nearbyItem = null;
async function $6edd29be782b9195$export$2e2bcd8739ae039(k) {
    (0, $96277ef5c4fda650$export$8e361a1ffbebf172).setCurrentScene("train");
    (0, $3d1117e281c70288$export$7a6134494e9ab3f8).playMusic(k, "trainMusic");
    (0, $820877bea407f5fe$export$3e24ac339becbb9d)(k, 70, 70, 70);
    const mapData = await (0, $820877bea407f5fe$export$1040e9253d215679)("./assets/maps/trainstation.json");
    const map = k.add([
        k.pos(480, 200)
    ]);
    const interactPrompt = (0, $9bc24edee806a245$export$f9c1beccff5673bc)(k);
    const heartBarInstance = (0, $3f33787d0c03f6d8$export$4535535e2d81a294)(k);
    (0, $820877bea407f5fe$export$f87c018a61aadd8e)(k);
    const entities = {
        player: null,
        koji: null
    };
    for (const layer of mapData.layers){
        const layerName = layer.name;
        if (layerName === "Boundaries") {
            (0, $820877bea407f5fe$export$8619674b9a9c7477)(k, map, layer);
            continue;
        }
        if (layerName === "SpawnPoints") {
            for (const obj of layer.objects){
                const pos = k.vec2(obj.x, obj.y);
                switch(obj.name){
                    case "player":
                        entities.player = map.add([
                            ...(0, $9327de97d5aeca88$export$f591f00788965a32)(k, pos)
                        ]);
                        k.camPos(pos);
                        k.onLoad(()=>k.play("door-open", {
                                volume: 0.8
                            }));
                        break;
                    case "koji":
                        entities.koji = (0, $7c2bd9cf5c64ddf0$export$f726ef728996a999)(k, map, pos);
                        break;
                    case "signtrain":
                        {
                            const sign = map.add([
                                ...(0, $9dc1f6b2afa33337$export$cd4e35fb3180adf2)(k, pos)
                            ]);
                            sign.itemName = "signtrain";
                            sign.z = 1;
                            break;
                        }
                    case "orange-vending":
                        {
                            const orange = map.add([
                                ...(0, $25568d473e0568f2$export$33c3054366d585d3)(k, pos)
                            ]);
                            orange.itemName = "orange-vending";
                            orange.z = 1;
                            break;
                        }
                    case "white-vending":
                        {
                            const white = map.add([
                                ...(0, $4c0a60caeb3b6673$export$45bcde450294d514)(k, pos)
                            ]);
                            white.itemName = "white-vending";
                            white.z = 1;
                            break;
                        }
                    case "antiqueKey":
                        if (!(0, $96277ef5c4fda650$export$ab4b6c53ec258d17).getHasPickedUpAntiqueKey()) {
                            const key = map.add([
                                ...(0, $23aca5ce6053109e$export$6e20ba8c3077cbd5)(k, pos)
                            ]);
                            key.itemName = "antiqueKey";
                        }
                        break;
                }
            }
            continue;
        }
        const zIndex = layerName === "Upmost" ? 999 : 0;
        (0, $820877bea407f5fe$export$120b04d2a5575c18)(k, map, layer, mapData.tileheight, mapData.tilewidth, zIndex);
    }
    k.camScale(4);
    (0, $9327de97d5aeca88$export$267aabae32ccde1c)(k, entities.player);
    entities.player.onCollide("item", (obj)=>{
        if (!obj?.itemName) return;
        $6edd29be782b9195$var$nearbyItem = obj;
        interactPrompt.show();
    });
    entities.player.onCollideEnd("item", ()=>{
        $6edd29be782b9195$var$nearbyItem = null;
        interactPrompt.hide();
    });
    let isTalkingToKoji = false;
    entities.player.onCollide("koji", async ()=>{
        if (isTalkingToKoji || !entities.koji || entities.koji.isTalking) return;
        isTalkingToKoji = true;
        await (0, $7c2bd9cf5c64ddf0$export$a3881aa67efe73f5)(k, entities.koji, entities.player, heartBarInstance);
        isTalkingToKoji = false;
    });
    entities.player.onCollideEnd("koji", ()=>{
        (0, $7c2bd9cf5c64ddf0$export$745f393e14120a0c)(entities.koji);
    });
    entities.player.onCollide("door-exit", ()=>{
        (0, $96277ef5c4fda650$export$8e361a1ffbebf172).setPreviousScene("train");
        (0, $3d1117e281c70288$export$7a6134494e9ab3f8).stopMusic();
        k.go("world");
    });
    entities.player.onCollide("end", ()=>{
        if ($6edd29be782b9195$var$isConfirmingExit) return;
        $6edd29be782b9195$var$isConfirmingExit = true;
        const centerX = k.center().x;
        const centerY = k.center().y;
        const boxWidth = 300;
        const boxHeight = 130;
        k.add([
            k.rect(boxWidth, boxHeight, {
                radius: 12
            }),
            k.color(255, 255, 255),
            k.pos(centerX - boxWidth / 2, centerY - boxHeight / 2),
            k.z(2000),
            k.opacity(0.95),
            "confirmExitBox",
            k.fixed()
        ]);
        k.add([
            k.text("Would you like to go home\nand end the game?\n\nY = Yes     N = No", {
                size: 18,
                align: "center",
                width: boxWidth - 20
            }),
            k.color(0, 0, 0),
            k.pos(centerX, centerY),
            k.anchor("center"),
            k.z(2001),
            "confirmExitText",
            k.fixed()
        ]);
        const cleanupPrompt = ()=>{
            k.destroyAll("confirmExitBox");
            k.destroyAll("confirmExitText");
            $6edd29be782b9195$var$isConfirmingExit = false;
        };
        k.onKeyPress("y", ()=>{
            if (!$6edd29be782b9195$var$isConfirmingExit) return;
            cleanupPrompt();
            (0, $3d1117e281c70288$export$7a6134494e9ab3f8).stopMusic();
            k.go("endingCredits");
        });
        k.onKeyPress("n", ()=>{
            if (!$6edd29be782b9195$var$isConfirmingExit) return;
            cleanupPrompt();
        });
    });
    k.onKeyPress("e", async ()=>{
        if (!$6edd29be782b9195$var$nearbyItem) return;
        switch($6edd29be782b9195$var$nearbyItem.itemName){
            case "signtrain":
                await (0, $9dc1f6b2afa33337$export$f7600f37a882d006)(k);
                break;
            case "orange-vending":
                await (0, $25568d473e0568f2$export$851f325ffd660674)(k);
                break;
            case "white-vending":
                await (0, $4c0a60caeb3b6673$export$ef8124b577654bff)(k);
                break;
            case "antiqueKey":
                await (0, $23aca5ce6053109e$export$ad305e8b41b7cafd)(k, $6edd29be782b9195$var$nearbyItem, interactPrompt);
                break;
        }
    });
    k.onKeyPress("r", ()=>{
        k.go("reset");
    });
    let cameraTimer = 0;
    k.onUpdate(()=>{
        if (!entities.player) return;
        cameraTimer += k.dt();
        if (cameraTimer > 0.016) {
            const target = entities.player.worldPos();
            const current = k.camPos();
            k.camPos(current.lerp(target, 0.2));
            cameraTimer = 0;
        }
        if ($6edd29be782b9195$var$nearbyItem) interactPrompt.setPosition($6edd29be782b9195$var$nearbyItem.worldPos());
    });
    (0, $9327de97d5aeca88$export$436ca3b7c65de203)(k);
}





function $914eda969ed0e52d$export$2e2bcd8739ae039(k) {
    // 🎵 Play background music
    (0, $3d1117e281c70288$export$7a6134494e9ab3f8).playMusic(k, "endingMusic");
    // 🌅 Background image
    k.add([
        k.sprite("endingCredits"),
        k.anchor("center"),
        k.scale(k.width() / 1280, k.height() / 620),
        k.pos(k.center()),
        k.z(-1)
    ]);
    // 🪧 Text background box
    const boxWidth = 600;
    const boxHeight = 240;
    const boxX = k.center().x - boxWidth / 2;
    const boxY = 120;
    k.add([
        k.rect(boxWidth, boxHeight, {
            radius: 12
        }),
        k.pos(boxX, boxY),
        k.color(255, 255, 255),
        k.opacity(0.75),
        k.z(0)
    ]);
    // 🕹 Title text
    k.add([
        k.text("Randy decided to Go Home!", {
            size: 48,
            font: "gameboy"
        }),
        k.anchor("center"),
        k.pos(k.center().x, boxY + 40),
        k.color(0, 0, 0),
        k.z(1)
    ]);
    // 📝 Credit text
    k.add([
        k.text("Created by Shanel L0g1cF@11acy Locke\nPlease Find Me Online @ www.shanellockeart.com", {
            size: 20,
            width: 540,
            lineSpacing: 18,
            font: "gameboy"
        }),
        k.anchor("center"),
        k.pos(k.center().x, boxY + 110),
        k.color(0, 0, 0),
        k.z(1)
    ]);
    // 🔁 Blinking prompt
    const prompt = k.add([
        k.text("Press ENTER to Finish the Game", {
            size: 18,
            font: "gameboy"
        }),
        k.anchor("center"),
        k.pos(k.center().x, boxY + 200),
        k.color(0, 0, 0),
        k.z(1)
    ]);
    let blinkTimer = 0;
    k.onUpdate(()=>{
        blinkTimer += k.dt();
        prompt.hidden = Math.floor(blinkTimer * 2) % 2 === 0;
    });
    const finish = ()=>{
        k.go("endingSelection");
    };
    // 🎮 Inputs
    k.onKeyPress("enter", finish);
    k.onClick(finish);
    k.onTouchStart(finish);
}





const $068aaa9c566c1d4a$export$d570083a30107be1 = {
    manga: {
        lines: [
            {
                speaker: "Mari",
                text: "Scroll, scroll, swipe and sigh\u2014\nsome likes hit, some just fly by.\nStill no reason why."
            },
            {
                speaker: "Randy",
                text: "I swipe for deep chats\u2014\nand sometimes free hotel soap.\nStill no reason, too."
            },
            {
                speaker: "Mari",
                text: "Mochi in my hand,\nthis caf\xe9\u2019s wi-fi is sweet\u2014\nIRL feels banned."
            },
            {
                speaker: "Randy",
                text: "Wi-fi hugs my soul.\nBut I hug my mochi more\u2014\nsquishy love is real."
            },
            {
                speaker: "Mari",
                text: "Flirting in DMs,\nbut you blink and they\u2019re gone\u2014poof!\nLove\u2019s just HTML."
            },
            {
                speaker: "Randy",
                text: "HTML once broke\nmy homepage and my heart, girl.\nBut my pics still load."
            },
            {
                speaker: "Mari",
                text: "Pages turn so fast,\nbut the hero\u2019s still alone\u2014\nI feel seen at last."
            },
            {
                speaker: "Randy",
                text: "I\u2019m that manga boy\u2014\nbut with more chest hair and shoes.\nWanna share one arc?"
            },
            {
                speaker: "Mari",
                text: "Blue light on my face,\nfilter hides the empty space\u2014\nbut my feed looks ace."
            },
            {
                speaker: "Randy",
                text: "Filters hide my teeth,\nand this mole I named \u2018Terry.\u2019\nStill get one like. Yours?"
            }
        ],
        voices: [
            "mari_manga1",
            "mari_manga2",
            "mari_manga3",
            "mari_manga4",
            "mari_manga5"
        ],
        randyVoices: [
            "randy_mari1",
            "randy_mari2",
            "randy_mari3",
            "randy_mari4",
            "randy_mari5"
        ]
    }
};
var $068aaa9c566c1d4a$export$2e2bcd8739ae039 = $068aaa9c566c1d4a$export$d570083a30107be1;



function $ed80959e55e45201$export$dfed4cc480d084af(k, pos) {
    return [
        k.sprite("assets", {
            anim: "mari-down"
        }),
        k.area({
            shape: new k.Rect(k.vec2(), 15, 15)
        }),
        k.body({
            isStatic: true
        }),
        k.pos(pos),
        "mari"
    ];
}
function $ed80959e55e45201$var$facePlayerToNPC(npc, player) {
    const dx = player.pos.x - npc.pos.x;
    const dy = player.pos.y - npc.pos.y;
    if (Math.abs(dx) > Math.abs(dy)) {
        npc.flipX = dx < 0;
        (0, $820877bea407f5fe$export$a1ebaf6fd15c8a74)(npc, "mari-side");
    } else if (dy < 0) (0, $820877bea407f5fe$export$a1ebaf6fd15c8a74)(npc, "mari-up");
    else (0, $820877bea407f5fe$export$a1ebaf6fd15c8a74)(npc, "mari-down");
}
async function $ed80959e55e45201$var$handleSharedDialogue(k, entity, player, npcKey, linesData, portraitKey, heartBarInstance) {
    const originalDirection = player.direction;
    player.direction = "down";
    entity.isTalking = true;
    $ed80959e55e45201$var$facePlayerToNPC(entity, player);
    const scene = (0, $96277ef5c4fda650$export$8e361a1ffbebf172).getCurrentScene();
    const gaveManga = (0, $96277ef5c4fda650$export$ab4b6c53ec258d17).getHasGivenMangaToMari?.();
    const hasManga = (0, $96277ef5c4fda650$export$ab4b6c53ec258d17).getHasManga?.();
    if (hasManga && !gaveManga) {
        await (0, $e05b45d86fdf942d$export$f1d985ef2ac6d781)(k, k.vec2(0, 0), [
            "Pages steamed my lens\u2014\nI came for swords, stayed for abs.\nPlot? Who even cares?"
        ], false, [
            portraitKey
        ], [
            "mari_manga"
        ], [
            "Mari"
        ]);
        (0, $96277ef5c4fda650$export$ab4b6c53ec258d17).setHasGivenMangaToMari(true);
        (0, $96277ef5c4fda650$export$ab4b6c53ec258d17).setHasManga(false);
        if (!(0, $96277ef5c4fda650$export$405cc0fd5207d608).getHasGivenHeart(npcKey) && (0, $96277ef5c4fda650$export$ab4b6c53ec258d17).getCurrentMaxHealth() < (0, $96277ef5c4fda650$export$ab4b6c53ec258d17).getTrueMaxHealth()) {
            (0, $96277ef5c4fda650$export$ab4b6c53ec258d17).setCurrentMaxHealth((0, $96277ef5c4fda650$export$ab4b6c53ec258d17).getCurrentMaxHealth() + 1);
            (0, $96277ef5c4fda650$export$ab4b6c53ec258d17).setHealth((0, $96277ef5c4fda650$export$ab4b6c53ec258d17).getCurrentMaxHealth());
            k.destroyAll("healthContainer");
            const newHeartBar = (0, $3f33787d0c03f6d8$export$4535535e2d81a294)(k);
            if (newHeartBar?.update) {
                newHeartBar.giveHeartToNPC(npcKey);
                newHeartBar.update();
            }
            (0, $96277ef5c4fda650$export$405cc0fd5207d608).setHasGivenHeart(npcKey, true);
        }
        (0, $e05b45d86fdf942d$export$d526e17d3827c2fd)(()=>{
            entity.isTalking = false;
            entity.trigger("dialogue-ended");
        });
        player.direction = originalDirection;
        return;
    }
    const currentData = linesData[scene] || {};
    const { lines: lines = [], voices: voices = [], randyVoices: randyVoices = [], fallbackRandyLines: fallbackRandyLines = [], fallbackRandyVoices: fallbackRandyVoices = [] } = currentData;
    let nbTalked = (0, $96277ef5c4fda650$export$405cc0fd5207d608).getNbTalked(npcKey);
    const shouldGiveHeart = nbTalked === 1 && !(0, $96277ef5c4fda650$export$405cc0fd5207d608).getHasGivenHeart(npcKey);
    const entry1 = lines[nbTalked * 2];
    const entry2 = lines[nbTalked * 2 + 1];
    if (entry1?.text && entry2?.text) await (0, $e05b45d86fdf942d$export$f1d985ef2ac6d781)(k, k.vec2(0, 0), [
        entry1.text,
        entry2.text
    ], false, [
        portraitKey,
        "randyPortrait"
    ], [
        voices[nbTalked] || null,
        randyVoices[nbTalked] || null
    ], [
        "Mari",
        "Randy"
    ]);
    else {
        const fallbackOptions = {
            manga: [
                "Late night manga binge\u2014\nMy charger sighs in protest.\nStill, one more chapter...",
                "Battery at five\u2014\nJust like my social meter.\nBoth will soon shut down.",
                "I post, then I scroll\u2014\nLooking for a sign or meme.\nMostly just thirst traps."
            ]
        };
        const voiceOptions = {
            manga: [
                "mari_extra1",
                "mari_extra2",
                "mari_extra3"
            ]
        };
        const linesArray = fallbackOptions[scene] || fallbackOptions.manga;
        const voiceArray = voiceOptions[scene] || voiceOptions.manga;
        const randIndex = Math.floor(Math.random() * linesArray.length);
        await (0, $e05b45d86fdf942d$export$f1d985ef2ac6d781)(k, k.vec2(0, 0), [
            linesArray[randIndex]
        ], false, [
            portraitKey
        ], [
            voiceArray[randIndex]
        ], [
            "Mari"
        ]);
    }
    if (shouldGiveHeart && (0, $96277ef5c4fda650$export$ab4b6c53ec258d17).getCurrentMaxHealth() < (0, $96277ef5c4fda650$export$ab4b6c53ec258d17).getTrueMaxHealth()) {
        (0, $96277ef5c4fda650$export$ab4b6c53ec258d17).setCurrentMaxHealth((0, $96277ef5c4fda650$export$ab4b6c53ec258d17).getCurrentMaxHealth() + 1);
        (0, $96277ef5c4fda650$export$ab4b6c53ec258d17).setHealth((0, $96277ef5c4fda650$export$ab4b6c53ec258d17).getCurrentMaxHealth());
        k.destroyAll("healthContainer");
        heartBarInstance.giveHeartToNPC("mari");
        heartBarInstance.update();
        (0, $96277ef5c4fda650$export$405cc0fd5207d608).setHasGivenHeart(npcKey, true);
    }
    (0, $96277ef5c4fda650$export$405cc0fd5207d608).setNbTalked(npcKey, nbTalked + 1);
    player.direction = originalDirection;
    (0, $e05b45d86fdf942d$export$d526e17d3827c2fd)(()=>{
        entity.isTalking = false;
        entity.trigger("dialogue-ended");
    });
}
async function $ed80959e55e45201$export$a3881aa67efe73f5(k, mari, player, heartBarInstance) {
    await $ed80959e55e45201$var$handleSharedDialogue(k, mari, player, "mari", (0, $068aaa9c566c1d4a$export$d570083a30107be1), "mariPortrait", heartBarInstance);
}
function $ed80959e55e45201$export$745f393e14120a0c(mari) {
    (0, $820877bea407f5fe$export$a1ebaf6fd15c8a74)(mari, "mari-down");
}





function $ea104acccb40c0bc$export$e4ab787be380fba0(k, pos) {
    return [
        k.sprite("assets", {
            anim: "npc5-down"
        }),
        k.pos(pos),
        k.body({
            isStatic: false
        }),
        k.area({
            shape: new k.Rect(k.vec2(), 20, 20)
        }),
        k.z(1),
        "npc5",
        "wall",
        "npc",
        "solid"
    ];
}
function $ea104acccb40c0bc$var$facePlayerToNPC(npc, player) {
    const dx = player.pos.x - npc.pos.x;
    const dy = player.pos.y - npc.pos.y;
    if (Math.abs(dx) > Math.abs(dy)) {
        npc.flipX = dx < 0;
        (0, $820877bea407f5fe$export$a1ebaf6fd15c8a74)(npc, "npc5-side");
    } else (0, $820877bea407f5fe$export$a1ebaf6fd15c8a74)(npc, "npc5-down");
}
async function $ea104acccb40c0bc$var$handleFallbackDialogue(k, entity, player, portraitKey) {
    const originalDirection = player.direction;
    player.direction = "down";
    entity.isTalking = true;
    entity.pauseWander = true;
    $ea104acccb40c0bc$var$facePlayerToNPC(entity, player);
    const fallbackText = [
        "Ink curls on the page\u2014\nWorlds unfold between each line.",
        "Shh... plot twist coming.\nLife imitates manga art.\nSilence is sacred.",
        "I shelve volume ten\u2014\nBut I lived volume eleven.\nSpoilers hurt sometimes."
    ];
    const fallbackVoices = [
        "npc5_extra1",
        "npc5_extra2",
        "npc5_extra3"
    ];
    const randIndex = Math.floor(Math.random() * fallbackText.length);
    await (0, $e05b45d86fdf942d$export$f1d985ef2ac6d781)(k, k.vec2(0, 0), [
        fallbackText[randIndex]
    ], false, [
        portraitKey
    ], [
        fallbackVoices[randIndex]
    ], [
        "Stranger"
    ]);
    (0, $96277ef5c4fda650$export$405cc0fd5207d608).setNbTalked("npc5", (0, $96277ef5c4fda650$export$405cc0fd5207d608).getNbTalked("npc5") + 1);
    player.direction = originalDirection;
    (0, $e05b45d86fdf942d$export$d526e17d3827c2fd)(()=>{
        entity.isTalking = false;
        entity.pauseWander = false;
        entity.trigger("dialogue-ended");
    });
}
async function $ea104acccb40c0bc$export$a3881aa67efe73f5(k, npc5, player) {
    await $ea104acccb40c0bc$var$handleFallbackDialogue(k, npc5, player, "npc5Portrait");
}
function $ea104acccb40c0bc$export$745f393e14120a0c(npc5) {
    (0, $820877bea407f5fe$export$a1ebaf6fd15c8a74)(npc5, "npc5-down");
}
function $ea104acccb40c0bc$export$1c3626c8f31e54d9(k, parent, pos) {
    const npc5Components = $ea104acccb40c0bc$export$e4ab787be380fba0(k, pos);
    const npc5 = parent.add([
        ...npc5Components
    ]);
    npc5.lastAnim = "down";
    return npc5;
}



const $a4bda5994ac81c89$var$mangaBookLines = [
    // 1
    "Cherry blossoms fall\u2014\nthe rival swears revenge with\nhis hair still perfect.",
    // 2
    "She slapped him again,\nbut this time he caught her hand\u2014\n'You're late,' he whispered.",
    // 3
    "Cat girl steals the map\u2014\nbut not before winking twice.\nPlot twist: she\u2019s the boss.",
    // 4
    "Power level ten?\nNope. He takes off his glasses\u2014\ntwenty thousand. Easy.",
    // 5
    "Swords clash in moonlight.\nNeither speaks of feelings but\ntheir hands both tremble.",
    // 6
    "Nosebleed from a hug\u2014\nthe physics unclear but hey,\nwe stan true passion.",
    // 7
    "School roof, final bell\u2014\nshe confesses with closed eyes.\nHe\u2019s asleep. Classic.",
    // 8
    "Tentacles again.\nNo one asked for this chapter.\nYet here we all are.",
    // 9
    "Eyes wide, wind blowing\u2014\nthe monologue is thirty\npages of drama.",
    // 10
    "The bread in her mouth\nmeans she\u2019s late\u2014but plot armor\nsaves her from traffic.",
    // 11
    "Villain\u2019s tragic past:\na single raindrop falls down.\nCue piano chords now.",
    // 12
    "Training montage ends.\nHe yells the move\u2019s name so loud,\nthe stars hear his punch.",
    // 13
    "Beach episode arc.\nAll trauma conveniently\nleft in the locker.",
    // 14
    "Cursed prince in chains\u2014\nhe\u2019s rude, brooding, and pretty.\nYes, I will love him.",
    // 15
    "Time traveler sighs.\nSaves her for the eighth time now.\nStill can\u2019t confess though.",
    // 16
    "She turns into mist.\nHe yells, 'Don\u2019t vanish on me!'\nToo late\u2014chapter ends.",
    // 17
    "Twin brother reveals\nhe\u2019s the clone of their cousin\u2014\nbut born from a tree.",
    // 18
    "Glasses flash with light\u2014\nshe knows everything and more.\nNo one asks how though.",
    // 19
    "They fight for honor,\nbut keep switching hairstyles each\ntime a page flips fast.",
    // 20
    "He trips on her scarf.\nThey fall in love mid-fall scene.\nGravity ships them."
];
var $a4bda5994ac81c89$export$2e2bcd8739ae039 = $a4bda5994ac81c89$var$mangaBookLines;


function $ae53afd028800ac3$export$27e3818cfa1ecb9(k, pos) {
    return [
        k.sprite("assets", {
            anim: "mangabookshelf"
        }),
        k.area({
            shape: new k.Rect(k.vec2(-4, -4), 24, 24)
        }),
        k.body({
            isStatic: true
        }),
        k.pos(pos.x, pos.y + 6),
        k.z(1),
        "item",
        {
            itemName: "mangabooks"
        }
    ];
}
async function $ae53afd028800ac3$export$368a223349ea0b46(k) {
    const lines = (0, $a4bda5994ac81c89$export$2e2bcd8739ae039);
    const randomLine = lines[Math.floor(Math.random() * lines.length)];
    const header = "Manga Book";
    k.play("soundUI", {
        volume: 0.4
    }); // Make the UI sound quieter
    await (0, $e05b45d86fdf942d$export$f1d985ef2ac6d781)(k, k.vec2(0, 0), [
        randomLine
    ], true, null, [], null, header // Label at top
    );
}




const $2ac509f554850633$var$mangaPickupHaiku = [
    "Shirtless samurai\u2014\nPlot? Who cares! Their lips just touched.\nI read for the art."
];
function $2ac509f554850633$export$92b3a4ec34711f99(k, pos) {
    return [
        k.sprite("assets", {
            anim: "mangaBook"
        }),
        k.area({
            shape: new k.Rect(k.vec2(0, 0), 20, 25)
        }),
        k.body({
            isStatic: true
        }),
        k.pos(pos),
        k.z(1),
        k.scale(1),
        "item",
        {
            itemName: "manga"
        }
    ];
}
async function $2ac509f554850633$export$17b7afd52a6ce2c5(k, mangaObj, interactPrompt) {
    const header = "Special Manga Book";
    await (0, $e05b45d86fdf942d$export$f1d985ef2ac6d781)(k, k.vec2(0, 0), $2ac509f554850633$var$mangaPickupHaiku, true, null, [], null, header);
    k.play("soundUI", {
        volume: 0.4
    });
    // ✅ Update player state flags
    (0, $96277ef5c4fda650$export$ab4b6c53ec258d17).setHasManga(true);
    (0, $96277ef5c4fda650$export$ab4b6c53ec258d17).setHasPickedUpManga(true); // 🔒 Persist pickup
    interactPrompt.hide();
    k.destroy(mangaObj);
}








let $4b0264038acf4b6a$var$nearbyItem = null;
async function $4b0264038acf4b6a$export$2e2bcd8739ae039(k) {
    (0, $96277ef5c4fda650$export$8e361a1ffbebf172).setCurrentScene("manga");
    (0, $3d1117e281c70288$export$7a6134494e9ab3f8).playMusic(k, "mangaMusic");
    (0, $820877bea407f5fe$export$3e24ac339becbb9d)(k, 240, 220, 250); // Soft pastel tone for manga café
    const mapData = await (0, $820877bea407f5fe$export$1040e9253d215679)("./assets/maps/manga.json");
    const map = k.add([
        k.pos(480, 200)
    ]);
    const interactPrompt = (0, $9bc24edee806a245$export$f9c1beccff5673bc)(k);
    const heartBarInstance = (0, $3f33787d0c03f6d8$export$4535535e2d81a294)(k);
    (0, $820877bea407f5fe$export$f87c018a61aadd8e)(k);
    const entities = {
        player: null,
        mari: null,
        npc5: null
    };
    for (const layer of mapData.layers){
        const layerName = layer.name;
        if (layerName === "Boundaries") {
            (0, $820877bea407f5fe$export$8619674b9a9c7477)(k, map, layer);
            continue;
        }
        if (layerName === "SpawnPoints") {
            for (const obj of layer.objects){
                const pos = k.vec2(obj.x, obj.y);
                switch(obj.name){
                    case "player":
                        entities.player = map.add([
                            ...(0, $9327de97d5aeca88$export$f591f00788965a32)(k, pos)
                        ]);
                        k.camPos(pos);
                        k.onLoad(()=>k.play("chime-bell", {
                                volume: 0.4
                            }));
                        break;
                    case "mari":
                        entities.mari = map.add((0, $ed80959e55e45201$export$dfed4cc480d084af)(k, pos));
                        break;
                    case "books":
                        const books = map.add((0, $ae53afd028800ac3$export$27e3818cfa1ecb9)(k, pos));
                        books.itemName = "books";
                        break;
                    case "npc5":
                        entities.npc5 = (0, $ea104acccb40c0bc$export$1c3626c8f31e54d9)(k, map, pos);
                        break;
                    case "manga":
                        if (!(0, $96277ef5c4fda650$export$ab4b6c53ec258d17).getHasPickedUpManga()) {
                            const mangaItem = map.add((0, $2ac509f554850633$export$92b3a4ec34711f99)(k, pos));
                            mangaItem.itemName = "manga";
                        }
                        break;
                }
            }
            continue;
        }
        const zIndex = layerName === "Upmost" ? 999 : 0;
        (0, $820877bea407f5fe$export$120b04d2a5575c18)(k, map, layer, mapData.tileheight, mapData.tilewidth, zIndex);
    }
    k.camScale(4);
    (0, $9327de97d5aeca88$export$267aabae32ccde1c)(k, entities.player);
    // 📦 Item interactions
    entities.player.onCollide("item", (obj)=>{
        if (!obj?.itemName) return;
        $4b0264038acf4b6a$var$nearbyItem = obj;
        interactPrompt.show();
    });
    entities.player.onCollideEnd("item", ()=>{
        $4b0264038acf4b6a$var$nearbyItem = null;
        interactPrompt.hide();
    });
    // 💬 Mari
    let isTalkingToMari = false;
    entities.player.onCollide("mari", async ()=>{
        if (isTalkingToMari || !entities.mari || entities.mari.isTalking) return;
        isTalkingToMari = true;
        await (0, $ed80959e55e45201$export$a3881aa67efe73f5)(k, entities.mari, entities.player, heartBarInstance);
        isTalkingToMari = false;
    });
    entities.player.onCollideEnd("mari", ()=>{
        (0, $ed80959e55e45201$export$745f393e14120a0c)(entities.mari);
    });
    // 💬 NPC5
    let isTalkingToNpc5 = false;
    entities.player.onCollide("npc5", async ()=>{
        if (isTalkingToNpc5 || !entities.npc5 || entities.npc5.isTalking) return;
        isTalkingToNpc5 = true;
        await (0, $ea104acccb40c0bc$export$a3881aa67efe73f5)(k, entities.npc5, entities.player, heartBarInstance);
        isTalkingToNpc5 = false;
    });
    entities.player.onCollideEnd("npc5", ()=>{
        (0, $ea104acccb40c0bc$export$745f393e14120a0c)(entities.npc5);
    });
    // 🚪 Exit
    entities.player.onCollide("door-exit", ()=>{
        (0, $96277ef5c4fda650$export$8e361a1ffbebf172).setPreviousScene("manga");
        (0, $3d1117e281c70288$export$7a6134494e9ab3f8).stopMusic();
        k.go("world");
    });
    // 🧠 Interact prompt
    k.onKeyPress("e", async ()=>{
        if (!$4b0264038acf4b6a$var$nearbyItem) return;
        switch($4b0264038acf4b6a$var$nearbyItem.itemName){
            case "books":
                await (0, $ae53afd028800ac3$export$368a223349ea0b46)(k);
                break;
            case "manga":
                await (0, $2ac509f554850633$export$17b7afd52a6ce2c5)(k, $4b0264038acf4b6a$var$nearbyItem, interactPrompt);
                break;
        }
    });
    k.onKeyPress("r", ()=>{
        k.go("reset");
    });
    // 🎥 Camera follow
    let cameraTimer = 0;
    k.onUpdate(()=>{
        if (!entities.player) return;
        cameraTimer += k.dt();
        if (cameraTimer > 0.016) {
            const target = entities.player.worldPos();
            const current = k.camPos();
            k.camPos(current.lerp(target, 0.2));
            cameraTimer = 0;
        }
        if ($4b0264038acf4b6a$var$nearbyItem) interactPrompt.setPosition($4b0264038acf4b6a$var$nearbyItem.worldPos());
    });
    (0, $9327de97d5aeca88$export$436ca3b7c65de203)(k);
}


// File: src/scenes/ramen.js



const $43af12b636611f97$export$6fbb5b1b1874ca62 = {
    ramen: {
        lines: [
            {
                speaker: "Naoko",
                text: "Flicker from my past\u2014\na sword my father once held.\nShe sold it for spite."
            },
            {
                speaker: "Randy",
                text: "My ex sold my hat.\nNot a sword, but it still hurt.\nIt had my sweat stains."
            },
            {
                speaker: "Naoko",
                text: "Lips like kindling sparks,\nbut passion burned through too fast.\nNow I serve the coals."
            },
            {
                speaker: "Randy",
                text: "My lips sparked once too.\nChili ramen. Bad idea.\nStill, no regrets. Slurp."
            },
            {
                speaker: "Naoko",
                text: "He wore red for me.\nThen left my heart in embers.\nStill\u2014I pour, I burn."
            },
            {
                speaker: "Randy",
                text: "I wear red for you.\nMostly \u2018cause all my shirts match\ntropical regret."
            },
            {
                speaker: "Naoko",
                text: "Some fires stay buried\u2014\nsheathed beneath a lover\u2019s spite.\nBut still\u2014I feel heat."
            },
            {
                speaker: "Randy",
                text: "Same. My ex kept pics\u2014\nposted them with fire emojis.\nStill burns. Still hot, though."
            }
        ],
        voices: [
            "naoko_ramen1",
            "naoko_ramen2",
            "naoko_ramen3",
            "naoko_ramen4"
        ],
        randyVoices: [
            "randy_naoko1",
            "randy_naoko2",
            "randy_naoko3",
            "randy_naoko4"
        ]
    }
};
var $43af12b636611f97$export$2e2bcd8739ae039 = $43af12b636611f97$export$6fbb5b1b1874ca62;






const $c62b79df8bad9d88$var$pickupLine = [
    "Red with gentle seeds\u2014\nTurtles march for sweet delight.\nJoy snug in your palm."
];
function $c62b79df8bad9d88$export$f2c8d3cf6d4eb27a(k, pos) {
    return [
        k.sprite("assets", {
            anim: "strawberry"
        }),
        k.area({
            shape: new k.Rect(k.vec2(-4, -4), 20, 20)
        }),
        k.body({
            isStatic: true
        }),
        k.pos(pos),
        k.z(1),
        "item",
        {
            itemName: "strawberry"
        }
    ];
}
async function $c62b79df8bad9d88$export$c5087c64eb1954a9(k, strawberryObj, interactPrompt) {
    const header = "Fresh Strawberries";
    await (0, $e05b45d86fdf942d$export$f1d985ef2ac6d781)(k, k.vec2(0, 0), $c62b79df8bad9d88$var$pickupLine, true, null, [], null, header);
    // ✅ Set state flags to block future respawn
    (0, $96277ef5c4fda650$export$ab4b6c53ec258d17).setHasStrawberries(true);
    (0, $96277ef5c4fda650$export$ab4b6c53ec258d17).setHasPickedUpStrawberries(true); // Persistent respawn prevention
    interactPrompt.hide();
    k.destroy(strawberryObj);
}


function $1e276c86cf5eeebf$export$82d91fddebb09577(k, pos) {
    return [
        k.sprite("assets", {
            anim: "naoko-down"
        }),
        k.pos(pos),
        k.body({
            isStatic: false
        }),
        k.area({
            shape: new k.Rect(k.vec2(2, 4), 12, 12)
        }),
        k.z(1),
        "naoko",
        "wall",
        "npc",
        "solid"
    ];
}
function $1e276c86cf5eeebf$var$facePlayerToNPC(npc, player) {
    const dx = player.pos.x - npc.pos.x;
    const dy = player.pos.y - npc.pos.y;
    if (Math.abs(dx) > Math.abs(dy)) {
        npc.flipX = dx < 0;
        (0, $820877bea407f5fe$export$a1ebaf6fd15c8a74)(npc, "naoko-side");
    } else if (dy < 0) (0, $820877bea407f5fe$export$a1ebaf6fd15c8a74)(npc, "naoko-up");
    else (0, $820877bea407f5fe$export$a1ebaf6fd15c8a74)(npc, "naoko-down");
}
const $1e276c86cf5eeebf$var$naokoSwordSequence = [
    {
        speaker: "Naoko",
        text: "A blade brought with care\u2014\nits edge holds your quiet strength.\nStrawberries bloom now.",
        voice: "naoko_sword1"
    },
    {
        speaker: "Naoko",
        text: "By the shop\u2019s bright lights\u2014\nI thought I saw something red.\nFruit? Or just a dream?",
        voice: "naoko_hint1"
    }
];
async function $1e276c86cf5eeebf$var$handleSharedDialogue(k, entity, player, npcKey, linesData, portraitKey, heartBarInstance) {
    if (entity.isTalking || entity.canTalk === false) return;
    entity.isTalking = true;
    entity.pauseWander = true;
    entity.canTalk = false;
    const originalDirection = player.direction;
    player.direction = "down";
    $1e276c86cf5eeebf$var$facePlayerToNPC(entity, player);
    const scene = (0, $96277ef5c4fda650$export$8e361a1ffbebf172).getCurrentScene();
    const gaveSword = (0, $96277ef5c4fda650$export$ab4b6c53ec258d17).getHasGivenSwordToNaoko?.();
    const hasSword = (0, $96277ef5c4fda650$export$ab4b6c53ec258d17).getHasSword?.();
    if (hasSword && !gaveSword) {
        const lines = $1e276c86cf5eeebf$var$naokoSwordSequence.map((entry)=>entry.text);
        const voices = $1e276c86cf5eeebf$var$naokoSwordSequence.map((entry)=>entry.voice);
        const speakers = $1e276c86cf5eeebf$var$naokoSwordSequence.map((entry)=>entry.speaker);
        const portraits = speakers.map(()=>portraitKey);
        await (0, $e05b45d86fdf942d$export$f1d985ef2ac6d781)(k, k.vec2(0, 0), lines, false, portraits, voices, speakers);
        (0, $96277ef5c4fda650$export$ab4b6c53ec258d17).setHasGivenSwordToNaoko(true);
        if (!(0, $96277ef5c4fda650$export$405cc0fd5207d608).getHasGivenHeart(npcKey) && (0, $96277ef5c4fda650$export$ab4b6c53ec258d17).getCurrentMaxHealth() < (0, $96277ef5c4fda650$export$ab4b6c53ec258d17).getTrueMaxHealth()) {
            (0, $96277ef5c4fda650$export$ab4b6c53ec258d17).setCurrentMaxHealth((0, $96277ef5c4fda650$export$ab4b6c53ec258d17).getCurrentMaxHealth() + 1);
            (0, $96277ef5c4fda650$export$ab4b6c53ec258d17).setHealth((0, $96277ef5c4fda650$export$ab4b6c53ec258d17).getCurrentMaxHealth());
            k.destroyAll("healthContainer");
            if (heartBarInstance?.update) {
                heartBarInstance.giveHeartToNPC(npcKey);
                heartBarInstance.update();
            } else (0, $3f33787d0c03f6d8$export$4535535e2d81a294)(k);
            (0, $96277ef5c4fda650$export$405cc0fd5207d608).setHasGivenHeart(npcKey, true);
            k.play("sparkle");
        }
        if (!(0, $96277ef5c4fda650$export$8e361a1ffbebf172).getFlag("strawberrySpawned")) {
            (0, $96277ef5c4fda650$export$8e361a1ffbebf172).setFlag("strawberrySpawned", true);
            const strawberry = k.add((0, $c62b79df8bad9d88$export$f2c8d3cf6d4eb27a)(k, k.vec2(200, 180)));
            k.get("world")?.add?.(strawberry);
        }
        (0, $e05b45d86fdf942d$export$d526e17d3827c2fd)(()=>{
            entity.isTalking = false;
            entity.pauseWander = false;
            setTimeout(()=>entity.canTalk = true, 1500);
            entity.trigger("dialogue-ended");
        });
        setTimeout(()=>(0, $96277ef5c4fda650$export$8e361a1ffbebf172).setFreezePlayer(false), 1000);
        player.direction = originalDirection;
        return;
    }
    const currentData = linesData[scene] || {};
    const { lines: lines = [], voices: voices = [], randyVoices: randyVoices = [] } = currentData;
    let nbTalked = (0, $96277ef5c4fda650$export$405cc0fd5207d608).getNbTalked(npcKey);
    const entry1 = lines[nbTalked * 2];
    const entry2 = lines[nbTalked * 2 + 1];
    if (entry1?.text && entry2?.text) {
        await (0, $e05b45d86fdf942d$export$f1d985ef2ac6d781)(k, k.vec2(0, 0), [
            entry1.text,
            entry2.text
        ], false, [
            portraitKey,
            "randyPortrait"
        ], [
            voices[nbTalked] || null,
            randyVoices[nbTalked] || null
        ], [
            entry1.speaker,
            entry2.speaker
        ]);
        (0, $96277ef5c4fda650$export$405cc0fd5207d608).setNbTalked(npcKey, nbTalked + 1);
    } else {
        const fallback = [
            "This bowl holds secrets\u2014\nbroth brewed in midnight silence.\nAre you slurping truth?",
            "Ramen steam hides ghosts\u2014\nthey whisper through rising swirls.\nI nod. They return."
        ];
        const fallbackVoices = [
            "naoko_extra1",
            "naoko_extra2"
        ];
        const randIndex = Math.floor(Math.random() * fallback.length);
        await (0, $e05b45d86fdf942d$export$f1d985ef2ac6d781)(k, k.vec2(0, 0), [
            fallback[randIndex]
        ], false, [
            portraitKey
        ], [
            fallbackVoices[randIndex]
        ], [
            "Naoko"
        ]);
    }
    (0, $e05b45d86fdf942d$export$d526e17d3827c2fd)(()=>{
        entity.isTalking = false;
        entity.pauseWander = false;
        setTimeout(()=>entity.canTalk = true, 1500);
        entity.trigger("dialogue-ended");
    });
    setTimeout(()=>(0, $96277ef5c4fda650$export$8e361a1ffbebf172).setFreezePlayer(false), 1000);
    player.direction = originalDirection;
}
async function $1e276c86cf5eeebf$export$a3881aa67efe73f5(k, naoko, player, heartBarInstance) {
    await $1e276c86cf5eeebf$var$handleSharedDialogue(k, naoko, player, "naoko", (0, $43af12b636611f97$export$6fbb5b1b1874ca62), "naokoPortrait", heartBarInstance);
}
function $1e276c86cf5eeebf$export$745f393e14120a0c(naoko) {
    (0, $820877bea407f5fe$export$a1ebaf6fd15c8a74)(naoko, "naoko-down");
}
function $1e276c86cf5eeebf$export$8961d1b15e32004e(k, parent, pos) {
    const naokoComponents = $1e276c86cf5eeebf$export$82d91fddebb09577(k, pos);
    const naoko = parent.add([
        ...naokoComponents
    ]);
    naoko.lastAnim = "down";
    (0, $2b52c036dbdac93f$export$a861d836c9774c03)(k, naoko);
    return naoko;
}





function $b51c3833cd487abc$export$cb25f7e339e46775(k, pos) {
    return [
        k.sprite("assets", {
            anim: "npc4-side"
        }),
        k.pos(pos),
        k.body({
            isStatic: false
        }),
        k.area({
            shape: new k.Rect(k.vec2(), 20, 25)
        }),
        k.z(1),
        "npc4",
        "wall",
        "npc",
        "solid"
    ];
}
function $b51c3833cd487abc$var$facePlayerToNPC(npc, player) {
    const dx = player.pos.x - npc.pos.x;
    const dy = player.pos.y - npc.pos.y;
    if (Math.abs(dx) > Math.abs(dy)) (0, $820877bea407f5fe$export$a1ebaf6fd15c8a74)(npc, "npc4-side");
    else if (dy < 0) (0, $820877bea407f5fe$export$a1ebaf6fd15c8a74)(npc, "npc4-up");
    else (0, $820877bea407f5fe$export$a1ebaf6fd15c8a74)(npc, "npc4-down");
}
async function $b51c3833cd487abc$var$handleFallbackDialogue(k, entity, player, portraitKey) {
    const originalDirection = player.direction;
    player.direction = "down";
    entity.isTalking = true;
    entity.pauseWander = true;
    $b51c3833cd487abc$var$facePlayerToNPC(entity, player);
    const fallbackText = [
        "A soft breeze whispers\u2014\nEven chairs long for a walk.",
        "They think I sit still\u2014\nBut thoughts travel far from here.",
        "I watched clouds for years.\nThey always move on. I stayed.\nMaybe that\u2019s the point."
    ];
    const fallbackVoices = [
        "npc4_extra1",
        "npc4_extra2",
        "npc4_extra3"
    ];
    const randIndex = Math.floor(Math.random() * fallbackText.length);
    await (0, $e05b45d86fdf942d$export$f1d985ef2ac6d781)(k, k.vec2(0, 0), [
        fallbackText[randIndex]
    ], false, [
        portraitKey
    ], [
        fallbackVoices[randIndex]
    ], [
        "Stranger"
    ] // ✅ wrapped in array
    );
    (0, $96277ef5c4fda650$export$405cc0fd5207d608).setNbTalked("npc4", (0, $96277ef5c4fda650$export$405cc0fd5207d608).getNbTalked("npc4") + 1);
    player.direction = originalDirection;
    (0, $e05b45d86fdf942d$export$d526e17d3827c2fd)(()=>{
        entity.isTalking = false;
        entity.pauseWander = false;
        entity.trigger("dialogue-ended");
    });
}
async function $b51c3833cd487abc$export$a3881aa67efe73f5(k, npc4, player) {
    await $b51c3833cd487abc$var$handleFallbackDialogue(k, npc4, player, "npc4Portrait");
}
function $b51c3833cd487abc$export$745f393e14120a0c(npc4) {
    (0, $820877bea407f5fe$export$a1ebaf6fd15c8a74)(npc4, "npc4-side");
}
function $b51c3833cd487abc$export$4167484869dc9910(k, parent, pos) {
    const npc4Components = $b51c3833cd487abc$export$cb25f7e339e46775(k, pos);
    const npc4 = parent.add([
        ...npc4Components
    ]);
    npc4.lastAnim = "side";
    return npc4;
}








let $f720bf84da31aaf2$var$nearbyItem = null;
async function $f720bf84da31aaf2$export$2e2bcd8739ae039(k) {
    (0, $96277ef5c4fda650$export$8e361a1ffbebf172).setCurrentScene("ramen");
    (0, $3d1117e281c70288$export$7a6134494e9ab3f8).playMusic(k, "ramenMusic");
    (0, $820877bea407f5fe$export$3e24ac339becbb9d)(k, 30, 18, 12);
    const mapData = await (0, $820877bea407f5fe$export$1040e9253d215679)("./assets/maps/ramen.json");
    const map = k.add([
        k.pos(480, 200)
    ]);
    const interactPrompt = (0, $9bc24edee806a245$export$f9c1beccff5673bc)(k);
    const heartBarInstance = (0, $3f33787d0c03f6d8$export$4535535e2d81a294)(k);
    (0, $820877bea407f5fe$export$f87c018a61aadd8e)(k);
    const entities = {
        player: null,
        naoko: null,
        npc4: null
    };
    for (const layer of mapData.layers){
        const layerName = layer.name;
        if (layerName === "Boundaries") {
            (0, $820877bea407f5fe$export$8619674b9a9c7477)(k, map, layer);
            continue;
        }
        if (layerName === "SpawnPoints") {
            for (const obj of layer.objects){
                const pos = k.vec2(obj.x, obj.y);
                switch(obj.name){
                    case "player":
                        entities.player = map.add([
                            ...(0, $9327de97d5aeca88$export$f591f00788965a32)(k, pos)
                        ]);
                        k.camPos(pos);
                        k.onLoad(()=>k.play("chime-bell", {
                                volume: 0.4
                            }));
                        break;
                    case "naoko":
                        entities.naoko = (0, $1e276c86cf5eeebf$export$8961d1b15e32004e)(k, map, pos);
                        break;
                    case "npc4":
                        entities.npc4 = map.add((0, $b51c3833cd487abc$export$cb25f7e339e46775)(k, pos));
                        break;
                }
            }
            continue;
        }
        const zIndex = layerName === "Upmost" ? 999 : 0;
        (0, $820877bea407f5fe$export$120b04d2a5575c18)(k, map, layer, mapData.tileheight, mapData.tilewidth, zIndex);
    }
    k.camScale(4);
    (0, $9327de97d5aeca88$export$267aabae32ccde1c)(k, entities.player);
    entities.player.onCollide("item", (obj)=>{
        if (!obj?.itemName) return;
        $f720bf84da31aaf2$var$nearbyItem = obj;
        interactPrompt.show();
    });
    entities.player.onCollideEnd("item", ()=>{
        $f720bf84da31aaf2$var$nearbyItem = null;
        interactPrompt.hide();
    });
    // Naoko interaction
    let isTalkingToNaoko = false;
    entities.player.onCollide("naoko", async ()=>{
        if (isTalkingToNaoko || !entities.naoko || entities.naoko.isTalking) return;
        isTalkingToNaoko = true;
        await (0, $1e276c86cf5eeebf$export$a3881aa67efe73f5)(k, entities.naoko, entities.player, heartBarInstance);
        isTalkingToNaoko = false;
    });
    entities.player.onCollideEnd("naoko", ()=>{
        (0, $1e276c86cf5eeebf$export$745f393e14120a0c)(entities.naoko);
    });
    // NPC4 interaction
    let isTalkingToNpc4 = false;
    entities.player.onCollide("npc4", async ()=>{
        if (isTalkingToNpc4 || !entities.npc4 || entities.npc4.isTalking) return;
        isTalkingToNpc4 = true;
        await (0, $b51c3833cd487abc$export$a3881aa67efe73f5)(k, entities.npc4, entities.player, heartBarInstance);
        isTalkingToNpc4 = false;
    });
    entities.player.onCollideEnd("npc4", ()=>{
        (0, $b51c3833cd487abc$export$745f393e14120a0c)(entities.npc4);
    });
    entities.player.onCollide("door-exit", ()=>{
        (0, $96277ef5c4fda650$export$8e361a1ffbebf172).setPreviousScene("ramen");
        (0, $3d1117e281c70288$export$7a6134494e9ab3f8).stopMusic();
        k.go("world");
    });
    k.onKeyPress("e", async ()=>{
        if (!$f720bf84da31aaf2$var$nearbyItem) return;
    });
    let cameraTimer = 0;
    k.onUpdate(()=>{
        if (!entities.player) return;
        cameraTimer += k.dt();
        if (cameraTimer > 0.016) {
            const target = entities.player.worldPos();
            const current = k.camPos();
            k.camPos(current.lerp(target, 0.2));
            cameraTimer = 0;
        }
        if ($f720bf84da31aaf2$var$nearbyItem) interactPrompt.setPosition($f720bf84da31aaf2$var$nearbyItem.worldPos());
    });
    (0, $9327de97d5aeca88$export$436ca3b7c65de203)(k);
}










let $3fbe83284b15edf6$var$nearbyItem = null;
async function $3fbe83284b15edf6$export$2e2bcd8739ae039(k) {
    (0, $96277ef5c4fda650$export$8e361a1ffbebf172).setCurrentScene("cstore");
    (0, $3d1117e281c70288$export$7a6134494e9ab3f8).playMusic(k, "cstoreMusic");
    (0, $820877bea407f5fe$export$3e24ac339becbb9d)(k, 240, 200, 120);
    const mapData = await (0, $820877bea407f5fe$export$1040e9253d215679)("./assets/maps/cstore.json");
    const map = k.add([
        k.pos(530, 222)
    ]);
    const interactPrompt = (0, $9bc24edee806a245$export$f9c1beccff5673bc)(k);
    const heartBarInstance = (0, $3f33787d0c03f6d8$export$4535535e2d81a294)(k);
    (0, $820877bea407f5fe$export$f87c018a61aadd8e)(k);
    const entities = {
        player: null,
        yuki: null
    };
    for (const layer of mapData.layers){
        const layerName = layer.name;
        if (layerName === "Boundaries") {
            (0, $820877bea407f5fe$export$8619674b9a9c7477)(k, map, layer);
            continue;
        }
        if (layer.name === "SpawnPoints") {
            for (const obj of layer.objects){
                const pos = k.vec2(obj.x, obj.y);
                if (obj.name === "player") {
                    entities.player = map.add((0, $9327de97d5aeca88$export$f591f00788965a32)(k, pos));
                    k.camPos(pos);
                    k.onLoad(()=>{
                        k.play("chime-bell", {
                            volume: 0.4
                        });
                    });
                    continue;
                }
                if (obj.name === "yuki") {
                    entities.yuki = map.add((0, $49084d612a33e4e6$export$e209df1f201b98f7)(k, pos));
                    continue;
                }
                if (obj.name === "strawberrySpawn" && !(0, $96277ef5c4fda650$export$ab4b6c53ec258d17).getHasPickedUpStrawberries() && (0, $96277ef5c4fda650$export$8e361a1ffbebf172).getFlag("strawberrySpawned") // ✅ Ensure Naoko triggered it
                ) {
                    const strawberry = map.add((0, $c62b79df8bad9d88$export$f2c8d3cf6d4eb27a)(k, pos));
                    strawberry.itemName = "strawberry";
                }
            }
            continue;
        }
        let zIndex = 0;
        if (layerName === "Upmost") zIndex = 999;
        if (layerName === "Register") zIndex = 1050;
        (0, $820877bea407f5fe$export$120b04d2a5575c18)(k, map, layer, mapData.tileheight, mapData.tilewidth, zIndex);
    }
    k.camScale(3.6);
    (0, $9327de97d5aeca88$export$267aabae32ccde1c)(k, entities.player);
    k.onUpdate(()=>{
        const target = entities.player.worldPos();
        const current = k.camPos();
        k.camPos(current.lerp(target, 0.1));
        if ($3fbe83284b15edf6$var$nearbyItem) interactPrompt.setPosition($3fbe83284b15edf6$var$nearbyItem.worldPos());
    });
    entities.player.onCollide("door-exit", ()=>{
        (0, $96277ef5c4fda650$export$8e361a1ffbebf172).setPreviousScene("cstore");
        (0, $3d1117e281c70288$export$7a6134494e9ab3f8).stopMusic();
        k.go("world");
    });
    entities.player.onCollide("yuki", async ()=>{
        if (entities.yuki && !entities.yuki.isTalking) await (0, $49084d612a33e4e6$export$a3881aa67efe73f5)(k, entities.yuki, entities.player, heartBarInstance);
    });
    entities.player.onCollideEnd("yuki", ()=>{
        (0, $49084d612a33e4e6$export$745f393e14120a0c)(entities.yuki);
    });
    entities.player.onCollide("item", (obj)=>{
        if (!obj?.itemName) return;
        $3fbe83284b15edf6$var$nearbyItem = obj;
        interactPrompt.show();
    });
    entities.player.onCollideEnd("item", ()=>{
        $3fbe83284b15edf6$var$nearbyItem = null;
        interactPrompt.hide();
    });
    k.onKeyPress("e", async ()=>{
        if (!$3fbe83284b15edf6$var$nearbyItem) return;
        if ($3fbe83284b15edf6$var$nearbyItem.itemName === "strawberry") await (0, $c62b79df8bad9d88$export$c5087c64eb1954a9)(k, $3fbe83284b15edf6$var$nearbyItem, interactPrompt);
    });
    (0, $9327de97d5aeca88$export$436ca3b7c65de203)(k);
}





const $a63263745e6ab9c6$export$237eecb7b298ce0e = {
    antique: {
        lines: [
            {
                speaker: "Hana",
                text: "Ink stains my hands\u2014\nI carve stories in your skin.\nDo you feel the truth?"
            },
            {
                speaker: "Randy",
                text: "Once got 'YOLO' inked.\nI felt something... maybe itch?\nThat still counts, right... yes?"
            },
            {
                speaker: "Hana",
                text: "The needle hums low,\nSkin opens, blood calls the art.\nWhat is it we seek?"
            },
            {
                speaker: "Randy",
                text: "I seek nachos first.\nThen truth, love, or spicy soup.\nDo they sell that here?"
            },
            {
                speaker: "Hana",
                text: "A butterfly flies\u2014\nWings hold the memory's weight.\nWill it live or die?"
            },
            {
                speaker: "Randy",
                text: "Mine flew into glass.\nI named him Jeff. He knew fear.\nRest in wings, my bro."
            },
            {
                speaker: "Hana",
                text: "The flame burns so bright\u2014\nBut the shadow swallows light.\nDo we chase the dark?"
            },
            {
                speaker: "Randy",
                text: "I chased my own sock\ninto a laundry portal\u2014\nShould I have let go?"
            },
            {
                speaker: "Hana",
                text: "Tattoos fade with time,\nBut the pain still wears its mark.\nHow deep is your past?"
            },
            {
                speaker: "Randy",
                text: "One spring break in Guam,\na dolphin judged my dance moves.\nI still dream of that."
            },
            {
                speaker: "Hana",
                text: "Every line, a choice\u2014\nEach stroke a new beginning.\nWill you bear it well?"
            },
            {
                speaker: "Randy",
                text: "I once bore a cat.\nIt climbed me like destiny.\nI have the scar still."
            }
        ],
        voices: [
            "hana_antique1",
            "hana_antique2",
            "hana_antique3",
            "hana_antique4",
            "hana_antique5",
            "hana_antique6"
        ],
        randyVoices: [
            "randy_hana1",
            "randy_hana2",
            "randy_hana3",
            "randy_hana4",
            "randy_hana5",
            "randy_hana6"
        ]
    }
};
var $a63263745e6ab9c6$export$2e2bcd8739ae039 = $a63263745e6ab9c6$export$237eecb7b298ce0e;



function $ed86b2b09f0de91f$export$857f19948adf5310(k, pos) {
    return [
        k.sprite("assets", {
            anim: "hana-down"
        }),
        k.pos(pos),
        k.body({
            isStatic: false
        }),
        k.area({
            shape: new k.Rect(k.vec2(), 20, 20)
        }),
        k.z(1),
        "hana",
        "wall",
        "npc",
        "solid"
    ];
}
function $ed86b2b09f0de91f$var$facePlayerToNPC(npc, player) {
    const dx = player.pos.x - npc.pos.x;
    const dy = player.pos.y - npc.pos.y;
    if (Math.abs(dx) > Math.abs(dy)) {
        npc.flipX = dx < 0;
        (0, $820877bea407f5fe$export$a1ebaf6fd15c8a74)(npc, "hana-side");
    } else if (dy < 0) (0, $820877bea407f5fe$export$a1ebaf6fd15c8a74)(npc, "hana-up");
    else (0, $820877bea407f5fe$export$a1ebaf6fd15c8a74)(npc, "hana-down");
}
async function $ed86b2b09f0de91f$var$handleSharedDialogue(k, entity, player, npcKey, linesData, portraitKey, heartBarInstance) {
    const originalDirection = player.direction;
    player.direction = "down";
    entity.isTalking = true;
    $ed86b2b09f0de91f$var$facePlayerToNPC(entity, player);
    const scene = (0, $96277ef5c4fda650$export$8e361a1ffbebf172).getCurrentScene();
    const currentData = linesData[scene] || {};
    const { lines: lines = [], voices: voices = [], randyVoices: randyVoices = [], fallbackRandyLines: fallbackRandyLines = [], fallbackRandyVoices: fallbackRandyVoices = [] } = currentData;
    let nbTalked = (0, $96277ef5c4fda650$export$405cc0fd5207d608).getNbTalked(npcKey);
    const shouldGiveHeart = nbTalked === 1 && !(0, $96277ef5c4fda650$export$405cc0fd5207d608).getHasGivenHeart(npcKey);
    const entry1 = lines[nbTalked * 2];
    const entry2 = lines[nbTalked * 2 + 1];
    if (entry1?.text && entry2?.text) await (0, $e05b45d86fdf942d$export$f1d985ef2ac6d781)(k, k.vec2(0, 0), [
        entry1.text,
        entry2.text
    ], false, [
        portraitKey,
        "randyPortrait"
    ], [
        voices[nbTalked] || null,
        randyVoices[nbTalked] || null
    ], [
        "Hana",
        "Randy"
    ]);
    else {
        const fallbackOptions = {
            antique: [
                "You want a tattoo?\nSure, I\u2019ll ink your deep meaning\u2014\nLive, Laugh, Regret it.",
                "This one\u2019s a dragon\u2014\nOr maybe it\u2019s just your ex\nbreathing down your neck.",
                "Trust me, I\u2019m an *art*-ist\u2014\nYour pain is my canvas now.\nHold still or it\u2019s worse.",
                "Spiritual ink?\nLet\u2019s align your chakra set\u2014\nright above your butt."
            ]
        };
        const voiceOptions = {
            antique: [
                "hana_extra1",
                "hana_extra2",
                "hana_extra3",
                "hana_extra4"
            ]
        };
        const linesArray = fallbackOptions[scene] || fallbackOptions.antique;
        const voiceArray = voiceOptions[scene] || voiceOptions.antique;
        const randIndex = Math.floor(Math.random() * linesArray.length);
        await (0, $e05b45d86fdf942d$export$f1d985ef2ac6d781)(k, k.vec2(0, 0), [
            linesArray[randIndex]
        ], false, [
            portraitKey
        ], [
            voiceArray[randIndex]
        ], [
            "Hana"
        ]);
    }
    if (shouldGiveHeart && (0, $96277ef5c4fda650$export$ab4b6c53ec258d17).getCurrentMaxHealth() < (0, $96277ef5c4fda650$export$ab4b6c53ec258d17).getTrueMaxHealth()) {
        (0, $96277ef5c4fda650$export$ab4b6c53ec258d17).setCurrentMaxHealth((0, $96277ef5c4fda650$export$ab4b6c53ec258d17).getCurrentMaxHealth() + 1);
        (0, $96277ef5c4fda650$export$ab4b6c53ec258d17).setHealth((0, $96277ef5c4fda650$export$ab4b6c53ec258d17).getCurrentMaxHealth());
        k.destroyAll("healthContainer");
        heartBarInstance.giveHeartToNPC("hana");
        heartBarInstance.update();
        (0, $96277ef5c4fda650$export$405cc0fd5207d608).setHasGivenHeart(npcKey, true);
    }
    (0, $96277ef5c4fda650$export$405cc0fd5207d608).setNbTalked(npcKey, nbTalked + 1);
    player.direction = originalDirection;
    (0, $e05b45d86fdf942d$export$d526e17d3827c2fd)(()=>{
        entity.isTalking = false;
        entity.pauseWander = false;
        entity.reverseDirection = true;
        entity.trigger("dialogue-ended");
    });
}
async function $ed86b2b09f0de91f$export$a3881aa67efe73f5(k, hana, player, heartBarInstance) {
    await $ed86b2b09f0de91f$var$handleSharedDialogue(k, hana, player, "hana", (0, $a63263745e6ab9c6$export$2e2bcd8739ae039), "hanaPortrait", heartBarInstance);
}
function $ed86b2b09f0de91f$export$745f393e14120a0c(hana) {
    (0, $820877bea407f5fe$export$a1ebaf6fd15c8a74)(hana, "hana-down");
}
function $ed86b2b09f0de91f$export$bc7de74fa32e95b2(k, parent, pos) {
    const hanaComponents = $ed86b2b09f0de91f$export$857f19948adf5310(k, pos);
    const hana = parent.add([
        ...hanaComponents
    ]);
    hana.lastAnim = "down";
    (0, $2b52c036dbdac93f$export$a861d836c9774c03)(k, hana);
    return hana;
}




const $11eac2a99eceeda2$var$swordHaiku = [
    "Edge of silent steel\u2014\nOnce swung in forgotten wars.\nNow yours to protect."
];
function $11eac2a99eceeda2$export$7bf815797b098f0f(k, pos) {
    return [
        k.sprite("assets", {
            anim: "sword"
        }),
        k.area({
            shape: new k.Rect(k.vec2(0, 0), 20, 20)
        }),
        k.body({
            isStatic: true
        }),
        k.pos(pos),
        k.z(1),
        k.scale(1),
        "item",
        {
            itemName: "sword"
        }
    ];
}
async function $11eac2a99eceeda2$export$bee8643b4ab48b46(k, itemObj, interactPrompt) {
    const header = "Old Katana";
    await (0, $e05b45d86fdf942d$export$f1d985ef2ac6d781)(k, k.vec2(0, 0), $11eac2a99eceeda2$var$swordHaiku, true, null, [], null, header);
    k.play("soundUI", {
        volume: 0.4
    });
    (0, $96277ef5c4fda650$export$ab4b6c53ec258d17).setHasSword?.(true); // In-game flag
    (0, $96277ef5c4fda650$export$ab4b6c53ec258d17).setHasPickedUpSword?.(true); // Persistent flag
    interactPrompt.hide();
    k.destroy(itemObj);
}




const $be093a79ff0af2c1$var$lockedDoorHaiku = [
    "No key in your hand\u2014\nThe past stays shut, unmoving.\nOld wood guards secrets."
];
function $be093a79ff0af2c1$export$b2e1857b8348da2b(k, pos) {
    return [
        k.sprite("assets", {
            anim: "antiqueDoor"
        }),
        k.area({
            shape: new k.Rect(k.vec2(0, 0), 20, 15)
        }),
        k.body({
            isStatic: true
        }),
        k.pos(pos),
        k.z(1),
        "item",
        {
            itemName: "antiqueDoor",
            isOpen: false
        }
    ];
}
async function $be093a79ff0af2c1$export$dd40e290edd48aff(k, doorObj) {
    if (doorObj.isOpen) return;
    if ((0, $96277ef5c4fda650$export$ab4b6c53ec258d17).getHasKey()) {
        k.play("door-open", {
            volume: 0.8
        });
        // Replace sprite animation
        doorObj.use(k.sprite("assets", {
            anim: "antiqueDoorOpen"
        }));
        // ✅ Disable collision and remove interaction tag
        doorObj.area.hidden = true;
        doorObj.unuse("item");
        doorObj.unuse("body"); // ✅ Remove body so player can pass through
        doorObj.isOpen = true;
    } else {
        k.play("soundUI");
        await (0, $e05b45d86fdf942d$export$f1d985ef2ac6d781)(k, k.vec2(0, 0), $be093a79ff0af2c1$var$lockedDoorHaiku, true, null, [], null, "Antique Door");
    }
}




const $e225d9f6e0db3154$var$oriyokoHaiku = [
    "Bowls stacked with quiet\u2014\nEach grain earned with mindful hands.\nOld monks still recall."
];
function $e225d9f6e0db3154$export$2576ece412dea63d(k, pos) {
    return [
        k.sprite("assets", {
            anim: "oriyoki"
        }),
        k.area({
            shape: new k.Rect(k.vec2(0, 0), 20, 20)
        }),
        k.body({
            isStatic: true
        }),
        k.pos(pos),
        k.z(1),
        k.scale(1),
        "item",
        {
            itemName: "oriyoki"
        }
    ];
}
async function $e225d9f6e0db3154$export$583935870e0b9f20(k, itemObj, interactPrompt) {
    const header = "Oriyoki Set";
    await (0, $e05b45d86fdf942d$export$f1d985ef2ac6d781)(k, k.vec2(0, 0), $e225d9f6e0db3154$var$oriyokoHaiku, true, null, [], null, header);
    k.play("soundUI", {
        volume: 0.4
    });
    (0, $96277ef5c4fda650$export$ab4b6c53ec258d17).setHasOriyoki?.(true); // In-game flag
    (0, $96277ef5c4fda650$export$ab4b6c53ec258d17).setHasPickedUpOriyoki?.(true); // ✅ Persistent flag
    interactPrompt.hide();
    k.destroy(itemObj);
}








let $8fb8916ac81e31a1$var$nearbyItem = null;
async function $8fb8916ac81e31a1$export$2e2bcd8739ae039(k) {
    (0, $96277ef5c4fda650$export$8e361a1ffbebf172).setCurrentScene("antique");
    (0, $3d1117e281c70288$export$7a6134494e9ab3f8).playMusic(k, "antiqueMusic");
    (0, $820877bea407f5fe$export$3e24ac339becbb9d)(k, 60, 50, 30);
    const mapData = await (0, $820877bea407f5fe$export$1040e9253d215679)("./assets/maps/antique.json");
    const map = k.add([
        k.pos(480, 200)
    ]);
    const interactPrompt = (0, $9bc24edee806a245$export$f9c1beccff5673bc)(k);
    const heartBarInstance = (0, $3f33787d0c03f6d8$export$4535535e2d81a294)(k);
    (0, $820877bea407f5fe$export$f87c018a61aadd8e)(k);
    const entities = {
        player: null,
        hana: null,
        sword: null,
        antiqueDoor: null,
        oriyoki: null
    };
    for (const layer of mapData.layers){
        const layerName = layer.name;
        if (layerName === "Boundaries") {
            (0, $820877bea407f5fe$export$8619674b9a9c7477)(k, map, layer);
            continue;
        }
        if (layerName === "SpawnPoints") {
            for (const obj of layer.objects){
                const pos = k.vec2(obj.x, obj.y);
                switch(obj.name){
                    case "player":
                        entities.player = map.add([
                            ...(0, $9327de97d5aeca88$export$f591f00788965a32)(k, pos)
                        ]);
                        k.camPos(pos);
                        k.onLoad(()=>k.play("chime-bell", {
                                volume: 0.4
                            }));
                        break;
                    case "hana":
                        entities.hana = (0, $ed86b2b09f0de91f$export$bc7de74fa32e95b2)(k, map, pos);
                        break;
                    case "sword":
                        if (!(0, $96277ef5c4fda650$export$ab4b6c53ec258d17).getHasPickedUpSword?.()) {
                            const sword = map.add([
                                ...(0, $11eac2a99eceeda2$export$7bf815797b098f0f)(k, pos)
                            ]);
                            sword.itemName = "sword";
                            entities.sword = sword;
                        }
                        break;
                    case "antiqueDoor":
                        {
                            const door = map.add((0, $be093a79ff0af2c1$export$b2e1857b8348da2b)(k, pos));
                            door.itemName = "antiqueDoor";
                            entities.antiqueDoor = door;
                            break;
                        }
                    case "oriyoki":
                        if (!(0, $96277ef5c4fda650$export$ab4b6c53ec258d17).getHasPickedUpOriyoki()) {
                            const oriyokiItem = map.add((0, $e225d9f6e0db3154$export$2576ece412dea63d)(k, pos));
                            oriyokiItem.itemName = "oriyoki";
                            entities.oriyoki = oriyokiItem;
                        }
                        break;
                }
            }
            continue;
        }
        const zIndex = layerName === "Upmost" ? 999 : 0;
        (0, $820877bea407f5fe$export$120b04d2a5575c18)(k, map, layer, mapData.tileheight, mapData.tilewidth, zIndex);
    }
    k.camScale(4);
    (0, $9327de97d5aeca88$export$267aabae32ccde1c)(k, entities.player);
    k.onUpdate(()=>{
        const target = entities.player.worldPos();
        const current = k.camPos();
        const newPos = current.lerp(target, 0.1);
        k.camPos(newPos);
        if ($8fb8916ac81e31a1$var$nearbyItem) interactPrompt.setPosition($8fb8916ac81e31a1$var$nearbyItem.worldPos());
    });
    entities.player.onCollide("door-exit", ()=>{
        (0, $96277ef5c4fda650$export$8e361a1ffbebf172).setPreviousScene("antique");
        (0, $3d1117e281c70288$export$7a6134494e9ab3f8).stopMusic();
        k.go("world");
    });
    let isTalkingToHana = false;
    entities.player.onCollide("hana", async ()=>{
        if (isTalkingToHana || !entities.hana || entities.hana.isTalking) return;
        isTalkingToHana = true;
        await (0, $ed86b2b09f0de91f$export$a3881aa67efe73f5)(k, entities.hana, entities.player, heartBarInstance);
        isTalkingToHana = false;
    });
    entities.player.onCollideEnd("hana", ()=>{
        (0, $ed86b2b09f0de91f$export$745f393e14120a0c)(entities.hana);
    });
    entities.player.onCollide("item", (obj)=>{
        if (!obj?.itemName) return;
        $8fb8916ac81e31a1$var$nearbyItem = obj;
        interactPrompt.show();
    });
    entities.player.onCollideEnd("item", ()=>{
        $8fb8916ac81e31a1$var$nearbyItem = null;
        interactPrompt.hide();
    });
    k.onKeyPress("r", ()=>{
        k.go("reset");
    });
    k.onKeyPress("e", async ()=>{
        if (!$8fb8916ac81e31a1$var$nearbyItem) return;
        if ($8fb8916ac81e31a1$var$nearbyItem.itemName === "sword") await (0, $11eac2a99eceeda2$export$bee8643b4ab48b46)(k, $8fb8916ac81e31a1$var$nearbyItem, interactPrompt);
        if ($8fb8916ac81e31a1$var$nearbyItem.itemName === "antiqueDoor") await (0, $be093a79ff0af2c1$export$dd40e290edd48aff)(k, $8fb8916ac81e31a1$var$nearbyItem);
        if ($8fb8916ac81e31a1$var$nearbyItem.itemName === "oriyoki") {
            await (0, $e225d9f6e0db3154$export$583935870e0b9f20)(k, $8fb8916ac81e31a1$var$nearbyItem, interactPrompt);
            (0, $96277ef5c4fda650$export$ab4b6c53ec258d17).setHasPickedUpOriyoki(true); // ✅ Persist the pickup
        }
    });
    (0, $9327de97d5aeca88$export$436ca3b7c65de203)(k);
}




const $942467b551ba1410$export$52831c9dd0c253bb = [
    {
        key: "yuki",
        name: "Yuki Tanaka",
        description: "She brewed quiet tea\u2014\nWhispers turned to cherry winds.\nDon\u2019t ask about love."
    },
    {
        key: "satoshi",
        name: "Satoshi Watanabe",
        description: "LOL he said, bruh\u2014\nHaikus slap when turtles vibe.\nWanna date or nah?"
    },
    {
        key: "koji",
        name: "Koji Nakamura",
        description: "Sweeps tracks like old sins\u2014\nDog watches him like Buddha.\nHairless. Also wise."
    },
    {
        key: "mari",
        name: "Mari Aoyama",
        description: "Haikus drop like beats\u2014\nSelfie queen with samurai\nvibes and glitter shoes."
    },
    {
        key: "naoko",
        name: "Naoko Ishikawa",
        description: "Whiskey breath ignites\u2014\nLove burns like microwave fish.\nCareful. I spark quick."
    },
    {
        key: "hana",
        name: "Hana Matsuda",
        description: "Ink beneath her skin\u2014\nTruths with a sizzling side eye.\nDid you feel that too?"
    },
    {
        key: "oldman",
        name: "Tetsuya Ito",
        description: "Fed birds. Loved one wife.\nSpoke of days when boats still sang.\nNow? I only was."
    },
    {
        key: "player",
        name: "Randy Weston",
        description: "Beer gut full of charm\u2014\nStill single, still in America.\nCall me maybe, bro."
    }
];



function $7c40a1dd3da32151$export$2e2bcd8739ae039(k) {
    (0, $96277ef5c4fda650$export$8e361a1ffbebf172).setCurrentScene("endingSelection");
    (0, $96277ef5c4fda650$export$8e361a1ffbebf172).setFreezePlayer(false);
    (0, $3d1117e281c70288$export$7a6134494e9ab3f8).playMusic(k, "endingMusic");
    const tileSize = 1000;
    const tileCols = Math.ceil(k.width() / tileSize) + 2;
    const tileRows = Math.ceil(k.height() / tileSize) + 2;
    // 💖 Heart tile background
    for(let i = 0; i < tileCols; i++)for(let j = 0; j < tileRows; j++)k.add([
        k.sprite("heart-bg"),
        k.pos(i * tileSize, j * tileSize),
        k.scale(1),
        k.opacity(.65),
        k.z(-10),
        k.fixed()
    ]);
    k.add([
        k.text("Choose Your Love to Bring Back to the U.S.", {
            size: 40
        }),
        k.pos(k.center().x, 50),
        k.anchor("center"),
        k.color(0, 0, 0),
        k.z(1000)
    ]);
    const characters = (0, $942467b551ba1410$export$52831c9dd0c253bb);
    const spacingX = 300;
    const spacingY = 300;
    const columns = 4;
    const totalRows = Math.ceil(characters.length / columns);
    const startX = k.center().x - (columns - 1) * spacingX / 2;
    const startY = k.center().y - (totalRows - 1) * spacingY / 2 + 40;
    const slots = [];
    characters.forEach((char, index)=>{
        const col = index % columns;
        const row = Math.floor(index / columns);
        const xPos = startX + col * spacingX;
        const yPos = startY + row * spacingY;
        const hasHeart = (0, $96277ef5c4fda650$export$405cc0fd5207d608).getHasGivenHeart(char.key);
        const isRandy = char.key === "player";
        const isActive = hasHeart || isRandy;
        k.add([
            k.sprite("assets", {
                anim: `${char.key}-idle-down`
            }),
            k.pos(xPos - 35, yPos - 165),
            k.scale(5),
            k.z(500),
            {
                npcKey: char.key
            },
            isActive ? "selectable" : "locked",
            k.opacity(isActive ? 1 : 0.3)
        ]);
        if (hasHeart && !isRandy) k.add([
            k.sprite("full-heart"),
            k.pos(xPos, yPos - 95),
            k.scale(2),
            k.z(501)
        ]);
        k.add([
            k.text(char.name, {
                size: 30,
                width: 180,
                align: "center"
            }),
            k.pos(xPos - 90, yPos - 75),
            k.anchor("topleft"),
            k.color(0, 0, 0),
            k.z(502)
        ]);
        k.add([
            k.text(char.description, {
                size: 16,
                width: 275,
                align: "left"
            }),
            k.pos(xPos - 90, yPos),
            k.anchor("topleft"),
            k.color(0, 0, 0),
            k.z(502)
        ]);
        slots.push({
            x: xPos,
            y: yPos,
            character: char,
            active: isActive
        });
    });
    let selectedIndex = slots.findIndex((s)=>s.character.key === "player" || s.active);
    if (selectedIndex === -1) selectedIndex = 0;
    const selector = k.add([
        k.sprite("full-heart"),
        k.pos(slots[selectedIndex].x, slots[selectedIndex].y),
        k.anchor("center"),
        k.z(999),
        k.scale(1.3)
    ]);
    function updateSelector() {
        const currentSlot = slots[selectedIndex];
        selector.pos.x = currentSlot.x;
        selector.pos.y = currentSlot.y - 95;
        selector.opacity = currentSlot.active ? 1 : 0.3;
    }
    updateSelector();
    function chooseCharacter(charKey) {
        (0, $96277ef5c4fda650$export$8e361a1ffbebf172).setChosenEnding(charKey);
        (0, $3d1117e281c70288$export$7a6134494e9ab3f8).stopMusic();
        if (charKey === "player") k.go("endingAlone");
        else k.go(`ending_${charKey}`);
    }
    k.onKeyPress("left", ()=>{
        let tries = 0;
        do {
            selectedIndex = (selectedIndex - 1 + slots.length) % slots.length;
            tries++;
        }while (!slots[selectedIndex].active && slots[selectedIndex].character.key !== "player" && tries < slots.length);
        updateSelector();
    });
    k.onKeyPress("right", ()=>{
        let tries = 0;
        do {
            selectedIndex = (selectedIndex + 1) % slots.length;
            tries++;
        }while (!slots[selectedIndex].active && slots[selectedIndex].character.key !== "player" && tries < slots.length);
        updateSelector();
    });
    k.onKeyPress("enter", ()=>{
        const selected = slots[selectedIndex];
        if (selected && (selected.active || selected.character.key === "player")) chooseCharacter(selected.character.key);
    });
    k.onClick(()=>{
        const mouseX = k.mousePos().x;
        const mouseY = k.mousePos().y;
        const clicked = slots.find((s)=>(s.active || s.character.key === "player") && Math.abs(s.x - mouseX) < spacingX / 2 && Math.abs(s.y - mouseY) < spacingY / 2);
        if (clicked) chooseCharacter(clicked.character.key);
    });
    const prompt = k.add([
        k.text("Use \u2190 \u2192 or touch to choose. Press ENTER to confirm.", {
            size: 30
        }),
        k.pos(k.center().x, k.height() - 20),
        k.anchor("center"),
        k.color(0, 0, 0),
        k.z(1000)
    ]);
    let blinkTimer = 0;
    k.onUpdate(()=>{
        blinkTimer += k.dt();
        prompt.hidden = Math.floor(blinkTimer * 1) % 2 === 0;
    });
}




function $442f906206c75bae$export$2e2bcd8739ae039(k) {
    (0, $96277ef5c4fda650$export$8e361a1ffbebf172).setCurrentScene("endingAlone");
    (0, $3d1117e281c70288$export$7a6134494e9ab3f8).playMusic(k, "lonelyEndingMusic");
    k.setBackground(k.Color.fromHex("#E6E6E6"));
    // ✅ Load and fit image to the left half
    const leftImageWidth = k.width() / 2;
    const leftImageHeight = k.height();
    const spriteOriginalWidth = 600;
    const spriteOriginalHeight = 400;
    const scaleX = leftImageWidth / spriteOriginalWidth;
    const scaleY = leftImageHeight / spriteOriginalHeight;
    const scale = Math.min(scaleX, scaleY); // Keep aspect ratio
    k.add([
        k.sprite("endingAlone"),
        k.pos(-10, 20),
        k.scale(.65),
        k.z(0)
    ]);
    const textStartX = k.width() * 0.55;
    // 🖋️ Title
    k.add([
        k.text("You Return Alone", {
            size: 48
        }),
        k.pos(textStartX, 60),
        k.anchor("left"),
        k.color(50, 50, 50),
        k.z(100)
    ]);
    // 💬 Message
    k.add([
        k.text("Randy understood\u2014\nLove\u2019s just like airport sushi.\nTry again next flight.\n\nHe waved with a grin\u2014\nLove\u2019s delayed, not canceled yet.\nYou board solo, meh.", {
            size: 28,
            width: k.width() / 1.5,
            align: "left",
            lineSpacing: 10
        }),
        k.pos(textStartX, 260),
        k.anchor("left"),
        k.color(80, 80, 80),
        k.z(100)
    ]);
    // 🔁 Prompt
    const promptText = k.add([
        k.text("Press ENTER or TAP anywhere\nto return to the main menu.", {
            size: 24
        }),
        k.pos(textStartX, k.height() - 100),
        k.anchor("left"),
        k.color(0, 0, 0),
        k.z(100)
    ]);
    function returnToMenu() {
        (0, $3d1117e281c70288$export$7a6134494e9ab3f8).stopMusic();
        k.go("mainMenu");
    }
    k.onKeyPress("enter", returnToMenu);
    k.onClick(returnToMenu); // ✅ Touch/click support
}




function $612418092cb11506$export$2e2bcd8739ae039(k) {
    (0, $96277ef5c4fda650$export$8e361a1ffbebf172).setCurrentScene("ending_hana");
    (0, $3d1117e281c70288$export$7a6134494e9ab3f8).playMusic(k, "lonelyEndingMusic");
    k.setBackground(k.Color.fromHex("#E6E6E6"));
    // 🖼️ Hana’s portrait on left
    const leftImageWidth = k.width() / 2;
    const leftImageHeight = k.height();
    const scale = Math.min(leftImageWidth / 600, leftImageHeight / 400);
    k.add([
        k.sprite("endingHana"),
        k.pos(-10, 20),
        k.scale(0.65),
        k.z(0)
    ]);
    const textStartX = k.width() * 0.55;
    // 🖋️ Title
    k.add([
        k.text("You Chose Hana", {
            size: 48
        }),
        k.pos(textStartX, 60),
        k.anchor("left"),
        k.color(50, 50, 50),
        k.z(100)
    ]);
    // 💬 Haikus
    k.add([
        k.text("Needles on her skin\u2014\nShe inked your name upside down.\nThen moved out that night.\n\n'What\u2019s your deepest truth?'\nShe asked mid-tattoo, then left.\nYour answer? Regret.", {
            size: 28,
            width: k.width() / 1.5,
            align: "left",
            lineSpacing: 10
        }),
        k.pos(textStartX, 260),
        k.anchor("left"),
        k.color(80, 80, 80),
        k.z(100)
    ]);
    // 🔁 Prompt
    k.add([
        k.text("Press ENTER or TAP anywhere\nto return to the main menu.", {
            size: 24
        }),
        k.pos(textStartX, k.height() - 100),
        k.anchor("left"),
        k.color(0, 0, 0),
        k.z(100)
    ]);
    function returnToMenu() {
        (0, $3d1117e281c70288$export$7a6134494e9ab3f8).stopMusic();
        k.go("mainMenu");
    }
    k.onKeyPress("enter", returnToMenu);
    k.onClick(returnToMenu);
}




function $514bc2d15b09a1b8$export$2e2bcd8739ae039(k) {
    (0, $96277ef5c4fda650$export$8e361a1ffbebf172).setCurrentScene("ending_naoko");
    (0, $3d1117e281c70288$export$7a6134494e9ab3f8).playMusic(k, "lonelyEndingMusic");
    k.setBackground(k.Color.fromHex("#E6E6E6"));
    // 🔥 Naoko’s image on the left
    const leftImageWidth = k.width() / 2;
    const leftImageHeight = k.height();
    const scale = Math.min(leftImageWidth / 600, leftImageHeight / 400);
    k.add([
        k.sprite("endingNaoko"),
        k.pos(-20, 80),
        k.scale(0.65),
        k.z(0)
    ]);
    const textStartX = k.width() * 0.55;
    // 🖋️ Title
    k.add([
        k.text("You Chose Naoko", {
            size: 48
        }),
        k.pos(textStartX, 60),
        k.anchor("left"),
        k.color(50, 50, 50),
        k.z(100)
    ]);
    // 🔥 Haikus
    k.add([
        k.text("They burned incense low\u2014\n'Love is ash,' they softly said.\nYou coughed, then they left.\n\nThey ghosted your calls\u2014\nYou mailed a mixtape to hell.\nEven hell returned.", {
            size: 28,
            width: k.width() / 1.5,
            align: "left",
            lineSpacing: 10
        }),
        k.pos(textStartX, 260),
        k.anchor("left"),
        k.color(80, 80, 80),
        k.z(100)
    ]);
    // 🔁 Prompt
    const promptText = k.add([
        k.text("Press ENTER or TAP anywhere\nto return to the main menu.", {
            size: 24
        }),
        k.pos(textStartX, k.height() - 100),
        k.anchor("left"),
        k.color(0, 0, 0),
        k.z(100)
    ]);
    function returnToMenu() {
        (0, $3d1117e281c70288$export$7a6134494e9ab3f8).stopMusic();
        k.go("mainMenu");
    }
    k.onKeyPress("enter", returnToMenu);
    k.onClick(returnToMenu);
}




function $360c447a81b3e68e$export$2e2bcd8739ae039(k) {
    (0, $96277ef5c4fda650$export$8e361a1ffbebf172).setCurrentScene("ending_oldman");
    (0, $3d1117e281c70288$export$7a6134494e9ab3f8).playMusic(k, "lonelyEndingMusic");
    k.setBackground(k.Color.fromHex("#E6E6E6"));
    // 🖼️ Old Man image on the left
    const scale = Math.min(k.width() / 2 / 600, k.height() / 400);
    k.add([
        k.sprite("endingOldman"),
        k.pos(-10, 20),
        k.scale(0.65),
        k.z(0)
    ]);
    const textStartX = k.width() * 0.55;
    // 🖋️ Title
    k.add([
        k.text("You Chose Tetsuya", {
            size: 48
        }),
        k.pos(textStartX, 60),
        k.anchor("left"),
        k.color(50, 50, 50),
        k.z(100)
    ]);
    k.add([
        k.text("Sailed west with my bones\u2014\nHe insisted I was bait.\nNo fish, just silence.\n\n'Wife once fed the crows.'\nHe said that, then fed your dreams.\nYou woke up... in Guam.", {
            size: 28,
            width: k.width() / 1.5,
            align: "left",
            lineSpacing: 10
        }),
        k.pos(textStartX, 260),
        k.anchor("left"),
        k.color(80, 80, 80),
        k.z(100)
    ]);
    // 🔁 Prompt
    k.add([
        k.text("Press ENTER or TAP anywhere\nto return to the main menu.", {
            size: 24
        }),
        k.pos(textStartX, k.height() - 100),
        k.anchor("left"),
        k.color(0, 0, 0),
        k.z(100)
    ]);
    function returnToMenu() {
        (0, $3d1117e281c70288$export$7a6134494e9ab3f8).stopMusic();
        k.go("mainMenu");
    }
    k.onKeyPress("enter", returnToMenu);
    k.onClick(returnToMenu);
}




function $b08a61583fbf1f0a$export$2e2bcd8739ae039(k) {
    (0, $96277ef5c4fda650$export$8e361a1ffbebf172).setCurrentScene("ending_yuki");
    (0, $3d1117e281c70288$export$7a6134494e9ab3f8).playMusic(k, "lonelyEndingMusic");
    k.setBackground(k.Color.fromHex("#E6E6E6"));
    k.add([
        k.sprite("endingYuki"),
        k.pos(-10, 20),
        k.scale(0.65),
        k.z(0)
    ]);
    const textStartX = k.width() * 0.55;
    k.add([
        k.text("You Brought Yuki Home", {
            size: 48
        }),
        k.pos(textStartX, 60),
        k.anchor("left"),
        k.color(50, 50, 50),
        k.z(100)
    ]);
    k.add([
        k.text("She missed the calm rain\u2014\nNow she names your houseplants all.\nThey still wither fast.\n\nTourists make poor soil.\nTea tastes strange in Missouri.\nYou steep in regret.", {
            size: 28,
            width: k.width() / 1.5,
            align: "left",
            lineSpacing: 10
        }),
        k.pos(textStartX, 260),
        k.anchor("left"),
        k.color(80, 80, 80),
        k.z(100)
    ]);
    const promptText = k.add([
        k.text("Press ENTER or TAP anywhere\nto return to the main menu.", {
            size: 24
        }),
        k.pos(textStartX, k.height() - 100),
        k.anchor("left"),
        k.color(0, 0, 0),
        k.z(100)
    ]);
    function returnToMenu() {
        (0, $3d1117e281c70288$export$7a6134494e9ab3f8).stopMusic();
        k.go("mainMenu");
    }
    k.onKeyPress("enter", returnToMenu);
    k.onClick(returnToMenu);
}




function $bbed3e6fa908b9bd$export$2e2bcd8739ae039(k) {
    (0, $96277ef5c4fda650$export$8e361a1ffbebf172).setCurrentScene("ending_satoshi");
    (0, $3d1117e281c70288$export$7a6134494e9ab3f8).playMusic(k, "lonelyEndingMusic");
    k.setBackground(k.Color.fromHex("#E6E6E6"));
    // 📸 Left-side image
    const leftImageWidth = k.width() / 2;
    const leftImageHeight = k.height();
    const scale = Math.min(leftImageWidth / 600, leftImageHeight / 400);
    k.add([
        k.sprite("endingSatoshi"),
        k.pos(-10, 20),
        k.scale(0.65),
        k.z(0)
    ]);
    const textStartX = k.width() * 0.55;
    // 🖋️ Title
    k.add([
        k.text("You Chose Satoshi", {
            size: 48
        }),
        k.pos(textStartX, 60),
        k.anchor("left"),
        k.color(50, 50, 50),
        k.z(100)
    ]);
    // 💬 Haikus
    k.add([
        k.text("Slang flew over you\u2014\nHis turtle liked you better.\nYou paid for Wi-Fi.\n\nLong-distance heartbreak\u2014\nHe ghosted you in Discord.\nYou miss his emoji.", {
            size: 28,
            width: k.width() / 1.5,
            align: "left",
            lineSpacing: 10
        }),
        k.pos(textStartX, 260),
        k.anchor("left"),
        k.color(80, 80, 80),
        k.z(100)
    ]);
    // 🔁 Prompt
    const promptText = k.add([
        k.text("Press ENTER or TAP anywhere\nto return to the main menu.", {
            size: 24
        }),
        k.pos(textStartX, k.height() - 100),
        k.anchor("left"),
        k.color(0, 0, 0),
        k.z(100)
    ]);
    function returnToMenu() {
        (0, $3d1117e281c70288$export$7a6134494e9ab3f8).stopMusic();
        k.go("mainMenu");
    }
    k.onKeyPress("enter", returnToMenu);
    k.onClick(returnToMenu);
}




function $b2423a315fe2f183$export$2e2bcd8739ae039(k) {
    (0, $96277ef5c4fda650$export$8e361a1ffbebf172).setCurrentScene("ending_koji");
    (0, $3d1117e281c70288$export$7a6134494e9ab3f8).playMusic(k, "lonelyEndingMusic");
    k.setBackground(k.Color.fromHex("#E6E6E6"));
    // 📸 Koji’s image on the left
    const leftImageWidth = k.width() / 2;
    const leftImageHeight = k.height();
    const scale = Math.min(leftImageWidth / 600, leftImageHeight / 400);
    k.add([
        k.sprite("endingKoji"),
        k.pos(-10, 20),
        k.scale(0.65),
        k.z(0)
    ]);
    const textStartX = k.width() * 0.55;
    // 🖋️ Title
    k.add([
        k.text("You Chose Koji", {
            size: 48
        }),
        k.pos(textStartX, 60),
        k.anchor("left"),
        k.color(50, 50, 50),
        k.z(100)
    ]);
    // 💬 Haikus
    k.add([
        k.text("You liked his broom work\u2014\nBut poems don\u2019t do dishes.\nHe swept out your cash.\n\nMorning head shaving\u2014\nHe says it\u2019s a zen cleansing.\nYou say 'midlife goth.'", {
            size: 28,
            width: k.width() / 1.5,
            align: "left",
            lineSpacing: 10
        }),
        k.pos(textStartX, 260),
        k.anchor("left"),
        k.color(80, 80, 80),
        k.z(100)
    ]);
    // 🔁 Prompt
    const promptText = k.add([
        k.text("Press ENTER or TAP anywhere\nto return to the main menu.", {
            size: 24
        }),
        k.pos(textStartX, k.height() - 100),
        k.anchor("left"),
        k.color(0, 0, 0),
        k.z(100)
    ]);
    function returnToMenu() {
        (0, $3d1117e281c70288$export$7a6134494e9ab3f8).stopMusic();
        k.go("mainMenu");
    }
    k.onKeyPress("enter", returnToMenu);
    k.onClick(returnToMenu);
}




function $5df2715e54d2017b$export$2e2bcd8739ae039(k) {
    (0, $96277ef5c4fda650$export$8e361a1ffbebf172).setCurrentScene("ending_mari");
    (0, $3d1117e281c70288$export$7a6134494e9ab3f8).playMusic(k, "lonelyEndingMusic");
    k.setBackground(k.Color.fromHex("#E6E6E6"));
    // 📸 Mari’s image on the left
    const leftImageWidth = k.width() / 2;
    const leftImageHeight = k.height();
    const scale = Math.min(leftImageWidth / 600, leftImageHeight / 400);
    k.add([
        k.sprite("endingMari"),
        k.pos(-10, 20),
        k.scale(0.65),
        k.z(0)
    ]);
    const textStartX = k.width() * 0.55;
    // 🖋️ Title
    k.add([
        k.text("You Chose Mari", {
            size: 48
        }),
        k.pos(textStartX, 60),
        k.anchor("left"),
        k.color(50, 50, 50),
        k.z(100)
    ]);
    // 💬 Haikus
    k.add([
        k.text("She posted your pic\u2014\nCaption: 'LOL what is this?'\nYou cried in the tags.\n\nBack home she ghosted\u2014\n'Our vibe was super kawaii!'\nThen she blocked your mom.", {
            size: 28,
            width: k.width() / 1.5,
            align: "left",
            lineSpacing: 10
        }),
        k.pos(textStartX, 260),
        k.anchor("left"),
        k.color(80, 80, 80),
        k.z(100)
    ]);
    // 🔁 Prompt
    const promptText = k.add([
        k.text("Press ENTER or TAP anywhere\nto return to the main menu.", {
            size: 24
        }),
        k.pos(textStartX, k.height() - 100),
        k.anchor("left"),
        k.color(0, 0, 0),
        k.z(100)
    ]);
    function returnToMenu() {
        (0, $3d1117e281c70288$export$7a6134494e9ab3f8).stopMusic();
        k.go("mainMenu");
    }
    k.onKeyPress("enter", returnToMenu);
    k.onClick(returnToMenu);
}





function $3ba21ea9e27add48$export$2e2bcd8739ae039(k) {
    // 🎵 Play chill background music
    (0, $3d1117e281c70288$export$7a6134494e9ab3f8).playMusic(k, "instructionsMusic", {
        volume: 0.7
    });
    // 🖼️ Background image
    k.add([
        k.sprite("instructions"),
        k.anchor("center"),
        k.scale(k.width() / 1536, k.height() / 1024),
        k.pos(k.center()),
        k.z(-1)
    ]);
    // 🪧 Background box for title and instructions
    const boxWidth = 900;
    const boxHeight = 600;
    const boxX = k.center().x - boxWidth / 2;
    const boxY = 100;
    k.add([
        k.rect(boxWidth, boxHeight, {
            radius: 16
        }),
        k.pos(boxX, boxY - 20),
        k.color(255, 255, 255),
        k.opacity(0.75),
        k.z(0)
    ]);
    // 📜 Title (centered inside box)
    k.add([
        k.text("HOW TO PLAY", {
            size: 60,
            font: "gameboy"
        }),
        k.pos(k.center().x, boxY + 25),
        k.anchor("center"),
        k.color(0, 0, 0),
        k.z(1)
    ]);
    // 📝 Instructions (left-aligned, visually centered)
    k.add([
        k.text("You play as *Randy*, an obnoxious American tourist seeking love (and maybe immigration paperwork).\n\n- Talk to people using the E key.\n- End the game at any time using the ESC key.\n- Everyone speaks in haiku. So do you.\n- Win hearts by saying the right things or giving gifts.\n- Collect hearts to start the K-1 visa journey with that person.\n\nTips:\n- Listen closely. Locals will drop hints.\n- Flattery and weird snacks go a long way.\n- You\u2019re not a hero. You\u2019re Randy.", {
            size: 20,
            width: boxWidth - 40,
            lineSpacing: 14,
            font: "gameboy"
        }),
        k.pos(boxX + 20, boxY + 100),
        k.color(0, 0, 0),
        k.z(1)
    ]);
    // 🔁 Blinking "Press ENTER" prompt
    const prompt = k.add([
        k.text("Press ENTER to Begin", {
            size: 26,
            font: "gameboy"
        }),
        k.anchor("center"),
        k.pos(k.center().x, boxY - 30 + boxHeight - 30),
        k.color(0, 0, 0),
        k.z(1)
    ]);
    let blinkTimer = 0;
    k.onUpdate(()=>{
        blinkTimer += k.dt();
        prompt.hidden = Math.floor(blinkTimer * 2) % 2 === 0;
    });
    // Input to start game
    const startGame = ()=>{
        (0, $3d1117e281c70288$export$7a6134494e9ab3f8).stopMusic();
        k.go("world");
    };
    k.onKeyPress("enter", startGame);
    k.onClick(startGame);
    k.onTouchStart(startGame);
}



function $39475d97d5867efd$export$2e2bcd8739ae039(k) {
    k.add([
        k.text("\uD83D\uDD01 Resetting...", {
            size: 36
        }),
        k.pos(k.center()),
        k.anchor("center")
    ]);
    // 🧹 Clear all localStorage flags set by gameState
    for(let key in localStorage)if (key.startsWith("flag-")) localStorage.removeItem(key);
    // 🧹 Reset player state flags
    (0, $96277ef5c4fda650$export$ab4b6c53ec258d17).setHasPickedUpAntiqueKey(false);
    (0, $96277ef5c4fda650$export$ab4b6c53ec258d17).setHasPickedUpManga(false);
    (0, $96277ef5c4fda650$export$ab4b6c53ec258d17).setHasPickedUpOriyoki(false);
    (0, $96277ef5c4fda650$export$ab4b6c53ec258d17).setHasOriyoki(false);
    (0, $96277ef5c4fda650$export$ab4b6c53ec258d17).setHasPickedUpSword(false);
    (0, $96277ef5c4fda650$export$ab4b6c53ec258d17).setHasPickedUpStrawberries(false);
    // 🕒 Delay briefly then go to main menu or world
    k.wait(1, ()=>{
        k.go("world");
    });
}


const $8d245c1f3b744b73$var$scenes = {
    mainMenu: $4fa71b5ad2e676c4$export$2e2bcd8739ae039,
    world: $7f8d2ae62d27bc6f$export$2e2bcd8739ae039,
    teahouse: $9ef7e57c1a16e747$export$2e2bcd8739ae039,
    hotel: $7c04be5d3b422822$export$2e2bcd8739ae039,
    bath: $7808d7de2e8cf289$export$2e2bcd8739ae039,
    train: $6edd29be782b9195$export$2e2bcd8739ae039,
    endingCredits: $914eda969ed0e52d$export$2e2bcd8739ae039,
    manga: $4b0264038acf4b6a$export$2e2bcd8739ae039,
    ramen: $f720bf84da31aaf2$export$2e2bcd8739ae039,
    cstore: $3fbe83284b15edf6$export$2e2bcd8739ae039,
    antique: $8fb8916ac81e31a1$export$2e2bcd8739ae039,
    endingSelection: $7c40a1dd3da32151$export$2e2bcd8739ae039,
    endingAlone: $442f906206c75bae$export$2e2bcd8739ae039,
    ending_hana: $612418092cb11506$export$2e2bcd8739ae039,
    ending_naoko: $514bc2d15b09a1b8$export$2e2bcd8739ae039,
    ending_oldman: $360c447a81b3e68e$export$2e2bcd8739ae039,
    ending_yuki: $b08a61583fbf1f0a$export$2e2bcd8739ae039,
    ending_satoshi: $bbed3e6fa908b9bd$export$2e2bcd8739ae039,
    ending_koji: $b2423a315fe2f183$export$2e2bcd8739ae039,
    ending_mari: $5df2715e54d2017b$export$2e2bcd8739ae039,
    instructions: $3ba21ea9e27add48$export$2e2bcd8739ae039,
    reset: $39475d97d5867efd$export$2e2bcd8739ae039
};
function $8d245c1f3b744b73$export$2e2bcd8739ae039(k) {
    for(const name in $8d245c1f3b744b73$var$scenes)k.scene(name, ()=>$8d245c1f3b744b73$var$scenes[name](k));
}


(0, $2f9f10e955c94a7b$export$2e2bcd8739ae039)((0, $40b70ca180e06959$export$2e2bcd8739ae039));
(0, $f99e5c35cd4b910d$export$2e2bcd8739ae039)((0, $40b70ca180e06959$export$2e2bcd8739ae039));
(0, $0854c6558b0c048c$export$2e2bcd8739ae039)((0, $40b70ca180e06959$export$2e2bcd8739ae039));
(0, $8d245c1f3b744b73$export$2e2bcd8739ae039)((0, $40b70ca180e06959$export$2e2bcd8739ae039));
(0, $40b70ca180e06959$export$2e2bcd8739ae039).go("mainMenu");


//# sourceMappingURL=90-Day-Haiku-Build.9c34fe2d.js.map
